var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6472,
    height: 668,
    fill: "none",
    viewBox: "0 0 6472 668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map - redesign - Final A",
    className: "map - redesign - Final A",
    clipPath: "url(#clip0_5370_44915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1156",
    className: "Group 1156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    fill: "#DEF5F5",
    d: "M6472 0H1v701h6471V0Z",
    className: "bg"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blob map",
    fill: "#E0E0E0",
    fillOpacity: 0.35,
    d: "M5934.5 399c18.5-111.5 137.22-259.158 99.72-312.58-37.5-53.42-166-48.017-285.5 0-98.5 39.581-148.22 68.58-227.22 68.58s-192.2-.43-266-31.5c-73.8-31.07-276-97.5-427.28-50C4676.95 121 4677 178 4602 178c-75 10.5-122.29-88.56-193.21-91.58-56.88-2.43-66.67 32.551-145.32 50.141-79.08 17.68-148.48 0-171.62-6.1-112-29.75-127.24-93.14-206.49-93.38-46-.14-44.54 21.24-130.85 53.8-89.52 33.77-165.69 39.83-290.09 47.33-90.36 5.45-137.66-.26-159.4-2.33-146.32-13.92-173.13-49.53-260-50.78-29.66-.42-53.24 3.34-73.29 9.66-113.28 35.67-149.07 74.27-208.4 91.71-142.77 42-230.89-155.46-442.23-144.34-63.57 3.35-42.24 20.51-220.7 59.67-23.5 5.15-118.09 25.53-248.26 42.53 0 0-67.1 8.77-128.41 14.19-270.59 23.9-421.72-24-701-58.35-233.317-28.7-572.937-68.24-614.997 36-20.26 50.19 42.41 99.2 12.5 187.54-21.52 63.57-56.56 73-88.66 137.08-34.85 69.56-57.56 194-7.19 250.5 60.22 67.59 262.56 21.73 667.25-70 79.777-18.08 133.507-27.2 201.157-11s85.52 44.56 158.77 48.74c44.56 2.55 53.07-7.1 135.4-9.86 48-1.6 83.88.38 115.4 2.21 135.35 7.85 149.77 25.75 207.92 24.86 129.77-2 127.81-92.15 269.71-111.54 127.11-17.36 264.69 35.7 289.48 46.34 39.47 16.95 73.94 37.66 130.93 44.14 85 9.66 152.5-20.07 175.6-29.22 140.92-55.85 350.28-29.67 699.08 13.95 247.73 31 381.49 71.08 540.18 19.12 15.64-5.12 53.47-18.32 112-35.74 183.57-54.64 264-55.47 321.49-57.73 47.25-1.85 55.38 1 61.73 4.57 25.85 14.68 11.14 43.38 29.94 69.78 33.3 46.75 153.75 61 235.79 26.77 34.66-14.47 62.72-37.72 96.65-28.77 13.61 3.6 27.53 12.21 55.36 15.24a173.765 173.765 0 0 0 36.82 0c37.58-4 51.57-16 100.5-33 61.45-21.35 565.38-3.67 672.78-6.93 21.05-.63-444.43-1.77-432.43-3.3 9.28-1.19 17.37-2.42 24.32-3.57 15.76-2.63 634.01 4.978 155.79 4.748 31.83-6.13 173.3 67.961 237.5 83.401 59.72 14.4 400.76 11.68 420-52 21.15-70.06-109-87.5-109-263.5Z",
    className: "blob map"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sun clouds",
    className: "sun clouds"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#FFDF5A",
    d: "M2160.59 285.679c43.97 0 79.61-35.643 79.61-79.61s-35.64-79.61-79.61-79.61-79.61 35.643-79.61 79.61 35.64 79.61 79.61 79.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "#fff",
    d: "M2526.37 179.431c0-.6.07-1.2.07-1.81 0-10.81-7.06-19.57-15.76-19.57-7.43 0-13.65 6.39-15.31 15-3.32-4.89-8.11-8.17-13.53-8.8v-1.21c0-13.8-9-25-20.13-25-7.28 0-13.65 4.8-17.19 12a16.61 16.61 0 0 0-5.31-.89c-8.69 0-16.09 6.83-18.92 16.4a7.777 7.777 0 0 0-6.06-3.12c-3.74 0-6.92 3-8.08 7.17h-.19c-4.72 0-8.55 4.75-8.55 10.61 0 .498.03.996.09 1.49v.07c.6 5.13 4.15 9.06 8.45 9.06 3.75 0 6.93-3 8.09-7.16h.18a7.435 7.435 0 0 0 4.89-1.91h29.24a19.325 19.325 0 0 0 8 5.41c1.72.58 3.51.878 5.32.88 2.54-.049 5.05-.635 7.35-1.719a18.09 18.09 0 0 0 6-4.571h51.51v-2.3l-.16-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#fff",
    d: "M2000.08 140.23c-.37-13.12-9.06-23.62-19.71-23.62-.97-.002-1.93.089-2.89.27a8.989 8.989 0 0 0-7.45-4.46c-5.28 0-9.55 5.31-9.55 11.85-.02 2.453.61 4.868 1.82 7a29.669 29.669 0 0 0-1.66 9.88v1.42a11.412 11.412 0 0 0-6.1-.91c-1.78-6.89-7-11.88-13.11-11.88-7.15 0-13 6.78-13.7 15.44-4.08.35-7.39 4.15-8 9.09v.19c-.06.524-.1 1.052-.11 1.58a16.68 16.68 0 0 0 .3 2.79h22.37c.02 1.686.24 3.365.65 5 1.77 6.88 7 11.88 13.11 11.88 6.77 0 12.4-6.08 13.54-14.09.13-.918.2-1.843.21-2.77h40.07c.42-1.485.62-3.019.62-4.56.01-7.5-4.62-13.54-10.41-14.1Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fill: "#6B655F",
    d: "M392.983 668.77h532.49V476.6s-67.42 137.21-110.4 69.21c-42.54-67.37-102-8.94-103.22-7.79-38.41 55.44-84.58 56.56-118 46.61a116.476 116.476 0 0 0-23.12-4.46 108.764 108.764 0 0 0-29.58 1.37c-2.347.42-4.68.92-7 1.5-15.63 3.84-31 11.14-46 21.77l-95.17 63.96Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mountains",
    className: "mountains"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fill: "#7D8696",
    d: "m470.502 172.432-68.45 316.57c13.35-13.37 28.22-18 42.77-13.42 54.82 17.58 89.28 107.49 89.28 107.49 2.34-.58 4.674-1.08 7-1.5l69.45-222.37-85.45-205.56c-.37-.89-.75-1.78-1.15-2.64-16.11-35.19-43.75-23.4-53.45 21.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fill: "#7D8696",
    d: "M123.323 222 27.65 608.5c-73.508 295.43 27.673 100.989 42.223 105.569 54.82 17.58 117.05-81.429 117.05-81.429 2.34-.58 4.673-1.08 7-1.5l69.45-222.37-85.45-205.56c-.37-.89-.75-1.78-1.15-2.64-16.11-35.19-43.75-23.4-53.45 21.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fill: "#C7CACE",
    d: "m366.323 223-68.45 316.57c13.35-13.37.45 170.919 15 175.499 54.82 17.58 117.05-81.429 117.05-81.429 2.34-.58 4.673-1.08 7-1.5l69.45-222.37-85.45-205.56c-.37-.89-.75-1.78-1.15-2.64-16.11-35.19-43.75-23.4-53.45 21.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fill: "#F4D3C6",
    d: "m781.763 260.891 35.76 121.92c51.89-44.35 110 73.05 110 73.05h65.21l-109.81-244.53c-10.16-22.58-25.85-28.61-39-15l-62.16 64.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 964",
    className: "Group 964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fill: "#F4D3C6",
    d: "M541.135 581.54a108.842 108.842 0 0 1 29.58-1.37s78.1-15.86 83.55-107.58c4.56-76.36 3.87-139.37 60.82-170.71 39.63-21.81 48.089-113.56 48.089-113.56l-20.359-69.4c-10.06-34.21-31-44.29-46.85-22.5a72.354 72.354 0 0 0-9.871 20.75l-75.539 242-69.42 222.37Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fill: "#D3B4A7",
    d: "M570.713 580.17c7.853.7 15.614 2.204 23.16 4.49 33.42 10 79.59 8.83 118-46.61 13.62-19.79 25.41-44.95 34.74-74.17 13.67-42.28 40-74.71 68.37-99L779.203 243l-16-54.65s-8.46 91.75-48.09 113.56c-57 31.34-56.26 94.35-60.82 170.71-5.45 91.72-83.55 107.58-83.55 107.58l-.03-.03Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fill: "#908C85",
    d: "M814.963 364.89c-28.36 24.25-54.7 56.68-68.37 99-9.33 29.18-21.12 54.34-34.72 74.11 1.19-1.15 60.68-59.58 103.22 7.79 43 68 110.4-69.21 110.4-69.21V303.5s-58.62 17.04-110.53 61.39Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fill: "#9CA3AE",
    d: "M389.101 669.52s-395.278 18.83-389.028 0C.073 579.5 172.647 396 421.647 396c264 0 320.664 200.84 343.234 275.69 2.18 7.22-174.54-2.17-174.54-2.17h-201.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fill: "#BACC4E",
    d: "M689.403 534.83s69.47-310.06 340.187-310.06c270.72 0 337.89 310.06 337.89 310.06H689.403Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fill: "#44AA85",
    d: "M663.633 662s-267.37 18.64-261.12-.19c25.29-76.17 109.81-268.33 319.06-268.33 211.46 0 295.267 195.84 317.837 270.69 2.18 7.22-174.537-2.17-174.537-2.17h-201.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "house",
    className: "house"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fill: "#686868",
    d: "M556.924 388.889h-9.039v12.26h9.039v-12.26Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fill: "#CCC",
    d: "M611.642 439.482h-71.64v58.03h71.64v-58.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fill: "#686868",
    d: "M541.444 401.15h68.76l6.63 38.33h-82.02l6.63-38.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fill: "#EAEAEA",
    d: "M585.074 464.611h-18.51v32.9h18.51v-32.9Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fill: "#fff",
    d: "M560.564 454.619h-14.41v19.54h14.41v-19.54Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fill: "#fff",
    d: "M605.494 454.619h-14.41v19.54h14.41v-19.54Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fill: "#91DC5A",
    d: "M915.252 567.852a11.736 11.736 0 0 0-1.61-3.8 10.99 10.99 0 0 0-3.7-3.45.531.531 0 0 0-.64.08.464.464 0 0 0-.06.6 14.886 14.886 0 0 1 2.36 10.77.485.485 0 0 0 .1.4.553.553 0 0 0 .4.18h2.95a.51.51 0 0 0 .51-.43 12.92 12.92 0 0 0-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fill: "#4CBA68",
    d: "M918.432 564.331a14.308 14.308 0 0 0-6.35-7.44.531.531 0 0 0-.64.08.453.453 0 0 0-.06.6 19.343 19.343 0 0 1 3.38 9.79 18.654 18.654 0 0 1-.21 4.69.447.447 0 0 0 .1.4.553.553 0 0 0 .4.18h2.9a.502.502 0 0 0 .51-.49v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fill: "#91DC5A",
    d: "M924.522 557.571a.459.459 0 0 0-.06-.6.531.531 0 0 0-.64-.08 14.49 14.49 0 0 0-4.88 4.54 15.87 15.87 0 0 0-2.13 5 17.568 17.568 0 0 0-.41 5.74.509.509 0 0 0 .51.43h3.96a.465.465 0 0 0 .416-.169.462.462 0 0 0 .084-.441 19.19 19.19 0 0 1-.21-4.66 19.483 19.483 0 0 1 3.36-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fill: "#4CBA68",
    d: "M926.664 561.282a.47.47 0 0 0-.06-.6.534.534 0 0 0-.64-.08 10.838 10.838 0 0 0-3.7 3.45 11.77 11.77 0 0 0-1.62 3.8 13.238 13.238 0 0 0-.31 4.35.508.508 0 0 0 .51.43h2.95a.471.471 0 0 0 .5-.61 15.003 15.003 0 0 1 2.37-10.74Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_2",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fill: "#91DC5A",
    d: "M839.967 534.036a11.727 11.727 0 0 0-1.61-3.8 10.98 10.98 0 0 0-3.7-3.45.531.531 0 0 0-.64.08.461.461 0 0 0-.06.6 14.885 14.885 0 0 1 2.36 10.77.485.485 0 0 0 .1.4.555.555 0 0 0 .4.18h2.95a.508.508 0 0 0 .51-.43 12.916 12.916 0 0 0-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fill: "#4CBA68",
    d: "M843.147 530.515a14.308 14.308 0 0 0-6.35-7.44.531.531 0 0 0-.64.08.448.448 0 0 0-.06.6 19.349 19.349 0 0 1 3.38 9.79 18.656 18.656 0 0 1-.21 4.69.447.447 0 0 0 .1.4.555.555 0 0 0 .4.18h2.9a.503.503 0 0 0 .51-.49v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fill: "#91DC5A",
    d: "M849.237 523.755a.461.461 0 0 0-.06-.6.534.534 0 0 0-.64-.08 14.48 14.48 0 0 0-4.88 4.54 15.837 15.837 0 0 0-2.13 5 17.566 17.566 0 0 0-.41 5.74.512.512 0 0 0 .51.43h3.96a.478.478 0 0 0 .514-.379.464.464 0 0 0-.014-.231 19.19 19.19 0 0 1-.21-4.66 19.477 19.477 0 0 1 3.36-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fill: "#4CBA68",
    d: "M851.379 527.466a.472.472 0 0 0-.06-.6.528.528 0 0 0-.64-.08 10.838 10.838 0 0 0-3.7 3.45 11.762 11.762 0 0 0-1.62 3.8 13.234 13.234 0 0 0-.31 4.35.508.508 0 0 0 .51.43h2.95a.474.474 0 0 0 .514-.379.464.464 0 0 0-.014-.231 15.002 15.002 0 0 1 2.37-10.74Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_3",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fill: "#91DC5A",
    d: "M660.967 459.036a11.727 11.727 0 0 0-1.61-3.8 10.98 10.98 0 0 0-3.7-3.45.531.531 0 0 0-.64.08.461.461 0 0 0-.06.6 14.885 14.885 0 0 1 2.36 10.77.485.485 0 0 0 .1.4.555.555 0 0 0 .4.18h2.95a.508.508 0 0 0 .51-.43 12.916 12.916 0 0 0-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fill: "#4CBA68",
    d: "M664.147 455.515a14.308 14.308 0 0 0-6.35-7.44.531.531 0 0 0-.64.08.448.448 0 0 0-.06.6 19.349 19.349 0 0 1 3.38 9.79 18.656 18.656 0 0 1-.21 4.69.447.447 0 0 0 .1.4.555.555 0 0 0 .4.18h2.9a.503.503 0 0 0 .51-.49v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fill: "#91DC5A",
    d: "M670.237 448.755a.461.461 0 0 0-.06-.6.534.534 0 0 0-.64-.08 14.48 14.48 0 0 0-4.88 4.54 15.837 15.837 0 0 0-2.13 5 17.566 17.566 0 0 0-.41 5.74.512.512 0 0 0 .51.43h3.96a.478.478 0 0 0 .514-.379.464.464 0 0 0-.014-.231 19.19 19.19 0 0 1-.21-4.66 19.477 19.477 0 0 1 3.36-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fill: "#4CBA68",
    d: "M672.379 452.466a.472.472 0 0 0-.06-.6.528.528 0 0 0-.64-.08 10.838 10.838 0 0 0-3.7 3.45 11.762 11.762 0 0 0-1.62 3.8 13.234 13.234 0 0 0-.31 4.35.508.508 0 0 0 .51.43h2.95a.474.474 0 0 0 .514-.379.464.464 0 0 0-.014-.231 15.002 15.002 0 0 1 2.37-10.74Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_4",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fill: "#91DC5A",
    d: "M505.967 577.036a11.727 11.727 0 0 0-1.61-3.8 10.99 10.99 0 0 0-3.7-3.45.528.528 0 0 0-.64.08.456.456 0 0 0-.06.6 14.89 14.89 0 0 1 2.36 10.77.47.47 0 0 0 .281.531.55.55 0 0 0 .219.049h2.95a.508.508 0 0 0 .51-.43 12.916 12.916 0 0 0-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fill: "#4CBA68",
    d: "M509.147 573.515a14.308 14.308 0 0 0-6.35-7.44.534.534 0 0 0-.64.08.447.447 0 0 0-.06.6 19.349 19.349 0 0 1 3.38 9.79 18.656 18.656 0 0 1-.21 4.69.447.447 0 0 0 .1.4.56.56 0 0 0 .4.18h2.9a.503.503 0 0 0 .51-.49v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fill: "#91DC5A",
    d: "M515.237 566.755a.461.461 0 0 0-.06-.6.534.534 0 0 0-.64-.08 14.461 14.461 0 0 0-4.88 4.54 15.837 15.837 0 0 0-2.13 5 17.539 17.539 0 0 0-.41 5.74.508.508 0 0 0 .51.43h3.96a.474.474 0 0 0 .514-.379.464.464 0 0 0-.014-.231 19.14 19.14 0 0 1-.21-4.66 19.458 19.458 0 0 1 3.36-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fill: "#4CBA68",
    d: "M517.379 570.466a.472.472 0 0 0-.06-.6.528.528 0 0 0-.64-.08 10.838 10.838 0 0 0-3.7 3.45 11.74 11.74 0 0 0-1.62 3.8 13.207 13.207 0 0 0-.31 4.35.508.508 0 0 0 .51.43h2.95a.464.464 0 0 0 .415-.17.465.465 0 0 0 .085-.44 14.992 14.992 0 0 1 2.37-10.74Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_5",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fill: "#91DC5A",
    d: "M836.65 424.245a8.8 8.8 0 0 0-1.203-2.839 8.216 8.216 0 0 0-2.764-2.577.405.405 0 0 0-.25-.052.403.403 0 0 0-.229.111.345.345 0 0 0-.044.449 11.128 11.128 0 0 1 1.763 8.046.357.357 0 0 0 .075.299.399.399 0 0 0 .298.134h2.204a.382.382 0 0 0 .381-.321 9.635 9.635 0 0 0-.231-3.25Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    fill: "#4CBA68",
    d: "M839.025 421.615a10.685 10.685 0 0 0-4.744-5.559.393.393 0 0 0-.478.06.338.338 0 0 0-.045.448 14.462 14.462 0 0 1 2.526 7.314c.095 1.17.042 2.348-.157 3.504a.336.336 0 0 0 .074.299.411.411 0 0 0 .299.135h2.167a.384.384 0 0 0 .35-.224.385.385 0 0 0 .031-.142v-5.716a.323.323 0 0 0-.023-.119Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    fill: "#91DC5A",
    d: "M843.575 416.564a.342.342 0 0 0-.044-.448.4.4 0 0 0-.478-.06 10.815 10.815 0 0 0-3.646 3.392 11.841 11.841 0 0 0-1.592 3.736 13.104 13.104 0 0 0-.306 4.288.38.38 0 0 0 .381.321h2.959a.352.352 0 0 0 .373-.456 14.337 14.337 0 0 1-.157-3.481 14.56 14.56 0 0 1 2.51-7.292Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    fill: "#4CBA68",
    d: "M845.175 419.337a.352.352 0 0 0-.044-.449.4.4 0 0 0-.229-.111.4.4 0 0 0-.249.052 8.105 8.105 0 0 0-2.765 2.577 8.815 8.815 0 0 0-1.21 2.839 9.9 9.9 0 0 0-.232 3.25.381.381 0 0 0 .381.321h2.204a.348.348 0 0 0 .384-.283.346.346 0 0 0-.01-.172 11.21 11.21 0 0 1 1.77-8.024Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bench1",
    className: "bench1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    fill: "#CCC",
    d: "M542.753 631.361h-3.88v23.35h3.88v-23.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    fill: "#CCC",
    d: "M594.901 631.361h-3.88v23.35h3.88v-23.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    fill: "#CCC",
    d: "M547.324 605.889h-3.74v23.35h3.74v-23.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    fill: "#CCC",
    d: "M590.205 605.889h-3.75v23.35h3.75v-23.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    fill: "#E0A370",
    d: "M599.663 626.369h-65.56v9.36h65.56v-9.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    fill: "#E0A370",
    d: "M595.132 603.131h-56.49v6.77h56.49v-6.77Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    fill: "#E0A370",
    d: "M595.132 613.982h-56.49v6.77h56.49v-6.77Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree4",
    className: "tree4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    fill: "#72493E",
    d: "M794.335 615.971h-7.38v39.27h7.38v-39.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    fill: "#A0D755",
    d: "M805.413 602.88c0 14.46-6.62 26.18-14.77 26.18-8.15 0-14.77-11.72-14.77-26.18 0-45.82 6.61-104.73 14.77-104.73s14.77 58.91 14.77 104.73Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    fill: "#8CBE4B",
    d: "M786.953 602.88c0-37.58 3.33-83.9 7.91-99.37-1.34-3.4-2.75-5.36-4.22-5.36-8.16 0-14.77 58.91-14.77 104.73 0 14.46 6.61 26.18 14.77 26.18a9.099 9.099 0 0 0 4.22-1.21c-4.57-3.24-7.91-13.13-7.91-24.97Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bush",
    fill: "#BCB704",
    d: "M878.823 631.49c.505-1.509.765-3.089.77-4.68 0-7.07-4.81-12.81-10.75-12.81a10.325 10.325 0 0 0-8.71 5.36 8.07 8.07 0 0 0-5.85-2.68c-4.9 0-8.87 4.74-8.87 10.58.013.401.046.802.1 1.2h-.64c-6 0-11 5.85-11 13.06 0 7.21 4.91 13.06 11 13.06 1.06 0 31.91 1.46 33.47 1.46 5.69 0 10.31-5.5 10.31-12.29 0-6.62-4.36-11.96-9.83-12.26Z",
    className: "bush"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bush_2",
    fill: "#BCB704",
    d: "M531.263 526.941c.376-1.133.568-2.318.57-3.51 0-5.31-3.61-9.62-8.07-9.62a7.753 7.753 0 0 0-6.55 4 6.066 6.066 0 0 0-4.39-2c-3.68 0-6.67 3.56-6.67 7.95.011.301.038.601.08.9h-.48c-4.55 0-8.23 4.4-8.23 9.81s3.68 9.81 8.23 9.81c.79 0 24 1.1 25.15 1.1 4.27 0 7.74-4.13 7.74-9.23 0-5.1-3.28-8.97-7.38-9.21Z",
    className: "bush"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sport outside",
    className: "sport outside"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    fill: "#738B95",
    d: "M899.123 491c-.52 0-1-.58-1-1.3v-18.39c0-.72.43-1.3 1-1.3.57 0 1 .58 1 1.3v18.34c-.05.72-.48 1.35-1 1.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    fill: "#738B95",
    d: "M893.873 491c-.53 0-1-.58-1-1.3v-18.39c0-.72.42-1.3 1-1.3.58 0 .94.58.94 1.3v18.34c-.04.72-.46 1.35-.94 1.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    fill: "#75A4BC",
    d: "M857.162 484.451h26.21v6.24h-26.21v-6.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    fill: "#355A6D",
    d: "M857.162 488.08h26.21v2.61h-26.21v-2.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    fill: "#75A4BC",
    d: "M857.162 499.709h26.21v6.29h-26.21v-6.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    fill: "#75A4BC",
    d: "M857.162 515.002h26.21v6.24h-26.21v-6.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    fill: "#355A6D",
    d: "M857.162 503.342h26.21v2.66h-26.21v-2.66Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    fill: "#355A6D",
    d: "M857.162 518.6h26.21v2.61h-26.21v-2.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    fill: "#75A4BC",
    d: "M857.162 469.182h52.42v6.25h-52.42v-6.25Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    fill: "#355A6D",
    d: "M857.162 472.311h52.42v3.12h-52.42v-3.12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    fill: "#A9C5D3",
    d: "M854.873 464.002h4.53v71.3h-4.53v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    fill: "#A9C5D3",
    d: "M881.103 464.002h4.54v71.3h-4.54v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    fill: "#A9C5D3",
    d: "M907.314 464.002h4.56v71.3h-4.53l-.03-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    fill: "#4F7D99",
    d: "M907.314 464.002h2.27v71.3h-2.27v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    fill: "#4F7D99",
    d: "M881.103 464.002h2.27v71.3h-2.27v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    fill: "#4F7D99",
    d: "M854.873 464.002h2.26v71.3h-2.26v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    fill: "#75A4BC",
    d: "M893.875 505.522c-3.45 0-6.24-3.85-6.24-8.59s2.79-8.59 6.24-8.59 6.24 3.86 6.24 8.59-2.84 8.59-6.24 8.59Zm0-14.52c-2.4 0-4.35 2.68-4.35 6s1.95 6 4.35 6c2.4 0 4.34-2.68 4.34-6s-1.95-6-4.34-6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    fill: "#A9C5D3",
    d: "M899.125 505.522c-3.44 0-6.24-3.85-6.24-8.59s2.8-8.59 6.24-8.59c3.44 0 6.24 3.86 6.24 8.59s-2.8 8.59-6.24 8.59Zm0-14.57c-2.4 0-4.35 2.68-4.35 6s2 6 4.35 6c2.35 0 4.349-2.68 4.349-6s-1.999-6-4.349-6Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bench2",
    className: "bench2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    fill: "#7D8696",
    d: "M841.522 384.732h-2.88v17.33h2.88v-17.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    fill: "#7D8696",
    d: "M880.222 384.732h-2.88v17.33h2.88v-17.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    fill: "#7D8696",
    d: "M844.914 365.83h-2.779v17.32h2.779v-17.32Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    fill: "#7D8696",
    d: "M876.735 365.83h-2.78v17.32h2.78v-17.32Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    fill: "#DB8849",
    d: "M883.765 381.021h-48.65v6.94h48.65v-6.94Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    fill: "#DB8849",
    d: "M880.384 363.779h-41.91v5.02h41.91v-5.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    fill: "#DB8849",
    d: "M880.384 371.83h-41.91v5.02h41.91v-5.02Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    fill: "#72493E",
    d: "M936.824 511.74h-4.33v23.04h4.33v-23.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    fill: "#4FC99A",
    d: "M943.324 504.061c0 8.49-3.88 15.37-8.66 15.37s-8.67-6.88-8.67-15.37c0-26.88 3.88-61.45 8.67-61.45s8.66 34.57 8.66 61.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    fill: "#44AA85",
    d: "M932.494 504.061c0-22 2-49.22 4.64-58.3-.78-2-1.61-3.15-2.47-3.15-4.79 0-8.67 34.57-8.67 61.45 0 8.49 3.88 15.36 8.67 15.36a5.267 5.267 0 0 0 2.47-.71c-2.67-1.9-4.64-7.71-4.64-14.65Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_2",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    fill: "#72493E",
    d: "M917.953 340.311h-3.35v17.81h3.35v-17.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    fill: "#4FC99A",
    d: "M922.974 334.369c0 6.56-3 11.88-6.7 11.88s-6.69-5.32-6.69-11.88c0-20.78 3-47.5 6.69-47.5 3.69 0 6.7 26.72 6.7 47.5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    fill: "#44AA85",
    d: "M914.604 334.369c0-17 1.51-38.05 3.59-45.07-.61-1.54-1.25-2.43-1.92-2.43-3.7 0-6.69 26.72-6.69 47.5 0 6.56 3 11.88 6.69 11.88a4.056 4.056 0 0 0 1.92-.56c-2.07-1.46-3.59-5.95-3.59-11.32Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree2",
    className: "tree2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    fill: "#72493E",
    d: "M807.602 439.471h-3.35v17.81h3.35v-17.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    fill: "#4FC99A",
    d: "M812.622 433.539c0 6.55-3 11.87-6.69 11.87-3.69 0-6.7-5.32-6.7-11.87 0-20.79 3-47.51 6.69-47.51 3.69 0 6.7 26.72 6.7 47.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    fill: "#44AA85",
    d: "M804.252 433.539c0-17 1.51-38.06 3.59-45.08-.61-1.53-1.25-2.43-1.92-2.43-3.69 0-6.69 26.72-6.69 47.51 0 6.55 3 11.87 6.69 11.87a4.147 4.147 0 0 0 1.92-.55c-2.07-1.47-3.59-5.95-3.59-11.32Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bush2",
    className: "bush2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    fill: "#44AA85",
    d: "M916.741 386.221a5.756 5.756 0 0 0-5.06 3.69 5.346 5.346 0 0 0-4.68-3.32c-3 0-5.45 3-5.45 6.81a8.12 8.12 0 0 0 .72 3.39h-.06c-3.19 0-5.78 3.23-5.78 7.22 0 3.99 2.59 7.23 5.78 7.23 3.19 0 15.67-.69 17.87-.69 3.22 0 2.49-13 2.49-17s-2.61-7.33-5.83-7.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    fill: "#4FC99A",
    d: "M935.072 398.272h-.29c.027-.189.044-.379.05-.57 0-2.72-1.77-4.93-4-4.93a3.526 3.526 0 0 0-2.56 1.23 4.566 4.566 0 0 0-3.88-2.5c-2.64 0-4.78 2.67-4.78 6-.002.74.113 1.476.34 2.18-2.44.14-4.38 2.63-4.38 5.7 0 3.07 2.06 5.74 4.59 5.74.7 0 14.44-.68 14.91-.68 2.69 0 4.88-2.73 4.88-6.1 0-3.37-2.19-6.07-4.88-6.07Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "building",
    fill: "#A3A3A3",
    d: "M1415.24 266.21h-171.36v165.37h171.36V266.21Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    fill: "#A3B212",
    d: "M4914.87 707.6s103-459.6 504.27-459.6S5920 707.6 5920 707.6H4914.87Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    fill: "#44AA85",
    d: "M4478.35 657.36s103-459.6 504.27-459.6 500.86 459.6 500.86 459.6H4478.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    className: "Group",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    fill: "#fff",
    d: "M3943.56 158.35h.06c3.32.01 2.89 0-.06 0Z",
    className: "Vector",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "building_2",
    fill: "#A3A3A3",
    d: "M3542.7 223.91h-137.62v216.75h137.62V223.91Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_3",
    fill: "#A3A3A3",
    d: "M3675.68 252.79h-38.91v52.96h-66.22v20.8h-35.33v72.5h35.33v8.73h122.5V305.75h-17.37v-52.96Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_4",
    fill: "#CCC",
    d: "M3782.17 350.66h-84.58v-18.99h-13.25v18.99h-6.11v-36.24h-5.1v36.24h-10.27v178.4h146.18V342.99h-26.87v7.67Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_5",
    fill: "#AFAFAF",
    d: "M3425.5 337.78h4.45v-.85h-4.45v-4.38h5.62v-.86h-5.62v-3.6h9v-.85h-9v-1.44h-1.27v1.44h-8.79v.85h8.79v3.6h-5.6v.86h5.6v4.38h-4.41v.85h4.41v16.53h-103.69v305.74h134.42V354.31h-29.46v-16.53Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    fill: "#CCC",
    d: "M3329.2 572.42H3131v9.46h198.2v-9.46Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    fill: "#F2E1A1",
    d: "M3324.02 639.8h-11.38v4.49h11.38v-4.49Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    fill: "#F2E1A1",
    d: "M3319.52 603h-12.57v6.7h12.57V603Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    fill: "#686868",
    d: "M3522.15 433.09h-137.52v3.94h137.52v-3.94Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    fill: "#686868",
    d: "M3397.31 433.1h11.8v-5.92l-11.8-5.26v11.18Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    fill: "#fff",
    d: "M3423.72 450.76h-18.64v40.81h18.64v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    fill: "#fff",
    d: "M3423.67 510.971h-18.64v40.81h18.64v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_6",
    fill: "#AFAFAF",
    d: "M3890.82 408.149c.96-2.849.34-5.568-1.37-6.069-1.72-.502-3.91 1.414-4.86 4.264-.3.87-.45 1.785-.45 2.705h-115.27V586h158V409.049h-36.41c.13-.288.25-.584.36-.9Zm-97.21 6.091h-23.3v-3.433h23.3v3.433Zm27.11 0h-25.96v-3.433h26l-.04 3.433Zm26.92 0h-25.77v-3.433h25.74l.03 3.433Zm38.32 0h-37.19v-3.433h25.72v3.371h1.14v-3.371h8.79c.11.364.3.697.57.972.26.274.58.482.94.607l.03 1.854Zm16.59-3.433h22.55v3.433h-22.55v-3.433Zm-11.02 0h9.85v3.433h-9.85v-3.433Zm-.78 0v3.433h-3.08v-2.06a5.06 5.06 0 0 0 1.65-1.373h1.43Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    fill: "#fff",
    d: "M3462.19 450.92h-18.64v40.81h18.64v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    fill: "#fff",
    d: "M3462.14 511.13h-18.64v40.81h18.64v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    fill: "#fff",
    d: "M3500.4 450.76h-18.64v40.81h18.64v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    fill: "#fff",
    d: "M3500.35 510.971h-18.64v40.81h18.64v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    fill: "#CCC",
    d: "M3752.58 415.76h-231.63v67.12h231.63v-67.12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    fill: "#FFE9B3",
    d: "m3587.03 652.249 23.18.11v-8.25h-23.18v8.14Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    className: "Group",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    fill: "#FCEEC3",
    d: "M3588.3 625.99h-16.86v4.95h16.86v-4.95Z",
    className: "Vector",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    className: "Group",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    fill: "#FCEEC3",
    d: "M3643.85 550.99h-19.3v6.62h19.3v-6.62Z",
    className: "Vector",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    className: "Group",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    fill: "#FCEEC3",
    d: "M3635.74 527.85h-14.03v5.03h14.03v-5.03Z",
    className: "Vector",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    fill: "#fff",
    d: "M3580.19 597.311h-29.48v27.36h29.48v-27.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    fill: "#fff",
    d: "M3580.06 513.92h-29.3v46.1h29.3v-46.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_7",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    fill: "#CCC",
    d: "M3520.7 486.861v168.36h231.92l-.11-168.36H3520.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    fill: "#919191",
    d: "M3752.62 407.779h-231.84v7.98h231.84v-7.98Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    fill: "#919191",
    d: "M3752.51 482.869h-231.84v7.98h231.84v-7.98Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    fill: "#919191",
    d: "M3658.14 601.881h-44.41v53.09h44.41v-53.09Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows",
    className: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    fill: "#fff",
    d: "M3722.61 597.33h-29.48v27.36h29.48v-27.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    fill: "#fff",
    d: "M3722.47 513.92h-29.3v46.1h29.3v-46.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    fill: "#fff",
    d: "M3580.06 426.33h-29.3v46.1h29.3v-46.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    fill: "#fff",
    d: "M3722.35 426.33h-29.3v46.1h29.3v-46.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    fill: "#fff",
    d: "M3651.01 426.33h-29.3v46.1h29.3v-46.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    fill: "#fff",
    d: "M3651.01 513.92h-29.3v46.1h29.3v-46.1Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 32",
    fill: "#919191",
    d: "M3539.87 398.002h31v10h-31z",
    className: "Rectangle 32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "building_8",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    fill: "#EAEAEA",
    d: "M3929.85 532.15h-194.81v60.28h194.81v-60.28Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    fill: "#919191",
    d: "M3929.87 527h-203v8h203v-8Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    fill: "#919191",
    d: "M3929.86 569.279h-199.91v7.71h199.91v-7.71Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    fill: "#919191",
    d: "M3929.87 596h-33v59h33v-59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    fill: "#919191",
    d: "M3763.12 596.85h-28.08v59.16h28.08v-59.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    fill: "#919191",
    d: "M3927.88 589.521h-197.93v7.33h197.93v-7.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1039",
    className: "Group 1039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    fill: "#fff",
    d: "M3786.3 542.631h-19.22v17.84h19.22v-17.84Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    fill: "#fff",
    d: "M3838.86 542.67h-19.22v17.84h19.22v-17.84Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    fill: "#fff",
    d: "M3891.26 542.572h-19.22v17.84h19.22v-17.84Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    fill: "#CCC",
    d: "M3325.97 653.6h58.66l-.57-80.23.57-140 12.68-.27.1-11.06 11.7 5.14v-24.06h-83.14V653.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_9",
    fill: "#A3A3A3",
    d: "m3770.94 388.65-13.65-.08-1.07.08-3.63 19.46-.08 119.01h13.94l162.59.08v-52.76h-158.1v-85.79Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    fill: "#545454",
    d: "M3250.43 516.721h-4.11v137.15h4.11v-137.15Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    fill: "#545454",
    d: "M3276 528c0-1.26 0-10.24-9.91-10.24-9.31 0-9.72 8.67-9.9 11.48-.18 2.81 0 28.45 0 28.45h2.94s-.2-26.25 0-28.36c.2-2.11 0-7.94 6.74-8.25 6.49-.31 7.14 6.43 7.19 7a7.247 7.247 0 0 0-4.23 2.396 7.223 7.223 0 0 0-1.77 4.534h15.35a7.293 7.293 0 0 0-1.9-4.693A7.313 7.313 0 0 0 3276 528Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    fill: "#ADADAD",
    d: "M3260.6 531.42h-14.94v4.36h14.94v-4.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    fill: "#ADADAD",
    d: "M3260.6 548.29h-14.94v4.36h14.94v-4.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    fill: "#6D6D6D",
    d: "M3248.24 532.82a.782.782 0 0 0-.4.149.79.79 0 0 0-.25.343.87.87 0 0 0-.02.424.755.755 0 0 0 .6.552c.14.024.29.005.42-.053a.703.703 0 0 0 .32-.277.74.74 0 0 0 .12-.408.782.782 0 0 0-.24-.529.755.755 0 0 0-.55-.201Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    fill: "#282121",
    d: "M3248.24 534.38a.821.821 0 0 1-.44-.168.796.796 0 0 1-.28-.383.85.85 0 0 1-.02-.474.825.825 0 0 1 .24-.409.824.824 0 0 1 .89-.155c.15.064.28.17.37.305a.9.9 0 0 1 .13.454c0 .113-.03.225-.07.327a.972.972 0 0 1-.2.273.824.824 0 0 1-.29.177.824.824 0 0 1-.33.053Zm0-1.46a.65.65 0 0 0-.34.133c-.1.076-.17.18-.21.298a.652.652 0 0 0-.02.366.65.65 0 0 0 .52.473c.12.02.25.004.36-.048a.628.628 0 0 0 .38-.592.551.551 0 0 0-.06-.25.79.79 0 0 0-.15-.208.761.761 0 0 0-.22-.133.682.682 0 0 0-.26-.039Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    fill: "#6D6D6D",
    d: "M3257.63 534.399c.44 0 .79-.326.79-.73 0-.403-.35-.73-.79-.73-.43 0-.79.327-.79.73 0 .404.36.73.79.73Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    fill: "#282121",
    d: "M3257.63 534.5a.83.83 0 0 1-.74-1.026.758.758 0 0 1 .24-.409.824.824 0 0 1 .89-.155c.15.064.28.17.37.305a.9.9 0 0 1 .13.455c0 .113-.03.224-.07.327a.982.982 0 0 1-.2.272.824.824 0 0 1-.29.177.824.824 0 0 1-.33.054Zm0-1.46a.66.66 0 0 0-.47.172.641.641 0 0 0-.16.207c-.03.079-.05.164-.06.251 0 .183.08.358.2.488.13.129.31.202.49.202a.685.685 0 0 0 .69-.69c0-.09-.01-.18-.05-.263a.548.548 0 0 0-.15-.222.643.643 0 0 0-.49-.185v.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    fill: "#6D6D6D",
    d: "M3248.27 549.66a.761.761 0 0 0-.39.151.77.77 0 0 0-.24.339.834.834 0 0 0-.02.415c.04.138.11.262.22.359a.72.72 0 0 0 .78.133c.13-.057.24-.15.32-.269a.705.705 0 0 0 .12-.398.59.59 0 0 0-.07-.289.755.755 0 0 0-.72-.441Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    fill: "#282121",
    d: "M3248.27 551.211a.83.83 0 1 1 .4-1.587.827.827 0 0 1 .49.767.882.882 0 0 1-.27.593.878.878 0 0 1-.62.227Zm0-1.46a.648.648 0 0 0-.34.131.618.618 0 0 0-.21.296.65.65 0 0 0-.02.365.658.658 0 0 0 .51.476c.13.021.25.006.37-.043.11-.05.21-.132.28-.236.07-.104.1-.225.1-.349a.673.673 0 0 0-.21-.462.67.67 0 0 0-.48-.178Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    fill: "#6D6D6D",
    d: "M3257.66 549.77a.717.717 0 0 0-.39.148.657.657 0 0 0-.25.342.764.764 0 0 0-.03.423c.04.14.11.267.22.366a.747.747 0 0 0 .8.139.733.733 0 0 0 .38-.97.674.674 0 0 0-.18-.243.747.747 0 0 0-.55-.205Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    fill: "#282121",
    d: "M3257.66 551.33a.83.83 0 1 1 .4-1.587.833.833 0 0 1 .49.767.882.882 0 0 1-.27.593.878.878 0 0 1-.62.227Zm0-1.46a.648.648 0 0 0-.34.131.618.618 0 0 0-.21.296.65.65 0 0 0-.02.365.658.658 0 0 0 .51.477c.13.021.25.005.37-.044.11-.05.21-.132.28-.236a.615.615 0 0 0 .04-.603.514.514 0 0 0-.15-.211.64.64 0 0 0-.48-.175Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    fill: "#E2CF91",
    d: "M3283.21 534.73h-16.98v1.53h16.98v-1.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    fill: "#545454",
    d: "M3253.53 574.311h-10.7v79.55h10.7v-79.55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    fill: "#ADADAD",
    d: "M3255.33 579.97h-14.94v4.36h14.94v-4.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    fill: "#6D6D6D",
    d: "M3248.37 581.66a.71.71 0 0 0-.51.214.724.724 0 0 0-.22.516c0 .194.08.379.22.516a.71.71 0 0 0 .51.214c.2 0 .38-.077.52-.214a.713.713 0 0 0 .21-.516.714.714 0 0 0-.21-.516.733.733 0 0 0-.52-.214Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    fill: "#282121",
    d: "M3248.37 583.22a.821.821 0 0 1-.44-.168.796.796 0 0 1-.28-.383.85.85 0 0 1-.02-.474.764.764 0 0 1 .24-.41.824.824 0 0 1 .89-.154c.15.064.28.17.37.305a.9.9 0 0 1 .13.454c0 .113-.03.224-.07.327a.972.972 0 0 1-.2.273.807.807 0 0 1-.29.176c-.1.04-.21.058-.33.054Zm0-1.47a.643.643 0 0 0-.64.64.643.643 0 0 0 .64.64c.17 0 .34-.067.46-.187s.18-.283.18-.453a.633.633 0 0 0-.18-.452.658.658 0 0 0-.46-.188Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    fill: "#BACC4E",
    d: "M3589.87 633.45c.54-1.265.83-2.625.84-4 0-6.08-5.31-11-11.86-11a12.142 12.142 0 0 0-9.62 4.6 10.175 10.175 0 0 0-6.45-2.3c-5.41 0-9.8 4.07-9.8 9.09.02.335.06.67.12 1h-.71c-6.68 0-12.09 5-12.09 11.22 0 6.22 5.41 11.22 12.09 11.22 1.17 0 35.22 1.26 36.94 1.26 6.28 0 11.38-4.72 11.38-10.56.02-5.69-4.79-10.27-10.84-10.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    fill: "#BACC4E",
    d: "M3395.38 639.74h-.53c.08-.246.15-.496.2-.75a6.83 6.83 0 0 0-.22-2.698 7.004 7.004 0 0 0-1.26-2.398 6.96 6.96 0 0 0-2.09-1.721 6.877 6.877 0 0 0-2.6-.773 7.62 7.62 0 0 0-5 1.08 8.76 8.76 0 0 0-6.54-4.29c-4.8-.62-9.23 2.49-9.9 6.94a7.589 7.589 0 0 0 .18 3c-4.45-.38-8.48 2.52-9.1 6.67-.62 4.15 2.57 8.21 7.17 8.81 1.26.16 26.34 2.47 27.2 2.58 4.89.63 9.41-2.54 10.09-7.08.68-4.54-2.71-8.74-7.6-9.37Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    fill: "#544225",
    d: "M3571.22 641.72v-4.57h-1.71v9.86l-4.15-4.74-.99.74 5.14 5.86v4.05h1.71v-9.35l6.65-7.6-.97-.73-5.68 6.48Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    fill: "#544225",
    d: "M3381.18 648.78v-6.61h-1.15v3.06l-3.8-4.35-.66.5 4.46 5.09v6.27h1.15v-2.71l3.45-3.93-.67-.5-2.78 3.18Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    fill: "#B2A9A1",
    d: "M3494.71 652.679h35.42l1.95-4.49h-39.57l2.2 4.49Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    fill: "#A3A3A3",
    d: "M3347.96 546.189h-4.07v107.68h4.07v-107.68Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    fill: "#A3A3A3",
    d: "M3352.6 544.29h-13.51v31.04h13.51v-31.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    fill: "#FF000D",
    d: "M3354.42 545.84c-.77 0-1.39 1.68-1.39 3.76s.62 3.75 1.39 3.75c.77 0 1.38-1.68 1.38-3.75 0-2.07-.62-3.76-1.38-3.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    fill: "#7A7A7A",
    d: "M3354.26 544.93h-1.72l.08 8.42h1.64v-1.84l3.2-4.49v-1.41h-3.2v-.68Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    fill: "#FFF200",
    d: "M3354.31 556.51c-.77 0-1.39 1.68-1.39 3.76s.62 3.76 1.39 3.76c.77 0 1.38-1.69 1.38-3.76s-.62-3.76-1.38-3.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    fill: "#7A7A7A",
    d: "M3354.21 555.6h-1.61l-.03 8.43h1.64v-1.84l3.19-4.5v-1.4h-3.19v-.69Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    fill: "#0F0",
    d: "M3354.48 567.18c-.77 0-1.39 1.69-1.39 3.76s.62 3.76 1.39 3.76c.77 0 1.39-1.68 1.39-3.76s-.62-3.76-1.39-3.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    fill: "#7A7A7A",
    d: "M3354.33 566.27h-1.73v8.43h1.73v-1.841l3.19-4.5v-1.399h-3.19v-.69Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    fill: "#EAC632",
    d: "M3322.81 604.06h-22a3.325 3.325 0 0 0-2.38.884 3.365 3.365 0 0 0-1.06 2.306v32.51c.01.445.11.883.29 1.289.19.405.45.77.78 1.072.32.303.71.536 1.13.687.41.151.86.216 1.3.192h6.51v10.72h9.34V643h6.14c.88.033 1.74-.285 2.38-.883a3.284 3.284 0 0 0 1.06-2.307v-32.56a3.292 3.292 0 0 0-.3-1.271 3.341 3.341 0 0 0-.78-1.054c-.32-.297-.7-.526-1.11-.674a3.357 3.357 0 0 0-1.3-.191Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    fill: "#EAEAEA",
    d: "M3323.69 606.34h-23.75v34.22h23.75v-34.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    className: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    fill: "#631D0A",
    d: "m3343.89 578.25 2.03 1.13v72.95h2.03v-77.07h-4.06v2.99Z",
    className: "Vector",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    className: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    fill: "#631D0A",
    d: "M3494.54 652.33h35.74l1.63-3.75h-39.21l1.84 3.75Z",
    className: "Vector",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    className: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    fill: "#631D0A",
    d: "m3242.84 586.21 7.55 2.68.35 63.44h2.79v-68h-10.69v1.88Z",
    className: "Vector",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    className: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    fill: "#631D0A",
    d: "m3246.32 553.31 2.44 1.12.06 19.89h1.6v-21.67h-4.11l.01.66Z",
    className: "Vector",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    className: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    fill: "#631D0A",
    d: "m3246.34 536.99 2.42.559.04 10.74 1.63.091v-12.61h-4.12l.03 1.22Z",
    className: "Vector",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    className: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    fill: "#631D0A",
    d: "M3256.11 535.77v1.35l1.75.489.07 10.68h1.14l-.02-12.519h-2.94Z",
    className: "Vector",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    className: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    fill: "#631D0A",
    d: "M3256.18 552.65v1.34l1.74.49.03 3.16h1.17l-.01-4.99h-2.93Z",
    className: "Vector",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    className: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    fill: "#631D0A",
    d: "M3269.03 520.61c-3.82-1.34-7.89-.12-9.59 3.08-1.7 3.2-1.19 7.73-1.19 7.73h.82l.13-3.14c.09-1.218.34-2.421.72-3.58.35-.812.88-1.537 1.55-2.121a5.944 5.944 0 0 1 2.3-1.259c3.64-.94 6.29.21 7.73 2.29a9.605 9.605 0 0 1 1.57 4.42c-1.29.282-2.5.868-3.52 1.71a7.205 7.205 0 0 0-2.36 4.12c.02-.09.04-.177.08-.26a9.553 9.553 0 0 1 2.74-3.54 19.341 19.341 0 0 1 4.71-2.09c-.26-.043-.52-.12-.76-.23-.21-1.46-1.09-5.74-4.93-7.13Z",
    className: "Vector",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    fill: "#fff",
    d: "M3183.85 329.6h-37.28v40.81h37.28V329.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_10",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    fill: "#EAEAEA",
    d: "M3378.85 307.072h-194.97v350.36h194.97v-350.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    fill: "#CCC",
    d: "M3382.08 287.213h-198.21v19.86h198.21v-19.86Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    fill: "#CCC",
    d: "M3219.39 273.502h-10.89v16.08h10.89v-16.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    fill: "#CCC",
    d: "M3205.78 259.002h-12.99v31.76h12.99v-31.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    fill: "#CCC",
    d: "M3378.85 283.033h-37.28v5.28h37.28v-5.28Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    fill: "#fff",
    d: "M3382.08 287.213h-198.21v3.55h198.21v-3.55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1026",
    className: "Group 1026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    fill: "#fff",
    d: "M3300.03 326.982h-37.28v40.81h37.28v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    fill: "#fff",
    d: "M3363.33 326.982h-37.28v40.81h37.28v-40.81Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    fill: "#fff",
    d: "M3183.85 394.01h-37.28v40.81h37.28v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    fill: "#fff",
    d: "M3247.15 394.01h-37.28v40.81h37.28v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    fill: "#fff",
    d: "M3310.45 394.01h-37.28v40.81h37.28v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    fill: "#fff",
    d: "M3183.85 458.43h-37.28v40.81h37.28v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    fill: "#fff",
    d: "M3247.15 458.43h-37.28v40.81h37.28v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1106",
    className: "Group 1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "building_11",
    fill: "#CCC",
    d: "M4264.5 464.3h-22.67v-33.1h-19.37v33.1h-11.97v22.56h54.01v14.6h94.01V388.17h-94.01v76.13Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_12",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    fill: "#A3A3A3",
    d: "M4357.49 494.251h-175.96v82.27h175.96v-82.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1040",
    className: "Group 1040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    fill: "#fff",
    d: "M4286.33 512.06h-36.35v46.02h36.35v-46.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    fill: "#fff",
    d: "M4246.84 512.06h-36.35v46.02h36.35v-46.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    fill: "#fff",
    d: "M4325.94 512.06h-36.35v46.02h36.35v-46.02Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    fill: "#CCC",
    d: "M4355.45 484.868h-181.9v9.38h181.9v-9.38Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    fill: "#CCC",
    d: "M4357.49 576.521h-175.96v18.989h175.96v-18.989Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    fill: "#CCC",
    d: "M4201.4 595.509h-19.87v59.68h19.87v-59.68Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    fill: "#CCC",
    d: "M4358.22 590.001h-23v65h23v-65Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    fill: "#CCC",
    d: "M4358.51 490.539h-184.96v3.7h184.96v-3.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_13",
    fill: "#EAEAEA",
    d: "M4095.22 348.93h-29.83V527.2h116.14v-32.95l-7.98.19.25-9.33 36.86-.16-.2-20.59 11.96.02.04-22.85h-127.24v-92.6Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_14",
    fill: "#EAEAEA",
    d: "m4355.48 455.88-1.91.03v-4.23l1.33-.01v-30.16l-1.49-.03.03-4.23 1.98-.02.03-2.34h-62.67v58.39h-50.95V431.2h-6.88v42.08h-17.07v11.59l135.6-.03-.07-2.34 2.2-.02-.13-26.6Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("g", {
    id: "light",
    className: "light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    fill: "#4F7D99",
    d: "M4240.82 646.998h-4.85v-121.92c0-7.78 5.13-14.12 11.43-14.12s11.44 6.34 11.44 14.12v11.48h-4.85v-11.48c0-4.49-3-8.14-6.59-8.14s-6.58 3.65-6.58 8.14v121.92Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    fill: "#A9C5D3",
    d: "M4241.94 618.11h-7.11l-4.1 36.6h14.81l-3.6-36.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    fill: "#FDC800",
    d: "M4248.57 541.528v.11c0 5.06 3.32 9.17 7.43 9.17 4.11 0 7.43-4.11 7.43-9.17v-.11h-14.86Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    fill: "#A9C5D3",
    d: "M4255.99 529.591c-6 0-10.88 6.06-10.88 13.54h21.76c0-7.48-4.87-13.54-10.88-13.54Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    fill: "#fff",
    d: "M3310.45 458.43h-37.28v40.81h37.28v-40.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_15",
    fill: "#AFAFAF",
    d: "M5199.35 299.91c1.4-4 .5-7.84-2-8.54-2.5-.7-5.67 2-7.07 6a11.229 11.229 0 0 0-.63 3.81h-167.4v249.09h229.46V301.18h-52.84c.19-.413.35-.837.48-1.27Zm-141.17 8.58h-33.83v-4.8h33.83v4.8Zm39.37 0h-37.68v-4.8h37.7l-.02 4.8Zm39.1 0h-37.43v-4.8h37.43v4.8Zm55.63 0h-54v-4.8h37.35v4.74h1.67v-4.74h12.76a3.426 3.426 0 0 0 2.19 2.22l.03 2.58Zm24.11-4.8h32.73v4.8h-32.73v-4.8Zm-16 0h14.3v4.8h-14.3v-4.8Zm-1.15 0v4.8h-4.47v-2.91a7.283 7.283 0 0 0 2.41-1.89h2.06Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    fill: "#919191",
    d: "M5003.91 365.001h-84.58v-18.35h-13.25v18.35h-6.12v-35.03h-5.09v35.03h-10.28v172.44h146.19v-179.85h-26.87v7.41Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_16",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    fill: "#919191",
    d: "M4565.46 318.092h-5.34v57.13h5.34v-57.13Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    fill: "#919191",
    d: "M4574.63 336.369h-3.82v36.1h3.82v-36.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    fill: "#919191",
    d: "M4565.46 364.092h-13.16v7.62h13.16v-7.62Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    fill: "#919191",
    d: "M4647.24 352.551h4.44v-.82h-4.44v-4.24h5.62v-.82h-5.62v-3.48h9v-.83h-9v-1.39h-1.28v1.39h-8.79v.83h8.79v3.48h-5.6v.82h5.6v4.24h-4.4v.82h4.4v15.98h-103.69v295.52h134.43v-295.52h-29.46v-15.98Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "building_17",
    fill: "#CCC",
    d: "M5229.51 474.921h-22.52v-32.133h-19.23v32.133h-11.89v21.908h53.64v14.173h93.36v-110h-93.36v73.919Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_18",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    fill: "#EAEAEA",
    d: "M5151.59 540.432h-194.81v58.27h194.81v-58.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    fill: "#919191",
    d: "M5146.92 535.639h-198.55v7.46h198.55v-7.46Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    fill: "#919191",
    d: "M5151.6 576.311h-199.91v7.46h199.91v-7.46Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    fill: "#919191",
    d: "M5147.93 601.67h-29.04v57.19h29.04v-57.19Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    fill: "#919191",
    d: "M4984.86 602.959h-28.08v57.19h28.08v-57.19Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    fill: "#919191",
    d: "M5149.62 595.881h-197.93v7.08h197.93v-7.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1050",
    className: "Group 1050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    fill: "#fff",
    d: "M5008.03 550.549h-19.22v17.24h19.22v-17.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    fill: "#fff",
    d: "M5060.6 550.592h-19.22v17.24h19.22v-17.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    fill: "#fff",
    d: "M5113 550.502h-19.22v17.24H5113v-17.24Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "building_19",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    fill: "#A3A3A3",
    d: "M5322.88 503.791h-175.96v79.52h175.96v-79.52Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    fill: "#FFF9F0",
    d: "M5320.84 494.721h-181.9v9.06h181.9v-9.06Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    fill: "#CCC",
    d: "M5322.88 583.311h-175.96v18.36h175.96v-18.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    fill: "#CCC",
    d: "M5166.79 601.67h-19.87v54.92h19.87v-54.92Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    fill: "#CCC",
    d: "M5322.87 602.002h-23v55h23v-55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    fill: "#CCC",
    d: "M5323.9 500.209h-184.96v3.58h184.96v-3.58Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    fill: "#EAEAEA",
    d: "M5060.69 371h-29.82v172.31h116.14v-31.85l-7.99.19.26-9.03 36.86-.15-.21-19.9 11.97.02.04-22.09h-127.25V371Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    fill: "#CCC",
    d: "M4547.71 657.82h58.65l-.56-77.56.56-135.31 12.68-.27.11-10.68 11.7 4.97v-23.26h-83.14v242.11Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    fill: "#A3A3A3",
    d: "m4983.3 409.08-13.65-.08-1.08.08-3.63 18.81-.07 115.04h13.93l42.6.07v-50.99h-38.1v-82.93Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_20",
    fill: "#EAEAEA",
    d: "m5320.87 466.7-1.91.03v-4.08l1.32-.02v-29.15l-1.48-.02.03-4.09 1.97-.02.04-2.26h-62.68v56.44h-50.95v-40.68h-6.88v40.68h-17.07v11.2l135.6-.03-.06-2.26 2.2-.02-.13-25.72Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_21",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    fill: "#EAEAEA",
    d: "M4547.71 325.4h-194.97v338.65h194.97V325.4Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    fill: "#CCC",
    d: "M4550.94 306.201h-198.21v19.19h198.21v-19.19Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    fill: "#CCC",
    d: "M4550.94 579.35h-198.2v9.14h198.2v-9.14Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    fill: "#CCC",
    d: "M4388.25 292.951h-10.88v15.54h10.88v-15.54Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    fill: "#CCC",
    d: "M4374.64 278.932h-12.99v30.7h12.99v-30.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    fill: "#CCC",
    d: "M4547.72 302.17h-37.28v5.1h37.28v-5.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    fill: "#CCC",
    d: "M4550.94 306.201h-198.21v3.43h198.21v-3.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1044",
    className: "Group 1044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    fill: "#fff",
    d: "M4405.59 344.639h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    fill: "#fff",
    d: "M4468.9 344.639h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    fill: "#fff",
    d: "M4532.18 344.639h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    fill: "#fff",
    d: "M4405.59 406.912h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    fill: "#fff",
    d: "M4468.9 406.912h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    fill: "#fff",
    d: "M4532.18 406.912h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    fill: "#fff",
    d: "M4405.59 469.17h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    fill: "#fff",
    d: "M4468.9 469.17h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    fill: "#fff",
    d: "M4532.18 469.17h-37.28v39.45h37.28v-39.45Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    fill: "#BACC4E",
    d: "M2514.87 656.76S2606.26 249 2962.26 249s444.37 407.76 444.37 407.76h-891.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    className: "Group",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    fill: "#fff",
    d: "M1062.33 151.43c3.37.01 2.94 0 0 0Z",
    className: "Vector",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    fill: "#A3A3A3",
    d: "M1931.34 261.189h-93.67v12.7h-5.01v187.66h103.94v-187.66h-5.26v-12.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "buildings",
    className: "buildings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    fill: "#A3A3A3",
    d: "M2010.17 268.072h-60.72v88.95h60.72v-88.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    fill: "#A3A3A3",
    d: "M2074.79 277.272h-10.7v-45.77h-37.19v61.59h-28.2v26.62h28.2v20.21h37.19v-13.31h52.15v-71.37h-41.45v22.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    fill: "#A3A3A3",
    d: "M2162.94 296.729h-54.86v35.65h82.89v-105.85h-28.03v70.2Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "building_22",
    fill: "#A3A3A3",
    d: "M1512.78 247.54h-38.91v53.89h-66.22v21.17h-35.33v73.78h35.33v8.88h122.5V301.43h-17.37v-53.89Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_23",
    fill: "#AFAFAF",
    d: "M1814.72 278.61c1.39-4.23.49-8.26-2-9-2.49-.74-5.68 2.09-7.07 6.31-.43 1.29-.64 2.641-.64 4h-167.39V542.2h229.46V279.94h-52.89c.19-.43.37-.87.53-1.33Zm-141.17 9h-33.84v-5.06h33.84v5.06Zm39.37 0h-37.71v-5.06h37.71v5.06Zm39.1 0h-37.44v-5.06h37.44v5.06Zm55.63 0h-54v-5.06H1791v5h1.66v-5h12.76c.16.537.44 1.03.82 1.439.38.408.86.72 1.38.911l.03 2.71Zm24.1-5.06h32.74v5.06h-32.74v-5.06Zm-16 0h14.3v5.06h-14.3v-5.06Zm-1.14 0v5.06h-4.47v-3.06a7.377 7.377 0 0 0 2.4-2h2.07Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_24",
    fill: "#CCC",
    d: "M1619.27 347.14h-84.58v-19.33h-13.25v19.33h-6.11v-36.89h-5.1v36.89h-10.27v181.54h146.19V339.33h-26.88v7.81Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_25",
    fill: "#AFAFAF",
    d: "M1262.6 334.03h4.45v-.87h-4.45v-4.46h5.63v-.87h-5.63v-3.66h9v-.87h-9v-1.47h-1.27v1.47h-8.79v.87h8.79v3.66h-5.6v.87h5.6v4.46h-4.4v.87h4.4v16.82h-103.69v311.14h134.42V350.85h-29.46v-16.82Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    fill: "#919191",
    d: "M2084.9 600.16h-44.41v54.02h44.41v-54.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    className: "Group",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    fill: "#FCEEC3",
    d: "M1480.95 551h-19.3v6.74h19.3V551Z",
    className: "Vector",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    className: "Group",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    fill: "#FCEEC3",
    d: "M1472.84 527.46h-14.03v5.12h14.03v-5.12Z",
    className: "Vector",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 970",
    className: "Group 970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    fill: "#EAEAEA",
    d: "M1589.68 413.381h-231.63v68.3h231.63v-68.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    fill: "#EAEAEA",
    d: "M1357.8 485.752v169.6h231.92l-.11-169.6H1357.8Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    fill: "#EAEAEA",
    d: "M1589.72 405.26h-231.84v8.12h231.84v-8.12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    fill: "#EAEAEA",
    d: "M1589.61 481.682h-231.84v8.12h231.84v-8.12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    fill: "#919191",
    d: "M1495.79 600.162h-44.41v55.19h44.41v-55.19Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows_2",
    className: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    fill: "#fff",
    d: "M1559.71 598.162h-29.48v27.84h29.48v-27.84Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    fill: "#fff",
    d: "M1417.29 598.139h-29.48v27.84h29.48v-27.84Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    fill: "#fff",
    d: "M1417.16 513.279h-29.3v46.91h29.3v-46.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    fill: "#fff",
    d: "M1559.58 513.279h-29.3v46.91h29.3v-46.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    fill: "#fff",
    d: "M1417.16 424.139h-29.3v46.91h29.3v-46.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    fill: "#fff",
    d: "M1559.45 424.139h-29.3v46.91h29.3v-46.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    fill: "#fff",
    d: "M1488.11 424.139h-29.3v46.91h29.3v-46.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    fill: "#fff",
    d: "M1488.11 513.279h-29.3v46.91h29.3v-46.91Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    fill: "#EAEAEA",
    d: "M1763.3 596.311h-29.04v60.21h29.04v-60.21Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    fill: "#EAEAEA",
    d: "M1600.22 597.67h-28.08v60.21h28.08v-60.21Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_26",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    fill: "#EAEAEA",
    d: "M1766.95 531.83h-194.81v61.35h194.81v-61.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    fill: "#CCC",
    d: "M1762.28 526.791h-198.55v7.85h198.55v-7.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    fill: "#CCC",
    d: "M1766.96 569.611h-199.91v7.85h199.91v-7.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    fill: "#CCC",
    d: "M1764.98 590.209h-197.93v7.46h197.93v-7.46Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows_3",
    className: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    fill: "#fff",
    d: "M1623.4 542.49h-19.22v18.15h19.22v-18.15Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    fill: "#fff",
    d: "M1675.97 542.529h-19.22v18.15h19.22v-18.15Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    fill: "#fff",
    d: "M1728.36 542.439h-19.22v18.15h19.22v-18.15Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "building_27",
    fill: "#A3A3A3",
    d: "M1675.97 345.38h-29.82v181.41h116.13v-33.53l-7.98.2.25-9.5 36.86-.17-.2-20.95 11.96.02.04-23.25h-127.24v-94.23Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hill",
    className: "hill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hill-outline",
    className: "hill-outline",
    filter: "url(#filter0_f_5370_44915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    fill: "url(#paint0_linear_5370_44915)",
    stroke: "url(#paint1_linear_5370_44915)",
    strokeWidth: 6,
    d: "m2977.87 655.22-2.92-.656-.82 3.656h677.16l-.79-3.635-2.93.635c2.93-.635 2.93-.637 2.93-.641v-.013l-.01-.046c-.01-.04-.02-.099-.04-.176-.02-.1-.05-.231-.09-.393-.02-.086-.04-.18-.06-.283-.14-.593-.34-1.467-.62-2.602a327.34 327.34 0 0 0-2.59-9.81c-2.35-8.436-6.01-20.47-11.23-34.904-10.45-28.858-27.19-67.359-52.35-105.882C3533.18 423.41 3448.94 346 3313.87 346c-135.06 0-219.88 77.405-270.78 154.456-25.45 38.521-42.47 77.02-53.14 105.877-5.33 14.434-9.08 26.467-11.49 34.903a311.238 311.238 0 0 0-2.66 9.809c-.29 1.135-.5 2.009-.64 2.602-.07.296-.12.522-.16.676-.02.077-.03.136-.04.176l-.01.047v.012c0 .004 0 .006 2.92.662Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    fill: "#A3B212",
    d: "M2977.87 655.22s68.59-306.22 336-306.22c267.41 0 333.7 306.22 333.7 306.22h-669.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hill-elements",
    className: "hill-elements"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bush_3",
    className: "bush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    fill: "#44AA85",
    d: "M3431.01 526.001c1.15.068 2.26.464 3.18 1.141a5.952 5.952 0 0 1 2.06 2.679 5.607 5.607 0 0 1 1.92-2.423 5.551 5.551 0 0 1 2.92-1.017c3.12 0 5.64 3.16 5.64 7.05a8.335 8.335 0 0 1-.75 3.51h.06c3.31 0 6 3.35 6 7.48 0 4.13-2.68 7.48-6 7.48s-16.2-.71-18.48-.71c-3.33 0-2.58-13.49-2.58-17.65 0-4.16 2.7-7.54 6.03-7.54Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    fill: "#4FC99A",
    d: "M3412.04 538.51h.3a5.805 5.805 0 0 1 0-.59c0-2.82 1.83-5.1 4.09-5.1.52.011 1.03.132 1.49.354.47.223.88.542 1.21.936.38-.747.95-1.38 1.65-1.835a4.74 4.74 0 0 1 2.35-.754c2.74 0 5 2.77 5 6.19 0 .767-.12 1.529-.36 2.259 2.52.15 4.53 2.72 4.53 5.9s-2.13 5.94-4.75 5.94c-.72 0-14.94-.71-15.43-.71-2.78 0-5-2.82-5-6.31 0-3.49 2.14-6.28 4.92-6.28Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "desk",
    className: "desk"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    fill: "#CCC",
    d: "M3512.55 529.58h-15.34a1.375 1.375 0 0 1-.88-.484 1.392 1.392 0 0 1-.33-.956l-1.61-27.74c-.05-.368.03-.744.24-1.054.21-.31.52-.529.88-.616.66-.06 1.24.58 1.29 1.44l1.53 26.31h13v-10a1.345 1.345 0 0 1-.01-.565c.04-.187.12-.362.24-.513.11-.151.26-.273.43-.357a1.265 1.265 0 0 1 1.11 0c.17.084.32.206.43.357a1.2 1.2 0 0 1 .22 1.078v11.6a1.401 1.401 0 0 1-1.2 1.5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    fill: "#CCC",
    d: "M3485.28 529.58h-15.33a1.431 1.431 0 0 1-1.22-1.55v-11.6a1.326 1.326 0 0 1 .23-1.067 1.272 1.272 0 0 1 .99-.477c.19 0 .37.043.54.125.17.083.32.203.44.352.12.148.2.322.24.506.04.185.04.377-.01.561v10h13l1.53-26.31c.05-.86.63-1.5 1.3-1.44.36.086.68.306.89.615.21.31.29.686.23 1.055l-1.63 27.82c.01.342-.1.677-.32.938-.23.261-.54.429-.88.472Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    fill: "#F3D69E",
    d: "M3505.45 500.28h-28.4a1.878 1.878 0 0 1-1.22-.707 1.87 1.87 0 0 1-.4-1.363v-4.14a1.87 1.87 0 0 1 .4-1.363c.3-.386.74-.64 1.22-.707h28.4c.49.067.93.321 1.23.707.3.387.45.875.39 1.363v4.1c.07.494-.07.993-.37 1.388-.31.395-.75.655-1.25.722Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    fill: "#EDC472",
    d: "M3505.45 492h-1v5.28c.02.147.01.296-.04.439a1.09 1.09 0 0 1-.54.671c-.13.071-.27.115-.42.13h-28.06c.01.437.18.856.47 1.18.3.323.7.529 1.13.58h28.4c.49-.067.93-.321 1.23-.707.3-.387.44-.875.39-1.363v-4.14c.05-.479-.08-.96-.37-1.345a1.877 1.877 0 0 0-1.19-.725Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    fill: "#F3D69E",
    d: "M3519.01 516.429h-12.91a1.878 1.878 0 0 1-1.23-.708c-.3-.386-.44-.874-.39-1.362v-2.07c-.05-.488.09-.977.39-1.363.3-.386.74-.64 1.23-.707h12.91a1.89 1.89 0 0 1 1.61 2.07v2.07a1.9 1.9 0 0 1-.38 1.362c-.3.386-.74.64-1.23.708Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    fill: "#EDC472",
    d: "M3519.01 510.219h-.32v4a1.118 1.118 0 0 1-1 1.24h-13c.12.265.31.492.55.656.23.165.51.259.8.274h12.91c.49-.068.93-.322 1.23-.708.3-.387.44-.875.38-1.362v-2.07a1.84 1.84 0 0 0-.38-1.317c-.28-.375-.7-.63-1.17-.713Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    fill: "#F3D69E",
    d: "M3476.4 516.429h-12.91a1.884 1.884 0 0 1-1.22-.708c-.3-.387-.44-.875-.39-1.362v-2.07a1.89 1.89 0 0 1 1.61-2.07h12.91c.49.069.93.324 1.23.71.3.386.44.873.38 1.36v2.07c.06.487-.08.975-.38 1.362-.3.386-.74.64-1.23.708Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    fill: "#EDC472",
    d: "M3476.4 510.219h-.32v4a1.118 1.118 0 0 1-1 1.24h-13a1.59 1.59 0 0 0 1.35.93h12.91c.49-.068.93-.322 1.23-.708.3-.387.44-.875.38-1.362v-2.07a1.84 1.84 0 0 0-.38-1.317c-.28-.375-.7-.63-1.17-.713Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_3",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    fill: "#C0EA6E",
    d: "M3564.2 511.998a10.373 10.373 0 0 0 1.7-5.77c0-5-3.38-9.12-7.74-9.68-.78-4.48-4.32-7.86-8.57-7.86s-7.78 3.38-8.57 7.86c-4.35.56-7.74 4.68-7.74 9.68a10.49 10.49 0 0 0 1.7 5.78 5.234 5.234 0 0 0-1.27 1.813 5.247 5.247 0 0 0-.42 2.176c.01.747.18 1.482.5 2.158.32.676.78 1.277 1.34 1.763-.26.939-.39 1.907-.39 2.88 0 5.38 3.91 9.75 8.74 9.75a8.122 8.122 0 0 1 2.73-2 8.101 8.101 0 0 1 6.62 0 8.122 8.122 0 0 1 2.73 2c4.83 0 8.74-4.37 8.74-9.75 0-.942-.12-1.88-.37-2.79a5.142 5.142 0 0 0 1.49-1.818c.35-.714.52-1.498.51-2.292a5.225 5.225 0 0 0-.44-2.135 5.22 5.22 0 0 0-1.29-1.765Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    fill: "#72493E",
    d: "M3551.17 529.021H3548v29.76h3.17v-29.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    fill: "#A3E440",
    d: "M3564.2 511.999a10.373 10.373 0 0 0 1.7-5.77 10.1 10.1 0 0 0-1.02-4.552 10.123 10.123 0 0 0-2.98-3.598c.61 2.133.92 4.341.92 6.56 0 11.87-8.63 21.49-19.27 21.49a17.595 17.595 0 0 1-8.81-2.37c.43 4.93 4.16 8.79 8.7 8.79a8.086 8.086 0 0 1 12.08 0c4.83 0 8.74-4.37 8.74-9.75 0-.942-.12-1.88-.37-2.79a5.145 5.145 0 0 0 1.49-1.819c.35-.713.52-1.498.51-2.291a5.044 5.044 0 0 0-.43-2.13 5.175 5.175 0 0 0-1.26-1.77Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bin",
    className: "bin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    fill: "#CCC",
    d: "M3483.64 543.15v-.33a3.605 3.605 0 0 0-.88-2.589 3.589 3.589 0 0 0-2.44-1.231h-2.18a3.61 3.61 0 0 0-2.44 1.231 3.605 3.605 0 0 0-.88 2.589c-.01.136-.01.273 0 .41-1.4.713-2.65 1.7-3.66 2.902a11.755 11.755 0 0 0-2.25 4.098c-.05.17.31.23 1 .22v20.54h18.81v-20.53c.64 0 1 0 .94-.22a11.713 11.713 0 0 0-2.28-4.167 11.601 11.601 0 0 0-3.74-2.923Zm-4.3-1c-.92.014-1.83.152-2.72.41.03-.405.2-.787.48-1.075.29-.289.67-.464 1.07-.495h2.18c.4.03.77.2 1.05.481.29.28.46.652.49 1.049a9.836 9.836 0 0 0-2.55-.37Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    fill: "#878787",
    d: "M3489.9 549.141h-21.03v1.49h21.03v-1.49Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1002",
    className: "Group 1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    fill: "#878787",
    d: "M3471.87 551.953a.59.59 0 0 0-.21.058.648.648 0 0 0-.17.134.497.497 0 0 0-.11.191.795.795 0 0 0-.03.217v16.71c0 .074.01.148.03.218.02.07.06.135.11.19.05.056.11.102.17.135.07.033.14.052.21.057a.591.591 0 0 0 .39-.194.59.59 0 0 0 .13-.406v-16.71a.588.588 0 0 0-.13-.405.592.592 0 0 0-.39-.195Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    fill: "#878787",
    d: "M3476.83 551.93a.589.589 0 0 0-.21.057.522.522 0 0 0-.17.135.486.486 0 0 0-.11.19.797.797 0 0 0-.03.218v16.71c0 .073.01.147.03.217.02.07.06.135.11.191.05.056.1.101.17.134a.59.59 0 0 0 .21.058.548.548 0 0 0 .38-.195.55.55 0 0 0 .14-.405v-16.71a.553.553 0 0 0-.14-.406.543.543 0 0 0-.38-.194Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    fill: "#878787",
    d: "M3481.73 551.98a.585.585 0 0 0-.52.61v16.7c-.01.075 0 .152.02.224a.533.533 0 0 0 .51.379.533.533 0 0 0 .51-.379.562.562 0 0 0 .01-.224v-16.7a.567.567 0 0 0-.14-.412.587.587 0 0 0-.39-.198Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    fill: "#878787",
    d: "M3486.69 551.961a.564.564 0 0 0-.38.198.567.567 0 0 0-.14.412v16.7c-.01.075 0 .151.02.224.02.073.06.14.11.197a.527.527 0 0 0 .8 0 .506.506 0 0 0 .11-.197.563.563 0 0 0 .01-.224v-16.7c.01-.075 0-.15-.02-.221a.673.673 0 0 0-.11-.194.566.566 0 0 0-.4-.195Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1115",
    className: "Group 1115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    fill: "#CCC",
    d: "M3291.28 432.999c.01-.09.01-.18 0-.27.05-.77-.2-1.529-.71-2.113a2.932 2.932 0 0 0-1.99-1.007h-1.79c-.77.062-1.48.423-1.99 1.007-.5.584-.76 1.343-.71 2.113v.33a9.602 9.602 0 0 0-4.82 5.73c0 .15.25.19.79.19v16.76h15.35v-16.8c.52 0 .81 0 .77-.18a9.564 9.564 0 0 0-1.85-3.385 9.632 9.632 0 0 0-3.05-2.375Zm-3.5-.82c-.75.007-1.5.121-2.23.34.02-.331.16-.644.39-.881s.54-.383.87-.409h1.79a1.357 1.357 0 0 1 1.25 1.25 8.006 8.006 0 0 0-2.07-.32v.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    fill: "#878787",
    d: "M3296.39 437.859h-17.16v1.22h17.16v-1.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    fill: "#878787",
    d: "M3281.67 440.16a.46.46 0 0 0-.42.49v13.63c-.01.061 0 .124.01.184.02.059.05.114.09.162.04.047.09.084.15.11a.416.416 0 0 0 .5-.11.506.506 0 0 0 .09-.162c.02-.06.02-.123.01-.184v-13.63a.36.36 0 0 0-.02-.178.458.458 0 0 0-.41-.312Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    fill: "#878787",
    d: "M3285.72 440.14a.46.46 0 0 0-.42.49v13.63c-.01.061 0 .124.01.183.02.06.05.115.09.162.04.047.09.085.15.111.05.026.12.039.18.039a.45.45 0 0 0 .18-.039.473.473 0 0 0 .23-.273.378.378 0 0 0 .01-.183v-13.63a.364.364 0 0 0-.02-.179.478.478 0 0 0-.23-.265.499.499 0 0 0-.18-.046Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    fill: "#878787",
    d: "M3289.73 440.18a.421.421 0 0 0-.17.046.478.478 0 0 0-.23.265.547.547 0 0 0-.03.179v13.64c-.01.061 0 .124.01.183.02.06.05.115.09.162.04.047.09.085.15.111.05.026.12.039.18.039a.45.45 0 0 0 .18-.039.473.473 0 0 0 .23-.273.378.378 0 0 0 .01-.183v-13.64a.46.46 0 0 0-.42-.49Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    fill: "#878787",
    d: "M3293.77 440.17a.46.46 0 0 0-.42.49v13.63c-.01.061 0 .124.01.183.02.06.05.115.09.162.04.047.09.085.15.111.05.026.12.039.18.039a.45.45 0 0 0 .18-.039.473.473 0 0 0 .23-.273.378.378 0 0 0 .01-.183v-13.63a.36.36 0 0 0-.02-.178.458.458 0 0 0-.41-.312Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1118",
    className: "Group 1118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    fill: "#CBC4CC",
    d: "m3362.54 408.17-3.49-2.87 3.37-22.07a.594.594 0 0 0-.08-.467.62.62 0 0 0-.38-.283.533.533 0 0 0-.23.015.537.537 0 0 0-.21.107.612.612 0 0 0-.22.408l-.61 4h-2.82l.38-3.78a.574.574 0 0 0-.11-.455.612.612 0 0 0-.39-.255.533.533 0 0 0-.23.028.574.574 0 0 0-.35.31.627.627 0 0 0-.06.232l-.4 3.92h-3.45l.19-3.81a.654.654 0 0 0-.12-.451.643.643 0 0 0-.41-.239c-.16 0-.31.064-.43.178a.633.633 0 0 0-.18.432l-.2 3.89h-3.45v-3.85a.506.506 0 0 0-.02-.244.47.47 0 0 0-.12-.215.563.563 0 0 0-.19-.146.61.61 0 0 0-.24-.051.6.6 0 0 0-.44.197.775.775 0 0 0-.12.215.668.668 0 0 0-.02.244V387h-3.08v-3.85a.51.51 0 0 0-.02-.245.472.472 0 0 0-.12-.214.563.563 0 0 0-.19-.146.61.61 0 0 0-.24-.051.6.6 0 0 0-.44.197.784.784 0 0 0-.12.214.676.676 0 0 0-.02.245V387h-3.46l-.19-3.89a.59.59 0 0 0-.18-.432.603.603 0 0 0-.43-.178.64.64 0 0 0-.4.24.665.665 0 0 0-.14.45l.2 3.81h-3.46l-.4-3.92c0-.08-.02-.158-.05-.229a.53.53 0 0 0-.14-.19.646.646 0 0 0-.2-.12.62.62 0 0 0-.24-.031.612.612 0 0 0-.39.255.665.665 0 0 0-.11.455l.38 3.78h-2.87l-.61-4a.598.598 0 0 0-.06-.227.645.645 0 0 0-.15-.181.591.591 0 0 0-.45-.122.648.648 0 0 0-.38.283.69.69 0 0 0-.08.467l3.37 22.07-3.49 2.87c-.12.11-.2.261-.23.426-.02.165.01.333.1.474.04.067.09.124.16.169a.526.526 0 0 0 .64-.029l3.63-3h24.64l3.63 3c.1.075.21.118.33.12a.565.565 0 0 0 .47-.26.717.717 0 0 0 .1-.474.663.663 0 0 0-.23-.426l-.05.01Zm-10.25-3.23.17-3.2h2.7l-.33 3.2h-2.54Zm-3.68 0v-3.2h2.7l-.16 3.2h-2.54Zm-7.92 0-.16-3.2h2.7v3.2h-2.54Zm-3.69 0-.32-3.2h2.7l.16 3.2H3337Zm22.32-9h-2.45l.33-3.2h2.58l-.46 3.2Zm-3.57 0h-3l.17-3.2h3.16l-.33 3.2Zm-4.14 0h-3v-3.2h3.16l-.16 3.2Zm-7.23 1.3h3.08v3.2h-3.08v-3.2Zm-1.15 3.2h-2.77l-.16-3.2h2.93v3.2Zm5.38-3.2h2.93l-.16 3.2h-2.77v-3.2Zm-1.15-1.3h-3.08v-3.2h3.08v3.2Zm-4.23 0h-3l-.16-3.2h3.16v3.2Zm-4.14 0h-3l-.33-3.2h3.16l.17 3.2Zm-4.15 0h-2.42l-.49-3.2h2.58l.33 3.2Zm-2.22 1.3h2.35l.33 3.2h-2.19l-.49-3.2Zm3.5 0h2.93l.17 3.2h-2.77l-.33-3.2Zm8.16 4.49h3.08v3.2h-3.08v-3.2Zm8.14-1.29.17-3.2h2.93l-.33 3.2h-2.77Zm4.25-3.2h2.35l-.49 3.2h-2.19l.33-3.2Zm3.72-9-.48 3.2h-2.65l.32-3.2h2.81Zm-4 0-.32 3.2h-3.23l.16-3.2h3.39Zm-4.53 0-.17 3.2h-3.22v-3.2h3.39Zm-4.54 0v3.2h-3.08v-3.2h3.08Zm-4.23 0v3.2h-3.23l-.16-3.2h3.39Zm-4.54 0 .17 3.2h-3.23l-.32-3.2h3.38Zm-4.54 0 .33 3.2h-2.57l-.49-3.2h2.73Zm-.75 13.48h2.13l.32 3.2h-2l-.45-3.2Zm22.59 3.2.32-3.2h2.12l-.48 3.2h-1.96Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    fill: "#918291",
    d: "M3329.64 409.309v-25.67a.502.502 0 0 1 .12-.352.5.5 0 0 1 .33-.168h31.66c.13.011.25.071.33.168a.46.46 0 0 1 .12.352v25.64l2.67 1.32v-28.34c.02-.266-.01-.534-.1-.788a2.007 2.007 0 0 0-.39-.688c-.18-.201-.4-.364-.64-.479-.24-.116-.5-.182-.77-.195h-34.1c-.27.012-.53.077-.77.192s-.46.278-.64.478a2.04 2.04 0 0 0-.4.69c-.08.254-.12.523-.1.79v28.34l2.68-1.29Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1116",
    className: "Group 1116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    fill: "#72493E",
    d: "M3253.82 472.1h-2.81v14.94h2.81V472.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    fill: "#4FC99A",
    d: "M3258.03 467.12c0 5.5-2.52 10-5.62 10s-5.62-4.46-5.62-10c0-17.43 2.52-39.85 5.62-39.85s5.62 22.42 5.62 39.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    fill: "#44AA85",
    d: "M3251.01 467.12c0-14.3 1.27-31.92 3-37.81-.51-1.29-1.05-2-1.61-2-3.1 0-5.62 22.42-5.62 39.85 0 5.5 2.52 10 5.62 10 .57-.02 1.12-.178 1.61-.46-1.73-1.31-3-5.08-3-9.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    fill: "#72493E",
    d: "M3243.77 466.17h-4.02v21.38h4.02v-21.38Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    fill: "#4FC99A",
    d: "M3249.8 459c0 7.88-3.6 14.26-8 14.26s-8-6.38-8-14.26c0-24.94 3.6-57 8-57s8 32.1 8 57Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    fill: "#44AA85",
    d: "M3239.75 459c0-20.46 1.82-45.67 4.31-54.1-.73-1.85-1.5-2.921-2.3-2.921-4.44 0-8 32.08-8 57 0 7.88 3.6 14.261 8 14.261.81-.031 1.6-.258 2.3-.66-2.49-1.71-4.31-7.09-4.31-13.58Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    fill: "#A3E440",
    d: "M3144.66 474.68h-.3c.03-.199.05-.4.05-.6 0-2.89-1.88-5.231-4.2-5.231-.52.014-1.04.139-1.52.366-.47.228-.9.553-1.24.954a4.857 4.857 0 0 0-4.12-2.649c-2.81 0-5.08 2.839-5.08 6.339 0 .788.12 1.57.36 2.321-2.59.15-4.65 2.8-4.65 6.06s2.18 6.09 4.88 6.09c.73 0 15.32-.731 15.82-.731 2.86 0 5.18-2.889 5.18-6.469 0-3.58-2.32-6.45-5.18-6.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1114",
    className: "Group 1114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    fill: "#CCC",
    d: "M3215 485.999h-13.73a1.228 1.228 0 0 1-.79-.433c-.2-.24-.3-.545-.29-.857l-1.45-24.85c-.05-.33.02-.667.21-.945.18-.278.47-.476.79-.555.6 0 1.12.52 1.16 1.29l1.37 23.56h11.65v-9a1.04 1.04 0 0 1 0-.496c.03-.164.11-.317.21-.448.11-.132.24-.238.39-.311a1.127 1.127 0 0 1 .97 0c.15.073.28.179.38.311.11.131.18.284.22.448.03.164.03.333-.01.496v10.38c.04.33-.05.662-.25.926-.2.263-.5.437-.83.484Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    fill: "#CCC",
    d: "M3190.57 486h-13.7c-.32-.048-.62-.22-.82-.481-.21-.261-.3-.59-.27-.919v-10.36a1.233 1.233 0 0 1-.01-.506c.04-.167.11-.324.21-.459.11-.135.24-.244.4-.319a1.102 1.102 0 0 1 .98 0c.15.075.29.184.39.319.11.135.18.292.21.459.04.167.03.34-.01.506v9h11.64l1.37-23.56c.05-.77.57-1.34 1.17-1.29.33.081.61.279.79.556.19.278.26.614.21.944l-1.45 24.85c.01.311-.1.613-.31.846-.2.234-.49.381-.8.414Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    fill: "#F3D69E",
    d: "M3208.64 459.77h-25.44c-.43-.06-.83-.287-1.1-.632a1.718 1.718 0 0 1-.35-1.218v-3.71a1.694 1.694 0 0 1 1.45-1.86h25.44c.44.06.83.287 1.11.635.27.347.39.787.34 1.225v3.71c.05.436-.08.873-.35 1.218-.27.345-.66.572-1.1.632Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    fill: "#EDC472",
    d: "M3208.64 452.35h-.87v4.74c.03.261-.04.523-.2.731-.16.208-.4.344-.66.379h-25.14c.01.39.16.765.42 1.054.26.289.62.472 1.01.516h25.44c.44-.06.83-.287 1.1-.632.27-.345.4-.782.35-1.218v-3.71c.05-.438-.07-.878-.34-1.225a1.716 1.716 0 0 0-1.11-.635Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    fill: "#F3D69E",
    d: "M3220.78 474.24h-11.56a1.698 1.698 0 0 1-1.45-1.86v-1.85c-.04-.437.08-.876.35-1.222a1.71 1.71 0 0 1 1.1-.638h11.56c.44.062.83.291 1.1.638.27.346.4.785.35 1.222v1.85c.05.438-.07.877-.34 1.225a1.72 1.72 0 0 1-1.11.635Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    fill: "#EDC472",
    d: "M3220.78 468.67h-.29v3.62a.942.942 0 0 1-.2.738 1 1 0 0 1-.66.382h-11.62c.11.237.28.44.49.586.21.147.46.231.72.244h11.56c.44-.06.83-.288 1.11-.635.27-.348.39-.787.34-1.225v-1.85c.05-.437-.08-.876-.35-1.222a1.687 1.687 0 0 0-1.1-.638Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    fill: "#F3D69E",
    d: "M3182.62 474.24h-11.57a1.665 1.665 0 0 1-1.09-.638c-.27-.348-.4-.786-.35-1.222v-1.85a1.705 1.705 0 0 1 1.44-1.86h11.57c.44.062.83.291 1.1.638.27.346.4.785.35 1.222v1.85c.05.438-.07.877-.34 1.225a1.72 1.72 0 0 1-1.11.635Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    fill: "#EDC472",
    d: "M3182.62 468.67h-.29v3.62c.02.131.01.263-.02.391-.04.127-.1.246-.18.35a.942.942 0 0 1-.3.256.97.97 0 0 1-.37.123h-11.59c.11.235.27.437.49.584.21.146.46.231.71.246h11.57c.44-.06.83-.288 1.11-.635.27-.348.39-.787.34-1.225v-1.85c.05-.44-.08-.881-.35-1.229a1.725 1.725 0 0 0-1.12-.631Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1113",
    className: "Group 1113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    fill: "#91DC5A",
    d: "M3183.06 405.149a11.727 11.727 0 0 0-1.62-3.8 10.785 10.785 0 0 0-3.7-3.45.547.547 0 0 0-.64.08.456.456 0 0 0-.14.289c-.01.11.02.22.08.311a14.324 14.324 0 0 1 2.52 7.28c.1 1.165.04 2.338-.16 3.49a.51.51 0 0 0 .01.213c.02.07.05.134.1.187a.518.518 0 0 0 .4.18h2.96c.13.001.24-.041.34-.12a.526.526 0 0 0 .17-.31 13 13 0 0 0-.32-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    fill: "#4CBA68",
    d: "M3186.24 401.629a14.31 14.31 0 0 0-6.36-7.44.547.547 0 0 0-.64.08.456.456 0 0 0-.14.289c-.01.11.02.221.08.311 2 2.897 3.17 6.28 3.39 9.79.12 1.566.05 3.142-.22 4.69a.51.51 0 0 0 .01.213c.02.07.05.134.1.187a.518.518 0 0 0 .4.18h2.89a.506.506 0 0 0 .37-.136c.04-.045.08-.1.11-.161a.429.429 0 0 0 .04-.193v-7.64a.491.491 0 0 0-.03-.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    fill: "#91DC5A",
    d: "M3192.32 394.869a.39.39 0 0 0 .08-.311.456.456 0 0 0-.14-.289.532.532 0 0 0-.64-.08 14.272 14.272 0 0 0-4.87 4.55 15.73 15.73 0 0 0-2.14 5 17.595 17.595 0 0 0-.41 5.74.54.54 0 0 0 .18.311c.1.079.22.121.34.119h3.93c.07.002.13-.01.19-.034a.474.474 0 0 0 .28-.265.42.42 0 0 0 .04-.191.205.205 0 0 0 0-.11c-.27-1.541-.34-3.11-.22-4.67.23-3.501 1.4-6.877 3.38-9.77Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    fill: "#4CBA68",
    d: "M3194.46 398.579a.39.39 0 0 0 .08-.311.456.456 0 0 0-.14-.289.532.532 0 0 0-.64-.08 11.056 11.056 0 0 0-3.7 3.45 11.946 11.946 0 0 0-1.61 3.8 12.997 12.997 0 0 0-.31 4.35c.02.122.08.234.18.313a.48.48 0 0 0 .33.117h2.95c.07.002.13-.01.19-.034a.474.474 0 0 0 .28-.265.42.42 0 0 0 .04-.191.205.205 0 0 0 0-.11 14.153 14.153 0 0 1-.16-3.44 14.526 14.526 0 0 1 2.51-7.31Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1117",
    className: "Group 1117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    fill: "#72493E",
    d: "M3450.16 375.97h-2.36v12.53h2.36v-12.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    fill: "#4FC99A",
    d: "M3453.69 371.789c0 4.62-2.11 8.36-4.71 8.36s-4.71-3.74-4.71-8.36c0-14.62 2.11-33.41 4.71-33.41s4.71 18.79 4.71 33.41Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    fill: "#44AA85",
    d: "M3447.8 371.789c0-12 1.07-26.76 2.52-31.7-.42-1.08-.87-1.71-1.34-1.71-2.6 0-4.71 18.79-4.71 33.41 0 4.62 2.11 8.36 4.71 8.36.48-.015.94-.149 1.34-.39-1.45-1.03-2.52-4.19-2.52-7.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    fill: "#72493E",
    d: "M3441.73 371h-3.37v17.93h3.37V371Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    fill: "#4FC99A",
    d: "M3446.79 364.999c0 6.6-3 12-6.74 12s-6.75-5.35-6.75-12c0-20.92 3-47.81 6.75-47.81s6.74 26.91 6.74 47.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    fill: "#44AA85",
    d: "M3438.36 364.999c0-17.16 1.52-38.3 3.61-45.37-.61-1.55-1.25-2.44-1.92-2.44-3.73 0-6.75 26.89-6.75 47.81 0 6.6 3 12 6.75 12a4.11 4.11 0 0 0 1.92-.55c-2.1-1.51-3.61-6.02-3.61-11.45Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_6",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    fill: "#91DC5A",
    d: "M3372.33 450.001a11.798 11.798 0 0 0-1.62-3.81 10.932 10.932 0 0 0-3.69-3.44.523.523 0 0 0-.33-.071.578.578 0 0 0-.31.141.461.461 0 0 0-.14.293c-.01.113.02.225.08.317a14.384 14.384 0 0 1 2.51 7.27c.11 1.165.05 2.339-.16 3.49a.535.535 0 0 0 .01.218c.02.071.06.136.1.192a.67.67 0 0 0 .19.128c.07.029.14.043.21.042h3c.13.004.24-.037.34-.114a.513.513 0 0 0 .17-.306c.13-1.46 0-2.93-.36-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    fill: "#4CBA68",
    d: "M3375.51 446.511a14.232 14.232 0 0 0-6.36-7.44.53.53 0 0 0-.33-.071.547.547 0 0 0-.31.141.54.54 0 0 0-.14.295c-.01.11.02.222.08.315 2 2.892 3.17 6.273 3.39 9.78a17.98 17.98 0 0 1-.22 4.69.535.535 0 0 0 .01.218.466.466 0 0 0 .28.32c.07.029.15.044.22.042h2.89c.07.003.13-.008.19-.03a.53.53 0 0 0 .29-.26c.02-.06.04-.124.04-.19v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    fill: "#91DC5A",
    d: "M3381.59 439.751a.45.45 0 0 0-.06-.61.544.544 0 0 0-.64-.07 14.505 14.505 0 0 0-4.87 4.54c-1 1.527-1.72 3.22-2.13 5a17.12 17.12 0 0 0-.41 5.75c.02.12.08.229.18.306.09.078.21.118.33.114h3.93c.07.003.13-.008.2-.03a.524.524 0 0 0 .16-.102.53.53 0 0 0 .12-.158c.03-.06.04-.124.04-.19.01-.04.01-.08 0-.12a20.069 20.069 0 0 1 3.17-14.45l-.02.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    fill: "#4CBA68",
    d: "M3383.73 443.458a.45.45 0 0 0 .09-.316.476.476 0 0 0-.15-.294.519.519 0 0 0-.31-.141.552.552 0 0 0-.33.071 11.025 11.025 0 0 0-3.69 3.44 11.77 11.77 0 0 0-1.62 3.81 13.265 13.265 0 0 0-.31 4.35c.02.12.08.229.18.306.09.078.21.118.33.114h2.95c.07.003.13-.007.19-.03a.53.53 0 0 0 .29-.26c.02-.06.04-.124.04-.19.01-.04.01-.08 0-.12a13.67 13.67 0 0 1-.16-3.44 14.483 14.483 0 0 1 2.5-7.3Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_7",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    fill: "#91DC5A",
    d: "M3311.55 510.809c-.3-1.355-.85-2.645-1.61-3.81a10.814 10.814 0 0 0-3.7-3.44.53.53 0 0 0-.33-.07.577.577 0 0 0-.31.14.456.456 0 0 0-.14.289c-.01.11.02.221.08.311a14.532 14.532 0 0 1 2.52 7.28c.08 1.167.02 2.339-.19 3.49a.753.753 0 0 0 0 .212c.02.07.06.135.1.188.05.056.12.101.18.132.07.031.15.047.22.048h2.95a.53.53 0 0 0 .34-.113.518.518 0 0 0 .17-.307c.15-1.455.06-2.925-.28-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    fill: "#4CBA68",
    d: "M3314.73 507.278a14.233 14.233 0 0 0-6.35-7.43.53.53 0 0 0-.33-.07.577.577 0 0 0-.31.14.452.452 0 0 0-.14.289c-.01.111.02.222.08.311a19.35 19.35 0 0 1 3.38 9.79c.14 1.566.07 3.141-.19 4.69a.432.432 0 0 0 .1.4c.05.056.12.101.18.132.07.031.15.048.22.048h2.9c.13.003.26-.046.36-.135.09-.09.15-.214.15-.345v-7.65a.352.352 0 0 0-.05-.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    fill: "#91DC5A",
    d: "M3320.87 500.518a.44.44 0 0 0 .09-.311.526.526 0 0 0-.15-.289.518.518 0 0 0-.3-.14.56.56 0 0 0-.34.07 14.345 14.345 0 0 0-4.88 4.54 15.717 15.717 0 0 0-2.13 5 17.658 17.658 0 0 0-.41 5.75.53.53 0 0 0 .18.307c.09.077.21.117.33.113h3.93a.457.457 0 0 0 .41-.166.41.41 0 0 0 .1-.206.357.357 0 0 0-.01-.228 19.22 19.22 0 0 1-.21-4.67 19.49 19.49 0 0 1 3.39-9.77Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    fill: "#4CBA68",
    d: "M3322.96 504.229a.434.434 0 0 0 .08-.311.461.461 0 0 0-.14-.289.518.518 0 0 0-.3-.14.56.56 0 0 0-.34.07 10.807 10.807 0 0 0-3.7 3.44 11.77 11.77 0 0 0-1.62 3.81 13.542 13.542 0 0 0-.31 4.35c.02.12.09.229.18.307.09.077.21.117.33.113h2.95a.48.48 0 0 0 .23-.032.408.408 0 0 0 .18-.134c.05-.06.09-.13.1-.206a.357.357 0 0 0-.01-.228 14.675 14.675 0 0 1-.16-3.44 14.64 14.64 0 0 1 2.53-7.31Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_8",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    fill: "#91DC5A",
    d: "M3446.67 470.669c-.3-1.356-.85-2.646-1.61-3.81a10.794 10.794 0 0 0-3.7-3.44.523.523 0 0 0-.33-.071.578.578 0 0 0-.31.141.45.45 0 0 0-.14.288c-.01.111.02.222.08.312a14.535 14.535 0 0 1 2.52 7.28c.09 1.165.04 2.337-.16 3.49a.441.441 0 0 0 .1.4c.05.056.12.1.18.131.07.031.15.048.22.049h2.95c.12.004.24-.037.34-.114a.513.513 0 0 0 .17-.306c.14-1.457.04-2.927-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    fill: "#4CBA68",
    d: "M3449.87 467.138a14.23 14.23 0 0 0-6.35-7.43.523.523 0 0 0-.33-.071.578.578 0 0 0-.31.141.45.45 0 0 0-.14.288c-.01.111.02.222.08.312 2 2.896 3.17 6.28 3.38 9.79.13 1.566.06 3.141-.21 4.69a.441.441 0 0 0 .1.4c.05.056.12.1.18.131.07.031.15.048.22.049h2.9c.13.002.26-.046.36-.136.09-.09.15-.213.15-.344v-7.65a.491.491 0 0 0-.03-.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    fill: "#91DC5A",
    d: "M3455.94 460.378a.434.434 0 0 0 .08-.311.459.459 0 0 0-.14-.289.519.519 0 0 0-.3-.141.553.553 0 0 0-.34.071 14.335 14.335 0 0 0-4.88 4.54 15.707 15.707 0 0 0-2.13 5 17.372 17.372 0 0 0-.36 5.75c.02.12.09.229.18.306.09.077.21.118.33.114h3.93a.465.465 0 0 0 .41-.167c.05-.059.09-.13.1-.205a.356.356 0 0 0-.01-.228 19.224 19.224 0 0 1-.21-4.67 19.552 19.552 0 0 1 3.34-9.77Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    fill: "#4CBA68",
    d: "M3458.08 464.089a.488.488 0 0 0 .08-.311.459.459 0 0 0-.14-.289.537.537 0 0 0-.64-.07 10.709 10.709 0 0 0-3.7 3.44 11.77 11.77 0 0 0-1.62 3.81 13.265 13.265 0 0 0-.31 4.35c.02.12.08.229.18.306.09.077.21.118.33.114h3a.48.48 0 0 0 .23-.032.475.475 0 0 0 .18-.135c.05-.059.09-.13.1-.205a.441.441 0 0 0-.01-.228 14.87 14.87 0 0 1 2.37-10.75h-.05Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bush_4",
    className: "bush"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1020",
    className: "Group 1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    fill: "#44AA85",
    d: "M3285.94 621.419c3.46 0 6.47 2.37 8.06 5.87 1.52-3.16 4.28-5.28 7.45-5.28 4.79 0 8.68 4.85 8.68 10.84.01 1.859-.39 3.697-1.16 5.39h.09c5.09 0 9.22 5.16 9.22 11.51s-4.13 11.51-9.22 11.51c-5.09 0-24.92-1.11-28.43-1.11-5.12 0-4-20.75-4-27.14 0-6.39 4.24-11.59 9.31-11.59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    fill: "#4FC99A",
    d: "M3256.77 640.591h.46a8.842 8.842 0 0 1-.07-.89c0-4.34 2.81-7.86 6.29-7.86.79.022 1.57.212 2.29.557.71.345 1.34.836 1.85 1.443a7.243 7.243 0 0 1 2.55-2.836 7.242 7.242 0 0 1 3.62-1.164c4.21 0 7.62 4.26 7.62 9.52 0 1.177-.18 2.347-.54 3.47 3.87.23 7 4.19 7 9.08s-3.27 9.13-7.3 9.13c-1.11 0-23-1.09-23.73-1.09-4.29 0-7.76-4.34-7.76-9.7 0-5.36 3.43-9.66 7.72-9.66Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    fill: "#BCEA73",
    d: "M3237.48 560.91c-.15-.01-.3-.01-.45 0 0-.3.07-.59.07-.89 0-4.29-2.79-7.77-6.23-7.77-.78.024-1.56.214-2.26.559a5.51 5.51 0 0 0-1.84 1.441 7.197 7.197 0 0 0-6.11-3.93c-4.16 0-7.54 4.21-7.54 9.41 0 1.168.19 2.328.54 3.44-3.83.22-6.89 4.14-6.89 9s3.24 9 7.23 9c1.09 0 22.73-1.08 23.48-1.08 4.24 0 7.68-4.29 7.68-9.6s-3.44-9.58-7.68-9.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1120",
    className: "Group 1120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1119",
    className: "Group 1119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "siderika",
    fill: "#CCC",
    d: "m3279.55 532.389 3.18-5.54-.94-.05-2.73 4.74-2.73-4.74-.94.05 3.18 5.54-6.21 10.79-6.21-10.79 3.19-5.54-.94-.05-2.73 4.74-2.74-4.74-.94.05 3.19 5.54-6.21 10.79-6.21-10.79 3.18-5.54-.94-.05-2.73 4.74-2.73-4.74-.94.05 3.18 5.54-6.21 10.79-6.21-10.79 3.19-5.54-.94-.05-2.73 4.74-2.74-4.74-.94.05 3.19 5.54-6.21 10.79-6.21-10.79 3.18-5.54-.94-.05-2.73 4.74-2.73-4.74-.94.05 3.19 5.54-6.22 10.79-6.21-10.79 3.19-5.54-.94-.05-2.73 4.74-2.73-4.74-.95.05 3.19 5.54-6.19 10.76-6.2-10.76 3.19-5.54-.94-.05-2.73 4.74-2.74-4.74-.94.05 3.19 5.54-6.21 10.79-6.16-10.79 3.18-5.54-.94-.05-2.73 4.74-2.73-4.74-.94.05 3.18 5.54-6.21 10.79-6.21-10.79 3.19-5.54-.94-.05-2.73 4.74-2.74-4.74-.94.05 3.19 5.54-6.21 10.79-6.21-10.79 3.18-5.54-.94-.05-2.73 4.74-2.73-4.74-.94.05 3.19 5.54-6.24 10.79-6.21-10.79 3.19-5.54-.94-.05-2.73 4.74-2.73-4.74-1 .05 3.19 5.54-6.21 10.79-6.21-10.79 3.19-5.54-.95-.05-2.73 4.74-2.73-4.74-.94.05 3.19 5.54-6.21 10.79-6.17-10.79 3.19-5.54-.94-.05-2.73 4.74-2.73-4.74-.94.05 3.18 5.54-6.21 10.79-6.21-10.79 3.19-5.54-.94-.05-3 5.6 6.44 11.6-6.49 11.64 6.49 11.63-6.49 11.64 6.49 11.64-6.65 11.63 6.65 11.64-6.81 11.64 6.81 11.63-6.22 11.67 2.89 5.57.8-.07-3.19-5.53 6.21-10.79 6.21 10.79-3.18 5.53.94.06 2.73-4.75 2.73 4.75.94-.06-3.19-5.53 6.22-10.79 6.21 10.79-3.19 5.53.94.06 2.73-4.75 2.73 4.75.95-.06-3.19-5.53 6.21-10.79 6.21 10.79-3.19 5.53 1 .06 2.73-4.75 2.73 4.75.94-.06-3.19-5.53 6.19-10.73 6.22 10.79-3.19 5.53.94.06 2.73-4.75 2.73 4.75.94-.06-3.18-5.53 6.21-10.79 6.21 10.79-3.19 5.53.94.06 2.74-4.75 2.73 4.75.94-.06-3.19-5.53 6.21-10.79 6.21 10.79-3.18 5.53.94.06 2.73-4.75 2.73 4.75.94-.06-3.18-5.53 6.21-10.79 6.21 10.79-3.19 5.53.94.06 2.74-4.75 2.73 4.75.94-.06-3.19-5.53 6.2-10.76 6.19 10.76-3.19 5.53.95.06 2.73-4.75 2.73 4.75.94-.06-3.19-5.53 6.21-10.79 6.22 10.79-3.19 5.53.94.06 2.73-4.75 2.73 4.75.94-.06-3.18-5.53 6.21-10.79 6.21 10.79-3.19 5.53.94.06 2.74-4.75 2.73 4.75.94-.06-3.19-5.53 6.18-10.79 6.21 10.79-3.18 5.53.94.06 2.73-4.75 2.73 4.75.94-.06-3.18-5.53 6.21-10.79 6.21 10.79-3.19 5.53.94.06 2.74-4.75 2.73 4.75.94-.06-3.19-5.53 6.21-10.79 6.21 10.79-3.18 5.53.94.06 2.73-4.75 2.73 4.75.94-.06-3.18-5.53 6.79-11.64-3.61-6.1-3.18-5.53 6.72-11.52-3.54-6.27-3.18-5.53 6.79-11.6-3.61-6.14-3.18-5.53 3.18-5.53 3.38-6.06-6.56-11.68 3.18-5.53 3.38-6.13-6.56-11.61Zm-4.16 17.74 3.18 5.53-6.21 10.79-6.21-10.79 3.19-5.53 3-5.26 3.05 5.26Zm3.18 28.8-3.18 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26 3.18 5.53Zm0 23.27-3.18 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.52 3-5.26 3 5.26 3.18 5.52Zm-19.11-34.91 6.21-10.78 6.2 10.78-6.2 10.79-6.21-10.79Zm12.41 23.28-6.2 10.78-6.21-10.78 6.21-10.79 6.2 10.79Zm-9.87-17.17 3.19 5.53-3.19 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-3.52 17.17-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm-6.21-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.67-4.68 3.18 5.53-3.18 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-3.51 17.17-6.22 10.78-6.21-10.78 6.21-10.79 6.22 10.79Zm-6.22-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.67-4.68 3.19 5.53-3.19 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-3.52 17.17-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm-6.21-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.67-4.68 3.18 5.53-3.18 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-3.51 17.17-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm-6.21-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.67-4.68 3.19 5.53-3.19 5.53-3 5.23-3-5.23-3.18-5.53 3.18-5.53 3-5.23 3 5.23Zm-3.49 17.17-6.2 10.78-6.21-10.78 6.21-10.79 6.2 10.79Zm-6.2-12.49-6.21-10.79 6.21-10.78 6.2 10.78-6.2 10.79Zm-3.67-4.68 3.19 5.53-3.19 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-3.52 17.17-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm-6.21-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.67-4.68 3.18 5.53-3.18 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-3.51 17.17-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm-6.21-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.67-4.68 3.19 5.53-3.19 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-3.52 17.17-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm-6.21-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.66-4.68 3.18 5.53-3.18 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-3.51 17.17-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm-6.21-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.67-4.68 3.19 5.53-3.19 5.53-3 5.26-3-5.26-3.19-5.53 3.19-5.53 3-5.26 3 5.26Zm-3.52 17.17-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm-6.21-12.49-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm-3.67-4.68 3.18 5.53-3.18 5.53-3 5.26-3-5.26-3.18-5.53 3.18-5.53 3-5.26 3 5.26Zm-9.72 4.68-6.21-10.79 6.21-10.78 6.21 10.78-6.21 10.79Zm6.21 12.49-6.21 10.78-6.21-10.78 6.21-10.79 6.21 10.79Zm0 23.27-6.21 10.79-6.21-10.79 6.21-10.78 6.21 10.78Zm-2.54-6.11-3.16-5.53 3.18-5.52 3-5.26 3 5.26 3.18 5.52-3.18 5.53-3 5.26-3.02-5.26Zm9.72-4.67 6.21 10.78-6.21 10.79-6.21-10.79 6.21-10.78Zm3.67 4.67-3.19-5.53 3.19-5.52 3-5.26 3 5.26 3.19 5.52-3.19 5.53-3 5.26-3-5.26Zm9.73-4.67 6.21 10.78-6.21 10.79-6.21-10.79 6.21-10.78Zm3.67 4.67-3.18-5.53 3.18-5.52 3-5.26 3 5.26 3.18 5.52-3.18 5.53-3 5.26-3-5.26Zm9.72-4.67 6.21 10.78-6.21 10.79-6.21-10.79 6.21-10.78Zm3.67 4.67-3.18-5.53 3.18-5.52 3-5.26 3 5.26 3.19 5.52-3.19 5.53-3 5.26-3-5.26Zm9.73-4.67 6.21 10.78-6.21 10.79-6.21-10.79 6.21-10.78Zm3.67 4.67-3.18-5.53 3.18-5.52 3-5.26 3 5.26 3.18 5.52-3.18 5.53-3 5.26-3-5.26Zm9.72-4.67 6.21 10.78-6.21 10.79-6.21-10.79 6.21-10.78Zm3.67 4.67-3.13-5.53 3.18-5.52 3-5.26 3 5.26 3.19 5.52-3.19 5.53-3 5.26-3.05-5.26Zm9.73-4.67 6.2 10.78-6.2 10.79-6.21-10.79 6.21-10.78Zm3.66 4.67-3.18-5.53 3.18-5.52 3-5.24 3 5.24 3.19 5.52-3.19 5.53-3 5.24-3-5.24Zm9.7-4.67 6.21 10.78-6.21 10.79-6.22-10.79 6.22-10.78Zm3.67 4.67-3.18-5.53 3.18-5.52 3-5.26 3 5.26 3.18 5.52-3.18 5.53-3 5.26-3-5.26Zm9.72-4.67 6.21 10.78-6.21 10.79-6.21-10.79 6.21-10.78Zm3.67 4.67-3.18-5.53 3.18-5.52 3-5.26 3 5.26 3.19 5.52-3.19 5.53-3 5.26-3-5.26Zm9.73-4.67 6.21 10.78-6.22 10.79-6.21-10.79 6.22-10.78Zm3.67 4.67-3.18-5.53 3.18-5.52 3-5.26 3 5.26 3.18 5.52-3.18 5.53-3 5.26-3-5.26Zm9.72-4.67 6.21 10.78-6.21 10.79-6.21-10.79 6.21-10.78Zm3.67 4.67-3.18-5.53 3.18-5.52 3-5.26 3 5.26 3.19 5.52-3.19 5.53-3 5.26-3-5.26Zm9.73-4.67 6.2 10.78-6.2 10.79-6.21-10.79 6.21-10.78Zm0-69.83 6.2 10.77-6.21 10.79-6.21-10.79 6.22-10.77Zm-3.67 16.9 3.19 5.53-6.21 10.79-6.21-10.79 3.18-5.53 3-5.26 3.05 5.26Zm-9.73-16.9 6.21 10.79-6.21 10.79-6.21-10.81 6.21-10.77Zm-3.67 16.9 3.18 5.53-6.21 10.79-6.21-10.79 3.19-5.53 3-5.26 3.05 5.26Zm-9.72-16.9 6.21 10.79-6.22 10.79-6.2-10.81 6.21-10.77Zm-3.67 16.9 3.19 5.53-6.21 10.79-6.21-10.79 3.18-5.53 3-5.26 3.05 5.26Zm-9.73-16.9 6.21 10.79-6.21 10.79-6.21-10.81 6.21-10.77Zm-3.67 16.9 3.18 5.53-6.21 10.79-6.2-10.79 3.18-5.53 3-5.26 3.05 5.26Zm-9.72-16.9 6.21 10.79-6.21 10.79-6.22-10.81 6.22-10.77Zm-3.67 16.9 3.19 5.53-6.19 10.76-6.2-10.76 3.19-5.53 3-5.23 3.01 5.23Zm-9.69-16.9 6.21 10.79-6.21 10.79-6.22-10.81 6.22-10.77Zm-3.67 16.9 3.19 5.53-6.21 10.79-6.17-10.79 3.18-5.53 3-5.26 3.01 5.26Zm-9.73-16.9 6.21 10.79-6.21 10.79-6.21-10.81 6.21-10.77Zm-3.67 16.9 3.18 5.53-6.21 10.79-6.21-10.79 3.19-5.53 3-5.26 3.05 5.26Zm-9.72-16.9 6.21 10.79-6.21 10.79-6.21-10.81 6.21-10.77Zm-3.67 16.9 3.19 5.53-6.21 10.79-6.21-10.79 3.18-5.53 3-5.26 3.05 5.26Zm-9.73-16.9 6.21 10.79-6.21 10.79-6.21-10.81 6.21-10.77Zm-3.67 16.9 3.18 5.53-6.18 10.79-6.2-10.79 3.18-5.53 3-5.26 3.02 5.26Zm-9.72-16.9 6.21 10.79-6.21 10.79-6.21-10.81 6.21-10.77Zm-3.67 16.9 3.19 5.53-6.21 10.79-6.21-10.79 3.19-5.53 3-5.26 3.04 5.26Zm-9.73-16.9 6.21 10.79-6.21 10.79-6.21-10.81 6.21-10.77Zm-3.67 16.9 3.18 5.53-6.2 10.79-6.19-10.79 3.18-5.53 3-5.26 3.03 5.26Zm-9.72-16.9 6.21 10.77-6.21 10.79-6.21-10.79 6.21-10.77Zm-12.91 22.43 3.19-5.53 3-5.26 3 5.26 3.18 5.53-6.21 10.79-6.16-10.79Zm3.18 28.8-3.19-5.53 3.19-5.53 3-5.26 3 5.26 3.18 5.53-3.18 5.53-3 5.26-3-5.26Zm0 23.27-3.19-5.53 3.19-5.52 3-5.26 3 5.26 3.18 5.52-3.18 5.53-3 5.26-3-5.26Zm0 23.28-3.19-5.53 6.21-10.79 6.21 10.79-3.18 5.53-3 5.26-3.05-5.26Zm9.73 16.89-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.67-16.89-3.18-5.53 6.21-10.79 6.2 10.79-3.18 5.53-3 5.26-3.05-5.26Zm9.72 16.89-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.67-16.89-3.19-5.53 6.21-10.79 6.21 10.79-3.18 5.52-3 5.26-3.05-5.25Zm9.73 16.89-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.72-16.9-3.18-5.53 6.2-10.79 6.21 10.79-3.23 5.53-3 5.26-3-5.26Zm9.72 16.89-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.67-16.89-3.18-5.53 6.21-10.79 6.21 10.79-3.19 5.53-3 5.26-3.05-5.26Zm9.73 16.89-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.67-16.89-3.19-5.53 6.21-10.79 6.21 10.79-3.18 5.53-3 5.26-3.05-5.26Zm9.72 16.89-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.67-16.89-3.18-5.53 6.21-10.79 6.21 10.79-3.19 5.53-3 5.26-3.05-5.26Zm9.73 16.89-6.22-10.79 6.22-10.79 6.21 10.79-6.21 10.79Zm3.66-16.89-3.19-5.53 6.2-10.76 6.19 10.76-3.19 5.53-3 5.23-3.01-5.23Zm9.7 16.89-6.27-10.78 6.21-10.79 6.21 10.79-6.15 10.78Zm3.67-16.89-3.18-5.53 6.2-10.79 6.21 10.79-3.18 5.53-3 5.26-3.05-5.26Zm9.72 16.89-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.67-16.89-3.18-5.53 6.21-10.79 6.21 10.79-3.19 5.53-3 5.26-3.05-5.26Zm9.67 16.9-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.67-16.89-3.19-5.53 6.21-10.79 6.21 10.79-3.18 5.53-3 5.26-3.05-5.26Zm9.72 16.89-6.21-10.79 6.21-10.79 6.21 10.79-6.21 10.79Zm3.67-16.89-3.18-5.53 6.21-10.79 6.21 10.79-3.19 5.53-3 5.26-3.05-5.26Zm9.73 16.89-6.22-10.79 6.22-10.79 6.21 10.79-6.21 10.79Zm3.66-16.89-3.19-5.53 6.21-10.79 6.21 10.79-3.18 5.53-3 5.26-3.05-5.26Zm15.94 6.1-6.21 10.79-6.18-10.79 6.21-10.79 6.18 10.79Zm0-23.27-6.21 10.79-6.18-10.79 6.21-10.78 6.18 10.78Zm0-23.27-6.21 10.78-6.18-10.78 6.21-10.79 6.18 10.79Zm0-23.28-6.21 10.79-6.18-10.79 6.21-10.78 6.18 10.78Zm-6.21-12.48-6.18-10.81 6.21-10.79 6.19 10.79-6.22 10.81Z",
    className: "siderika"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    fill: "#878787",
    d: "M3288.17 526.18h-187.12v1.14h187.12v-1.14Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "basket",
    className: "basket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    fill: "#918291",
    d: "M3192.78 584.54v59.48l-5.36 8.69c-.14.225-.22.481-.24.744-.01.263.04.526.15.766a1.256 1.256 0 0 0 1.15.79h11.22a1.277 1.277 0 0 0 1.13-.74c.11-.229.17-.483.17-.74s-.06-.511-.17-.74l-4.57-8.61v-59.64h-3.48Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    fill: "#918291",
    d: "M3215.29 575.721v-23.78a.844.844 0 0 0-.22-.641.87.87 0 0 0-.61-.299h-39.76a.867.867 0 0 0-.6.299.893.893 0 0 0-.23.641v23.78h41.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    fill: "#3AD1E0",
    d: "M3215.29 574.813v8.901a.843.843 0 0 1-.22.64.87.87 0 0 1-.61.3h-39.76a.868.868 0 0 1-.6-.3.892.892 0 0 1-.23-.64v-8.901h41.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    fill: "#20BFD5",
    d: "M3199.9 584.653v-8.25c.03-.54-.15-1.071-.51-1.476-.36-.404-.87-.65-1.41-.684h-6.8c-.54.034-1.04.28-1.4.684-.36.405-.55.936-.52 1.476v8.27l10.64-.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    fill: "#20BFD5",
    d: "M3205.81 584.653h-22.43c-.03-.601.18-1.191.57-1.642.4-.451.96-.727 1.56-.768h18.2c.6.041 1.16.317 1.56.768.4.451.61 1.041.57 1.642h-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    fill: "#D4F2F6",
    d: "M3211.96 557.312v21a.931.931 0 0 1-.25.67l-1.49 1.68a.761.761 0 0 1-.59.28h-30.17a.775.775 0 0 1-.32-.076.909.909 0 0 1-.27-.204l-1.42-1.61a1.002 1.002 0 0 1-.25-.66v-20.99c0-.243.09-.477.25-.66l1.49-1.69c.08-.083.17-.15.27-.196.1-.047.21-.072.32-.074h30.17a.798.798 0 0 1 .59.27l1.42 1.61c.16.18.25.411.25.65Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    fill: "#3AD1E0",
    d: "M3182.76 561.48v15.47c-.01.235.07.465.23.641.15.176.37.284.6.299h22a.87.87 0 0 0 .61-.299.844.844 0 0 0 .22-.641v-15.47a.845.845 0 0 0-.22-.641.87.87 0 0 0-.61-.299h-22a.867.867 0 0 0-.6.299.894.894 0 0 0-.23.641Zm20.62 13.92h-17.64a.913.913 0 0 1-.61-.298.941.941 0 0 1-.23-.642v-10.53a.941.941 0 0 1 .23-.642.918.918 0 0 1 .61-.298h17.64a.92.92 0 0 1 .62.298c.15.176.24.407.22.642v10.57a.84.84 0 0 1-.24.616.888.888 0 0 1-.6.284Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    fill: "#FB7722",
    d: "M3201.27 578.832v2.06h-13.38v-2.06a.93.93 0 0 1 .22-.641.91.91 0 0 1 .61-.299h11.72a.87.87 0 0 1 .61.299c.16.176.24.406.22.641Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    fill: "#F2671F",
    d: "M3189.26 577.892h10.64v3h-10.64v-3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    fill: "#B4CFEA",
    d: "M3184.38 558.403a.676.676 0 0 1-.46-.224.664.664 0 0 1-.13-.226.768.768 0 0 1-.04-.26c0-.087.01-.175.04-.258a.646.646 0 0 1 .59-.442h.08a.627.627 0 0 1 .46.218c.06.065.11.141.14.224.03.083.04.171.03.258a.662.662 0 0 1-.71.71Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    fill: "#B4CFEA",
    d: "M3186.69 558.403h-.09a.656.656 0 0 1-.45-.227.664.664 0 0 1-.17-.483c0-.087.01-.173.04-.256a.65.65 0 0 1 .13-.223.645.645 0 0 1 .45-.221h.09a.685.685 0 0 1 .46.221c.06.065.1.141.13.223.03.083.04.169.03.256.01.176-.05.35-.16.483a.679.679 0 0 1-.46.227Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    fill: "#B4CFEA",
    d: "M3202.56 558.403h-.09a.656.656 0 0 1-.45-.227.664.664 0 0 1-.17-.483c0-.087.01-.173.04-.256a.65.65 0 0 1 .13-.223.786.786 0 0 1 .2-.156c.08-.038.17-.06.25-.065h.09a.685.685 0 0 1 .46.221c.06.065.1.141.13.223.03.083.04.169.03.256.02.176-.04.35-.16.483a.679.679 0 0 1-.46.227Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    fill: "#B4CFEA",
    d: "M3204.83 558.403h-.08a.684.684 0 0 1-.46-.224.664.664 0 0 1-.13-.226.768.768 0 0 1-.04-.26c0-.087.01-.175.04-.258a.646.646 0 0 1 .59-.442h.08a.68.68 0 0 1 .47.218c.05.065.1.141.13.224.03.083.04.171.03.258.01.088 0 .176-.03.26a.882.882 0 0 1-.13.226.676.676 0 0 1-.47.224Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    fill: "#FC9744",
    d: "M3198.82 576.402v8.27h-8.43v-8.27a.844.844 0 0 1 .22-.641.87.87 0 0 1 .61-.299h6.8c.23.015.45.123.6.299.16.176.24.406.23.641h-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    fill: "#FB8627",
    d: "M3190.38 582.243h8.46v2.41h-8.46v-2.41Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    fill: "#FB8627",
    d: "M3198.82 576.402v8.27h-1.43v-8.27a.893.893 0 0 0-.23-.641.867.867 0 0 0-.6-.299h1.43c.23.015.45.123.6.299.16.176.24.406.23.641Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    fill: "#FB7722",
    d: "M3193.24 578.591h-.08a.68.68 0 0 1-.47-.218.87.87 0 0 1-.13-.224.567.567 0 0 1-.03-.258.574.574 0 0 1 .03-.26c.03-.083.08-.16.13-.226a.676.676 0 0 1 .47-.224h.08a.684.684 0 0 1 .46.224c.06.066.1.143.13.226.03.083.04.172.04.26 0 .087-.01.175-.04.258a.655.655 0 0 1-.34.379.678.678 0 0 1-.25.063Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    fill: "#FB7722",
    d: "M3196.01 578.591h-.08a.678.678 0 0 1-.46-.218.655.655 0 0 1-.13-.224.757.757 0 0 1-.04-.258c0-.088.01-.177.04-.26a.664.664 0 0 1 .59-.45h.08c.18.012.34.094.46.227s.17.306.16.483a.641.641 0 0 1-.37.634.653.653 0 0 1-.25.066Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    fill: "#B4CFEA",
    d: "M3202.69 584.24a.546.546 0 0 0-.24-.061.649.649 0 0 0-.25.045.487.487 0 0 0-.2.142.62.62 0 0 0-.14.214l-1 2.48-.69 1.65h-2.94l.22-1.65.31-2.31a.69.69 0 0 0-.11-.503.666.666 0 0 0-.42-.297.627.627 0 0 0-.25.023.727.727 0 0 0-.23.121.75.75 0 0 0-.16.2.696.696 0 0 0-.07.246l-.33 2.52-.22 1.65h-2.7l-.22-1.65-.33-2.52c0-.086-.03-.17-.06-.246a.626.626 0 0 0-.17-.2.592.592 0 0 0-.22-.121.66.66 0 0 0-.26-.023.723.723 0 0 0-.42.297.802.802 0 0 0-.11.503l.31 2.31.22 1.65h-2.94l-.69-1.65-1-2.48a.483.483 0 0 0-.13-.214.668.668 0 0 0-.2-.142.63.63 0 0 0-.5.016.74.74 0 0 0-.32.414c-.06.173-.05.36.02.526l.79 1.88.7 1.68a.703.703 0 0 0-.33.267.754.754 0 0 0-.12.413c0 .087.01.174.04.256a.65.65 0 0 0 .13.223c.06.065.13.118.2.156.08.038.17.06.25.065h.41l1.45 3.46a.73.73 0 0 0-.22.263.784.784 0 0 0-.08.337c-.01.176.05.35.17.483.11.133.28.214.45.227v2.51c-.01.089 0 .179.03.265a.646.646 0 0 0 .34.389.623.623 0 0 0 .73-.158.544.544 0 0 0 .13-.231.48.48 0 0 0 .02-.265v-2.48h1.44v2.48c-.01.089 0 .179.03.265a.646.646 0 0 0 .34.389.623.623 0 0 0 .73-.158.544.544 0 0 0 .13-.231.48.48 0 0 0 .02-.265v-2.48h1.26v2.48c-.01.089 0 .179.03.265a.646.646 0 0 0 .34.389.623.623 0 0 0 .73-.158.544.544 0 0 0 .13-.231.48.48 0 0 0 .02-.265v-2.48h1.44v2.48c-.01.089 0 .179.03.265a.646.646 0 0 0 .34.389.623.623 0 0 0 .73-.158.544.544 0 0 0 .13-.231.48.48 0 0 0 .02-.265v-2.48h.13a.684.684 0 0 0 .47-.224c.06-.066.1-.143.13-.226a.574.574 0 0 0 .03-.26.616.616 0 0 0-.11-.392.683.683 0 0 0-.31-.268l1.43-3.4h.54a.67.67 0 0 0 .47-.218c.05-.065.1-.141.13-.224.03-.082.04-.17.03-.258a.66.66 0 0 0-.15-.467.69.69 0 0 0-.43-.243l.69-1.65.79-1.88a.686.686 0 0 0 .03-.526.716.716 0 0 0-.33-.414l-.08-.03Zm-11.66 9.24-1.4-3.36h2.53l.44 3.36h-1.57Zm4.26 0h-1.42l-.45-3.36h2.32l-.45 3.36Zm2.84 0h-1.57l.44-3.36h2.53l-1.4 3.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    fill: "#FCA863",
    d: "M3203.68 585.834h-18.2a1.209 1.209 0 0 1-.74-.395 1.187 1.187 0 0 1-.29-.785c0-.289.1-.568.29-.786.19-.217.46-.357.74-.394h18.2a1.201 1.201 0 0 1 1.04 1.18 1.197 1.197 0 0 1-1.04 1.18Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    fill: "#A8E7EF",
    d: "M3199.7 576.16v4.51h-10.64v-4.51c-.03-.541.16-1.071.52-1.476s.86-.651 1.4-.684h6.8c.54.033 1.05.279 1.41.684.36.405.54.935.51 1.476Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    fill: "#20BFD5",
    d: "M3199.7 576.16v1.51h-10.64v-1.51c0-.324.07-.645.2-.94h10.24c.14.295.2.616.2.94Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    fill: "#99BDE4",
    d: "m3187.1 584.339 1 2.48h-1.38l-.79-1.88a.734.734 0 0 1-.02-.526.74.74 0 0 1 .32-.414.631.631 0 0 1 .26-.077c.09-.007.18.006.26.039.08.033.16.084.22.149.06.065.11.144.13.229Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    fill: "#99BDE4",
    d: "m3192.48 584.299.33 2.52h-1.26l-.31-2.31a.802.802 0 0 1 .11-.503c.1-.148.25-.254.42-.297.09-.01.18-.002.26.023.08.025.16.066.23.121a.75.75 0 0 1 .16.2c.03.076.06.16.06.246Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    fill: "#99BDE4",
    d: "m3197.52 584.509-.31 2.31h-1.26l.33-2.52c.01-.086.03-.17.07-.246a.75.75 0 0 1 .16-.2.727.727 0 0 1 .23-.121.61.61 0 0 1 .25-.023c.18.043.33.149.43.297.09.148.13.328.1.503Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    fill: "#99BDE4",
    d: "m3202.79 584.94-.79 1.88h-1.38l1-2.48c.03-.08.08-.153.14-.215.05-.061.12-.11.2-.142a.63.63 0 0 1 .25-.044c.09.003.17.023.24.061.16.094.28.241.33.413a.69.69 0 0 1-.03.527h.04Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_4",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    fill: "#C0EA6E",
    d: "M3372.1 590.84a14.226 14.226 0 0 0 2.31-7.88c0-6.83-4.62-12.46-10.56-13.22-1.08-6.12-5.91-10.74-11.71-10.74-5.8 0-10.63 4.62-11.71 10.74-5.94.76-10.56 6.39-10.56 13.22-.01 2.799.79 5.541 2.31 7.89a7.36 7.36 0 0 0-1.73 2.477 7.22 7.22 0 0 0-.58 2.97c.02 1.019.26 2.023.69 2.945a7.369 7.369 0 0 0 1.83 2.408 14.979 14.979 0 0 0-.53 3.94c0 7.35 5.34 13.31 11.93 13.31 1.03-1.17 2.3-2.108 3.73-2.75 1.42-.642 2.96-.974 4.52-.974a10.99 10.99 0 0 1 8.25 3.724c6.59 0 11.94-6 11.94-13.31 0-1.286-.17-2.567-.5-3.81a6.947 6.947 0 0 0 2-2.496c.47-.975.7-2.044.68-3.124.02-1-.18-1.991-.58-2.908a7.096 7.096 0 0 0-1.73-2.412Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    fill: "#72493E",
    d: "M3354.3 614.082h-4.33v40.64h4.33v-40.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    fill: "#A3E440",
    d: "M3372.1 590.84a14.308 14.308 0 0 0 2.31-7.88c.03-2.149-.44-4.277-1.37-6.212a13.782 13.782 0 0 0-4.03-4.928 32.241 32.241 0 0 1 1.25 9c0 16.21-11.78 29.35-26.31 29.35a24.103 24.103 0 0 1-12-3.24c.59 6.73 5.68 12 11.88 12a10.99 10.99 0 0 1 12.78-2.75 10.99 10.99 0 0 1 3.72 2.75c6.59 0 11.94-6 11.94-13.31 0-1.286-.17-2.567-.5-3.81a7.051 7.051 0 0 0 2-2.495c.46-.975.7-2.045.68-3.125a7.034 7.034 0 0 0-.6-2.929c-.4-.923-1-1.748-1.75-2.421Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_5",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    fill: "#8C5F50",
    d: "M3522.88 637.73h-3.23v17.17h3.23v-17.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    fill: "#4FC99A",
    d: "M3527.72 632.01c0 6.32-2.89 11.441-6.45 11.441s-6.46-5.121-6.46-11.441c0-20 2.89-45.78 6.46-45.78s6.45 25.75 6.45 45.78Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    fill: "#44AA85",
    d: "M3519.66 632.01c0-16.42 1.46-36.669 3.46-43.429-.58-1.49-1.2-2.351-1.84-2.351-3.57 0-6.46 25.75-6.46 45.78 0 6.32 2.89 11.441 6.46 11.441.65-.02 1.28-.202 1.84-.531-2-1.41-3.46-5.68-3.46-10.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    fill: "#72493E",
    d: "M3510.42 630.691h-4.62v24.56h4.62v-24.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    fill: "#4FC99A",
    d: "M3517.34 622.5c0 9-4.13 16.38-9.24 16.38s-9.23-7.33-9.23-16.38c0-28.65 4.13-65.5 9.23-65.5 5.1 0 9.24 36.85 9.24 65.5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    fill: "#44AA85",
    d: "M3505.8 622.5c0-23.5 2.08-52.47 4.94-62.15-.83-2.12-1.72-3.35-2.64-3.35-5.1 0-9.23 36.85-9.23 65.5 0 9 4.13 16.38 9.23 16.38a5.58 5.58 0 0 0 2.64-.76c-2.85-2.02-4.94-8.21-4.94-15.62Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    fill: "#BCEA73",
    d: "M3470.58 638.6h-.46c.04-.292.07-.586.08-.88 0-4.3-2.79-7.78-6.23-7.78-.78.024-1.56.214-2.26.559-.71.345-1.33.836-1.84 1.441a7.097 7.097 0 0 0-2.52-2.798 7.19 7.19 0 0 0-3.59-1.142c-4.16 0-7.54 4.22-7.54 9.42 0 1.164.19 2.321.54 3.43-3.83.23-6.89 4.15-6.89 9s3.23 9 7.23 9c1.09 0 22.73-1.07 23.48-1.07 4.24 0 7.68-4.3 7.68-9.6s-3.44-9.58-7.68-9.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grass_9",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    fill: "#91DC5A",
    d: "M3426.97 608.035a11.748 11.748 0 0 0-1.61-3.81 10.986 10.986 0 0 0-3.7-3.44.544.544 0 0 0-.64.07.526.526 0 0 0-.15.289c-.01.11.02.22.09.311a14.572 14.572 0 0 1 2.33 10.77.382.382 0 0 0 0 .212c.02.07.05.134.1.188a.543.543 0 0 0 .4.18h2.95c.12.004.24-.037.33-.114a.48.48 0 0 0 .18-.306c.14-1.456.05-2.926-.28-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    fill: "#4CBA68",
    d: "M3430.15 604.504a14.318 14.318 0 0 0-6.35-7.43.544.544 0 0 0-.64.07.44.44 0 0 0-.06.6 19.437 19.437 0 0 1 3.38 9.79c.13 1.565.07 3.141-.19 4.69a.511.511 0 0 0-.01.213c.02.07.06.135.11.187a.543.543 0 0 0 .4.18h2.9a.504.504 0 0 0 .51-.48v-7.65a.93.93 0 0 0-.05-.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    fill: "#91DC5A",
    d: "M3436.29 597.744c.06-.09.09-.201.08-.311a.456.456 0 0 0-.14-.289.578.578 0 0 0-.31-.141.53.53 0 0 0-.33.071 14.245 14.245 0 0 0-4.88 4.54c-1 1.529-1.72 3.221-2.13 5a17.656 17.656 0 0 0-.41 5.75c.02.12.08.229.17.306.1.078.22.118.34.114h3.93c.07.008.15-.003.22-.032a.432.432 0 0 0 .19-.135.51.51 0 0 0 .1-.205.583.583 0 0 0-.01-.228 19.221 19.221 0 0 1-.21-4.67c.23-3.502 1.4-6.878 3.39-9.77Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    fill: "#4CBA68",
    d: "M3438.38 601.455a.488.488 0 0 0 .08-.311.459.459 0 0 0-.14-.289.544.544 0 0 0-.64-.07 10.709 10.709 0 0 0-3.7 3.44 11.77 11.77 0 0 0-1.62 3.81 13.265 13.265 0 0 0-.31 4.35c.02.12.08.229.17.306.1.077.22.118.34.114h2.95a.44.44 0 0 0 .22-.032.432.432 0 0 0 .19-.135c.05-.059.08-.13.1-.205a.583.583 0 0 0-.01-.228 14.155 14.155 0 0 1-.16-3.44 14.537 14.537 0 0 1 2.53-7.31Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bin_2",
    className: "bin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    fill: "#CCC",
    d: "M3390.82 622.76v-.37c0-2.42-1.71-4.39-3.8-4.39h-2.43c-2.1 0-3.8 2-3.8 4.39a3.53 3.53 0 0 0 0 .46 13.613 13.613 0 0 0-4.21 3.342 13.539 13.539 0 0 0-2.57 4.718c-.06.2.36.27 1.11.26v23.57h21.58v-23.6c.73 0 1.14 0 1.08-.24a13.4 13.4 0 0 0-2.64-4.791 13.318 13.318 0 0 0-4.32-3.349Zm-4.93-1.15c-1.06.011-2.11.173-3.12.48.02-.466.22-.907.54-1.24.33-.334.77-.536 1.23-.57h2.51c.45.034.88.229 1.2.55.33.321.52.746.56 1.2-.95-.262-1.93-.403-2.92-.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    fill: "#878787",
    d: "M3397.99 629.629h-24.12v1.71h24.12v-1.71Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    fill: "#878787",
    d: "M3377.31 632.859a.7.7 0 0 0-.24.068.805.805 0 0 0-.2.155.823.823 0 0 0-.12.218c-.02.081-.03.165-.03.249v19.16c0 .084.01.169.03.249.03.081.07.155.12.219.06.064.13.117.2.155.08.038.16.061.24.067a.64.64 0 0 0 .44-.221.625.625 0 0 0 .16-.469v-19.16a.624.624 0 0 0-.16-.468.644.644 0 0 0-.44-.222Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    fill: "#878787",
    d: "M3383 632.84a.661.661 0 0 0-.59.69v19.16c-.01.084 0 .17.02.252.03.082.07.157.13.221.05.064.12.116.2.151a.606.606 0 0 0 .7-.151.61.61 0 0 0 .14-.473v-19.16a.623.623 0 0 0-.16-.468.64.64 0 0 0-.44-.222Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    fill: "#878787",
    d: "M3388.59 632.898a.644.644 0 0 0-.44.222.667.667 0 0 0-.16.468v19.16a.786.786 0 0 0 .01.265c.02.087.07.167.12.236a.609.609 0 0 0 .73.162.645.645 0 0 0 .21-.162c.06-.069.1-.149.12-.236a.593.593 0 0 0 .01-.265v-19.16a.624.624 0 0 0-.16-.468.644.644 0 0 0-.44-.222Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    fill: "#878787",
    d: "M3394.32 632.871a.644.644 0 0 0-.44.222.665.665 0 0 0-.16.468v19.17a.787.787 0 0 0 .01.265.92.92 0 0 0 .12.236.61.61 0 0 0 .94 0c.06-.069.1-.15.12-.236a.478.478 0 0 0 .01-.265v-19.17a.623.623 0 0 0-.16-.468.644.644 0 0 0-.44-.222Z",
    className: "Vector"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    fill: "#A3A3A3",
    d: "M1845.25 440.17h-22.67v22.62h22.67v-22.62Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_28",
    fill: "#CCC",
    d: "M1163.07 655.42h58.66l-.57-81.65.57-142.47 12.68-.27.1-11.25 11.7 5.23v-24.48h-83.14v254.89Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_29",
    fill: "#AFAFAF",
    d: "m1608.05 385.801-13.66-.08-1.07.08-3.63 19.8-.08 121.11h13.94l42.6.08v-53.69h-38.1v-87.3Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_30",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    fill: "#CCC",
    d: "M2190.97 326.611H1936.2v330.08h254.77v-330.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    fill: "#CCC",
    d: "M2150.46 306.639h-175.53v20.45h175.53v-20.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows_4",
    className: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    fill: "#fff",
    d: "M2016.38 346.432h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    fill: "#fff",
    d: "M2079.68 346.432h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    fill: "#fff",
    d: "M2142.98 346.432h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    fill: "#fff",
    d: "M2016.38 411.99h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    fill: "#fff",
    d: "M2079.68 411.99h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    fill: "#fff",
    d: "M2142.98 411.99h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    fill: "#fff",
    d: "M2016.38 477.541h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    fill: "#fff",
    d: "M2079.68 477.541h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    fill: "#fff",
    d: "M2142.98 477.541h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    fill: "#EAEAEA",
    d: "M2057.13 596.51h-44.41v57.21h44.41v-57.21Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    fill: "#EAEAEA",
    d: "M2108.36 596.51h-44.41v57.21h44.41v-57.21Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "building_31",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    fill: "#CCC",
    d: "M1221.64 326.611H966.873v330.08h254.767v-330.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    fill: "#CCC",
    d: "M1181.13 306.639H1005.6v20.45h175.53v-20.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows_5",
    className: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    fill: "#fff",
    d: "M1047.05 346.432h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    fill: "#fff",
    d: "M1110.35 346.432h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    fill: "#fff",
    d: "M1173.65 346.432h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    fill: "#fff",
    d: "M1047.05 411.99h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    fill: "#fff",
    d: "M1110.35 411.99h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    fill: "#fff",
    d: "M1173.65 411.99h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    fill: "#fff",
    d: "M1047.05 477.541h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    fill: "#fff",
    d: "M1110.35 477.541h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    fill: "#fff",
    d: "M1173.65 477.541h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    fill: "#EAEAEA",
    d: "M1087.8 596.51h-44.41v57.21h44.41v-57.21Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    fill: "#EAEAEA",
    d: "M1139.03 596.51h-44.41v57.21h44.41v-57.21Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    fill: "#A3A3A3",
    d: "M2363.29 157.33h-49.55l-16.66 101.13h-27.37v179.06h137.61V258.46h-28.31l-15.72-101.13Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    fill: "#AFAFAF",
    d: "M2540.31 245.58h-38.91v54.1h-66.22v21.26h-35.33v74.07h35.33v8.91h122.5V299.68h-17.37v-54.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    fill: "#A3A3A3",
    d: "m2744.51 225.21-.39 316.19h-188.38l.06-316.19h188.71Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    className: "Group",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    fill: "#FCEEC3",
    d: "M2508.48 550.24h-19.3v6.77h19.3v-6.77Z",
    className: "Vector",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    className: "Group",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    fill: "#FCEEC3",
    d: "M2500.37 526.6h-14.03v5.14h14.03v-5.14Z",
    className: "Vector",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    fill: "#AFAFAF",
    d: "M2190.6 655.08h58.65l-.56-81.98.56-143.03 12.69-.28.1-11.29 11.7 5.25v-24.58h-83.14v255.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    fill: "#44AA85",
    d: "M2407.25 659.73S2476.87 365 2748.33 365s338.77 294.73 338.77 294.73h-679.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "building_32",
    fill: "#CCC",
    d: "M2646.8 345.571h-84.58v-19.4h-13.25v19.4h-6.11v-37.03h-5.1v37.03h-10.27v309.431h146.18V337.731h-26.87v7.84Z",
    className: "building"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_33",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    fill: "#EAEAEA",
    d: "M2809.25 532.611h-191.31v61.59h191.31v-61.59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    fill: "#EAEAEA",
    d: "M2809.26 527.549h-199.57v7.88h199.57v-7.88Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    fill: "#AFAFAF",
    d: "M2809.25 570.541h-196.31v7.88h196.31v-7.88Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 993",
    className: "Group 993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    fill: "#fff",
    d: "M2668.28 543.311h-18.88v18.23h18.88v-18.23Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    fill: "#fff",
    d: "M2719.91 543.35h-18.88v18.23h18.88v-18.23Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    fill: "#fff",
    d: "M2771.36 543.26h-18.88v18.23h18.88v-18.23Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    fill: "#EAEAEA",
    d: "M2809.25 597.342h-29.04v60.44h29.04v-60.44Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    fill: "#EAEAEA",
    d: "M2646.17 598.709h-28.08v60.44h28.08v-60.44Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    fill: "#AFAFAF",
    d: "M2809.25 591.221H2613v7.49h196.25v-7.49Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "building_34",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    fill: "#EAEAEA",
    d: "M2392.87 393h-212v262h212V393Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows_6",
    className: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    fill: "#fff",
    d: "M2241.97 407.84h-28.85v41.7h28.85v-41.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    fill: "#fff",
    d: "M2241.89 469.348h-28.85v41.7h28.85v-41.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    fill: "#fff",
    d: "M2241.89 531h-28.85v41.7h28.85V531Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    fill: "#fff",
    d: "M2301.48 408h-28.84v41.7h28.84V408Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    fill: "#fff",
    d: "M2301.42 469.508h-28.84v41.7h28.84v-41.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    fill: "#fff",
    d: "M2301.42 531.16h-28.84v41.7h28.84v-41.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    fill: "#fff",
    d: "M2360.62 407.84h-28.84v41.7h28.84v-41.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    fill: "#fff",
    d: "M2360.54 469.348h-28.84v41.7h28.84v-41.7Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    fill: "#fff",
    d: "M2360.54 531h-28.84v41.7h28.84V531Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    fill: "#CCC",
    d: "M2314.06 598h-56.25v57.41h56.25V598Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    fill: "#EAEAEA",
    d: "M2391.84 389h-210.97v4.25h210.97V389Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    fill: "#EAEAEA",
    d: "M2200.99 389.04h18.1v-6.37l-18.1-5.67v12.04Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "feuer",
    className: "feuer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    fill: "red",
    d: "M3684.32 653.702v-16.3c.06-.56.01-1.126-.16-1.663a4.223 4.223 0 0 0-.83-1.45c-.38-.42-.84-.755-1.35-.985a4.014 4.014 0 0 0-4.62.985c-.37.42-.66.914-.83 1.45a4.068 4.068 0 0 0-.16 1.663v16.3h7.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    fill: "#C10202",
    d: "M3684.98 637.904h-9.64v1.97h9.64v-1.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    fill: "#C10202",
    d: "M3684.97 653.002h-9.45v2.27h9.45v-2.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    fill: "#C10202",
    d: "M3682 632.322h-3.45v1.22h3.45v-1.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    fill: "#C10202",
    d: "M3680.61 630.002h-.64v2.79h.64v-2.79Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    fill: "red",
    d: "M3686.03 643.975h-11.57v3.27h11.57v-3.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    fill: "red",
    d: "M3686.6 645.111h-12.73v1.04h12.73v-1.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    fill: "#C10202",
    d: "M3680.42 643.972c-.34-.026-.69.053-.99.227-.3.174-.54.434-.7.748-.15.313-.2.665-.15 1.009.06.344.21.664.45.919.23.255.54.432.88.509.34.077.7.05 1.02-.078.32-.128.6-.35.8-.638.19-.288.29-.628.29-.976.02-.44-.14-.867-.44-1.189-.3-.322-.72-.513-1.16-.531Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "feuer_2",
    className: "feuer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    fill: "red",
    d: "M3876.32 653.702v-16.3c.06-.56.01-1.126-.16-1.663a4.223 4.223 0 0 0-.83-1.45c-.38-.42-.84-.755-1.35-.985a4.014 4.014 0 0 0-4.62.985c-.37.42-.66.914-.83 1.45a4.068 4.068 0 0 0-.16 1.663v16.3h7.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    fill: "#C10202",
    d: "M3876.98 637.904h-9.64v1.97h9.64v-1.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    fill: "#C10202",
    d: "M3876.97 653.002h-9.45v2.27h9.45v-2.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    fill: "#C10202",
    d: "M3874 632.322h-3.45v1.22h3.45v-1.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    fill: "#C10202",
    d: "M3872.61 630.002h-.64v2.79h.64v-2.79Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    fill: "red",
    d: "M3878.03 643.975h-11.57v3.27h11.57v-3.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    fill: "red",
    d: "M3878.6 645.111h-12.73v1.04h12.73v-1.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    fill: "#C10202",
    d: "M3872.42 643.972c-.34-.026-.69.053-.99.227-.3.174-.54.434-.7.748-.15.313-.2.665-.15 1.009.06.344.21.664.45.919.23.255.54.432.88.509.34.077.7.05 1.02-.078.32-.128.6-.35.8-.638.19-.288.29-.628.29-.976.02-.44-.14-.867-.44-1.189-.3-.322-.72-.513-1.16-.531Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bin_3",
    className: "bin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    fill: "#A5A5A5",
    d: "M3739.34 627.352v-.33a3.632 3.632 0 0 0-3.35-3.86h-2.12a3.632 3.632 0 0 0-3.35 3.86v.41a11.786 11.786 0 0 0-3.72 2.937 11.879 11.879 0 0 0-2.28 4.163c-.05.17.31.23 1 .22v20.75h19v-20.77c.65 0 1-.05 1-.22a11.85 11.85 0 0 0-2.34-4.226 11.757 11.757 0 0 0-3.84-2.934Zm-4.34-1c-.93.012-1.85.154-2.74.42.02-.41.19-.8.48-1.093.29-.293.67-.47 1.08-.497h2.2c.4.028.78.199 1.06.481.29.283.46.659.49 1.059-.84-.238-1.7-.365-2.57-.38v.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    fill: "#878787",
    d: "M3745.65 633.389h-21.23v1.51h21.23v-1.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1038",
    className: "Group 1038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    fill: "#878787",
    d: "M3727.45 636.24a.544.544 0 0 0-.38.198.57.57 0 0 0-.14.412v16.87c-.01.075 0 .152.02.224.02.073.06.14.11.197.05.057.11.103.18.134.07.032.14.048.22.048a.546.546 0 0 0 .4-.182.485.485 0 0 0 .1-.197.428.428 0 0 0 .02-.224v-16.87a.42.42 0 0 0-.03-.221.509.509 0 0 0-.11-.194.637.637 0 0 0-.17-.136.57.57 0 0 0-.22-.059Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    fill: "#878787",
    d: "M3732.46 636.221a.589.589 0 0 0-.21.057.653.653 0 0 0-.17.135.486.486 0 0 0-.11.19.797.797 0 0 0-.03.218v16.88c0 .073.01.147.03.217.02.07.06.135.11.191.05.056.11.101.17.134a.59.59 0 0 0 .21.058.576.576 0 0 0 .39-.192c.1-.112.15-.259.14-.408v-16.88a.557.557 0 0 0-.14-.409.575.575 0 0 0-.39-.191Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    fill: "#878787",
    d: "M3737.42 636.271a.593.593 0 0 0-.39.195.509.509 0 0 0-.11.194.824.824 0 0 0-.03.221v16.87c-.01.15.05.297.14.409.1.112.24.181.39.191a.494.494 0 0 0 .21-.057.573.573 0 0 0 .18-.134.67.67 0 0 0 .11-.191c.02-.07.03-.144.02-.218v-16.87a.558.558 0 0 0-.13-.411.584.584 0 0 0-.39-.199Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    fill: "#878787",
    d: "M3742.43 636.252a.54.54 0 0 0-.21.058.566.566 0 0 0-.29.331c-.03.071-.03.146-.03.221v16.87c-.01.15.04.296.14.409.1.112.24.181.39.191a.54.54 0 0 0 .21-.058.558.558 0 0 0 .18-.134c.04-.056.08-.12.1-.19.03-.071.04-.144.03-.218v-16.87a.606.606 0 0 0-.13-.412.587.587 0 0 0-.39-.198Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bush_5",
    className: "bush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    fill: "#BCB704",
    d: "M3811.75 615.252c4.06 0 7.59 2.78 9.47 6.89 1.78-3.71 5-6.2 8.74-6.2 5.63 0 10.19 5.7 10.19 12.74.01 2.182-.45 4.34-1.35 6.33h.1c6 0 10.82 6 10.82 13.52s-4.85 13.47-10.85 13.47-29.28-1.3-33.39-1.3c-6 0-4.65-24.37-4.65-31.88 0-7.51 4.9-13.57 10.92-13.57Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    fill: "#E8BC03",
    d: "M3777.48 637.771c.18-.01.36-.01.54 0 0-.35-.08-.69-.08-1 0-5.1 3.3-9.23 7.38-9.23a6.567 6.567 0 0 1 4.87 2.34 8.614 8.614 0 0 1 2.99-3.324 8.56 8.56 0 0 1 4.26-1.356c4.94 0 8.95 5 8.95 11.18 0 1.385-.22 2.761-.64 4.08 4.55.27 8.18 4.92 8.18 10.67 0 5.92-3.84 10.72-8.58 10.72-1.3 0-27-1.28-27.87-1.28-5 0-9.12-5.1-9.12-11.39 0-6.29 4.09-11.41 9.12-11.41Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_6",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    fill: "#72493E",
    d: "M5382.17 626.859h-5.32v28.29h5.32v-28.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    fill: "#A0D755",
    d: "M5390.14 617.43c0 10.42-4.76 18.86-10.64 18.86-5.88 0-10.63-8.44-10.63-18.86 0-33 4.76-75.43 10.63-75.43 5.87 0 10.64 42.43 10.64 75.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    fill: "#8CBE4B",
    d: "M5376.84 617.43c0-27.06 2.41-60.43 5.7-71.57-1-2.45-2-3.86-3-3.86-5.87 0-10.63 42.43-10.63 75.43 0 10.42 4.76 18.86 10.63 18.86a6.408 6.408 0 0 0 3-.88c-3.28-2.33-5.7-9.45-5.7-17.98Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pot",
    className: "pot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    fill: "#B0BF1D",
    d: "M5276.87 634a5.027 5.027 0 0 0-3.49 1.58 5.37 5.37 0 0 0-1.97-2.597 5.409 5.409 0 0 0-6.22 0 5.45 5.45 0 0 0-1.98 2.597c-1.42-3-3.95-4.93-6.86-4.93-4.26 0-7.71 4.23-8 9.58a4.458 4.458 0 0 0-1.51-2.198 4.456 4.456 0 0 0-2.49-.952c-2.45 0-4.44 2.55-4.44 5.69 0 3.14 2 5.68 4.44 5.68h32.52c3.12 0 5.65-3.24 5.65-7.23s-2.53-7.22-5.65-7.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    fill: "#EAE3D6",
    d: "M5281.71 645.209h-41.34v4.69h41.34v-4.69Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    fill: "#876C66",
    d: "M5244.73 654.681h32.83l1.5-4.73h-36.02l1.69 4.73Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_7",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    fill: "#72493E",
    d: "M2898.21 495.828h-5.32v28.29h5.32v-28.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    fill: "#A0D755",
    d: "M2906.14 486.44c0 10.41-4.76 18.85-10.63 18.85-5.87 0-10.64-8.44-10.64-18.85 0-33 4.76-75.44 10.63-75.44 5.87 0 10.64 42.44 10.64 75.44Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    fill: "#8CBE4B",
    d: "M2892.89 486.44c0-27.07 2.4-60.43 5.69-71.58-1-2.44-2-3.86-3-3.86-5.87 0-10.63 42.43-10.63 75.43 0 10.42 4.76 18.86 10.63 18.86a6.503 6.503 0 0 0 3-.87c-3.28-2.37-5.69-9.5-5.69-17.98Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_8",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    fill: "#72493E",
    d: "M2818.5 442.85h-4.8v25.56h4.8v-25.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    fill: "#D2F0A2",
    d: "M2816.07 445.819c-5 0-9-4.81-9-10.73v-23.47c0-5.93 4-10.73 9-10.73s9 4.8 9 10.73v23.47c0 5.92-4 10.73-9 10.73Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    fill: "#BCEA73",
    d: "M2825.07 411.621v23.47c0 5.92-4 10.73-9 10.73a7.344 7.344 0 0 1-2.21-.33c3.89-1.17 6.78-5.39 6.78-10.4v-23.47a11.83 11.83 0 0 0-2.57-7.62 8.769 8.769 0 0 0-4.15-2.82 7.698 7.698 0 0 1 2.21-.32 8.293 8.293 0 0 1 6.35 3.14 11.776 11.776 0 0 1 2.63 7.59l-.04.03Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_9",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    fill: "#A3E440",
    d: "M2807.99 423.362c0 18.89-4.05 18.55-9.06 18.55-5.01 0-9.06.34-9.06-18.55s5.11-40.18 9.06-40.18 9.06 21.3 9.06 40.18Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    fill: "#99D53B",
    d: "M2807.99 423.36c0 18.89-4.05 18.55-9.06 18.55-.81 0-1.61 0-2.36-.06 3.86-.34 6.7-2.68 6.7-18.49 0-15.25-3.34-32.08-6.7-38 .8-1.41 1.6-2.19 2.36-2.19 3.95 0 9.06 21.3 9.06 40.18v.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    fill: "#72493E",
    d: "M2801.33 441.912h-4.8v25.56h4.8v-25.56Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_10",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    fill: "#91DC5A",
    d: "M2990.98 546.034a11.718 11.718 0 0 0-1.62-3.8 10.966 10.966 0 0 0-3.7-3.45.545.545 0 0 0-.34-.069.518.518 0 0 0-.3.149.523.523 0 0 0-.15.288c-.01.111.02.221.09.312a14.474 14.474 0 0 1 2.52 7.27c.09 1.168.04 2.344-.16 3.5a.386.386 0 0 0 0 .213c.02.069.06.133.11.187a.518.518 0 0 0 .4.18h2.95a.532.532 0 0 0 .51-.43c.13-1.458.03-2.928-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    fill: "#4CBA68",
    d: "M2994.16 542.513a14.291 14.291 0 0 0-6.36-7.44.524.524 0 0 0-.64.08.454.454 0 0 0-.14.288c-.02.111.01.221.08.312a19.547 19.547 0 0 1 3.39 9.79c.12 1.566.05 3.142-.22 4.69a.51.51 0 0 0 0 .213c.02.069.06.133.11.187a.518.518 0 0 0 .4.18h2.88c.06.002.13-.008.19-.032a.538.538 0 0 0 .17-.104c.05-.046.09-.1.11-.161a.443.443 0 0 0 .05-.193v-7.65a.844.844 0 0 0-.02-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    fill: "#91DC5A",
    d: "M3000.24 535.753a.489.489 0 0 0 .08-.312.454.454 0 0 0-.14-.288.551.551 0 0 0-.31-.149.516.516 0 0 0-.33.069 14.32 14.32 0 0 0-4.87 4.54c-1 1.529-1.73 3.221-2.14 5a17.593 17.593 0 0 0-.41 5.74c.02.121.08.23.18.308.09.079.21.122.34.122h3.93a.51.51 0 0 0 .19-.035.41.41 0 0 0 .16-.105c.05-.045.09-.1.12-.16.02-.06.04-.125.04-.19v-.12a18.193 18.193 0 0 1-.22-4.66 19.345 19.345 0 0 1 3.38-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    fill: "#4CBA68",
    d: "M3002.38 539.432c.06-.09.09-.201.08-.311a.456.456 0 0 0-.14-.289.543.543 0 0 0-.31-.148.509.509 0 0 0-.33.068 10.871 10.871 0 0 0-3.7 3.45 11.51 11.51 0 0 0-1.61 3.8 12.742 12.742 0 0 0-.31 4.35.5.5 0 0 0 .51.43h3a.49.49 0 0 0 .46-.299c.03-.06.04-.125.05-.191v-.12c-.2-1.132-.26-2.284-.16-3.43.14-2.614.99-5.14 2.46-7.31Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_11",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    fill: "#91DC5A",
    d: "M2728.98 408.034a12.209 12.209 0 0 0-1.62-3.8 11.056 11.056 0 0 0-3.7-3.45.545.545 0 0 0-.34-.069.518.518 0 0 0-.3.149.523.523 0 0 0-.15.288c-.01.111.02.221.09.312a14.919 14.919 0 0 1 2.36 10.77.386.386 0 0 0 0 .213c.02.069.06.133.11.187.05.056.11.101.17.132.07.031.14.047.22.048h2.95a.547.547 0 0 0 .52-.43c.13-1.458.03-2.928-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    fill: "#4CBA68",
    d: "M2732.15 404.513a14.276 14.276 0 0 0-6.35-7.44.524.524 0 0 0-.64.08.454.454 0 0 0-.14.288c-.02.111.01.221.08.312a19.547 19.547 0 0 1 3.39 9.79c.12 1.566.05 3.142-.22 4.69a.5.5 0 0 0 0 .211c.02.069.05.134.1.189a.536.536 0 0 0 .4.18h2.9c.13.002.26-.047.36-.139a.57.57 0 0 0 .16-.351v-7.65a.434.434 0 0 0-.04-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    fill: "#91DC5A",
    d: "M2738.24 397.753a.489.489 0 0 0 .08-.312.454.454 0 0 0-.14-.288.551.551 0 0 0-.31-.149.516.516 0 0 0-.33.069 14.282 14.282 0 0 0-4.87 4.54c-1 1.528-1.73 3.22-2.14 5a17.593 17.593 0 0 0-.41 5.74c.02.121.08.231.17.31.1.079.21.121.34.12h3.94a.51.51 0 0 0 .19-.035.41.41 0 0 0 .16-.105c.05-.045.09-.1.12-.16.02-.06.04-.125.04-.19v-.12a18.193 18.193 0 0 1-.22-4.66 19.345 19.345 0 0 1 3.38-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    fill: "#4CBA68",
    d: "M2740.38 401.464a.489.489 0 0 0 .08-.312.454.454 0 0 0-.14-.288.53.53 0 0 0-.64-.08 10.963 10.963 0 0 0-3.7 3.45 11.755 11.755 0 0 0-1.62 3.8 12.738 12.738 0 0 0-.3 4.35c.02.121.08.231.17.31.1.078.21.121.34.12h2.95a.51.51 0 0 0 .19-.035.41.41 0 0 0 .16-.105c.05-.045.09-.1.12-.16.02-.06.04-.125.04-.19v-.12c-.2-1.136-.25-2.292-.16-3.44a14.488 14.488 0 0 1 2.51-7.3Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_12",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    fill: "#91DC5A",
    d: "M2828.97 572.035a11.785 11.785 0 0 0-1.61-3.81 11.036 11.036 0 0 0-3.7-3.44.544.544 0 0 0-.64.07.52.52 0 0 0-.15.288.44.44 0 0 0 .09.312 14.539 14.539 0 0 1 2.52 7.28 14.07 14.07 0 0 1-.16 3.49.436.436 0 0 0 .1.4.518.518 0 0 0 .4.18h2.95c.12.004.24-.037.33-.114a.48.48 0 0 0 .18-.306c.14-1.457.03-2.927-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    fill: "#4CBA68",
    d: "M2832.15 568.514a14.236 14.236 0 0 0-6.35-7.44.53.53 0 0 0-.33-.071.547.547 0 0 0-.31.141.464.464 0 0 0-.14.294c-.02.112.02.225.08.316 2 2.893 3.16 6.274 3.38 9.78a17.98 17.98 0 0 1-.22 4.69.51.51 0 0 0 .01.213c.02.07.05.134.1.187a.518.518 0 0 0 .4.18h2.9a.531.531 0 0 0 .36-.133.488.488 0 0 0 .15-.347v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    fill: "#91DC5A",
    d: "M2838.24 561.754a.479.479 0 0 0-.06-.61.544.544 0 0 0-.64-.07 14.335 14.335 0 0 0-4.88 4.54c-1 1.529-1.72 3.221-2.13 5-.46 1.88-.6 3.824-.41 5.75.02.12.08.229.18.306.09.078.21.118.33.114h3.93c.07.003.13-.008.19-.03a.468.468 0 0 0 .28-.26c.03-.06.05-.124.05-.19.01-.04.01-.08 0-.12a19.221 19.221 0 0 1-.21-4.67 19.537 19.537 0 0 1 3.37-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    fill: "#4CBA68",
    d: "M2840.38 565.454a.495.495 0 0 0 .08-.313.51.51 0 0 0-.45-.427.536.536 0 0 0-.33.07c-1.49.841-2.75 2.02-3.7 3.44a11.788 11.788 0 0 0-1.62 3.81 13.265 13.265 0 0 0-.31 4.35c.02.12.08.229.17.306.1.077.22.118.34.114h3c.06.002.13-.008.19-.031a.547.547 0 0 0 .17-.101.385.385 0 0 0 .11-.158.43.43 0 0 0 .05-.19v-.12a14.155 14.155 0 0 1-.16-3.44c.14-2.615.99-5.142 2.46-7.31Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "buildings_2",
    className: "buildings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    fill: "#AFAFAF",
    d: "M1358.06 434.389h-136.33v222.3h136.33v-222.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows_7",
    className: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    fill: "#fff",
    d: "M1260.82 449.01h-18.64v41.53h18.64v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    fill: "#fff",
    d: "M1260.77 510.279h-18.64v41.53h18.64v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    fill: "#fff",
    d: "M1299.29 449.17h-18.64v41.53h18.64v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    fill: "#fff",
    d: "M1299.24 510.439h-18.64v41.53h18.64v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    fill: "#fff",
    d: "M1337.5 449.002h-18.64v41.53h18.64v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    fill: "#fff",
    d: "M1337.45 510.271h-18.64v41.53h18.64v-41.53Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    fill: "#CCC",
    d: "M1307.41 596.951h-36.35v57.18h36.35v-57.18Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    fill: "#919191",
    d: "M1358.06 431.029h-136.33v4.01h136.33v-4.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    fill: "#919191",
    d: "M1234.41 431.032h11.8v-6.02l-11.8-5.35v11.37Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 986",
    className: "Group 986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    fill: "#4F7D99",
    d: "M1961.09 652.312h-3.05v-117.08h20.25v3.45h-17.2v113.63Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    fill: "#3C3C3B",
    d: "M1985.61 584.84c.03.419-.03.839-.16 1.236a3.22 3.22 0 0 1-.63 1.077 3.2 3.2 0 0 1-2.21 1.067h-11.74a3.207 3.207 0 0 1-2.83-2.144 3.451 3.451 0 0 1-.17-1.236v-37.29c-.02-.419.04-.839.17-1.236.14-.397.35-.763.63-1.077a3.207 3.207 0 0 1 2.2-1.067h11.73a3.208 3.208 0 0 1 2.21 1.067c.28.314.49.68.63 1.077.13.397.19.817.16 1.236l.01 37.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    fill: "#E20613",
    d: "M1981.64 552.432c0 3.09-2.21 5.6-4.94 5.6-2.73 0-4.93-2.51-4.93-5.6s2.22-5.59 4.93-5.59c2.71 0 4.94 2.5 4.94 5.59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    fill: "#F39732",
    d: "M1981.69 565.752c0 3.09-2.2 5.59-4.92 5.59-2.72 0-4.94-2.5-4.94-5.59s2.21-5.59 4.94-5.59c2.73 0 4.92 2.5 4.92 5.59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    fill: "#93C01F",
    d: "M1981.76 578.77c0 3.09-2.22 5.59-4.93 5.59-2.71 0-4.93-2.5-4.93-5.59s2.21-5.6 4.93-5.6c2.72 0 4.93 2.51 4.93 5.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    fill: "#3C3C3B",
    d: "M1967.48 649.311h-15.35v5.41h15.35v-5.41Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    fill: "#4F7D99",
    d: "M1978.29 537.842h-3.05v6.33h3.05v-6.33Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1046",
    className: "Group 1046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    fill: "#4F7D99",
    d: "M4568.29 652.519h-3.04v-117.08h20.24v3.45h-17.2v113.63Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    fill: "#3C3C3B",
    d: "M4592.81 585.051c.03.419-.03.839-.17 1.236a3.06 3.06 0 0 1-.63 1.077c-.27.314-.61.57-.99.753-.38.183-.79.29-1.21.314h-11.73a3.112 3.112 0 0 1-1.2-.314 3.2 3.2 0 0 1-1-.753 3.22 3.22 0 0 1-.63-1.077 3.243 3.243 0 0 1-.17-1.236v-37.29c-.02-.419.03-.839.17-1.236s.35-.763.63-1.077a3.2 3.2 0 0 1 1-.753c.37-.183.78-.29 1.2-.314h11.79c.42.024.83.131 1.21.314s.72.439.99.753c.28.314.5.68.63 1.077.14.397.2.817.17 1.236l-.06 37.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    fill: "#E20613",
    d: "M4588.87 552.649c0 3.08-2.21 5.59-4.94 5.59-2.73 0-4.93-2.51-4.93-5.59s2.22-5.6 4.93-5.6c2.71 0 4.94 2.5 4.94 5.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    fill: "#F39732",
    d: "M4588.87 566.002c0 3.09-2.21 5.59-4.93 5.59-2.72 0-4.93-2.5-4.93-5.59s2.2-5.59 4.93-5.59c2.73 0 4.93 2.46 4.93 5.59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    fill: "#93C01F",
    d: "M4588.96 579c0 3.09-2.22 5.59-4.93 5.59-2.71 0-4.93-2.5-4.93-5.59s2.21-5.6 4.93-5.6c2.72 0 4.93 2.49 4.93 5.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    fill: "#3C3C3B",
    d: "M4574.68 649.521h-15.35v5.41h15.35v-5.41Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    fill: "#4F7D99",
    d: "M4585.49 538.049h-3.05v6.33h3.05v-6.33Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "birds",
    className: "birds"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    fill: "#67A4CF",
    d: "M4161.59 126.002c3.76-.26 7.23 1.73 10.68 3 4.82 1.73 9.74 2.15 14.8 2.48 7.64.52 12.6 4.28 16.21 9.88.15-.178.3-.342.47-.49a29.668 29.668 0 0 1 5.51-4c4.17-2.11 9.05-2.29 13.61-2.07 8 .4 18 7.5 25.86 4.12.17-.062.35-.099.52-.11-6.2 7.08-16.9 3-25.21 3.51-1.31.108-2.62.302-3.92.58a24.78 24.78 0 0 0-3.92.76 13.74 13.74 0 0 0-4.13 2.32 43.113 43.113 0 0 0-7.47 5.29 5.245 5.245 0 0 1-5.85-2.83c-.24-.705-.52-1.396-.85-2.07-1.44-3.38-3.09-6.31-7-7.52-.89-.259-1.8-.443-2.73-.55-1.44-.58-2.89-1.06-4.36-1.49-8.15-2.33-17.39-3.89-22.43-10.78l.21-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    fill: "#67A4CF",
    d: "M4570.36 122.589c1.82-.61 3.8-.09 5.67.11 2.57.118 5.14-.108 7.64-.67 1.66-.347 3.38-.272 5 .217a10.13 10.13 0 0 1 4.28 2.583 1 1 0 0 1 .17-.28 14.13 14.13 0 0 1 2.22-2.69 14.222 14.222 0 0 1 6.46-2.78c4-.82 9.87 1.41 13.33-1.28.08-.046.16-.083.25-.11-2.17 4.3-8 3.64-12 5-.63.219-1.25.476-1.86.77-.64.224-1.25.52-1.82.88a7.276 7.276 0 0 0-1.83 1.66 23.289 23.289 0 0 0-3 3.58 2.692 2.692 0 0 1-3.25-.64c-.2-.331-.43-.643-.69-.93-1.14-1.47-2.32-2.74-4.44-2.82a6.216 6.216 0 0 0-1.42.08c-.77-.104-1.56-.154-2.34-.15-4.36-.15-9.1.27-12.48-2.5l.11-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    fill: "#67A4CF",
    d: "M4390.77 162.242c-1.83-.61-3.81-.09-5.68.11-2.56.117-5.12-.108-7.63-.67a10.086 10.086 0 0 0-4.99.215c-1.62.489-3.1 1.378-4.29 2.585a.89.89 0 0 0-.18-.29 13.712 13.712 0 0 0-2.21-2.68 14.183 14.183 0 0 0-6.46-2.78c-4-.82-9.88 1.41-13.33-1.28a.922.922 0 0 0-.26-.11c2.17 4.3 8 3.64 12 5 .64.218 1.26.475 1.86.77.64.226 1.26.521 1.83.88a6.754 6.754 0 0 1 1.77 1.67 22.466 22.466 0 0 1 3 3.58c.54.271 1.15.355 1.74.239a2.665 2.665 0 0 0 1.51-.879c.21-.329.44-.64.69-.93 1.15-1.48 2.32-2.74 4.44-2.82.48-.028.96-.002 1.42.08.78-.104 1.56-.154 2.34-.15 4.36-.15 9.1.27 12.48-2.5l-.05-.04Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "helikopter",
    className: "helikopter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1033",
    className: "Group 1033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1031",
    className: "Group 1031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    fill: "#7D8696",
    d: "M2623.48 234.17h-1.21v4.91h1.21v-4.91Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    fill: "#7D8696",
    d: "M2624.7 234.17h-1.21v4.91h1.21v-4.91Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "M2622.33 233.232h-15.6c-1.19 0 .67 2.11 1.86 2.11h11v-.19c0-.248.09-.489.26-.674a.976.976 0 0 1 .64-.326h2.73a1.001 1.001 0 0 0-.89-.92Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "M2640.03 233.232h-15.59a1 1 0 0 0-.6.281.993.993 0 0 0-.3.599h3.33a.984.984 0 0 1 .9 1v.19h10.4c1.21.04 3.06-2.07 1.86-2.07Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1032",
    className: "Group 1032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    fill: "#FFDF5A",
    fillRule: "evenodd",
    d: "M2625.87 235.591c0-1.73-1.06-3.14-2.35-3.14s-2.36 1.41-2.36 3.14h4.71Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    fill: "#FCD017",
    fillRule: "evenodd",
    d: "M2623.49 235.591v-3.14c1.29 0 2.35 1.4 2.35 3.14h-2.35Z",
    className: "Vector",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1030",
    className: "Group 1030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "m2595.87 242.001-6.89-4.85c-1.4-1-3.91-1.24-4.76-.67l3.28 6.41 8.37-.89Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1029",
    className: "Group 1029"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    fill: "#7D8696",
    d: "M2616.66 253.01h-.68v3.65h.68v-3.65Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_524",
    fill: "#7D8696",
    d: "M2631.52 254.1h-.68v2.57h.68v-2.57Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_525",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "M2612.94 256.662h22.56c.1.46-.41.72-1.38.85h-21.18v-.85Z",
    className: "Vector",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1028",
    className: "Group 1028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_526",
    fill: "#FFDF5A",
    fillRule: "evenodd",
    d: "M2620.21 239.142c-2 .1-3.32.27-3.33.27l-30.28 3.21c-1.35-.19-1.74 3.07.39 2.91l18.31.17c.41 5.06 3.41 6.48 7.62 8.06a74.395 74.395 0 0 0 19.75 1.24c2.32-1.33 3.2-3.87 3-6.8-.38-5-3.2-8.07-7.92-8.83-2.49-.339-5.01-.43-7.52-.27l-.02.04Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_527",
    fill: "#FCD017",
    fillRule: "evenodd",
    d: "M2635.2 245.702c.45 2.54 3.34 2.44 3.4 4 .13 2.93-1.4 4.93-5.93 5.32a74.75 74.75 0 0 1-19.75-1.28c-4.21-1.58-7.21-3-7.62-8.06l29.9.02Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_528",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "M2636.29 247.541a3.025 3.025 0 0 1-1-1.4 8.481 8.481 0 0 0-3-4.85h-.35c-5.64 0-10.22 1.4-10.22 3.12 0 1.72 4.58 3.13 10.22 3.13h4.35Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_529",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "M2622.63 245.701h12.57l.12.44c.19.554.54 1.041 1 1.4h-4.34c-4.18 0-7.75-.76-9.35-1.84Z",
    className: "Vector",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_530",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3279.87 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.02.326-.08.647-.3.894-.21.247-.51.4-.84.426h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.63a1.3 1.3 0 0 1 .31-.886c.21-.244.51-.396.83-.424Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_531",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3285.05 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.02.322-.08.641-.29.888-.21.246-.51.401-.83.432h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.63a1.24 1.24 0 0 1 .3-.882c.21-.244.5-.398.82-.428Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_532",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3305.8 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.02.322-.08.641-.29.888-.21.246-.51.401-.83.432h-1a1.23 1.23 0 0 1-.83-.419 1.288 1.288 0 0 1-.31-.881v-2.63a1.24 1.24 0 0 1 .3-.882c.21-.244.5-.398.82-.428Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_533",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3310.99 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.02.322-.08.641-.29.888-.21.246-.51.401-.83.432h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.63c-.01-.321.09-.635.3-.879s.5-.398.82-.431Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "aeroplane",
    className: "aeroplane"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_534",
    fill: "#78BFEA",
    fillRule: "evenodd",
    d: "m3362.98 161.259 7.95-37.48-6.07.15-19 25.59a14.013 14.013 0 0 1-6.93 5.08l-13.47 4.47 26.06 4.36 11.46-2.17Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_535",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "m3362.98 161.259 7.95-37.48-4 .1-16.45 29.4c-3.15 4.47-8.65 6.71-13 7.79l24.19 3.13 1.31-2.94Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1037",
    className: "Group 1037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_536",
    fill: "#9CDCFF",
    fillRule: "evenodd",
    d: "m3245.28 184.131 81.6 2.06c34-6.19 37.92-14.66 36.53-25.11a884.434 884.434 0 0 0-105.79-2.67c-4.29.15-14.62 1.68-19.59 6.49a9.538 9.538 0 0 0-1.95 2.66c-6 3.65-9.17 6.79-3.77 11 3.7 3.059 8.2 4.992 12.97 5.57Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1036",
    className: "Group 1036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_537",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "m3236.08 167.562 5.15 2.34c1.85-1.19 3.1-2.55 3.4-4.19l-5.54-1.73a9.715 9.715 0 0 0-3.01 3.58Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_538",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3303.4 180.55h31.41a47.074 47.074 0 0 0 6.08-2.84l-34.88-1.29-2.61 4.13Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows_8",
    className: "windows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1035",
    className: "Group 1035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_539",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3317.04 168.752h1c.16.01.32.052.46.123.15.071.27.17.38.291.1.121.18.261.24.413.05.153.07.313.05.473v2.62c.03.324-.08.644-.29.891-.21.247-.51.401-.84.429h-1c-.16-.009-.32-.05-.46-.12a1.325 1.325 0 0 1-.38-.29 1.157 1.157 0 0 1-.24-.415 1.274 1.274 0 0 1-.06-.475v-2.62a1.244 1.244 0 0 1 1.14-1.32Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_540",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3322.23 168.752h1c.16.009.32.05.46.12.15.071.28.169.38.29.11.121.19.262.24.415.05.153.07.314.06.475v2.62c.02.324-.08.644-.29.891-.21.247-.51.401-.84.429h-1a1.258 1.258 0 0 1-.84-.416 1.239 1.239 0 0 1-.3-.884v-2.62a1.26 1.26 0 0 1 .3-.891c.21-.247.51-.401.83-.429Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_541",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3327.42 168.752h1c.16.01.32.052.46.123.15.071.28.169.38.29.11.121.19.261.24.414.05.152.07.313.06.473v2.62c.01.16 0 .322-.05.475-.05.153-.13.295-.23.418a1.35 1.35 0 0 1-.38.297c-.14.073-.3.117-.46.13h-1a1.258 1.258 0 0 1-.84-.416 1.239 1.239 0 0 1-.3-.884v-2.62c-.02-.323.08-.641.29-.888.21-.246.51-.402.83-.432Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_542",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3332.61 168.752h1c.32.023.63.172.84.416.21.243.32.561.3.884v2.62c.03.323-.08.643-.29.89-.21.248-.5.402-.83.43h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.62c-.02-.323.08-.641.29-.888.21-.246.51-.402.83-.432Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_543",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3337.8 168.752h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.03.323-.08.643-.28.89-.21.248-.51.402-.84.43h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.62c-.02-.323.09-.641.3-.888.2-.246.5-.402.82-.432Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_544",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3342.99 168.752h1c.16.01.32.052.46.123.15.071.27.17.38.291a1.14 1.14 0 0 1 .29.886v2.62c.03.323-.08.641-.29.888-.21.246-.5.401-.83.432h-1a1.24 1.24 0 0 1-.84-.413c-.1-.121-.18-.262-.24-.414a1.263 1.263 0 0 1-.06-.473v-2.62a1.26 1.26 0 0 1 .3-.891c.21-.247.51-.401.83-.429Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_545",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3348.18 168.752h1c.16.01.32.052.46.123.14.071.27.17.38.291a1.266 1.266 0 0 1 .29.886v2.62c.02.323-.08.641-.29.888-.21.246-.51.401-.83.432h-1c-.16-.009-.32-.05-.46-.12a1.1 1.1 0 0 1-.38-.29 1.157 1.157 0 0 1-.24-.415 1.274 1.274 0 0 1-.06-.475v-2.62a1.26 1.26 0 0 1 .3-.891c.21-.247.51-.401.83-.429Z",
    className: "Vector",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1034",
    className: "Group 1034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_546",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3253.92 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.03.322-.08.641-.29.888-.21.246-.5.401-.83.432h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.63a1.24 1.24 0 0 1 .3-.882c.21-.244.5-.398.82-.428Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_547",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3259.11 168.76h1c.32.023.62.173.83.416.22.244.32.562.3.884v2.62c.02.322-.08.641-.29.888-.21.246-.51.401-.83.432h-1a1.23 1.23 0 0 1-1.13-1.3v-2.63a1.24 1.24 0 0 1 .3-.882c.21-.244.5-.398.82-.428Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_548",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3264.29 168.76h1c.32.023.62.172.84.416.21.243.32.561.3.884v2.62c.02.324-.08.644-.29.891-.22.247-.52.401-.84.429h-1a1.23 1.23 0 0 1-1.13-1.3v-2.63a1.24 1.24 0 0 1 .3-.882c.21-.244.5-.398.82-.428Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_549",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3269.48 168.76h1c.32.023.62.172.84.416.21.243.32.561.3.884v2.62a1.253 1.253 0 0 1-1.13 1.32h-1a1.23 1.23 0 0 1-.83-.419 1.198 1.198 0 0 1-.31-.881v-2.63a1.244 1.244 0 0 1 1.13-1.31Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_550",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3274.67 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.03.322-.08.641-.29.888-.21.246-.5.401-.83.432h-1a1.23 1.23 0 0 1-.83-.419 1.288 1.288 0 0 1-.31-.881v-2.63a1.24 1.24 0 0 1 .3-.882c.21-.244.5-.398.82-.428Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_551",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3279.87 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.03.326-.08.647-.3.894-.21.247-.51.4-.84.426h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.63a1.3 1.3 0 0 1 .31-.886c.21-.244.51-.396.83-.424Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_552",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3285.05 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.03.322-.08.641-.29.888-.21.246-.51.401-.83.432h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.63a1.24 1.24 0 0 1 .3-.882c.21-.244.5-.398.82-.428Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_553",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3290.24 168.76h1c.16.01.32.052.47.123.14.07.27.169.37.29.11.121.19.261.24.413.05.153.08.313.06.474v2.62c.03.322-.08.641-.29.888-.21.246-.5.401-.83.432h-1a1.247 1.247 0 0 1-1.14-1.3v-2.63a1.24 1.24 0 0 1 .3-.882c.21-.244.5-.398.82-.428Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_554",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3295.42 168.76h1c.16.01.32.052.46.123.15.07.28.169.38.29.11.121.19.261.24.413.05.153.07.313.06.474v2.62c.02.324-.08.644-.29.891-.21.247-.51.401-.84.429h-1a1.214 1.214 0 0 1-.83-.416 1.204 1.204 0 0 1-.31-.884v-2.63a1.244 1.244 0 0 1 1.13-1.31Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_555",
    fill: "#67A4CF",
    fillRule: "evenodd",
    d: "M3300.61 168.76h1c.33.023.63.172.84.416.21.243.32.561.3.884v2.62c.02.323-.08.642-.29.888-.22.246-.51.401-.84.432h-1a1.23 1.23 0 0 1-.83-.419 1.288 1.288 0 0 1-.31-.881v-2.63a1.244 1.244 0 0 1 1.13-1.31Z",
    className: "Vector",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_556",
    fill: "#78BFEA",
    fillRule: "evenodd",
    d: "m3259.69 180.42 6.53-2.28 29.65-4.84c3.43.19 17.41-12.57 23.42-24.7l3.72.07-8.88 22.87c-1.85 4.8-4.48 7.8-7.88 9l-22.8.14-23.76-.26Z",
    className: "Vector",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "balloon1",
    className: "balloon1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_557",
    fill: "#9BC1F9",
    fillRule: "evenodd",
    d: "M832.103 226.572c8.73 0 17.12 5.72 17.38 16.27.24 9.72-7.54 18.36-10.28 24.41h-7.1v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_558",
    fill: "#E8313F",
    fillRule: "evenodd",
    d: "M832.103 226.572c6.43 0 15.06 6.17 14.61 16.91-.37 8.65-5.13 15.52-9.38 23.77h-5.23v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_559",
    fill: "#9BC1F9",
    fillRule: "evenodd",
    d: "M832.103 226.572c4.57 0 10.71 6.17 10.39 16.91-.26 8.65-3.65 15.52-6.67 23.77h-3.72v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_560",
    fill: "#E8313F",
    fillRule: "evenodd",
    d: "M832.103 226.572c2.62 0 6.14 6.17 6 16.91-.15 8.65-2.09 15.52-3.83 23.77h-2.13l-.04-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_561",
    fill: "#9BC1F9",
    fillRule: "evenodd",
    d: "M832.104 226.572c-8.72 0-17.11 5.72-17.37 16.27-.24 9.72 7.54 18.36 10.28 24.41h7.09v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_562",
    fill: "#FF4248",
    fillRule: "evenodd",
    d: "M832.103 226.572c-6.42 0-15.05 6.17-14.6 16.91.36 8.65 5.13 15.52 9.38 23.77h5.22v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_563",
    fill: "#9BC1F9",
    fillRule: "evenodd",
    d: "M832.103 226.572c-4.56 0-10.7 6.17-10.37 16.91.25 8.65 3.64 15.52 6.66 23.77h3.71v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_564",
    fill: "#FF4248",
    fillRule: "evenodd",
    d: "M832.103 226.572c-2.61 0-6.13 6.17-6 16.91.15 8.65 2.09 15.52 3.83 23.77h2.12l.05-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 969",
    className: "Group 969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_565",
    fill: "#7D8696",
    d: "M829.342 274.311h-.45v3.28h.45v-3.28Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_566",
    fill: "#7D8696",
    d: "M835.315 274.311h-.45v3.28h.45v-3.28Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_567",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "M835.554 277.381h-6.89a.337.337 0 0 0-.228.117.337.337 0 0 0-.082.243v4.07a.338.338 0 0 0 .31.36h6.89a.343.343 0 0 0 .31-.36v-4.07a.341.341 0 0 0-.31-.36Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_568",
    fill: "#FFDF5A",
    fillRule: "evenodd",
    d: "M832.114 267.252h-7.14l3.26 7.38h3.88v-7.38Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_569",
    fill: "#FCD017",
    fillRule: "evenodd",
    d: "M832.115 267.252h7.13l-3.26 7.38h-3.87v-7.38Z",
    className: "Vector",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "birds cloud",
    className: "birds cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_570",
    fill: "#67A4CF",
    d: "M2794.27 224.309c2.34-.44 4.71.53 6.94 1.05 3.14.601 6.35.756 9.53.46 2.11-.155 4.22.221 6.14 1.095s3.6 2.216 4.86 3.905c.08-.125.17-.24.27-.34.93-1.106 2-2.091 3.17-2.93 2.47-1.66 5.53-2.13 8.42-2.34 5.08-.35 11.9 3.37 16.63.63.09-.062.2-.09.3-.08-3.38 4.93-10.46 3.15-15.62 4.11-.82.166-1.64.379-2.45.64-.81.2-1.62.461-2.4.78a8.86 8.86 0 0 0-2.45 1.79 28.527 28.527 0 0 0-4.28 3.88 3.272 3.272 0 0 1-3.89-1.31 7.7 7.7 0 0 0-.72-1.25c-1.14-2-2.42-3.75-5-4.23a9.404 9.404 0 0 0-1.78-.13 23.81 23.81 0 0 0-2.85-.59c-5.32-.87-11.24-1.18-14.94-5.13l.12-.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_571",
    fill: "#67A4CF",
    d: "M2927.51 126.002c3.76-.26 7.24 1.73 10.68 3 4.83 1.73 9.75 2.15 14.8 2.48 7.65.52 12.6 4.28 16.22 9.88.14-.177.3-.341.46-.49a29.738 29.738 0 0 1 5.52-4c4.17-2.11 9-2.29 13.61-2.07 8 .4 18 7.5 25.86 4.12.17-.062.34-.099.51-.11-6.2 7.08-16.9 3-25.21 3.51-1.31.109-2.62.302-3.92.58-1.32.146-2.63.401-3.91.76-1.5.523-2.9 1.309-4.14 2.32a43.997 43.997 0 0 0-7.47 5.29 5.213 5.213 0 0 1-3.41-.398 5.22 5.22 0 0 1-2.43-2.432c-.24-.705-.53-1.396-.85-2.07-1.45-3.38-3.1-6.31-7-7.52-.89-.258-1.8-.442-2.73-.55a47.71 47.71 0 0 0-4.36-1.49c-8.15-2.33-17.39-3.89-22.43-10.78l.2-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_572",
    fill: "#fff",
    d: "M3167.51 146.001c0-8.36-5.89-15.14-13.16-15.14-5 0-9.35 3.21-11.58 7.94-3.8-6.35-10.15-10.51-17.35-10.51-9.17 0-17 6.74-19.86 16.15-.4-.063-.8-.097-1.21-.1-5.29 0-9.58 4.94-9.58 11 .01.575.05 1.15.12 1.72-4 1.33-6.91 5.56-6.91 10.59 0 6.09 4.29 11 9.58 11 .98.003 1.94-.166 2.86-.5 2.91 4.84 7.76 8 13.25 8a14.34 14.34 0 0 0 7.14-1.94 12.215 12.215 0 0 0 9 4.1c5.86 0 10.82-4.41 12.52-10.5 1.33.516 2.74.784 4.17.79 7.27 0 13.16-6.78 13.16-15.15 0-1.173-.12-2.342-.36-3.49 4.8-2.15 8.21-7.59 8.21-13.96Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 985",
    className: "Group 985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_573",
    fill: "#EAC632",
    d: "M1718.65 595.451h-19c-1.65 0-3 1.71-3 3.81v38.85c0 2.11 1.33 3.81 3 3.81h5.62v12.81h8.08v-12.81h5.31c1.64 0 3-1.7 3-3.81v-38.85c-.04-2.1-1.37-3.81-3.01-3.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_574",
    fill: "#EAEAEA",
    d: "M1719.41 598.17h-20.53v40.89h20.53v-40.89Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bush_6",
    className: "bush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_575",
    fill: "#BCB704",
    d: "M1637.11 604.002c-4.84 0-9 3.31-11.28 8.21-2.12-4.42-6-7.38-10.41-7.38-6.71 0-12.14 6.79-12.14 15.16-.01 2.6.54 5.172 1.61 7.54h-.13c-7.12 0-12.89 7.2-12.89 16.09s5.77 16.1 12.89 16.1c7.12 0 34.88-1.55 39.78-1.55 7.16 0 5.54-29 5.54-38s-5.81-16.17-12.97-16.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_576",
    fill: "#E8BC03",
    d: "M1677.93 630.831h-.64c0-.42.1-.82.1-1.25 0-6.07-3.94-11-8.8-11-1.11.028-2.2.29-3.2.769a7.775 7.775 0 0 0-2.6 2.011c-1.93-3.36-5.07-5.57-8.64-5.57-5.88 0-10.65 6-10.65 13.31 0 1.65.25 3.289.76 4.86-5.42.32-9.75 5.86-9.75 12.71 0 7.05 4.58 12.77 10.23 12.77 1.54 0 32.14-1.52 33.19-1.52 6 0 10.86-6.08 10.86-13.57s-4.86-13.52-10.86-13.52Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_577",
    fill: "red",
    d: "M1739.87 653.18v-16.3c0-1.061-.42-2.078-1.17-2.829a4.005 4.005 0 0 0-5.66 0 4.002 4.002 0 0 0-1.17 2.829v16.3h8Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_578",
    fill: "#C10202",
    d: "M1740.52 637.38h-9.64v1.97h9.64v-1.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_579",
    fill: "#C10202",
    d: "M1740.52 652.49h-9.45v2.27h9.45v-2.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_580",
    fill: "#C10202",
    d: "M1737.54 631.811h-3.45v1.22h3.45v-1.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_581",
    fill: "#C10202",
    d: "M1736.16 629.48h-.64v2.791h.64v-2.791Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_582",
    fill: "red",
    d: "M1741.58 643.46h-11.57v3.27h11.57v-3.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_583",
    fill: "red",
    d: "M1742.14 644.59h-12.73v1.04h12.73v-1.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_584",
    fill: "#C10202",
    d: "M1735.96 643.461c-.34-.022-.68.059-.98.234-.3.176-.54.436-.68.747-.15.312-.2.661-.15 1.002a1.742 1.742 0 0 0 1.32 1.411c.34.076.69.049 1.01-.078.32-.126.6-.346.79-.63.2-.285.3-.622.3-.966.02-.442-.15-.87-.45-1.193-.3-.322-.72-.512-1.16-.527Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_585",
    fill: "#4F7D99",
    d: "M4480.87 647h-4.84V525.08c0-7.78 5.12-14.12 11.43-14.12s11.44 6.34 11.44 14.12v11.48h-4.85v-11.48c0-4.49-3-8.14-6.59-8.14s-6.59 3.65-6.59 8.14V647Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_586",
    fill: "#A9C5D3",
    d: "M4482.03 618.109h-7.11l-4.1 36.6h14.82l-3.61-36.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_587",
    fill: "#FDC800",
    d: "M4488.67 541.53v.11c0 5.06 3.32 9.17 7.43 9.17 4.11 0 7.42-4.11 7.42-9.17v-.11h-14.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_588",
    fill: "#A9C5D3",
    d: "M4496.09 529.59c-6 0-10.89 6.06-10.89 13.54h21.77c0-7.48-4.87-13.54-10.88-13.54Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1047",
    className: "Group 1047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_589",
    fill: "#EAC632",
    d: "M4530.71 595.439h-19c-1.64 0-3 1.7-3 3.81v38.84c0 2.11 1.33 3.82 3 3.82h5.62v12.8h8.07v-12.8h5.31c1.65 0 3-1.71 3-3.82v-38.84c-.03-2.11-1.35-3.81-3-3.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_590",
    fill: "#EAEAEA",
    d: "M4531.47 598.162h-20.53v40.89h20.53v-40.89Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1055",
    className: "Group 1055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_591",
    fill: "#67D3CB",
    d: "M4363.89 638.292v7.45l3.16 2h78.92l12.41-4.41c2-.71 2.51-2.89 2.51-5.36v-9.47l-2.29-3.76-5.45-.81c-2.7-.407-5.3-1.337-7.65-2.74l-7.49-4.43a19.289 19.289 0 0 0-9.89-2.76h-14.05a18.299 18.299 0 0 0-11 3.79l-12.32 9.28s-14.31 0-23.23 4.91a6.608 6.608 0 0 0-2.53 2.56l-1.06 3.74-.04.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_592",
    fill: "#67D3CB",
    d: "M4363.88 645.731c-.07.914.22 1.819.81 2.519.6.701 1.44 1.139 2.35 1.221h78.92l12.41-4.41a5.589 5.589 0 0 0 2.53-2.159c.6-.959.89-2.08.84-3.211v-5.17l-1.29-2.82 1.29-2.78v-.44a3.518 3.518 0 0 0-.7-2.361 3.546 3.546 0 0 0-2.06-1.349l-.39-.05v13.67c.04.731-.16 1.454-.55 2.074-.39.62-.95 1.106-1.63 1.396-.74.228-1.55.154-2.25-.204a3.03 3.03 0 0 1-1.47-1.716c-1.8-4.32-5.55-7.28-9.89-7.28-5.25 0-9.65 4.34-10.77 10.16a3.298 3.298 0 0 1-1.01 2.005c-.56.531-1.29.85-2.06.905h-33.89a3.303 3.303 0 0 1-2.05-.904 3.355 3.355 0 0 1-1.01-2.006c-1.12-5.82-5.52-10.16-10.78-10.16s-9.65 4.34-10.77 10.16a3.298 3.298 0 0 1-1.01 2.005c-.56.531-1.29.85-2.06.905h-3.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_593",
    fill: "#8BB3EA",
    d: "M4398.88 625.362c-.67.5-.37 1.72.42 1.72h2.25l37.72-1.65c.41-.323.78-.685 1.11-1.08.13-.159.23-.344.28-.541.06-.198.07-.405.04-.609a1.325 1.325 0 0 0-.2-.574 1.54 1.54 0 0 0-.42-.446l-3.49-2.07-.16-.09-3.53-1.55a16.22 16.22 0 0 0-4.83-.74h-7.41l-1.47 1.22-1.68-1.22h-3.44a15.54 15.54 0 0 0-9.32 3.21l-5.85 4.41-.02.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_594",
    fill: "#739AD6",
    d: "m4404.73 624.733-3.18 2.39h16l1.55-1.46 1.6 1.46h13.82l3.12-.62a7.926 7.926 0 0 0 1.63-1l-2.68-1.59a16.626 16.626 0 0 0-8.48-2.36h-14.04c-3.37.01-6.65 1.127-9.34 3.18Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_595",
    fill: "#DBEAFF",
    d: "M4395.45 640.161a1.752 1.752 0 0 1 1.58-1.87h30c.44.079.84.309 1.12.651.29.342.45.773.45 1.219 0 .446-.16.877-.45 1.219-.28.342-.68.572-1.12.651h-30a1.752 1.752 0 0 1-1.58-1.87Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1052",
    className: "Group 1052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_596",
    fill: "#212121",
    d: "M4442.8 655.1c4.36 0 7.89-4.182 7.89-9.34 0-5.158-3.53-9.34-7.89-9.34-4.36 0-7.89 4.182-7.89 9.34 0 5.158 3.53 9.34 7.89 9.34Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_597",
    fill: "#DAD8DB",
    d: "M4442.8 651.362c2.62 0 4.74-2.507 4.74-5.6 0-3.093-2.12-5.6-4.74-5.6-2.61 0-4.74 2.507-4.74 5.6 0 3.093 2.13 5.6 4.74 5.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_598",
    fill: "#ECEAEC",
    d: "M4442.8 647.633c.87 0 1.58-.838 1.58-1.87 0-1.033-.71-1.87-1.58-1.87-.87 0-1.58.837-1.58 1.87 0 1.032.71 1.87 1.58 1.87Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1053",
    className: "Group 1053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1054",
    className: "Group 1054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_599",
    fill: "#212121",
    d: "M4381.24 655.1c4.36 0 7.89-4.182 7.89-9.34 0-5.158-3.53-9.34-7.89-9.34-4.35 0-7.89 4.182-7.89 9.34 0 5.158 3.54 9.34 7.89 9.34Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_600",
    fill: "#DAD8DB",
    d: "M4381.24 651.362c2.62 0 4.74-2.507 4.74-5.6 0-3.093-2.12-5.6-4.74-5.6s-4.74 2.507-4.74 5.6c0 3.093 2.12 5.6 4.74 5.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_601",
    fill: "#ECEAEC",
    d: "M4381.24 647.633c.87 0 1.58-.838 1.58-1.87 0-1.033-.71-1.87-1.58-1.87-.87 0-1.58.837-1.58 1.87 0 1.032.71 1.87 1.58 1.87Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_602",
    fill: "#5A82C3",
    d: "M4436.43 620.021a16.4 16.4 0 0 0-3.53-1.55l1.62 8.61h.28c.98 0 1.95-.212 2.84-.62l-1.21-6.44Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_603",
    fill: "#5A82C3",
    d: "M4420.7 627.082h-3.15v-9.35h3.15v9.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_604",
    fill: "#FF8086",
    d: "M4461.74 628.951h-3.15c-.45.043-.87.263-1.17.613-.29.35-.44.801-.41 1.257v1.91c-.03.456.12.906.41 1.254.3.348.72.565 1.17.606h3.15v-5.64Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_605",
    fill: "#E1A546",
    d: "M4208.04 624.88h.07-.07c0 .02 0 0 0 0Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "light_2",
    className: "light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_606",
    fill: "#4F7D99",
    d: "M1249.95 648.06h-4.85V526.12c0-7.78 5.13-14.12 11.43-14.12s11.44 6.34 11.44 14.12v11.48h-4.84v-11.48c0-4.49-3-8.14-6.6-8.14-3.6 0-6.58 3.65-6.58 8.14v121.94Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_607",
    fill: "#A9C5D3",
    d: "M1251.08 619.152h-7.11l-4.1 36.6h14.81l-3.6-36.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_608",
    fill: "#FDC800",
    d: "M1257.74 542.57v.11c0 5.06 3.32 9.17 7.43 9.17 4.11 0 7.42-4.11 7.42-9.17v-.11h-14.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_609",
    fill: "#A9C5D3",
    d: "M1265.15 530.621c-6 0-10.89 6.06-10.89 13.54h21.76c0-7.48-4.87-13.54-10.87-13.54Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dog",
    className: "dog"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_610",
    fill: "#D48748",
    d: "M907.129 652.572h-.35a.528.528 0 0 1-.44-.58v-2.34h-1.88v4.59h3.12v-1.09a.53.53 0 0 0-.45-.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_611",
    fill: "#D48748",
    d: "M919.42 652.57h-.21a1.12 1.12 0 0 1-.76-.41l-2.33-3a1.57 1.57 0 0 1-1.1.49h-1.17l2.55 3.3c.18.22.32.4.33.4.012.193.012.387 0 .58v.32h3.12v-1.1a.534.534 0 0 0-.43-.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_612",
    fill: "#D48748",
    d: "M913.941 642.883a2.927 2.927 0 0 1-.71-.09s-.07 0-.08.09a1.355 1.355 0 0 1-1.21 1.17 1.472 1.472 0 0 1-1.25-1.62v-2.59h-5.91a3.146 3.146 0 0 1-.62-3.23 1.523 1.523 0 0 0-.6-1.77c-.55-.28-1.16.07-1.37.78a6.555 6.555 0 0 0 .63 5.55c0 .07 0 .14-.07.22-.07.08-1.8 6-1.8 6a1.914 1.914 0 0 1-.54.84l-2.15 1.66a.994.994 0 0 0-.38.52v3.66a.551.551 0 0 0 0 .19h1.69a.605.605 0 0 0 0-.19v-1.27a.77.77 0 0 1 .43-.72l1.79-.57c.29-.124.52-.358.64-.65l.69-1.78a1.687 1.687 0 0 0 1.31.7h5.67v4.47h3.12v-1.09a.532.532 0 0 0-.45-.58h-.34a.531.531 0 0 1-.45-.58v-2.22h3a2.212 2.212 0 0 0 1.88-2.43v-4.45h-3l.08-.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_613",
    fill: "#D48748",
    d: "M917.678 633h-3.74c-1.86 0-3.36 1.94-3.36 4.33v.19a1.396 1.396 0 0 1 .733-1.598 1.382 1.382 0 0 1 1.225 0 1.38 1.38 0 0 1 .749.969c.043.208.037.423-.017.629v4.86c.001.162-.019.323-.06.48.239.063.484.097.73.1h3.74c.196.002.391-.022.58-.07a2.17 2.17 0 0 1-.82-1.76v-.66a1.829 1.829 0 0 1 1.56-2h.4a.09.09 0 0 0 .037-.008.084.084 0 0 0 .031-.022.078.078 0 0 0 .018-.032.083.083 0 0 0 .004-.038.399.399 0 0 1 .36-.38h.74a.392.392 0 0 1 .35.4.121.121 0 0 0 .08.1v-1.11c.03-2.44-1.49-4.38-3.34-4.38Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_614",
    fill: "#FFD5B3",
    d: "M922.477 641.173a1.919 1.919 0 0 1-1.65 2.12h-1.78a1.93 1.93 0 0 1-1.65-2.12v-.66a1.933 1.933 0 0 1 1.65-2.13h1.83a1.92 1.92 0 0 1 1.65 2.12l-.05.67Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_615",
    fill: "#15004D",
    d: "M918.49 641.171v-.66a1.918 1.918 0 0 1 1.65-2.12h-1.09a1.927 1.927 0 0 0-1.65 2.12v.66a1.932 1.932 0 0 0 1.65 2.12h1.14a1.918 1.918 0 0 1-1.635-1.373 1.907 1.907 0 0 1-.065-.747Z",
    className: "Vector",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_616",
    fill: "#A75436",
    d: "M921.051 639.012a.527.527 0 0 1-.45.58h-.74a.528.528 0 0 1-.45-.58v-.53a.53.53 0 0 1 .45-.58h.74a.531.531 0 0 1 .45.58v.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_617",
    fill: "#A75436",
    d: "M915.879 637.44a.791.791 0 0 1-.67-.87v-.77a.69.69 0 1 1 1.34 0v.77a.791.791 0 0 1-.67.87Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_618",
    fill: "#A75436",
    d: "M919.047 637.44a.791.791 0 0 1-.67-.87v-.77a.69.69 0 1 1 1.34 0v.77a.791.791 0 0 1-.67.87Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_619",
    fill: "#A75436",
    d: "M913.268 642.38a1.59 1.59 0 0 1-1.35 1.74 1.579 1.579 0 0 1-1.34-1.74v-4.9a1.574 1.574 0 0 1 1.34-1.73 1.581 1.581 0 0 1 1.35 1.73v4.9Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_620",
    fill: "#15004D",
    d: "M911.778 642.38v-4.9a1.841 1.841 0 0 1 .74-1.55 1.14 1.14 0 0 0-.6-.18 1.57 1.57 0 0 0-1.34 1.73v4.9a1.58 1.58 0 0 0 1.34 1.74 1.07 1.07 0 0 0 .6-.19 1.829 1.829 0 0 1-.74-1.55Z",
    className: "Vector",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_621",
    fill: "#A3A3A3",
    d: "M1339.77 322.061h-47.57v109.43h47.57v-109.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "balloon2",
    className: "balloon2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 967",
    className: "Group 967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_622",
    fill: "#ED7425",
    fillRule: "evenodd",
    d: "M604.705 214.201c8.72 0 17.11 5.73 17.37 16.27.24 9.72-7.53 18.37-10.27 24.41h-7.1v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_623",
    fill: "#FFDF5A",
    fillRule: "evenodd",
    d: "M604.705 214.201c6.42 0 15.05 6.17 14.6 16.92-.36 8.65-5.12 15.51-9.38 23.76h-5.22v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_624",
    fill: "#E8313F",
    fillRule: "evenodd",
    d: "M604.705 214.201c4.56 0 10.7 6.17 10.38 16.92-.26 8.65-3.64 15.51-6.67 23.76h-3.71v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_625",
    fill: "#ED7425",
    fillRule: "evenodd",
    d: "M604.705 214.201c2.62 0 6.14 6.17 5.95 16.92-.15 8.65-2.09 15.51-3.82 23.76h-2.13v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_626",
    fill: "#ED7425",
    fillRule: "evenodd",
    d: "M604.702 214.201c-8.72 0-17.11 5.73-17.37 16.27-.25 9.72 7.53 18.37 10.27 24.41h7.1v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_627",
    fill: "#FFDF5A",
    fillRule: "evenodd",
    d: "M604.701 214.201c-6.42 0-15.06 6.17-14.6 16.92.36 8.65 5.12 15.51 9.37 23.76h5.23v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_628",
    fill: "#E8313F",
    fillRule: "evenodd",
    d: "M604.702 214.201c-4.57 0-10.7 6.17-10.38 16.92.26 8.65 3.64 15.51 6.66 23.76h3.72v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_629",
    fill: "#FFA146",
    fillRule: "evenodd",
    d: "M604.701 214.201c-2.62 0-6.14 6.17-5.95 16.92.14 8.65 2.08 15.51 3.82 23.76h2.13v-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 966",
    className: "Group 966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_630",
    fill: "#FF4248",
    d: "M604.763 254.951h-6.8v2h6.8v-2Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_631",
    fill: "#E8313F",
    d: "M611.563 254.951h-6.8v2h6.8v-2Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 965",
    className: "Group 965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_632",
    fill: "#7D8696",
    d: "M600.453 256.951h-.69v5.11h.69v-5.11Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_633",
    fill: "#7D8696",
    d: "M609.754 256.951h-.69v5.11h.69v-5.11Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_634",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "M610.135 261.732h-10.73a.523.523 0 0 0-.48.55v6.34a.531.531 0 0 0 .48.56h10.73a.528.528 0 0 0 .48-.56v-6.34a.52.52 0 0 0-.48-.55Z",
    className: "Vector",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_635",
    fill: "#EBEBEB",
    d: "m1740.25 463.331 6.21-32.44h9.88l-8.85 40.02-7.24-7.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_636",
    fill: "#EBEBEB",
    d: "M1927.02 430.891h10.91l3.17 15.58-5.47 6.56-8.61-22.14Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_637",
    fill: "#A06E5F",
    d: "M1783.55 619.81c-.28-2.35-.3-3.27-.49-4.54l-2.14-1c.17 2.048.48 4.083.92 6.089.25.71 2.03.731 1.71-.549Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_638",
    fill: "#D86713",
    d: "m1783.16 619.46-1 .16-.36-3.29c.53 1.01.98 2.056 1.36 3.13Z",
    className: "Vector",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_639",
    fill: "#35488B",
    d: "m1770.69 627.46.3-1.64c5-7.23 5.38-8.53 3.13-11.78a4.81 4.81 0 0 0-2.29-1.64c.47-.168.95-.305 1.44-.41.45.188.87.437 1.25.74 6.86 5.94-3.83 14.73-3.83 14.73Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_640",
    fill: "#A06E5F",
    d: "M1767.96 621.39c.57-2.3.7-3.22 1.05-4.45l2.24-.77c-.41 2.015-.96 4-1.65 5.94-.34.7-2.09.5-1.64-.72Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_641",
    fill: "#C6C6C6",
    d: "M1782.13 619.62a13.2 13.2 0 0 1 1.59-.17s-.44-6.2-2.3-6.9l.71 7.07Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_642",
    fill: "#EDA1AB",
    d: "M1775.69 620.66c.02.086 0 .175-.05.246a.335.335 0 0 1-.22.134.351.351 0 0 1-.25-.056.363.363 0 0 1-.14-.214.329.329 0 0 1 .07-.251.35.35 0 0 1 .21-.139c.09-.012.18.011.25.063.07.052.12.13.13.217Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_643",
    fill: "#B49CDC",
    d: "M1777.03 617.28a1.379 1.379 0 0 0-.92.565c-.11.151-.19.322-.23.503-.04.181-.05.369-.02.552.04.265.16.513.34.71.03.029.06.063.07.101.02.038.02.078.02.119 0 .041 0 .082-.02.119a.237.237 0 0 1-.07.101.546.546 0 0 1-.25.13.52.52 0 0 1-.36-.08.338.338 0 0 0-.25-.061.37.37 0 0 0-.23.131.489.489 0 0 0-.05.122.31.31 0 0 0-.01.135c.01.045.03.088.05.126.02.038.06.071.09.097a1.183 1.183 0 0 0 .88.202c.15-.026.29-.082.42-.165s.25-.19.33-.317c0 .356-.11.703-.31 1a.303.303 0 0 0-.04.186c0 .066.02.129.06.183.03.054.08.097.14.123.06.027.13.037.19.028.1-.02.18-.074.23-.15.26-.39.4-.843.42-1.31 0 0 .06-.06.08 0 .17.435.45.816.82 1.1a.323.323 0 0 0 .27.06.329.329 0 0 0 .12-.038c.04-.02.07-.048.09-.082a.28.28 0 0 0 .06-.119.203.203 0 0 0 .01-.133.287.287 0 0 0-.04-.127.278.278 0 0 0-.09-.101 1.976 1.976 0 0 1-.62-.85 1.17 1.17 0 0 0 1.64-.26.298.298 0 0 0 .06-.256.31.31 0 0 0-.14-.224.324.324 0 0 0-.25-.059.377.377 0 0 0-.23.139.402.402 0 0 1-.13.126.542.542 0 0 1-.18.064.433.433 0 0 1-.28 0 .323.323 0 0 1-.16-.41c.1-.23.13-.481.1-.728a1.402 1.402 0 0 0-.87-1.122 1.407 1.407 0 0 0-.73-.09",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_644",
    fill: "#908CD6",
    d: "M1778.09 617.56a1.38 1.38 0 0 0-.62-.28.277.277 0 0 0-.08.143.32.32 0 0 0-.02.167c.02.095.07.18.15.236.08.056.18.079.27.064a.35.35 0 0 0 .3-.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_645",
    fill: "#908CD6",
    d: "M1776.69 618a.1.1 0 0 1 0 .076 1.52 1.52 0 0 1-.03.068c-.02.02-.03.038-.06.051a.146.146 0 0 1-.07.025.166.166 0 0 1-.07-.003.161.161 0 0 1-.07-.031.163.163 0 0 1-.05-.055 1.695 1.695 0 0 1-.03-.071c0-.025 0-.05.01-.075 0-.024.01-.047.03-.068.01-.02.03-.038.05-.051a.222.222 0 0 1 .07-.026c.05-.006.1.007.14.037.05.03.07.074.08.123Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_646",
    fill: "#EDA1AB",
    d: "M1776.74 619a.276.276 0 0 0-.14-.171.293.293 0 0 0-.22-.029.305.305 0 0 0-.28.31c.03.073.08.135.14.172.07.037.15.047.22.028.08-.005.15-.04.21-.098a.275.275 0 0 0 .07-.212Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_647",
    fill: "#4E5660",
    d: "M1776.43 618.84s-.07 0-.08-.06v-.14s0-.07.06-.08a.077.077 0 0 1 .03-.003c.01.002.02.006.03.012.01.006.01.013.02.022v.169c0 .018 0 .036-.01.051a.084.084 0 0 1-.05.029Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_648",
    fill: "#908CD6",
    d: "M1779.46 619.82c0-.007-.01-.014-.01-.023-.01-.009-.01-.018-.01-.027 0-.009 0-.019.01-.027 0-.009.01-.017.01-.023v-.07c.01-.008.02-.015.02-.02a.082.082 0 0 1 .03-.007c.01 0 .02.003.03.007.01.005.02.012.02.02.01.006.01.014.02.023v.054c-.01.009-.01.016-.02.023v.07c0 .013 0 .026-.01.035-.01.01-.02.015-.04.015-.01 0-.02-.005-.03-.015-.01-.009-.02-.022-.02-.035Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_649",
    fill: "#A06E5F",
    d: "M1775.48 618.091c-.17.164-.31.366-.4.591-.09.225-.13.467-.12.709.3.013.59-.067.84-.231.24-.164.43-.402.53-.679l.69-2-.32-.09c-.14.113-.26.252-.36.41-.17.494-.47.937-.86 1.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_650",
    fill: "#35488B",
    d: "m1775.46 615.28.06 2.51 1.38-.6c0-.463-.05-.925-.14-1.38-.11-.32-1.3-.53-1.3-.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pot ",
    className: "pot "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_651",
    fill: "#B0BF1D",
    d: "M1925.28 634.071a5.002 5.002 0 0 0-3.49 1.58 5.36 5.36 0 0 0-1.97-2.597 5.403 5.403 0 0 0-8.2 2.597c-1.43-2.95-4-4.93-6.86-4.93-4.26 0-7.71 4.23-8 9.58a4.46 4.46 0 0 0-1.51-2.199 4.462 4.462 0 0 0-2.49-.951c-2.45 0-4.44 2.55-4.44 5.69 0 3.14 2 5.68 4.44 5.68h32.49c3.12 0 5.65-3.24 5.65-7.23s-2.5-7.22-5.62-7.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_652",
    fill: "#EAE3D6",
    d: "M1930.11 645.24h-41.34v4.69h41.34v-4.69Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_653",
    fill: "#876C66",
    d: "M1893.14 654.712h32.83l1.49-4.73h-36.01l1.69 4.73Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bench",
    className: "bench"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_654",
    fill: "#7D8696",
    d: "M2942.03 365.471h-2.88v17.33h2.88v-17.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_655",
    fill: "#7D8696",
    d: "M2980.73 365.471h-2.88v17.33h2.88v-17.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_656",
    fill: "#7D8696",
    d: "M2945.43 346.572h-2.78v17.32h2.78v-17.32Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_657",
    fill: "#7D8696",
    d: "M2977.24 346.572h-2.78v17.32h2.78v-17.32Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_658",
    fill: "#DB8849",
    d: "M2984.27 361.771h-48.65v6.941h48.65v-6.941Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_659",
    fill: "#DB8849",
    d: "M2980.89 344.529h-41.91v5.02h41.91v-5.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_660",
    fill: "#DB8849",
    d: "M2980.89 352.58h-41.91v5.02h41.91v-5.02Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 999",
    className: "Group 999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_661",
    fill: "#72493E",
    d: "M3005.82 356.092h-2.9v27.24h2.9v-27.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 998",
    className: "Group 998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_662",
    fill: "#DCF3A3",
    d: "M3017.75 340.51a9.603 9.603 0 0 0 1.55-5.28c0-4.58-3.09-8.35-7.08-8.86-.72-4.1-4-7.2-7.85-7.2-3.85 0-7.12 3.1-7.85 7.2-4 .51-7.08 4.28-7.08 8.86a9.556 9.556 0 0 0 1.56 5.29 4.862 4.862 0 0 0-1.56 3.649c.02.684.17 1.357.46 1.976.3.619.71 1.169 1.23 1.615-.23.86-.35 1.748-.35 2.64 0 4.93 3.58 8.92 8 8.92a7.435 7.435 0 0 1 8.57-1.831 7.396 7.396 0 0 1 2.5 1.831c4.41 0 8-4 8-8.92 0-.861-.11-1.719-.34-2.55a4.802 4.802 0 0 0 1.35-1.674c.31-.654.46-1.371.45-2.096a4.838 4.838 0 0 0-.39-1.952 4.748 4.748 0 0 0-1.17-1.618Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_663",
    fill: "#CBED74",
    d: "M3017.75 340.51a9.605 9.605 0 0 0 1.55-5.28 9.101 9.101 0 0 0-.92-4.165 9.2 9.2 0 0 0-2.7-3.305c.56 1.951.84 3.971.84 6 0 10.87-7.9 19.68-17.64 19.68a16.142 16.142 0 0 1-8.07-2.18c.4 4.52 3.81 8.05 8 8.05.7-.78 1.55-1.404 2.51-1.831a7.415 7.415 0 0 1 8.56 1.831c4.41 0 8-4 8-8.92 0-.862-.11-1.719-.34-2.55a4.81 4.81 0 0 0 1.35-1.674c.31-.654.47-1.371.45-2.096a4.687 4.687 0 0 0-.41-1.951 4.595 4.595 0 0 0-1.18-1.609Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_664",
    fill: "#A3E440",
    d: "M2894.87 253.401c0 15.16-3.25 14.89-7.27 14.89s-7.28.27-7.28-14.89 4.11-32.26 7.28-32.26 7.27 17.1 7.27 32.26Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tree_10",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_665",
    fill: "#A3E440",
    d: "M2894.87 253.399c0 15.16-3.25 14.89-7.27 14.89s-7.28.27-7.28-14.89 4.11-32.26 7.28-32.26 7.27 17.1 7.27 32.26Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_666",
    fill: "#99D53B",
    d: "M2894.87 253.399c0 15.16-3.25 14.89-7.27 14.89-.66 0-1.29 0-1.9-.05 3.1-.27 5.38-2.16 5.38-14.84 0-12.24-2.68-25.76-5.38-30.5.65-1.12 1.29-1.76 1.9-1.76 3.17 0 7.27 17.11 7.27 32.26Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_667",
    fill: "#72493E",
    d: "M2889.57 268.291h-3.86v20.51h3.86v-20.51Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_668",
    fill: "#D2F0A2",
    d: "M2875.18 327.381h-.3c.01-.2.01-.4 0-.6 0-2.89-1.88-5.23-4.2-5.23-.52.013-1.04.138-1.52.365a3.8 3.8 0 0 0-1.24.955 4.844 4.844 0 0 0-4.12-2.65c-2.81 0-5.08 2.84-5.08 6.34 0 .787.12 1.57.36 2.32-2.58.15-4.65 2.8-4.65 6.06s2.19 6.09 4.88 6.09c.74 0 15.32-.73 15.82-.73 2.87 0 5.18-2.89 5.18-6.47 0-3.58-2.26-6.45-5.13-6.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 997",
    className: "Group 997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_669",
    fill: "#72493E",
    d: "M3012.86 270.939h-3.24v17.24h3.24v-17.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_670",
    fill: "#D2F0A2",
    d: "M3011.24 272.941c-3.35 0-6.06-3.24-6.06-7.24v-15.83c0-4 2.71-7.24 6.06-7.24 3.35 0 6.07 3.24 6.07 7.24v15.83c0 4-2.72 7.24-6.07 7.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_671",
    fill: "#BCEA73",
    d: "M3017.31 249.871v15.83c0 4-2.72 7.24-6.07 7.24a5.337 5.337 0 0 1-1.49-.22c2.63-.79 4.58-3.64 4.58-7v-15.85a8.008 8.008 0 0 0-1.78-5.12 5.814 5.814 0 0 0-2.8-1.9 5.3 5.3 0 0 1 1.49-.22c.83.014 1.64.212 2.38.579.75.366 1.4.893 1.91 1.541a8.008 8.008 0 0 1 1.78 5.12Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_672",
    fill: "#A3E440",
    d: "M3005.77 257.789c0 12.74-2.74 12.51-6.11 12.51s-6.12.23-6.12-12.51 3.45-27.1 6.12-27.1 6.11 14.37 6.11 27.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 996",
    className: "Group 996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_673",
    fill: "#A3E440",
    d: "M3005.77 257.789c0 12.74-2.74 12.51-6.11 12.51s-6.12.23-6.12-12.51 3.45-27.1 6.12-27.1 6.11 14.37 6.11 27.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_674",
    fill: "#99D53B",
    d: "M3005.77 257.792c0 12.74-2.74 12.51-6.11 12.51h-1.59c2.6-.23 4.52-1.81 4.52-12.47 0-10.29-2.26-21.64-4.52-25.63.53-.94 1.08-1.47 1.59-1.47 2.66 0 6.11 14.37 6.11 27.1v-.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_675",
    fill: "#72493E",
    d: "M3001.28 270.299h-3.24v17.24h3.24v-17.24Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_13",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_676",
    fill: "#91DC5A",
    d: "M2806.99 315.539a11.737 11.737 0 0 0-1.62-3.8 10.804 10.804 0 0 0-3.7-3.45.528.528 0 0 0-.64.08.456.456 0 0 0-.14.289c-.01.11.02.221.08.311a14.293 14.293 0 0 1 2.52 7.27c.1 1.169.04 2.345-.16 3.5a.515.515 0 0 0 .01.214.484.484 0 0 0 .28.316c.07.03.15.043.22.04h3c.12 0 .24-.042.33-.118.1-.077.16-.183.18-.302.12-1.459 0-2.929-.36-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_677",
    fill: "#4CBA68",
    d: "M2810.17 311.999a14.247 14.247 0 0 0-6.36-7.44.53.53 0 0 0-.64.08.456.456 0 0 0-.14.289c-.01.11.02.221.08.311 2 2.897 3.17 6.28 3.39 9.79.12 1.566.05 3.142-.22 4.69a.51.51 0 0 0 .01.213c.02.07.05.134.1.187a.507.507 0 0 0 .4.17h2.89c.07.003.13-.008.2-.03a.524.524 0 0 0 .16-.102.53.53 0 0 0 .12-.158c.02-.06.04-.124.04-.19v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_678",
    fill: "#91DC5A",
    d: "M2816.25 305.262a.39.39 0 0 0 .08-.311.456.456 0 0 0-.14-.289.522.522 0 0 0-.3-.148.538.538 0 0 0-.34.068 14.465 14.465 0 0 0-4.87 4.54 15.72 15.72 0 0 0-2.14 5 17.597 17.597 0 0 0-.41 5.74c.03.12.09.228.19.305.09.077.21.118.33.115h3.93c.07.003.13-.007.19-.03a.57.57 0 0 0 .17-.102.51.51 0 0 0 .11-.158c.03-.06.04-.124.04-.19a.244.244 0 0 0 0-.12 18.65 18.65 0 0 1-.22-4.66c.23-3.498 1.4-6.87 3.38-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_679",
    fill: "#4CBA68",
    d: "M2818.39 309.001a.434.434 0 0 0 .08-.311.454.454 0 0 0-.14-.289.53.53 0 0 0-.64-.08 11.056 11.056 0 0 0-3.7 3.45 11.705 11.705 0 0 0-1.61 3.8 12.997 12.997 0 0 0-.31 4.35c.02.12.08.229.18.306.09.077.21.118.33.114h2.95c.07.002.13-.008.19-.031a.55.55 0 0 0 .17-.102.765.765 0 0 0 .11-.158c.03-.06.04-.124.04-.189.01-.04.01-.08 0-.12-.2-1.136-.25-2.291-.16-3.44a14.488 14.488 0 0 1 2.51-7.3Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_680",
    fill: "#91DC5A",
    d: "M2962.97 296.81a11.737 11.737 0 0 0-1.62-3.8 10.82 10.82 0 0 0-3.69-3.45.53.53 0 0 0-.33-.07.577.577 0 0 0-.31.14.464.464 0 0 0-.14.294c-.01.112.02.225.08.316a14.387 14.387 0 0 1 2.51 7.27c.1 1.166.05 2.339-.16 3.49a.534.534 0 0 0 .01.218c.02.071.05.137.1.192.05.055.12.099.18.128.07.03.15.044.22.042h3a.53.53 0 0 0 .34-.113.518.518 0 0 0 .17-.307c.12-1.46 0-2.93-.36-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_681",
    fill: "#4CBA68",
    d: "M2966.15 293.29a14.247 14.247 0 0 0-6.36-7.44.53.53 0 0 0-.64.08.459.459 0 0 0-.14.289c-.01.11.02.22.08.311 2 2.893 3.18 6.279 3.39 9.79.13 1.563.06 3.136-.22 4.68a.535.535 0 0 0 .01.218c.02.071.05.137.1.192.05.055.12.099.18.128.07.029.15.044.22.042h2.89c.07.003.13-.008.2-.03a.524.524 0 0 0 .16-.102.53.53 0 0 0 .12-.158c.02-.06.04-.124.04-.19v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_682",
    fill: "#91DC5A",
    d: "M2972.24 286.529a.437.437 0 0 0 .08-.313.461.461 0 0 0-.15-.287.496.496 0 0 0-.3-.15.53.53 0 0 0-.33.07 14.453 14.453 0 0 0-4.88 4.54c-1 1.527-1.72 3.22-2.13 5-.46 1.88-.6 3.824-.41 5.75.02.121.08.229.18.307.09.077.21.117.33.113h3.93c.07.003.13-.007.2-.03a.506.506 0 0 0 .16-.102.517.517 0 0 0 .12-.158.602.602 0 0 0 .04-.19.244.244 0 0 0 0-.12 20.022 20.022 0 0 1 3.18-14.45l-.02.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_683",
    fill: "#4CBA68",
    d: "M2974.37 290.24a.45.45 0 0 0-.06-.61.544.544 0 0 0-.64-.07 11.004 11.004 0 0 0-3.69 3.45 11.7 11.7 0 0 0-1.62 3.8 13.265 13.265 0 0 0-.31 4.35c.02.12.08.229.18.307.09.077.21.117.33.113h2.95c.07.003.13-.007.2-.03a.506.506 0 0 0 .16-.102.517.517 0 0 0 .12-.158.602.602 0 0 0 .04-.19c.01-.04.01-.08 0-.12a13.67 13.67 0 0 1-.16-3.44 14.483 14.483 0 0 1 2.5-7.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_684",
    fill: "#A3E440",
    d: "M3116.32 374.401c0 15.15-3.25 14.88-7.27 14.88s-7.28.27-7.28-14.88 4.11-32.26 7.28-32.26 7.27 17.1 7.27 32.26Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1157",
    className: "Group 1157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_685",
    fill: "#44AA85",
    d: "M5615 719.6S5718 260 6119.27 260s500.86 459.6 500.86 459.6H5615Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grass_14",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_686",
    fill: "#91DC5A",
    d: "M5929.31 396.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_687",
    fill: "#4CBA68",
    d: "M5934.16 391.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_688",
    fill: "#91DC5A",
    d: "M5943.46 381.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_689",
    fill: "#4CBA68",
    d: "M5946.72 386.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_15",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_690",
    fill: "#91DC5A",
    d: "M6135.31 458.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_691",
    fill: "#4CBA68",
    d: "M6140.16 453.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_692",
    fill: "#91DC5A",
    d: "M6149.46 443.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_693",
    fill: "#4CBA68",
    d: "M6152.72 448.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_16",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_694",
    fill: "#91DC5A",
    d: "M6275.31 518.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_695",
    fill: "#4CBA68",
    d: "M6280.16 513.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_696",
    fill: "#91DC5A",
    d: "M6289.46 503.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_697",
    fill: "#4CBA68",
    d: "M6292.72 508.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_17",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_698",
    fill: "#91DC5A",
    d: "M5988.31 557.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_699",
    fill: "#4CBA68",
    d: "M5993.16 552.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_700",
    fill: "#91DC5A",
    d: "M6002.46 542.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_701",
    fill: "#4CBA68",
    d: "M6005.72 547.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_18",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_702",
    fill: "#91DC5A",
    d: "M6185.31 596.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_703",
    fill: "#4CBA68",
    d: "M6190.16 591.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_704",
    fill: "#91DC5A",
    d: "M6199.46 581.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_705",
    fill: "#4CBA68",
    d: "M6202.72 586.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_19",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_706",
    fill: "#91DC5A",
    d: "M6395.31 626.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_707",
    fill: "#4CBA68",
    d: "M6400.16 621.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_708",
    fill: "#91DC5A",
    d: "M6409.46 611.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_709",
    fill: "#4CBA68",
    d: "M6412.72 616.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_20",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_710",
    fill: "#91DC5A",
    d: "M5860.31 614.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_711",
    fill: "#4CBA68",
    d: "M5865.16 609.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_712",
    fill: "#91DC5A",
    d: "M5874.46 599.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_713",
    fill: "#4CBA68",
    d: "M5877.72 604.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_21",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_714",
    fill: "#91DC5A",
    d: "M6203.31 355.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_715",
    fill: "#4CBA68",
    d: "M6208.16 350.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_716",
    fill: "#91DC5A",
    d: "M6217.46 340.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_717",
    fill: "#4CBA68",
    d: "M6220.72 345.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_22",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_718",
    fill: "#91DC5A",
    d: "M6333.31 415.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_719",
    fill: "#4CBA68",
    d: "M6338.16 410.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_720",
    fill: "#91DC5A",
    d: "M6347.46 400.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_721",
    fill: "#4CBA68",
    d: "M6350.72 405.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_23",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_722",
    fill: "#91DC5A",
    d: "M5741.31 529.842a18.368 18.368 0 0 0-2.46-5.815 16.75 16.75 0 0 0-5.65-5.25.815.815 0 0 0-.97.107.691.691 0 0 0-.23.44.73.73 0 0 0 .13.476 22.19 22.19 0 0 1 3.85 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326c.03.107.08.205.16.285.07.087.17.157.27.205.11.047.22.071.34.07h4.5a.75.75 0 0 0 .51-.174.783.783 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_723",
    fill: "#4CBA68",
    d: "M5746.16 524.468a21.758 21.758 0 0 0-9.69-11.355.83.83 0 0 0-.98.107.75.75 0 0 0-.22.448c-.02.172.03.343.13.483a29.441 29.441 0 0 1 5.16 14.926c.2 2.391.08 4.797-.33 7.159a.599.599 0 0 0 .01.325.744.744 0 0 0 .43.49c.1.047.22.071.33.07h4.43c.1.004.2-.012.29-.047.1-.035.18-.088.25-.156a.64.64 0 0 0 .17-.241.727.727 0 0 0 .07-.289v-11.676a.686.686 0 0 0-.05-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_724",
    fill: "#91DC5A",
    d: "M5755.46 514.151a.742.742 0 0 0 .11-.482.705.705 0 0 0-.21-.449.815.815 0 0 0-.97-.107 21.74 21.74 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631 26.45 26.45 0 0 0-.63 8.776.767.767 0 0 0 .78.641h6a.799.799 0 0 0 .55-.201c.07-.068.13-.15.17-.241.04-.092.07-.19.07-.29a.562.562 0 0 0 0-.183c-.39-2.354-.5-4.748-.32-7.128a29.64 29.64 0 0 1 5.15-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_725",
    fill: "#4CBA68",
    d: "M5758.72 519.798a.689.689 0 0 0-.11-.916.817.817 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.69 16.69 0 0 0-5.65 5.25 18.39 18.39 0 0 0-2.47 5.815 20.32 20.32 0 0 0-.47 6.64c.03.183.12.349.27.467.14.118.32.18.51.174h4.57a.739.739 0 0 0 .55-.202c.08-.068.14-.15.18-.241.04-.091.06-.19.07-.29a.562.562 0 0 0 0-.183 21.981 21.981 0 0 1-.25-5.25 22.072 22.072 0 0 1 3.76-11.157Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000",
    className: "Group 1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_726",
    fill: "#A3E440",
    d: "M3116.32 374.399c0 15.15-3.25 14.88-7.27 14.88s-7.28.27-7.28-14.88 4.11-32.26 7.28-32.26 7.27 17.1 7.27 32.26Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_727",
    fill: "#99D53B",
    d: "M3116.32 374.402c0 15.16-3.25 14.88-7.27 14.88h-1.9c3.1-.28 5.38-2.16 5.38-14.84 0-12.25-2.68-25.76-5.38-30.5.65-1.13 1.29-1.76 1.9-1.76 3.17 0 7.27 17.1 7.27 32.26v-.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_728",
    fill: "#72493E",
    d: "M3110.98 389.279h-3.86v20.51h3.86v-20.51Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_729",
    fill: "#BCEA73",
    d: "M3066.01 416h-.46c.04-.291.07-.585.08-.88 0-4.3-2.79-7.78-6.23-7.78-.78.024-1.56.215-2.26.56-.71.344-1.34.836-1.84 1.44a7.248 7.248 0 0 0-2.52-2.797 7.18 7.18 0 0 0-3.59-1.143c-4.16 0-7.54 4.22-7.54 9.42 0 1.165.19 2.322.54 3.43-3.83.23-6.89 4.15-6.89 9s3.23 9 7.23 9c1.09 0 22.73-1.07 23.48-1.07 4.24 0 7.68-4.3 7.68-9.6s-3.44-9.58-7.68-9.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1001",
    className: "Group 1001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_730",
    fill: "#DCF3A3",
    d: "M3163.21 291.262a7.651 7.651 0 0 0 1.24-4.23c0-3.66-2.47-6.68-5.66-7.08a6.303 6.303 0 0 0-2.02-4.088 6.3 6.3 0 0 0-4.25-1.651c-1.58 0-3.09.589-4.26 1.651a6.303 6.303 0 0 0-2.02 4.088c-3.19.4-5.67 3.42-5.67 7.08a7.569 7.569 0 0 0 1.25 4.23c-.4.371-.72.823-.93 1.326a3.956 3.956 0 0 0-.32 1.592 3.907 3.907 0 0 0 1.35 2.872 8.35 8.35 0 0 0-.28 2.11c0 3.95 2.86 7.14 6.4 7.14a5.986 5.986 0 0 1 2-1.463 5.915 5.915 0 0 1 6.84 1.463c3.54 0 6.4-3.19 6.4-7.14 0-.675-.09-1.348-.27-2 .43-.349.79-.788 1.03-1.286.25-.497.39-1.042.41-1.598a3.773 3.773 0 0 0-.3-1.623 3.804 3.804 0 0 0-.94-1.353v-.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_731",
    fill: "#72493E",
    d: "M3153.67 303.721h-2.32v21.79h2.32v-21.79Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_732",
    fill: "#CBED74",
    d: "M3163.21 291.259a7.649 7.649 0 0 0 1.24-4.23 7.186 7.186 0 0 0-.73-3.345 7.336 7.336 0 0 0-2.16-2.655c.45 1.565.67 3.184.67 4.81 0 8.69-6.32 15.73-14.11 15.73-2.26.001-4.49-.599-6.45-1.74.32 3.62 3 6.44 6.37 6.44a5.986 5.986 0 0 1 2-1.463 5.914 5.914 0 0 1 4.84 0c.77.341 1.45.84 2 1.463 3.54 0 6.4-3.19 6.4-7.14 0-.675-.09-1.348-.27-2 .44-.349.79-.788 1.04-1.286.24-.497.38-1.042.4-1.598a3.912 3.912 0 0 0-.29-1.622 3.956 3.956 0 0 0-.95-1.354v-.01Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_733",
    fill: "#A5A5A5",
    d: "M3068.58 307.531c.01-.09.01-.18 0-.27.05-.772-.2-1.533-.71-2.117a2.958 2.958 0 0 0-2-1.003h-1.78c-.77.061-1.48.423-1.99 1.006-.5.584-.76 1.343-.71 2.114v.33a9.671 9.671 0 0 0-2.99 2.38 9.76 9.76 0 0 0-1.82 3.36c-.05.14.25.19.78.18v16.76h15.36v-16.78c.52 0 .81 0 .76-.17-.37-1.25-1-2.408-1.85-3.404a9.486 9.486 0 0 0-3.05-2.386Zm-3.5-.82c-.75.01-1.5.125-2.22.34.02-.33.16-.642.39-.878s.54-.379.87-.402h1.75c.33.022.63.16.86.387.23.227.37.53.4.853a7.857 7.857 0 0 0-2.05-.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_734",
    fill: "#878787",
    d: "M3073.69 312.41h-17.16v1.22h17.16v-1.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_735",
    fill: "#878787",
    d: "M3058.98 314.71a.46.46 0 0 0-.42.49v13.63a.46.46 0 0 0 .42.49c.12-.01.24-.067.32-.158a.449.449 0 0 0 .11-.332V315.2a.449.449 0 0 0-.11-.332.487.487 0 0 0-.32-.158Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_736",
    fill: "#878787",
    d: "M3063.03 314.7a.438.438 0 0 0-.31.156.339.339 0 0 0-.09.156.54.54 0 0 0-.03.178v13.63c-.01.061 0 .124.01.184.02.059.05.115.09.162.04.047.09.084.15.11a.416.416 0 0 0 .5-.11.495.495 0 0 0 .09-.162c.02-.06.02-.123.01-.184v-13.63a.46.46 0 0 0-.42-.49Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_737",
    fill: "#878787",
    d: "M3067.03 314.74a.465.465 0 0 0-.31.159.448.448 0 0 0-.11.331v13.63c-.01.062 0 .124.01.184.02.059.05.115.09.162.04.047.09.084.15.11a.416.416 0 0 0 .5-.11.495.495 0 0 0 .09-.162c.02-.06.02-.122.01-.184v-13.63a.36.36 0 0 0-.02-.178.458.458 0 0 0-.41-.312Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_738",
    fill: "#878787",
    d: "M3071.08 314.721a.464.464 0 0 0-.31.158.5.5 0 0 0-.12.332v13.63a.5.5 0 0 0 .12.331c.08.092.19.148.31.159a.47.47 0 0 0 .31-.159.448.448 0 0 0 .11-.331v-13.63a.46.46 0 0 0-.42-.49Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "grass_24",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_739",
    fill: "#91DC5A",
    d: "M2996.96 437.881c-.3-1.352-.85-2.639-1.61-3.8a10.871 10.871 0 0 0-3.7-3.45.523.523 0 0 0-.33-.071.57.57 0 0 0-.31.141.466.466 0 0 0-.14.294c-.01.111.02.224.08.316a14.3 14.3 0 0 1 2.52 7.27c.09 1.165.04 2.337-.16 3.49a.789.789 0 0 0 0 .217c.02.071.06.137.1.193a.566.566 0 0 0 .4.17h2.95c.13.004.24-.037.34-.114a.513.513 0 0 0 .17-.306c.14-1.458.04-2.927-.31-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_740",
    fill: "#4CBA68",
    d: "M3000.14 434.36a14.236 14.236 0 0 0-6.35-7.44.523.523 0 0 0-.33-.071.578.578 0 0 0-.31.141.461.461 0 0 0-.14.293c-.01.113.02.225.08.317 2 2.895 3.17 6.28 3.38 9.79.13 1.562.06 3.135-.21 4.68a.466.466 0 0 0 .1.41.566.566 0 0 0 .4.17h2.9c.07.002.13-.008.19-.031a.455.455 0 0 0 .17-.102.385.385 0 0 0 .11-.158c.03-.06.04-.124.04-.189v-7.65a.437.437 0 0 0-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_741",
    fill: "#91DC5A",
    d: "M3006.23 427.6c.07-.092.1-.204.09-.316a.537.537 0 0 0-.15-.294.537.537 0 0 0-.64-.07 14.443 14.443 0 0 0-4.88 4.54c-1 1.529-1.72 3.221-2.13 5a17.656 17.656 0 0 0-.41 5.75c.02.12.08.229.18.306.09.077.21.118.33.114h3.93c.07.002.13-.008.2-.031a.542.542 0 0 0 .28-.259c.02-.06.04-.125.04-.19.01-.04.01-.08 0-.12a19.14 19.14 0 0 1-.21-4.66 19.565 19.565 0 0 1 3.37-9.77Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_742",
    fill: "#4CBA68",
    d: "M3008.37 431.311a.505.505 0 0 0 .08-.316.474.474 0 0 0-.14-.294.537.537 0 0 0-.64-.07 10.785 10.785 0 0 0-3.7 3.45 11.718 11.718 0 0 0-1.62 3.8 13.263 13.263 0 0 0-.31 4.35c.02.12.08.229.18.306.09.077.21.118.33.114h3a.531.531 0 0 0 .36-.133.375.375 0 0 0 .11-.157.43.43 0 0 0 .05-.19.244.244 0 0 0 0-.12 14.155 14.155 0 0 1-.16-3.44c.15-2.611 1-5.134 2.46-7.3Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_25",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_743",
    fill: "#91DC5A",
    d: "M3148.66 359.22a11.807 11.807 0 0 0-1.62-3.81 10.814 10.814 0 0 0-3.7-3.44.53.53 0 0 0-.33-.07.577.577 0 0 0-.31.14.527.527 0 0 0-.13.295c-.02.111.01.222.07.315a14.293 14.293 0 0 1 2.52 7.27c.1 1.166.05 2.339-.16 3.49a.515.515 0 0 0 .01.214.514.514 0 0 0 .28.323c.07.031.15.046.22.043h3c.12.002.24-.039.34-.116a.508.508 0 0 0 .17-.304c.12-1.459 0-2.929-.36-4.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_744",
    fill: "#4CBA68",
    d: "M3151.87 355.7a14.184 14.184 0 0 0-6.36-7.44.523.523 0 0 0-.33-.071.57.57 0 0 0-.31.141.466.466 0 0 0-.14.293c-.01.112.02.225.08.317a19.417 19.417 0 0 1 3.39 9.78c.13 1.566.06 3.142-.22 4.69-.01.07-.01.143.01.213a.502.502 0 0 0 .5.367h2.89a.489.489 0 0 0 .36-.133.517.517 0 0 0 .12-.158.602.602 0 0 0 .04-.189v-7.65c0-.055-.01-.11-.03-.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_745",
    fill: "#91DC5A",
    d: "M3157.92 348.94a.453.453 0 0 0-.06-.61.513.513 0 0 0-.3-.141.553.553 0 0 0-.34.071 14.505 14.505 0 0 0-4.87 4.54 15.71 15.71 0 0 0-2.14 5 17.654 17.654 0 0 0-.41 5.75.537.537 0 0 0 .52.42h3.93c.07.002.13-.008.2-.031a.524.524 0 0 0 .16-.102.385.385 0 0 0 .11-.158c.03-.06.04-.124.04-.189a.244.244 0 0 0 0-.12 18.27 18.27 0 0 1-.21-4.67 19.425 19.425 0 0 1 3.37-9.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_746",
    fill: "#4CBA68",
    d: "M3160.06 352.65c.07-.092.1-.204.09-.316a.481.481 0 0 0-.15-.294.544.544 0 0 0-.64-.07 11.046 11.046 0 0 0-3.7 3.44 12.018 12.018 0 0 0-1.61 3.81 13.542 13.542 0 0 0-.31 4.35.53.53 0 0 0 .18.307c.09.077.21.117.33.113h2.95c.07.003.13-.007.19-.03a.468.468 0 0 0 .28-.26c.03-.06.04-.124.04-.19a.24.24 0 0 0 0-.119 14.164 14.164 0 0 1-.16-3.441 14.488 14.488 0 0 1 2.51-7.3Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_747",
    fill: "#009983",
    d: "m3145.01 609-.06.1.06-.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man running",
    className: "man running"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1025",
    className: "Group 1025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_748",
    fill: "#F29A7E",
    d: "M3146.3 635.779c.91-3.34 2.49-9.13 2.69-11l-4.49 1c0 2.85-.82 6.58-1 9.34-.18 2.76 2.1 2.68 2.8.66Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_749",
    fill: "#F29A7E",
    d: "M3145.52 637.531c.64-1.24.81-2.08-.08-2.71-1-.74-2.24.09-5.05 5.3-1.42 2.62-2.71 5.53-3.24 6.59-.29.88 0 .87.34 1.08.71.51 1.12.32 1.23.16 2.63-4.02 5.05-6.88 6.8-10.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_750",
    fill: "#F29A7E",
    d: "M3154.57 637.422c-.7-3.4-1.88-9.29-2.56-11.08l-4 3.25c1.28 2.54 2.67 5.88 3.71 8.45 1.04 2.57 3.15 1.5 2.85-.62Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_751",
    fill: "#F29A7E",
    d: "M3154.77 638.752c-.19-1.37-.54-2.16-1.63-2.16-1.27 0-1.77 1.37-1.06 7.25.37 3 1 6.07 1.18 7.25.27.88 1.28 1.87 1.65 1.87.87 0 .34-1.57.34-1.77-.18-4.8.14-8.53-.48-12.44Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_752",
    fill: "#FFFFF6",
    d: "M3144.68 624.822c-.31.597-.57 1.215-.79 1.85-.17.62-1 7.16-1 7.16s4.13 1.65 4.38 1.78l1.1-3.52 1.38 2.71 4.37-2.84-1.58-6.63-7.86-.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1024",
    className: "Group 1024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1023",
    className: "Group 1023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_753",
    fill: "#F29A7E",
    d: "M3151.15 618.842c-.65.59-1 .63-1.56.16s-.46-1.5 2.27-4c1.38-1.29 3-2.54 3.53-3 .49-.32.56-.1.75.05.46.38.42.67.34.76-2.02 2.19-3.51 4.4-5.33 6.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_754",
    fill: "#F29A7E",
    d: "M3157.99 610.791c-.14.485-.32.956-.55 1.41-.29.44-.89.69-1.11 1a.852.852 0 0 1-.36.269.923.923 0 0 1-.46.051.818.818 0 0 1-.36-.158.921.921 0 0 1-.24-.312c-.11-.53.48-1.09.42-1.74.27-.17.1-.47.35-.89.08-.12.17-.61.24-.72.23-.21.23-.21.45-.16.22.05.23.13.64.38.41.25 1.16.35.98.87Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_755",
    fill: "#F29A7E",
    d: "m3155.87 612.58-.37-2.45s0-.11-.18-.12c-.18-.01-.18.18-.18.18-.09.209-.13.433-.14.66.08.609.02 1.228-.18 1.81",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_756",
    fill: "#F29A7E",
    d: "m3150.58 605.801-.33 2.6-2.04-.4.15-3.34 1.05-.02.55-.83.62 1.99Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_757",
    fill: "#00B6A5",
    d: "M3152.25 610.061c-.13-.682-.31-1.351-.56-2-.6-1.11-2-1.47-3.05-1.73a9.996 9.996 0 0 0-3.23-.2c-.38-.014-.76.118-1.05.37a.905.905 0 0 0 0 1.18c-.3.11-.59.258-.85.44-.27.169-.46.433-.55.74-.04.17-.04.349 0 .52.04.122.09.236.18.335.08.098.18.178.29.235.21.093.43.154.66.18.04.469.14.931.31 1.37.22 1.14.48 7.56.48 7.56a27.62 27.62 0 0 1-.26 5.14 4.496 4.496 0 0 1-.64 1.57c.66.69 8.13 0 8.59-.48 0 0 .07-5.57.08-8 .06-2.417-.07-4.835-.4-7.23Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1021",
    className: "Group 1021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_758",
    fill: "#FFB4A0",
    d: "M3153.09 603.372c-.05-.114-.1-.224-.17-.33-.13-.21-.25-.43-.38-.65l-.08-.12a7.838 7.838 0 0 0-.85-2.53c-.46-.46-1.61.14-1.61.14a6.151 6.151 0 0 0-.73 2.91c-.12-.14-.27-.23-.43-.11-.19.182-.31.429-.34.694-.02.264.05.53.2.746a1.003 1.003 0 0 0 .86.29c.04.237.13.461.28.65 2.12 1.85 2.7.75 2.81.51.17-.569.19-1.169.08-1.75.09-.04.18-.091.26-.15a.2.2 0 0 0 .08-.081.22.22 0 0 0 .04-.109.418.418 0 0 0-.02-.11Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_759",
    fill: "#28130F",
    d: "M3147.15 602.21c.14.883.45 1.734.89 2.51.18.3.34.53.43.51.24 0 .6-.49.6-.49s.1.52.35.4c.25-.12.31-.73.31-.73s-.91-.1-1-.6c-.09-.5 0-1 .27-1.06a.489.489 0 0 1 .26-.002c.09.023.17.068.23.132 0 0 1-2.19.85-2.81 0 0 1.42.07 1.6-.33a2.29 2.29 0 0 0-.34-1.94c-.39-.32-.75.85-.75.85a2.708 2.708 0 0 0-1.59-.158c-.54.109-1.03.377-1.41.768-.59.53-.98 1.02-.7 2.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_760",
    fill: "#FF5F5C",
    d: "M3146.98 601.562a39.2 39.2 0 0 0 5-2.49s.31.82-.06 1.07c-1.57.73-3.18 1.371-4.83 1.92a2.128 2.128 0 0 1-.11-.5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_761",
    fill: "#F29A7E",
    d: "M3149.74 604.409a.694.694 0 0 1-.33.056.745.745 0 0 1-.32-.098.72.72 0 0 1-.35-.548c-.12-.49 0-1 .27-1.06a.491.491 0 0 1 .49.13 1.642 1.642 0 0 1 .24 1.52Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1022",
    className: "Group 1022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_762",
    fill: "#F29A7E",
    d: "M3143.87 618.901c.02-3.1.24-6.196.64-9.27l2 1.5c-.19 2.33 0 5.51-.57 7.79-.57 2.28-1.91 1.78-2.07-.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_763",
    fill: "#F29A7E",
    d: "M3145.13 620.541c-.85-.22-1.07-.49-1-1.22.07-.73 1-1.2 4.64-.31 1.83.45 3.74 1.1 4.46 1.3.54.24.39.42.37.66-.07.59-.33.71-.45.7-2.99-.45-5.66-.5-8.02-1.13Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_764",
    fill: "#028E7D",
    d: "M3148.66 610.671c-.05.65-1.6 6.23-1.6 6.23l-4-1.41s.67-4.25 1-5.32c0 0 .77-3.24 3.21-2.58 1.7.46 1.53 1.47 1.39 3.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_765",
    fill: "#F29A7E",
    d: "M3155.61 621.879c-.48.139-.98.243-1.48.31a9.171 9.171 0 0 1-1.42-.41.89.89 0 0 1-.71-.51.88.88 0 0 1-.06-.394.842.842 0 0 1 .13-.376c.38-.37 1.17-.19 1.69-.59.28.13.44-.18.93-.19.14 0 .61-.19.73-.19.31.07.31.08.38.28s0 .27 0 .74.34 1.19-.19 1.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_766",
    fill: "#F29A7E",
    d: "m3152.93 621.05 1.85-1.65s.08-.07 0-.21c-.08-.14-.24-.05-.24-.05-.22.035-.43.113-.63.23a3.96 3.96 0 0 1-1.62.85",
    className: "Vector"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shoe",
    className: "shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_767",
    fill: "#FFFFF6",
    d: "M3141.45 652.752c-.32.43-2.49-.69-2.95-1.08a5.74 5.74 0 0 1-1.05-1.89c-.22-.5-1.95-1.28-2-2 0-.25.08-.493.23-.69.38-.512.82-.975 1.31-1.38.21-.2.5 0 .5 0 .07.735.27 1.452.58 2.12.02.026.05.047.08.06.04.097.1.188.17.27.3.32 1.26-.44 1.57-.57.12.325.21.66.28 1 .12.73.27 1.68.33 2.1v.16c.07.48.63.77.78.93.09.092.17.196.24.31.06.102.09.222.08.342a.55.55 0 0 1-.15.318Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_768",
    fill: "#FF5F5C",
    d: "M3141.51 652.13a5.99 5.99 0 0 1-2.78-1.17 5.7 5.7 0 0 1-1.06-1.88c-.21-.5-1.92-1.27-2-2 .38-.512.82-.975 1.31-1.38.21-.2.5 0 .5 0 .07.735.27 1.453.58 2.12.02.026.05.047.08.06.41.14 1.3-.89 1.41-.81.15.144.26.318.33.51.12.325.22.66.28 1 .18.8.28 1.69.33 2.1a.11.11 0 0 1 0 .08v.08c.07.48.63.77.78.93.1.108.18.229.24.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_769",
    fill: "#FFFFF6",
    d: "M3140.43 648.562c-.1-.12-.17-.11-.3-.08l-.29.06c-.16.05-.41.07-.47.28-.01.017-.01.036-.01.055 0 .018.01.036.01.053.01.016.03.031.04.042.02.01.03.018.05.02.16.03.33.03.49 0 .15 0 .4 0 .48-.18.02-.037.04-.08.04-.125a.279.279 0 0 0-.04-.125Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_770",
    fill: "#FFFFF6",
    d: "M3140.78 649.509a.682.682 0 0 0-.23-.136.668.668 0 0 0-.28-.024 1.414 1.414 0 0 0-.55 0c-.14 0-.18.3 0 .36.17.054.35.084.52.09.15 0 .37.09.51 0a.256.256 0 0 0 .07-.14.265.265 0 0 0-.04-.15Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shoe_2",
    className: "shoe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_771",
    fill: "#FFFFF6",
    d: "M3159.69 653.602c-.05.58-2.32 1.28-2.88 1.3a4.032 4.032 0 0 1-1.76-.73c-.42-.25-2.18.4-2.6-.08a1.161 1.161 0 0 1-.15-.73c.06-.701.19-1.394.38-2.07a.528.528 0 0 1 .16-.232.486.486 0 0 1 .26-.098c.07.09 1.06 1.24 1.49 1.28h.09c.09.049.18.083.27.1.39 0 .8-1.29 1-1.61.25.158.48.342.69.55.46.5 1 1.14 1.29 1.44h.05v.06c.29.33.89.15 1.08.16.12.011.23.038.34.08.2.11.32.26.29.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_772",
    fill: "#FF5F5C",
    d: "M3159.44 653.061c-.82.598-1.79.98-2.8 1.11-.63-.1-1.23-.35-1.75-.73-.42-.25-2.16.39-2.59-.08.06-.702.19-1.395.38-2.07a.46.46 0 0 1 .42-.33c.07.09 1.06 1.24 1.49 1.28h.09c.39-.19.62-1.67.74-1.68.19.002.36.061.51.17.25.157.48.341.69.55.46.453.89.934 1.29 1.44h.05v.06c.29.33.89.15 1.08.16.14.017.28.058.4.12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_773",
    fill: "#FFFFF6",
    d: "M3156.87 651c-.14 0-.19 0-.28.15l-.2.27c-.11.15-.3.35-.24.57.06.22.09.11.15.07.15-.103.28-.228.38-.37.12-.13.33-.3.31-.51-.02-.21-.07-.18-.12-.18Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_774",
    fill: "#FFFFF6",
    d: "M3157.41 651.597c-.14 0-.19 0-.28.15l-.2.27c-.11.15-.3.35-.24.57.06.22.09.11.15.07.15-.102.28-.227.38-.37.12-.13.33-.3.31-.51-.02-.21-.07-.18-.12-.18Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_775",
    fill: "#E0752D",
    d: "M3454.35 653.7v.07h.34a2.737 2.737 0 0 1-.34-.07Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man sitting",
    className: "man sitting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_776",
    fill: "#7D8696",
    d: "M6472 655H1.147v14H6472v-14Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_11",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_777",
    fill: "#72493E",
    d: "M3030.07 626.4h-5.32v28.29h5.32V626.4Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_778",
    fill: "#A0D755",
    d: "M3038.04 617.001c0 10.41-4.76 18.86-10.63 18.86-5.87 0-10.64-8.45-10.64-18.86 0-33 4.76-75.44 10.64-75.44 5.88 0 10.63 42.44 10.63 75.44Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_779",
    fill: "#8CBE4B",
    d: "M3024.75 617.001c0-27.07 2.4-60.43 5.7-71.58-1-2.44-2-3.86-3-3.86-5.88 0-10.64 42.44-10.64 75.44 0 10.41 4.76 18.86 10.64 18.86a6.455 6.455 0 0 0 3-.88c-3.29-2.36-5.7-9.48-5.7-17.98Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "playing outside",
    className: "playing outside"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_780",
    fill: "#475959",
    d: "M2928.13 610.971c-.53 0-1-.59-1-1.31v-18.33c0-.72.42-1.31 1-1.31.58 0 .94.59.94 1.31v18.33c0 .72-.42 1.31-.94 1.31Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_781",
    fill: "#475959",
    d: "M2922.87 610.971c-.52 0-.94-.59-.94-1.31v-18.33c0-.72.42-1.31.94-1.31s.95.59.95 1.31v18.33c-.04.72-.46 1.31-.95 1.31Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_782",
    fill: "#75A4BC",
    d: "M2886.17 604.459h26.21v6.24h-26.21v-6.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_783",
    fill: "#355A6D",
    d: "M2886.17 608.092h26.21v2.61h-26.21v-2.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_784",
    fill: "#75A4BC",
    d: "M2886.17 619.721h26.21v6.25h-26.21v-6.25Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_785",
    fill: "#75A4BC",
    d: "M2886.17 634.99h26.21v6.24h-26.21v-6.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_786",
    fill: "#355A6D",
    d: "M2886.17 623.361h26.21v2.61h-26.21v-2.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_787",
    fill: "#355A6D",
    d: "M2886.17 638.619h26.21v2.61h-26.21v-2.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_788",
    fill: "#75A4BC",
    d: "M2886.17 589.201h52.41v6.24h-52.41v-6.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_789",
    fill: "#355A6D",
    d: "M2886.17 592.322h52.41v3.12h-52.41v-3.12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_790",
    fill: "#A9C5D3",
    d: "M2883.87 584.002h4.54v71.3h-4.54v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_791",
    fill: "#A9C5D3",
    d: "M2910.11 584.002h4.54v71.3h-4.54v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_792",
    fill: "#A9C5D3",
    d: "M2936.31 584.002h4.56v71.3h-4.54l-.02-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_793",
    fill: "#4F7D99",
    d: "M2936.31 584.002h2.27v71.3h-2.27v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_794",
    fill: "#4F7D99",
    d: "M2910.11 584.002h2.27v71.3h-2.27v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_795",
    fill: "#4F7D99",
    d: "M2883.87 584.002h2.27v71.3h-2.27v-71.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_796",
    fill: "#ECBE6B",
    d: "M2922.87 625.531c-3.44 0-6.24-3.85-6.24-8.58s2.8-8.59 6.24-8.59c3.44 0 6.24 3.85 6.24 8.59s-2.83 8.58-6.24 8.58Zm0-14.56c-2.39 0-4.34 2.68-4.34 6s2 6 4.34 6 4.35-2.68 4.35-6-1.95-6-4.35-6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_797",
    fill: "#F4DD45",
    d: "M2928.13 625.531c-3.44 0-6.24-3.85-6.24-8.58s2.8-8.59 6.24-8.59c3.44 0 6.24 3.85 6.24 8.59s-2.8 8.58-6.24 8.58Zm0-14.56c-2.4 0-4.35 2.68-4.35 6s2 6 4.35 6c2.35 0 4.34-2.68 4.34-6s-1.95-6-4.34-6Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 994",
    className: "Group 994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_798",
    fill: "#617881",
    d: "M2711.19 609.089a2.64 2.64 0 0 0-1.42 3.16l3.21 13.13 4-1.44-3.21-13.15a2.193 2.193 0 0 0-.3-.824 2.087 2.087 0 0 0-1.44-.939 2.043 2.043 0 0 0-.87.053l.03.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_799",
    fill: "#475959",
    d: "M2712.26 609.048c-.27.35-.45.756-.54 1.187-.08.432-.07.877.04 1.303l3.28 13.41-2 .71-3.28-13.41c-.18-.61-.14-1.264.12-1.844.26-.581.72-1.048 1.3-1.316.35-.115.72-.115 1.07 0l.01-.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_800",
    fill: "#617881",
    d: "M2671.91 623.15c-.58.271-1.04.74-1.3 1.321a2.622 2.622 0 0 0-.12 1.849l3.28 13.41 4-1.44-3.28-13.42c-.04-.29-.15-.567-.3-.815a2.079 2.079 0 0 0-.61-.622 2.07 2.07 0 0 0-1.67-.283Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_801",
    fill: "#475959",
    d: "M2672.98 623.121c-.27.348-.45.752-.54 1.182-.08.43-.07.873.04 1.298l3.28 13.42-2 .71-3.28-13.41a2.678 2.678 0 0 1 .12-1.849c.26-.582.72-1.051 1.3-1.321.35-.11.72-.11 1.07 0l.01-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_802",
    fill: "#F4DD45",
    d: "m2723.91 617.809-58.76 21a3.992 3.992 0 0 0-1.93 1.971 4.064 4.064 0 0 0-.19 2.749c.49 2 2.24 3.17 3.91 2.57l58.75-21a4 4 0 0 0 1.93-1.975c.39-.867.45-1.844.19-2.755-.49-2-2.24-3.16-3.9-2.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_803",
    fill: "#ECBE6B",
    d: "M2676.16 641.679c.35.235.74.384 1.16.436.41.053.84.006 1.23-.136l-11.61 4.16c-.4.142-.82.189-1.24.137a2.71 2.71 0 0 1-1.16-.437 3.76 3.76 0 0 1-1.51-2.27c-.26-.91-.19-1.884.19-2.749a4 4 0 0 1 1.93-1.971l11.62-4.16a3.998 3.998 0 0 0-1.93 1.972 4.062 4.062 0 0 0-.19 2.748c.2.921.74 1.733 1.51 2.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_804",
    fill: "#B1E4F9",
    d: "M2695.42 625.951c-4.83 0-8.74 4.73-8.74 10.58v18.36h17.49v-18.36c0-5.85-3.92-10.58-8.75-10.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_805",
    fill: "#93D8E4",
    d: "M2696.69 626.049c-4.23.75-7.48 5.15-7.48 10.48v15.11h-2.53v-15.11c0-5.85 3.91-10.59 8.74-10.59.43.002.85.039 1.27.11Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_806",
    fill: "#DF75A5",
    d: "M2695.42 641.509c2.27 0 4.11-2.23 4.11-4.98 0-2.751-1.84-4.98-4.11-4.98-2.27 0-4.11 2.229-4.11 4.98 0 2.75 1.84 4.98 4.11 4.98Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bin_4",
    className: "bin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_807",
    fill: "#CCC",
    d: "M2994.82 622.762v-.37c0-2.42-1.71-4.39-3.8-4.39h-2.51c-2.1 0-3.8 2-3.8 4.39a3.53 3.53 0 0 0 0 .46 13.459 13.459 0 0 0-4.2 3.342 13.539 13.539 0 0 0-2.57 4.718c-.07.2.35.27 1.1.26v23.57h21.59v-23.6c.73 0 1.14 0 1.07-.24a13.323 13.323 0 0 0-2.6-4.781 13.412 13.412 0 0 0-4.28-3.359Zm-4.93-1.15c-1.06.011-2.11.173-3.12.48.03-.465.22-.905.55-1.238.32-.333.76-.536 1.22-.572h2.51a1.885 1.885 0 0 1 1.76 1.75c-.95-.262-1.93-.403-2.92-.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_808",
    fill: "#878787",
    d: "M3001.99 629.631h-24.12v1.71h24.12v-1.71Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 995",
    className: "Group 995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_809",
    fill: "#878787",
    d: "M2981.32 632.861a.644.644 0 0 0-.44.222.665.665 0 0 0-.16.468v19.16c-.01.085 0 .171.02.253.03.081.07.157.13.221.05.064.12.115.2.15.08.035.16.054.25.054a.637.637 0 0 0 .45-.204c.05-.064.09-.14.12-.221a.718.718 0 0 0 .02-.253v-19.16a.653.653 0 0 0-.15-.465.66.66 0 0 0-.44-.225Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_810",
    fill: "#878787",
    d: "M2987.01 632.842a.643.643 0 0 0-.44.221.67.67 0 0 0-.16.469v19.16c-.01.084 0 .17.02.252.03.082.07.157.13.221.05.064.12.116.2.151a.606.606 0 0 0 .49 0 .64.64 0 0 0 .21-.151.61.61 0 0 0 .14-.473v-19.16a.653.653 0 0 0-.15-.465.656.656 0 0 0-.44-.225Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_811",
    fill: "#878787",
    d: "M2992.63 632.9a.661.661 0 0 0-.59.69v19.16c-.01.085 0 .171.02.253.03.081.07.157.13.221a.592.592 0 0 0 .69.15.637.637 0 0 0 .21-.15c.05-.064.1-.14.12-.221a.718.718 0 0 0 .02-.253v-19.16a.624.624 0 0 0-.16-.468.644.644 0 0 0-.44-.222Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_812",
    fill: "#878787",
    d: "M2998.32 632.873a.661.661 0 0 0-.59.69v19.17a.71.71 0 0 0 .02.252c.03.082.07.157.13.221.05.064.12.116.2.151a.606.606 0 0 0 .7-.151.61.61 0 0 0 .14-.473v-19.17a.623.623 0 0 0-.16-.468.64.64 0 0 0-.44-.222Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "scooter",
    className: "scooter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_813",
    fill: "#FFF5F5",
    d: "m2769.4 616.541-2.81 4.12a.65.65 0 0 0-.1.429c.01.15.08.291.18.401.09.076.2.118.32.12a.42.42 0 0 0 .22-.059.454.454 0 0 0 .17-.161l3.3-4.85h-1.28Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_814",
    fill: "#FFF5F5",
    d: "m2756.35 620.332-2.62-3.85h-1.27l3.09 4.54a.463.463 0 0 0 .4.22c.12 0 .23-.043.31-.12.1-.103.17-.236.18-.379a.599.599 0 0 0-.09-.411Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_815",
    fill: "#CADDEA",
    d: "M2765.23 649.509a.533.533 0 0 1-.36-.189.563.563 0 0 1-.14-.391v-4.25a.564.564 0 0 1 .01-.224.51.51 0 0 1 .99 0c.02.073.02.15 0 .224v4.25a.554.554 0 0 1-.13.391.535.535 0 0 1-.37.189Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_816",
    fill: "#CADDEA",
    d: "M2757.93 649.512a.506.506 0 0 1-.2-.056.52.52 0 0 1-.17-.13.62.62 0 0 1-.1-.184.746.746 0 0 1-.03-.21v-4.25a.551.551 0 0 1 .5-.59c.15.013.28.081.38.191.09.111.14.253.13.399v4.25a.56.56 0 0 1-.13.394.559.559 0 0 1-.38.186Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_817",
    fill: "#fff",
    d: "M2764.65 648.252h-6.13a.67.67 0 0 0-.24.064.79.79 0 0 0-.2.152.801.801 0 0 0-.12.217c-.02.079-.03.163-.03.247v.79a.65.65 0 0 0 .59.68h6.13a.638.638 0 0 0 .58-.68v-.79a.513.513 0 0 0-.03-.245.49.49 0 0 0-.12-.216.608.608 0 0 0-.43-.219Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_818",
    fill: "#FABE2C",
    d: "m2766.96 644.382-4.73 1.47c-.42.13-.87.13-1.29 0l-4.73-1.47a2.843 2.843 0 0 1-1.38-1.093 2.843 2.843 0 0 1-.48-1.697v-12.15c0-3.23 2.26-5.85 5.05-5.85h4.37c2.78 0 5 2.62 5 5.85v12.15c.03.596-.13 1.186-.45 1.686-.33.501-.8.887-1.36 1.104Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_819",
    fill: "#FFA300",
    d: "M2763.77 623.592h-3.14c2.79 0 5 2.62 5 5.85v12.82c.03.902-.12 1.801-.43 2.65l1.71-.53a2.82 2.82 0 0 0 1.38-1.095c.33-.501.5-1.094.47-1.695v-12.15c.05-3.23-2.21-5.85-4.99-5.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_820",
    fill: "#FABE2C",
    d: "M2767.97 622.549h-12.78a1.113 1.113 0 0 1-.74-.375 1.117 1.117 0 0 1-.26-.785c-.01-.255.06-.507.21-.715.15-.207.36-.357.61-.425l6.39-1.4c.12-.03.25-.03.37 0l6.39 1.4c.25.07.46.221.61.428.14.207.22.458.2.712a1.064 1.064 0 0 1-.26.788c-.09.107-.2.196-.33.26a1.11 1.11 0 0 1-.41.112Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_821",
    fill: "#AC19F9",
    d: "M2761.58 623.851c1.85 0 3.34-1.732 3.34-3.87 0-2.137-1.49-3.87-3.34-3.87-1.84 0-3.34 1.733-3.34 3.87 0 2.138 1.5 3.87 3.34 3.87Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_822",
    fill: "#8C02CC",
    d: "M2761.58 616.119a2.924 2.924 0 0 0-1.58.46c.54.387.98.897 1.29 1.489.3.591.46 1.246.46 1.911s-.16 1.32-.46 1.912a4.263 4.263 0 0 1-1.29 1.488c.47.305 1.02.468 1.58.47a3.934 3.934 0 0 0 2.38-1.318c.6-.709.94-1.612.94-2.547 0-.934-.34-1.838-.94-2.547a3.94 3.94 0 0 0-2.38-1.318Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_823",
    fill: "#FFB123",
    d: "M2761.58 621.88c.91 0 1.64-.851 1.64-1.9s-.73-1.9-1.64-1.9c-.9 0-1.64.851-1.64 1.9s.74 1.9 1.64 1.9Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_824",
    fill: "#212121",
    d: "M2761.58 654.711a2.14 2.14 0 0 1-1.47-.738 2.178 2.178 0 0 1-.53-1.562v-8.6h4v8.6a2.17 2.17 0 0 1-.52 1.562c-.38.431-.91.697-1.48.738Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_825",
    fill: "#212121",
    d: "M2760.43 643.811v10.47c.32.275.73.427 1.15.43.57-.041 1.1-.307 1.48-.738.37-.431.56-.993.52-1.562v-8.6h-3.15Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_826",
    fill: "#AC19F9",
    d: "M2766 639.622a4.755 4.755 0 0 0-4.42-3.8 4.784 4.784 0 0 0-2.86 1.147c-.8.687-1.34 1.62-1.56 2.653-.2.771-.2 1.58 0 2.35l.59 2.25c.1.497.37.946.75 1.277.38.331.87.526 1.37.553h3.4c.51-.027.99-.222 1.38-.553.38-.331.64-.78.74-1.277l.59-2.25c.21-.769.22-1.577.02-2.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_827",
    fill: "#8C02CC",
    d: "M2766 639.622a4.755 4.755 0 0 0-4.42-3.8c-.54.004-1.07.113-1.57.32.71.328 1.33.811 1.83 1.414.49.603.84 1.309 1.02 2.066.2.771.2 1.579 0 2.35l-1.07 4.08h1.5c.51-.027.99-.222 1.38-.553.38-.331.64-.78.74-1.277l.59-2.25c.2-.77.2-1.579 0-2.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_828",
    fill: "#AC19F9",
    d: "M2762.45 632.152h-1.73a.865.865 0 0 1-.79-.83l-.63-7.73h4.57l-.63 7.73c0 .212-.08.416-.23.57a.858.858 0 0 1-.56.26Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_829",
    fill: "#212121",
    d: "M2761.58 627.342a.556.556 0 0 0 .49-.376c.02-.069.03-.142.02-.214v-3.16h-1v3.16a.565.565 0 0 0 .49.59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_830",
    fill: "#FFF5F5",
    d: "M2756.48 635.001h-2.13v-3.55h2.13c.16.013.3.086.4.204a.6.6 0 0 1 .14.426v2.3c.01.076 0 .153-.03.225a.558.558 0 0 1-.29.336.57.57 0 0 1-.22.059Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_831",
    fill: "#FFF5F5",
    d: "M2766.69 635.001h2.12v-3.55h-2.12a.6.6 0 0 0-.4.204.6.6 0 0 0-.14.426v2.3c0 .076.01.153.03.225a.558.558 0 0 0 .29.336.57.57 0 0 0 .22.059Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_832",
    fill: "#8C02CC",
    d: "M2754.96 616.021h-5.1v2.27h5.1v-2.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_833",
    fill: "#8C02CC",
    d: "M2773.68 616.021h-5.1v2.27h5.1v-2.27Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "man",
    className: "man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_834",
    fill: "#F29A7E",
    d: "m2847.39 607.798-.34 2.6-2.04-.4.15-3.34.19-1.57 1.42.72.62 1.99Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_835",
    fill: "#FFB4A0",
    d: "M2849.82 605.727c-.05-.113-.1-.224-.16-.33l-.39-.65c-.02-.042-.05-.082-.07-.12a8.672 8.672 0 0 0-.85-2.53c-.46-.46-1.61.14-1.61.14a5.929 5.929 0 0 0-.73 2.91c-.12-.14-.28-.23-.43-.11a1.1 1.1 0 0 0-.35.693c-.02.264.04.529.2.747.11.111.24.195.39.243.15.049.31.062.47.037.08.22.1.5.28.66 2.13 1.85 2.71.75 2.82.51.15-.569.18-1.168.08-1.75.08-.04.17-.09.25-.15a.348.348 0 0 0 .13-.19 4.115 4.115 0 0 0-.03-.11Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_836",
    fill: "#28130F",
    d: "M2849.32 603.227c.38-.13.16-.94-.58-1.49-1.55-1.14-4.77-1.24-4.8 1.79-.25.745-.25 1.55 0 2.296.24.746.72 1.393 1.36 1.844.47-.24.26-1.54.64-2.41.15-.32.44-.26.64 0s.15.64.2.72c.05.08.27.13.29 0 .09-.74-.3-2.89.25-2.94.32-.1 1.49.36 2 .19Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_837",
    fill: "#663809",
    d: "M2835.1 650.677a7.671 7.671 0 0 0 1.13 3.9c.8.82-1.19.89-2.08.05-1.28-1.2-1.17-2.77-2.19-4.22-.46-.64.9-1.72 1.89-1.66 2.66.19 1.36.6 1.25 1.93Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_838",
    fill: "#F29A7E",
    d: "M2856.15 628.546a11.42 11.42 0 0 0-1.67-2.1.811.811 0 0 0-.35-.219.862.862 0 0 0-.42-.021.654.654 0 0 0-.32.158c-.1.08-.17.185-.21.302-.06.335-.01.681.14.988.14.308.38.56.68.722.49.212.98.383 1.49.51v.56l-.3.16c-.28-.11-.86-.33-1-.26s0 .26.06.35c.28.244.58.455.9.63.29.011.57-.048.82-.17.22-.507.29-1.067.18-1.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_839",
    fill: "#F29A7E",
    d: "M2853.74 628.246c-.2-.171-.36-.384-.48-.624a2.017 2.017 0 0 1-.18-.766 1.519 1.519 0 0 1 1.52 1l.9 2.11-.33.1a1.652 1.652 0 0 1-.42-.43 3.676 3.676 0 0 0-1.01-1.39Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_840",
    fill: "#F29A7E",
    d: "M2847.52 620.727c-.52-.78-.52-1.15.07-1.69.59-.54 1.65-.27 4 3 1.17 1.66 2.27 3.52 2.71 4.19.26.58 0 .62-.17.8-.46.43-.76.34-.85.25-2.15-2.47-4.29-4.38-5.76-6.55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_841",
    fill: "#2B73D3",
    d: "M2849.38 626.176c1.08 1.77 3.45 9.64 4.16 13.47.41 2.25-2.34 4-3 2-.36-1.08 0 0-4.67-9.8-2.84-2-3.92-2.58-3.16-5.13.76-2.55 4.94-3.38 6.67-.54Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_842",
    fill: "#663809",
    d: "M2854.33 651.675a8.173 8.173 0 0 0 4.81 1.5c1.46 0 1.33 1.42-1.16 1.68-1.91.21-2.12.27-4.1.41-1.37.11-1.32-1.7-1-3.11.41-1.66.63-.89 1.45-.48Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_843",
    fill: "#2F80ED",
    d: "M2846.19 639.336c-2 3.79-4.75 3.74-4.51 1.78.14-1.1.6-5.77.68-9.72 0-2.28-.55-2.91.59-5.67.15-.38 5 0 5 0 .44 5.23-.31 10.84-1.76 13.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_844",
    fill: "#2F80ED",
    d: "M2835.94 651.407c3-3.2 5.79-6.11 8.51-9.49 1.86-2.3-1.88-4.69-2.5-3.48-.95 1.83-3.1 3.66-4.09 4.85-2.49 2.81-4 4.22-4.61 4.79.28.31 1.57 1.86 2.69 3.33Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_845",
    fill: "#2B73D3",
    d: "M2853.52 639.167c.9 4.47 2.23 11.24 2.48 13-.16.17-3.54.87-3.62.34-.47-2.87-2.56-13.77-2.56-13.77-.55-1.16 3.11-2.49 3.7.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_846",
    fill: "#fff",
    d: "M2849.95 616.487c0-2.6-.61-5.42-1.88-7a12.608 12.608 0 0 1-3.67-1.38c-.7.56-1.62 1.15-1.68 5.75-.06 3.76 0 3.79-.25 12.72l7.41.21c0-2.11 0 .03.07-10.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_847",
    fill: "#F29A7E",
    d: "M2839.86 630.768c.24-.865.39-1.754.43-2.65a.794.794 0 0 0-.68-.861.73.73 0 0 0-.36.051c-.29.176-.51.442-.64.757a1.61 1.61 0 0 0-.07.993c.16.502.37.987.62 1.45l-.4.4-.32-.12c-.1-.28-.33-.85-.46-.9-.13-.05-.2.17-.22.28a5 5 0 0 0 .14 1.09c.18.22.41.391.67.5.52-.196.97-.54 1.29-.99Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_848",
    fill: "#F29A7E",
    d: "M2838.46 628.777a1.86 1.86 0 0 1 .14-.773c.11-.245.26-.465.45-.647.23.224.39.514.44.829.06.316.02.641-.12.931l-1 2.09-.3-.18a1.465 1.465 0 0 1 0-.59c.26-.516.39-1.084.39-1.66Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_849",
    fill: "#F29A7E",
    d: "M2840.07 618.236c1.22-2.89 3.81-6.35 4.73-7.82l1.32 1.4c-1.21 2.2-2.49 5.36-4 7.37-1.51 2.01-2.68.88-2.05-.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_850",
    fill: "#F29A7E",
    d: "M2839.87 619.127c.23-.92.5-1.16 1.3-1.09.8.07 1.31 1 .43 5-.44 2-1.08 4-1.28 4.82-.25.58-.44.43-.71.41-.63-.06-.77-.34-.76-.47.42-3.26.4-6.12 1.02-8.67Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_851",
    fill: "#C6C6C6",
    d: "M2845.89 609.825c-3.14-1.54-4.51 4.92-4.51 4.92l3.34 1.62s3.47-5.33 1.17-6.54Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "restaurant-outline",
    className: "restaurant-outline",
    filter: "url(#filter1_f_5370_44915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_852",
    fill: "url(#paint2_linear_5370_44915)",
    stroke: "url(#paint3_linear_5370_44915)",
    strokeWidth: 6,
    d: "M1938.29 430.162c-1.6-1.401-3.57-2.273-5.85-2.273h-180.25c-2.28 0-4.25.872-5.84 2.273h-1.86v2.096c-1.15 1.657-1.95 3.638-2.34 5.669v.001l-9.57 49.168-.7 3.573h12.61v167.023h196.93V490.669h11.34l-.69-3.573-9.57-49.168-4.21-7.766Zm0 0h3.13v4.367m-3.13-4.367 3.13 4.367m0 0c.49 1.081.85 2.23 1.08 3.397l-1.08-3.397Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "restaurant",
    className: "restaurant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Restaurant",
    className: "Restaurant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_853",
    fill: "#6830F2",
    d: "M1938.42 433.162h-190.93v221.53h190.93v-221.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_854",
    fill: "#EBEBEB",
    d: "M1949.12 487.669h-213.6l9.57-49.17c.87-4.49 3.78-7.61 7.1-7.61h180.25c3.32 0 6.24 3.12 7.11 7.61l9.57 49.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_855",
    fill: "#C7463B",
    d: "m1809.17 430.889-7.36 56.78h25.78l3.68-56.78h-22.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_856",
    fill: "#C7463B",
    d: "m1757.61 487.669 7.37-56.78h22.1l-7.37 56.78h-22.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_857",
    fill: "#C7463B",
    d: "m1882.87 487.669-7.37-56.78h-22.13l3.68 56.78h25.82Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_858",
    fill: "#C7463B",
    d: "m1919.66 430.889 7.36 56.78h-22.1l-7.36-56.78h22.1Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 974",
    className: "Group 974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_859",
    fill: "#8A84FF",
    d: "M1921.35 541.131h-85.54v53.11h85.54v-53.11Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_860",
    fill: "#4823E2",
    d: "M1921.35 594.561h-85.54v5.45h85.54v-5.45Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 975",
    className: "Group 975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_861",
    fill: "#8A84FF",
    d: "M1822.08 583.24h-39.63v66.02h39.63v-66.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_862",
    fill: "#9E9EF2",
    d: "M1822.08 649.26h-39.63v5.45h39.63v-5.45Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "restaurant-sign",
    className: "restaurant-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_863",
    fill: "#8A84FF",
    d: "M1796.65 531.95h-3.44V519h-3.45v12.95h-3.44V519h-3.45v12.95c0 3.922 2.86 7.104 6.46 7.345V556h4.31v-16.705c3.6-.241 6.46-3.423 6.46-7.345V519h-3.45v12.95Zm8.61-5.55v14.8h4.31V556h4.3v-37c-4.75 0-8.61 4.144-8.61 7.4Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kid",
    className: "kid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 981",
    className: "Group 981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_864",
    fill: "#A06E5F",
    d: "M1783.33 631.999c.03-.828-.04-1.657-.2-2.47a.677.677 0 0 0-.15-.356.7.7 0 0 0-.64-.274.676.676 0 0 0-.31.13c-.21.226-.35.515-.4.825-.04.31.01.627.15.905.26.416.55.807.87 1.17l-.26.45h-.31c-.15-.23-.48-.69-.61-.71-.13-.02-.14.2-.14.31.09.329.22.647.37.95.21.152.45.252.7.29.43-.304.75-.729.93-1.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_865",
    fill: "#A06E5F",
    d: "M1781.61 630.611a1.745 1.745 0 0 1-.05-.719c.04-.24.13-.469.26-.671.26.141.47.361.6.629s.17.569.11.861l-.39 2-.32-.09a1.378 1.378 0 0 1-.11-.53c.08-.495.05-1.001-.1-1.48Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_866",
    fill: "#A06E5F",
    d: "M1783.75 621.801c.06-2-.46-2.55-1.26-2.56-.8-.01-.9.229-.91 3.919 0 2 .4 4.741.37 5.611.07.54-.09.789.24.829.64.07.83-.169.84-.309.24-3.29.64-5.02.72-7.49Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_867",
    fill: "#35488B",
    d: "M1773.55 614.781s-3.35-1.521-5.89-.191c-2.54 1.33-1 12.371 2.64 13.441 0 0 6.81 2.17 3.25-13.25Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_868",
    fill: "#A06E5F",
    d: "m1779.18 612.33-3.45 1.76-.69-2.39c.33-.692.54-1.431.63-2.19.11-.662.13-1.333.08-2l2.81 1.44c-.05.211-.09.424-.12.64-.07.5-.07 1.009 0 1.51.1.484.36.919.74 1.23Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 980",
    className: "Group 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_869",
    fill: "#000",
    d: "M1784.97 651.311c.18.191.39.345.63.452.24.107.49.164.75.168.5-.024.98.137 1.36.45.07.059.13.138.16.226.02.088.03.183.01.274a.47.47 0 0 1-.14.238.482.482 0 0 1-.24.132l-4 .92a.664.664 0 0 1-.27-.001.759.759 0 0 1-.26-.109.63.63 0 0 1-.18-.201.801.801 0 0 1-.1-.259c0-.3-.08-.62-.13-.88a1.82 1.82 0 0 1 .38-1.21l2.03-.2Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_870",
    fill: "#02995B",
    d: "M1785.68 651.371a5.578 5.578 0 0 1-3.43.85s-1.75-12.61-2.21-13.23c-.1-.14-.33-.53-.61-1l-.07-.13a55.041 55.041 0 0 1-2.49-4.86c-.14-.57-.06-5.52 2.22-5.19.8.137 1.57.426 2.26.85l.19.12.14.56c.08.33.19.77.33 1.31v.2c.74 3 2.08 8.47 2.28 9.39.37 1.31 1.39 11.13 1.39 11.13Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_871",
    fill: "#000",
    d: "M1773.87 652.229c.13.217.29.407.49.558.2.152.43.261.67.322.48.091.9.35 1.2.73.06.07.09.154.09.241a.443.443 0 0 1-.05.252.372.372 0 0 1-.17.188.452.452 0 0 1-.25.069h-4a.56.56 0 0 1-.23-.052.6.6 0 0 1-.2-.141.764.764 0 0 1-.12-.208.955.955 0 0 1-.03-.239c0-.3.06-.65.08-.92.08-.394.3-.748.61-1l1.91.2Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_872",
    fill: "#02BF6D",
    d: "M1771.19 629.66s-.37 11.22-.51 22.53c.55.271 1.14.447 1.74.52 1.78.17 2.22-.53 2.22-.53s.89-9.93 1.34-13c.42-2.81 1.58-9.76 1.58-9.76l-6.37.24Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_873",
    fill: "#B67D69",
    d: "M1778.64 611.222s-3.53.43-3.6-2.06c-.07-2.49 1.4-4.09 2.38-4.07 2 0 2.28.82 2.51 1.65.23.83.34 4.31-1.29 4.48Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 983",
    className: "Group 983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_874",
    fill: "#000",
    d: "M1773.92 609.059c.01.076.03.15.06.22.05.1.12.191.19.27.09.07.18.125.28.16a.65.65 0 0 0 .31 0c.11-.018.2-.063.28-.13a.54.54 0 0 0 .19-.24c.05-.1.07-.21.06-.32a.6.6 0 0 0-.07-.32c-.05-.1-.12-.191-.2-.27.29.02.57-.066.79-.24.24-.181.4-.44.45-.73.17.106.37.168.56.18.2.022.39-.009.56-.09.18-.071.34-.189.45-.34.13-.155.22-.336.26-.53.25.149.55.209.83.17.29-.046.55-.191.73-.41a.86.86 0 0 0 0 .32c.05.103.12.198.19.28.08.072.17.127.27.16.11.024.21.024.31 0 .11-.019.2-.06.28-.12a.563.563 0 0 0 .2-.24.67.67 0 0 0 .07-.31.878.878 0 0 0-.06-.32.726.726 0 0 0-.12-.19c.15-.071.28-.172.38-.296.11-.124.19-.268.23-.424.12-.323.12-.677 0-1-.13-.32-.37-.582-.68-.74a1.214 1.214 0 0 0-.94-.09c.03-.306-.04-.612-.19-.88a1.376 1.376 0 0 0-.65-.61 1.245 1.245 0 0 0-.85-.07c-.27.076-.51.251-.67.49a1.194 1.194 0 0 0-.5-.105c-.17 0-.34.036-.5.105a1.228 1.228 0 0 0-.68-.41c-.25-.061-.52-.04-.76.06-.23.105-.43.284-.56.51-.13.238-.19.509-.17.78-.15.068-.29.167-.4.291-.12.124-.2.27-.26.429a1.19 1.19 0 0 0-.82.15c-.24.152-.43.386-.52.66-.09.293-.09.608 0 .9.09.294.27.552.51.74-.14.079-.26.187-.36.316-.1.128-.18.276-.22.434-.09.332-.06.687.08 1 .14.318.39.574.7.72.15.08.31.128.48.142.16.013.33-.007.48-.062Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_875",
    fill: "#000",
    d: "M1774.3 610.342c.56 0 1.01-.452 1.01-1.01s-.45-1.01-1.01-1.01c-.55 0-1.01.452-1.01 1.01s.46 1.01 1.01 1.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_876",
    fill: "#000",
    d: "M1773.39 609.509a.739.739 0 1 0 .002-1.478.739.739 0 0 0-.002 1.478Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_877",
    fill: "#fff",
    d: "M1779.04 609.74c0-.14-.1-.07-1.27.2-.34.06 1.1.99 1.27-.2Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_878",
    fill: "#fff",
    d: "m1770.96 629.721 11.59-.45-.42-9.65c.53-.089 1.06-.145 1.59-.17 0 0-.44-6.2-2.3-6.9a11.81 11.81 0 0 0-2.68-.75c0 .5-.12 1-1 1.07-.51.016-1.01-.08-1.48-.282a3.51 3.51 0 0 1-1.23-.888c-.59.065-1.18.162-1.77.29-.53.12-1.05.27-1.56.45-.45.137-.85.389-1.18.73a30.28 30.28 0 0 0-2.35 4.39c1.05.376 2.05.855 3 1.43v.12s-.21 9.68-.21 10.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 984",
    className: "Group 984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_879",
    fill: "#EDA1AB",
    d: "M1777.5 621.331c.01.043.01.087 0 .129a.468.468 0 0 1-.05.119.694.694 0 0 1-.09.09.33.33 0 0 1-.25.045.307.307 0 0 1-.12-.051.247.247 0 0 1-.09-.092.475.475 0 0 1-.05-.12.29.29 0 0 1 0-.131.467.467 0 0 1 .05-.121.352.352 0 0 1 .22-.138c.09-.014.18.006.25.057.07.05.12.127.13.213Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_880",
    fill: "#EDA1AB",
    d: "M1778.52 621.159c.01.044.01.089 0 .133a.282.282 0 0 1-.05.123c-.02.037-.06.068-.09.092a.318.318 0 0 1-.13.048.317.317 0 0 1-.25-.061.682.682 0 0 1-.09-.099.515.515 0 0 1-.04-.126.281.281 0 0 1 0-.129.468.468 0 0 1 .05-.119.349.349 0 0 1 .47-.075c.07.05.12.127.13.213Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_881",
    fill: "#E26E7E",
    d: "M1776.37 620.739c.02.086 0 .175-.06.246a.314.314 0 0 1-.21.134c-.04.01-.09.01-.13.002a.245.245 0 0 1-.12-.051.406.406 0 0 1-.1-.094.275.275 0 0 1-.04-.124.29.29 0 0 1 .06-.253.254.254 0 0 1 .1-.088.282.282 0 0 1 .12-.042.335.335 0 0 1 .13.001.39.39 0 0 1 .12.052c.04.025.07.058.09.095.02.037.04.079.04.122Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_882",
    fill: "#EDA1AB",
    d: "M1780.02 619.929a.37.37 0 0 1-.06.251.345.345 0 0 1-.22.139.319.319 0 0 1-.24-.063.333.333 0 0 1-.14-.217.357.357 0 0 1 .06-.246.33.33 0 0 1 .46-.078c.07.05.12.127.14.214Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_883",
    fill: "#E26E7E",
    d: "M1779.4 620.232c.02.086 0 .174-.05.245a.333.333 0 0 1-.22.135.335.335 0 0 1-.25-.053c-.03-.025-.07-.057-.09-.095a.505.505 0 0 1-.05-.122.348.348 0 0 1 .27-.39c.09-.015.18.007.26.059.07.053.12.132.13.221Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_884",
    fill: "#B49CDC",
    d: "M1777.03 617.279c-.18.028-.36.092-.52.189-.15.097-.29.225-.4.376-.11.151-.19.322-.23.503-.04.181-.05.369-.02.552.04.265.16.513.34.71.03.029.06.063.07.101a.253.253 0 0 1 0 .238.237.237 0 0 1-.07.101.546.546 0 0 1-.25.13.52.52 0 0 1-.36-.08.338.338 0 0 0-.25-.061.37.37 0 0 0-.23.131.48.48 0 0 0-.05.123c-.01.044-.01.089-.01.134.01.045.03.088.05.126.03.038.06.071.09.097a1.188 1.188 0 0 0 .88.202c.15-.026.29-.082.42-.165s.25-.19.33-.317c0 .356-.11.703-.31 1a.395.395 0 0 0-.04.186c0 .066.02.129.06.183.03.054.09.097.14.123.06.027.13.037.19.028.1-.02.18-.074.23-.15.26-.39.41-.843.42-1.31 0 0 .06-.06.08 0 .17.435.46.816.82 1.1a.33.33 0 0 0 .27.06.24.24 0 0 0 .12-.038c.04-.02.07-.048.09-.082a.28.28 0 0 0 .06-.119.203.203 0 0 0 .01-.133.287.287 0 0 0-.04-.127.278.278 0 0 0-.09-.101 1.976 1.976 0 0 1-.62-.85 1.17 1.17 0 0 0 1.64-.26c.06-.074.08-.166.06-.256a.31.31 0 0 0-.14-.224.324.324 0 0 0-.25-.059.377.377 0 0 0-.23.139.402.402 0 0 1-.13.126.473.473 0 0 1-.18.064.433.433 0 0 1-.28 0 .323.323 0 0 1-.16-.41 1.397 1.397 0 0 0-.18-1.406 1.402 1.402 0 0 0-.59-.444 1.407 1.407 0 0 0-.73-.09",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_885",
    fill: "#908CD6",
    d: "M1776.55 617.451a1.415 1.415 0 0 0-.69 1.45c.04.265.16.513.34.71.03.029.06.063.07.101a.253.253 0 0 1 0 .238.237.237 0 0 1-.07.101.546.546 0 0 1-.25.13.52.52 0 0 1-.36-.08.338.338 0 0 0-.25-.061.37.37 0 0 0-.23.131.489.489 0 0 0-.05.122c-.01.045-.01.09-.01.135.01.045.03.088.05.126.03.038.06.071.09.097a1.188 1.188 0 0 0 .88.202c.15-.026.29-.082.42-.165s.25-.19.33-.317c0 .356-.11.703-.31 1a.395.395 0 0 0-.04.186c0 .065.02.129.06.183.03.054.09.096.14.123.06.027.13.037.19.028.1-.02.18-.074.23-.15.25-.379.39-.817.41-1.27-.85-.47-1.47-2.35-.95-3.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_886",
    fill: "#EDA1AB",
    d: "M1778.47 618.731a.278.278 0 0 0-.14-.172.3.3 0 0 0-.22-.028.302.302 0 0 0-.11.09.325.325 0 0 0-.05.135c0 .049.01.097.04.14a.256.256 0 0 0 .46-.023.233.233 0 0 0 .02-.142Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_887",
    fill: "#4E5660",
    d: "M1777.51 618.69c0-.16-.14-.15-.29-.13-.15.02-.25.06-.23.22.01.034.02.067.04.096.02.029.04.055.07.074.03.02.06.035.09.042.04.008.07.009.11.003a.286.286 0 0 0 .09-.037.288.288 0 0 0 .08-.071c.02-.028.03-.06.04-.094a.18.18 0 0 0 0-.103Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_888",
    fill: "#4E5660",
    d: "M1778.06 618.569c-.02.001-.04-.004-.05-.015-.02-.01-.03-.026-.04-.045v-.14c0-.019 0-.04.01-.056a.081.081 0 0 1 .05-.034c.02 0 .04.006.06.019a.06.06 0 0 1 .03.051v.13c0 .02 0 .04-.01.057a.076.076 0 0 1-.05.033Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_889",
    fill: "#B49CDC",
    d: "M1776.87 621.541c0-.007-.01-.015-.01-.023-.01-.009-.01-.018-.01-.027 0-.01 0-.019.01-.028 0-.008.01-.016.01-.022v-.08a.109.109 0 0 1 .06-.019c.02 0 .04.006.05.019.01.006.02.014.02.022 0 .009.01.018.01.028 0 .009-.01.018-.01.027 0 .008-.01.016-.02.023v.08c0 .014 0 .028-.01.038a.064.064 0 0 1-.04.017c-.02 0-.03-.006-.04-.017-.01-.01-.02-.024-.02-.038Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_890",
    fill: "#35488B",
    d: "m1770.87 627.3-.11-1.2c5-7.23 5.78-9 3.53-12.22a4.705 4.705 0 0 0-2.29-1.64c.47-.166.96-.302 1.44-.41.45.187.87.436 1.25.74 6.82 5.94-3.82 14.73-3.82 14.73Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 979",
    className: "Group 979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_891",
    fill: "#A06E5F",
    d: "M1770.77 622.472c-1.86.66-2.56.35-2.82-.41-.26-.76 0-.93 3.46-2.07 1.08-.402 2.2-.687 3.33-.85.54-.1.73-.33.87 0 .26.58.08.84 0 .89a12.774 12.774 0 0 1-4.84 2.44Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_892",
    fill: "#A06E5F",
    d: "M1777.55 617.601c-.35.751-.79 1.461-1.3 2.12a.779.779 0 0 1-.68.31.626.626 0 0 1-.31-.109.684.684 0 0 1-.22-.251c-.09-.302-.08-.624.02-.922.1-.298.3-.556.55-.738.41-.261.85-.478 1.3-.65v-.52l-.29-.11a2.44 2.44 0 0 1-.86.36c-.12 0 0-.24 0-.33.22-.26.48-.488.76-.68.25-.064.51-.064.76 0 .24.469.33.998.27 1.52Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 982",
    className: "Group 982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_893",
    fill: "#3E9AE5",
    d: "M1775.51 600.071c-3.86 2.12-2.8 4.46-2.23 6.38 1.2-.508 2.44-.939 3.69-1.29-.46-1.74-.95-3.48-1.46-5.1v.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_894",
    fill: "#3E9AE5",
    d: "M1775.52 600.06c3.63-1.65 4.31 2.08 4.91 4.13a7.86 7.86 0 0 0-3.46 1c-.46-1.74-.95-3.48-1.46-5.1l.01-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_895",
    fill: "#7AC1FC",
    d: "M1776.45 603.26a7.601 7.601 0 0 0-3.17 3.19s.79 1.44 1.25 1.35c.73-.19 1.34-1.77 2.55-2.23-.21-.78-.41-1.57-.63-2.31Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_896",
    fill: "#53B1F2",
    d: "M1779.65 603.59a3.825 3.825 0 0 0-1.56-.513 3.91 3.91 0 0 0-1.64.183c.22.76.42 1.54.63 2.31 1.21-.43 2.44.49 3.11.31.42-.08.23-1.68.24-1.69-.23-.229-.49-.43-.78-.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_897",
    fill: "#64A9ED",
    d: "M1775.65 600.529c-3.28 1.63-2.33 3.49-1.86 5.08a7.252 7.252 0 0 1 2.66-2.35c-.26-.93-.52-1.85-.79-2.73h-.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_898",
    fill: "#97CBFF",
    d: "M1775.66 600.519c.27.88.53 1.8.79 2.73a3.85 3.85 0 0 1 1.64-.188c.55.057 1.08.234 1.56.518-.48-1.78-1.16-4.35-3.99-3.06Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "station",
    className: "station"
  }, /*#__PURE__*/React.createElement("g", {
    id: "station-outline",
    className: "station-outline",
    filter: "url(#filter2_f_5370_44915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_899",
    fill: "url(#paint4_linear_5370_44915)",
    stroke: "url(#paint5_linear_5370_44915)",
    strokeWidth: 6,
    d: "M1354.87 304.479V657h259V281.479h-22.72v-4.018h-43.28v4.018h-151.26v-13.721H1383V253h-18.99v28.479h-9.14v23Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "building_35",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_900",
    fill: "#066963",
    d: "M1610.87 304h-253v350h253V304Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_901",
    fill: "#82AFAC",
    d: "M1610.87 284.479h-253v20h253v-20Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_902",
    fill: "#82AFAC",
    d: "M1393.61 270.758h-10.89v16.36h10.89v-16.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_903",
    fill: "#82AFAC",
    d: "M1380 256h-12.99v32.32H1380V256Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_904",
    fill: "#82AFAC",
    d: "M1588.15 280.461h-37.28v5.37h37.28v-5.37Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_905",
    fill: "#82AFAC",
    d: "M1433.19 332.479h-42.32v43.979h42.32v-43.979Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_906",
    fill: "#82AFAC",
    d: "M1505.02 332.479h-42.31v43.979h42.31v-43.979Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_907",
    fill: "#82AFAC",
    d: "M1576.87 332.479h-42.31v43.979h42.31v-43.979Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_908",
    fill: "#82AFAC",
    d: "M1433.19 401.896h-42.32v43.981h42.32v-43.981Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_909",
    fill: "#82AFAC",
    d: "M1505.02 401.896h-42.31v43.981h42.31v-43.981Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_910",
    fill: "#82AFAC",
    d: "M1576.87 401.896h-42.31v43.981h42.31v-43.981Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "station-sign",
    className: "station-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_911",
    fill: "#82AFAC",
    d: "m1505.46 499.332-2.24-7.48a3.994 3.994 0 0 0-3.84-2.852h-15.02a3.973 3.973 0 0 0-3.83 2.852l-2.25 7.48a4.013 4.013 0 0 0-2.41 3.668v8c0 1.104.9 2 2 2v2c0 1.104.9 2 2 2h2c1.11 0 2-.896 2-2v-2h16v2c0 1.104.9 2 2 2h2c1.11 0 2-.896 2-2v-2c1.11 0 2-.896 2-2v-8c0-1.641-.99-3.052-2.41-3.668Zm-21.1-6.332h15.02l1.8 6h-18.62l1.8-6Zm-.49 15c-1.1 0-2-.896-2-2 0-1.105.9-2 2-2 1.11 0 2 .895 2 2 0 1.104-.89 2-2 2Zm16 0c-1.1 0-2-.896-2-2 0-1.105.9-2 2-2 1.11 0 2 .895 2 2 0 1.104-.89 2-2 2Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#82AFAC",
    fillRule: "evenodd",
    d: "M1485.03 467h-26.08a4.108 4.108 0 0 0-1.56.305c-.49.204-.94.503-1.32.88-.38.378-.68.826-.89 1.32-.2.494-.31 1.023-.31 1.558v31.036h19V501c0-1.641 1-3.052 2.41-3.668l2.25-7.48a3.973 3.973 0 0 1 3.83-2.852h6.75v-15.937c0-.535-.1-1.064-.31-1.558-.2-.494-.5-.942-.88-1.32a4.067 4.067 0 0 0-1.33-.88 4.035 4.035 0 0 0-1.56-.305Zm-2.53 35.099c-.2-.064-.41-.099-.63-.099-.22 0-.43.035-.62.099h1.25Zm-19.87-3.837a2.997 2.997 0 0 1-1.66-.495 2.993 2.993 0 0 1-1.1-1.333 2.897 2.897 0 0 1-.17-1.72c.11-.579.39-1.111.81-1.528a2.964 2.964 0 0 1 3.24-.652 2.971 2.971 0 0 1 1.84 2.752c0 .787-.31 1.542-.86 2.099-.56.558-1.31.874-2.1.877Zm21.64-14.404h-24.64V471.67h24.64v12.188Z",
    className: "Subtract",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_912",
    fill: "#82AFAC",
    d: "M1466.8 504.075h-5.93V510h5.93v-5.925Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "home-outline",
    className: "home-outline",
    filter: "url(#filter3_f_5370_44915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_913",
    fill: "url(#paint6_linear_5370_44915)",
    stroke: "url(#paint7_linear_5370_44915)",
    strokeWidth: 6,
    d: "M639.193 471.76h-3v16.379h-15.368l-.578 2.255-12.28 47.92-.96 3.745h8.077v115.632h145.27V542.059h6.325l-.96-3.745-12.28-47.92-.578-2.255h-94.988V471.76h-18.68Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "home",
    className: "home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_914",
    fill: "#56403B",
    d: "M654.873 474.76h-15.68v16.31h15.68v-16.31Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_915",
    fill: "#EF7D30",
    d: "M757.354 539.061h-139.27v115.63h139.27v-115.63Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_916",
    fill: "#C4332C",
    d: "M623.153 491.139h127.38l12.28 47.92h-151.94l12.28-47.92Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_917",
    fill: "#56403B",
    d: "M671.875 589.131h-36.49v65.56h36.49v-65.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_918",
    fill: "#9BC1F9",
    d: "M742.133 590.33h-58.6v38.97h58.6v-38.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_919",
    fill: "#EA6C18",
    d: "M714.232 590.131h-3v38.31h3v-38.31Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_920",
    fill: "#EA6C18",
    d: "M742.415 630.799h-59.37v-42h59.37v42Zm-56.37-3h53.37v-36h-53.37v36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "home-sign",
    className: "home-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_921",
    fill: "#FEA263",
    d: "M649.103 582v-13.059h8.4V582h10.5v-17.412h6.3l-21-19.588-21 19.588h6.3V582h10.5Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bicycle",
    className: "bicycle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bin1",
    className: "bin1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_922",
    fill: "#A5A5A5",
    d: "M1166.78 626.19v-.33a3.591 3.591 0 0 0-.88-2.62 3.609 3.609 0 0 0-2.47-1.24h-2.2c-.95.072-1.84.518-2.46 1.24a3.642 3.642 0 0 0-.89 2.62 2.67 2.67 0 0 0 0 .4 11.955 11.955 0 0 0-3.72 2.941 12.041 12.041 0 0 0-2.28 4.159c0 .18.32.24 1 .23v20.74h19v-20.77c.64 0 1 0 1-.21a11.782 11.782 0 0 0-6.1-7.16Zm-4.33-1c-.93.014-1.86.159-2.76.43.03-.41.2-.798.48-1.091.29-.293.68-.47 1.08-.499h2.2c.41.03.79.202 1.07.487.29.284.46.661.49 1.063a9.966 9.966 0 0 0-2.56-.4v.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_923",
    fill: "#878787",
    d: "M1173.1 632.23h-21.23v1.51h21.23v-1.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_924",
    fill: "#878787",
    d: "M1154.9 635.078a.552.552 0 0 0-.38.191c-.1.113-.15.26-.15.409v16.87c0 .075.01.15.03.221a.66.66 0 0 0 .11.194.59.59 0 0 0 .39.195.587.587 0 0 0 .39-.198.52.52 0 0 0 .13-.412v-16.87a.53.53 0 0 0-.02-.217.67.67 0 0 0-.11-.191.648.648 0 0 0-.17-.134.588.588 0 0 0-.22-.058Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_925",
    fill: "#878787",
    d: "M1159.91 635.059a.575.575 0 0 0-.39.191.557.557 0 0 0-.14.409v16.87c0 .074.01.15.03.221a.564.564 0 0 0 .29.33c.06.034.14.054.21.059a.584.584 0 0 0 .39-.199.605.605 0 0 0 .13-.411v-16.91a.547.547 0 0 0-.15-.383.547.547 0 0 0-.37-.177Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_926",
    fill: "#878787",
    d: "M1164.86 635.109a.561.561 0 0 0-.38.199.566.566 0 0 0-.14.411v16.9c0 .074.01.148.03.218.02.07.06.135.11.19.05.056.11.102.17.135.07.033.14.052.21.057.15-.01.29-.079.39-.191.1-.112.15-.259.14-.409v-16.9c.01-.075 0-.15-.02-.221a.716.716 0 0 0-.12-.194.437.437 0 0 0-.17-.136.57.57 0 0 0-.22-.059Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_927",
    fill: "#878787",
    d: "M1169.87 635.09a.61.61 0 0 0-.21.057.653.653 0 0 0-.17.135.665.665 0 0 0-.11.19.797.797 0 0 0-.03.218v16.87c-.01.15.04.298.14.412.1.114.24.185.38.198a.588.588 0 0 0 .4-.195.687.687 0 0 0 .11-.194.548.548 0 0 0 .02-.221v-16.87a.557.557 0 0 0-.14-.409.575.575 0 0 0-.39-.191Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1082",
    className: "Group 1082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_928",
    fill: "#2B150A",
    d: "M1376.11 623.538c.01.077 0 .154-.03.226a.698.698 0 0 1-.12.196.533.533 0 0 1-.18.135.614.614 0 0 1-.23.053h-2.41a.616.616 0 0 1-.22-.056.56.56 0 0 1-.29-.33.576.576 0 0 1-.04-.224c0-.153.05-.301.15-.413a.6.6 0 0 1 .4-.187h2.41a.594.594 0 0 1 .41.183c.05.056.09.122.12.193.02.071.04.147.03.224Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_929",
    fill: "#BCBCBC",
    d: "M1375.56 624.017c.25 0 .45-.219.45-.49s-.2-.49-.45-.49-.45.219-.45.49.2.49.45.49Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1080",
    className: "Group 1080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_930",
    fill: "#2B150A",
    d: "M1369.87 623.537c-.01.189.06.374.19.515.13.14.3.225.49.235h3c.1-.004.19-.026.27-.066a.65.65 0 0 0 .23-.167.722.722 0 0 0 .14-.24.655.655 0 0 0 .04-.277.718.718 0 0 0-.18-.511.745.745 0 0 0-.5-.229h-3a.762.762 0 0 0-.27.065.704.704 0 0 0-.36.401.647.647 0 0 0-.05.274Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_931",
    fill: "#BCBCBC",
    d: "M1370.56 624.128c.31 0 .56-.269.56-.6 0-.332-.25-.6-.56-.6-.31 0-.56.268-.56.6 0 .331.25.6.56.6Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1081",
    className: "Group 1081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1079",
    className: "Group 1079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_932",
    fill: "#ADADAD",
    d: "m1377.57 632.257-1.58-6.18a.54.54 0 0 1 .05-.374.516.516 0 0 1 .28-.246.442.442 0 0 1 .36.052c.06.033.1.076.14.128a.51.51 0 0 1 .07.17l1.58 6.18-.9.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_933",
    fill: "#BCBCBC",
    d: "M1376.14 626.076a.57.57 0 0 0 .04.133c.03.04.06.075.1.103.03.028.08.047.12.056a.347.347 0 0 0 .27-.057.274.274 0 0 0 .09-.105c.02-.04.04-.086.04-.132 0-.047 0-.093-.02-.138-.11-.52-.48-1.39-1.29-1.39-.37 0-.42-.12-.55-.42a1.25 1.25 0 0 0-.5-.682c-.25-.163-.54-.24-.83-.218v.72c.17-.029.33.005.47.096a.61.61 0 0 1 .27.394 1.134 1.134 0 0 0 1.14.82c.48 0 .64.81.65.82Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_934",
    fill: "#BCBCBC",
    d: "M1376.36 626.107c0 .4.41.42.46 0 .05-.42 0-1.341-.5-1.481-.24-.07-.24-.19-.25-.48-.01-.29 0-.88-.66-1l-.18.64c.35.1.35.28.37.58.02.3 0 .8.54.95.32.02.22.781.22.791Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1078",
    className: "Group 1078"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_935",
    fill: "#BCBCBC",
    d: "m1357.12 633.106-2.77-5.66a.542.542 0 0 1-.03-.376.502.502 0 0 1 .22-.304.51.51 0 0 1 .18-.06.426.426 0 0 1 .18.018c.06.019.12.05.16.092.05.042.09.093.11.15l2.78 5.66-.83.48Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_936",
    fill: "#ADADAD",
    d: "M1353.2 626.286c.02-.221.11-.431.24-.605a1.144 1.144 0 0 1 1.74-.063c.15.164.25.367.28.586.04.219.01.443-.08.645-.09.203-.24.374-.42.495-.19.12-.41.183-.63.182a1.192 1.192 0 0 1-1.13-1.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_937",
    fill: "#2B150A",
    d: "M1351.17 624.857a1.496 1.496 0 0 0 1.19 1.48c1.64.31 2.16-.29 4.74.2 1.5.29 1.67-1.34.16-1.63-2.16-.41-3.2-1.21-4.81-1.52a1.058 1.058 0 0 0-.94.261c-.13.115-.22.259-.28.418-.06.16-.08.332-.06.501v.29Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1077",
    className: "Group 1077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_938",
    fill: "#CC362B",
    d: "m1369.01 637.826-2.11 2.71c.24.05.47.07.71.06.24 0 .49-.08.73-.1l1.74-2.22a6.65 6.65 0 0 1-1.07-.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1076",
    className: "Group 1076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1075",
    className: "Group 1075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_939",
    fill: "#686766",
    d: "M1347.73 646.777c.43.03.86-.07 1.24-.288.37-.217.67-.542.85-.932.19-.39.25-.827.19-1.253a2.154 2.154 0 0 0-.56-1.14 2.097 2.097 0 0 0-1.1-.629 2.137 2.137 0 0 0-1.26.098 2.2 2.2 0 0 0-.99.793c-.24.357-.37.779-.37 1.211-.01.272.04.544.13.799.1.256.24.49.43.689.18.199.41.359.65.471.25.112.52.173.79.181Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_940",
    fill: "#F0553F",
    d: "M1363.02 644.398c.03.277.13.541.3.76.17.219.4.383.67.473.26.09.54.101.81.032a1.436 1.436 0 0 0 .96-1.964c-.12-.254-.3-.47-.53-.621a1.466 1.466 0 0 0-.79-.23c-.39.018-.76.191-1.03.482-.26.29-.4.674-.39 1.068Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1074",
    className: "Group 1074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_941",
    fill: "#F0553F",
    d: "M1377.69 633.127h1l2.94 11.58c.04.125.03.258-.03.373a.534.534 0 0 1-.29.247.427.427 0 0 1-.36-.048.356.356 0 0 1-.14-.128.562.562 0 0 1-.08-.174l-3.04-11.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_942",
    fill: "#F0553F",
    d: "m1377.34 626.887 1.57 6.54-1.19.52-1.73-7.06h1.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1073",
    className: "Group 1073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1069",
    className: "Group 1069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_943",
    fill: "#BCBCBC",
    d: "M1372.67 644.766v-.27h7c.01-.186.06-.369.13-.54l-6.1-3.84.12-.24 6.11 3.84c.1-.151.22-.286.36-.4l-3.52-6.65.21-.13 3.53 6.65c.16-.081.33-.132.5-.15v-7.68h.25v7.68c.18.021.35.072.5.15l3.52-6.65.21.13-3.52 6.65c.15.114.27.249.37.4l6.1-3.84.12.24-6.1 3.84c.08.171.12.354.13.54h7v.27h-7c-.01.19-.05.376-.13.55l6.1 3.84-.12.23-6.1-3.84c-.1.154-.22.29-.37.4l3.52 6.65-.21.13-3.52-6.65c-.15.079-.32.13-.5.15v7.68h-.25v-7.7a1.427 1.427 0 0 1-.5-.15l-3.53 6.65-.21-.13 3.52-6.65a1.661 1.661 0 0 1-.36-.4l-6.11 3.84-.12-.23 6.1-3.84c-.07-.174-.11-.36-.13-.55l-7 .02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1068",
    className: "Group 1068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_944",
    fill: "#BCBCBC",
    d: "M1372.3 644.637c0 5.34 4 9.67 8.88 9.67 4.88 0 8.88-4.33 8.88-9.67s-4-9.68-8.88-9.68c-4.88 0-8.88 4.33-8.88 9.68Zm1 0c0-4.77 3.55-8.64 7.93-8.64s7.93 3.87 7.93 8.64c0 4.77-3.55 8.63-7.93 8.63s-7.98-3.86-7.98-8.63h.05Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_945",
    fill: "#212121",
    d: "M1371.62 644.637c0 5.75 4.28 10.41 9.56 10.41s9.56-4.66 9.56-10.41-4.28-10.42-9.56-10.42-9.56 4.66-9.56 10.42Zm1.11 0c0-5.09 3.78-9.22 8.45-9.22s8.46 4.13 8.46 9.22c0 5.09-3.79 9.21-8.46 9.21-4.67 0-8.45-4.13-8.45-9.21Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1067",
    className: "Group 1067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_946",
    fill: "#BCBCBC",
    d: "M1339.22 644.767v-.27h7.05c.01-.186.06-.369.13-.54l-6.1-3.84.12-.24 6.11 3.84c.1-.151.22-.286.36-.4l-3.52-6.65.21-.13 3.53 6.65c.16-.081.33-.132.5-.15v-7.68h.25v7.68c.18.021.35.072.5.15l3.52-6.65.21.13-3.52 6.65c.15.114.27.249.37.4l6.1-3.84.12.24-6.1 3.84c.08.171.12.354.13.54h7v.27h-7c-.01.19-.05.376-.13.55l6.1 3.84-.12.23-6.1-3.84c-.1.154-.22.29-.37.4l3.52 6.65-.21.13-3.52-6.65c-.15.079-.32.13-.5.15v7.68h-.25v-7.7a1.427 1.427 0 0 1-.5-.15l-3.53 6.65-.21-.13 3.52-6.65a1.661 1.661 0 0 1-.36-.4l-6.11 3.84-.12-.23 6.1-3.84c-.07-.174-.11-.36-.13-.55l-7.05.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1066",
    className: "Group 1066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_947",
    fill: "#BCBCBC",
    d: "M1338.87 644.637c0 5.34 4 9.67 8.88 9.67 4.88 0 8.88-4.33 8.88-9.67s-4-9.68-8.88-9.68c-4.88 0-8.88 4.33-8.88 9.68Zm1 0c0-4.77 3.55-8.64 7.93-8.64s7.93 3.87 7.93 8.64c0 4.77-3.55 8.63-7.93 8.63s-8-3.86-8-8.63h.07Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_948",
    fill: "#212121",
    d: "M1337.87 644.627c0 5.75 4.28 10.41 9.56 10.41s9.56-4.66 9.56-10.41-4.28-10.42-9.56-10.42-9.56 4.66-9.56 10.42Zm1.11 0c0-5.09 3.78-9.22 8.45-9.22s8.46 4.13 8.46 9.22c0 5.09-3.79 9.21-8.46 9.21-4.67 0-8.45-4.13-8.45-9.21Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1072",
    className: "Group 1072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_949",
    fill: "#686766",
    d: "M1361.18 645.996c.15.451.39.866.71 1.218.32.352.71.634 1.14.828.44.194.91.295 1.38.298.48.002.95-.095 1.38-.284a3.993 3.993 0 0 0 1.88-5 3.38 3.38 0 0 0-.71-1.212 3.462 3.462 0 0 0-1.14-.824 3.455 3.455 0 0 0-2.76-.014 4.01 4.01 0 0 0-1.88 4.99Zm3.52-4c.12.292.13.618.01.913a1.25 1.25 0 0 1-.61.677c-.13.061-.28.092-.43.091-.15 0-.3-.032-.44-.093s-.26-.15-.36-.262c-.1-.112-.18-.243-.23-.386-.11-.294-.12-.62-.01-.916.11-.296.33-.54.61-.684a1.098 1.098 0 0 1 .89.017c.14.065.26.159.36.275.1.116.17.252.21.398v-.03Zm.54 2.1c-.11-.293-.12-.62-.01-.916.11-.296.33-.54.61-.684.14-.059.29-.088.44-.087a1.125 1.125 0 0 1 .81.36c.1.112.17.244.22.387a1.27 1.27 0 0 1-.6 1.6c-.13.06-.28.09-.43.091-.15 0-.3-.03-.44-.089a1.037 1.037 0 0 1-.36-.254.998.998 0 0 1-.24-.378v-.03Zm-1.06 2.84c-.11-.294-.12-.62-.01-.916.11-.296.33-.54.61-.684a1.096 1.096 0 0 1 1.24.274c.1.112.18.243.22.386a1.27 1.27 0 0 1-.6 1.6c-.13.059-.28.09-.43.09-.15.001-.3-.03-.43-.089a1.164 1.164 0 0 1-.37-.254c-.1-.108-.18-.237-.23-.377v-.03Zm-2.61-1.16c-.11-.293-.12-.62-.01-.916.11-.296.33-.54.61-.684a1.1 1.1 0 0 1 1.25.271c.1.112.18.245.22.389.12.292.13.618.01.913a1.25 1.25 0 0 1-.61.677c-.13.061-.28.094-.43.096-.15.001-.3-.028-.44-.086a1.105 1.105 0 0 1-.36-.253.987.987 0 0 1-.24-.377v-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1071",
    className: "Group 1071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_950",
    fill: "#2B150A",
    d: "M1360.76 649.146c0 .124.05.245.13.336.08.091.2.147.32.154h2a.45.45 0 0 0 .18-.043.425.425 0 0 0 .24-.265c.03-.058.04-.12.03-.182a.288.288 0 0 0-.03-.181.463.463 0 0 0-.09-.157.413.413 0 0 0-.15-.108.468.468 0 0 0-.18-.044h-2a.47.47 0 0 0-.32.155.514.514 0 0 0-.13.335Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_951",
    fill: "#BCBCBC",
    d: "M1363.78 644.007c.04-.091.1-.174.17-.242a.774.774 0 0 1 .26-.152.704.704 0 0 1 .57.044.88.88 0 0 1 .38.493c.06.205.04.425-.06.617a.73.73 0 0 1-.27.31.712.712 0 0 1-.39.12l-2 4.15a.365.365 0 0 1-.07.104c-.04.029-.07.052-.11.066a.338.338 0 0 1-.26-.02.35.35 0 0 1-.16-.218.366.366 0 0 1 .02-.272l2-4.11a.96.96 0 0 1-.16-.434c-.01-.156.02-.314.08-.456Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_952",
    fill: "#F0553F",
    d: "M1347.37 644.967a.66.66 0 0 0 .27.279c.11.066.24.097.37.091h15.7c.31-.04.61-.141.88-.297.26-.157.5-.365.68-.614l11.7-15c.35-.393.56-.893.59-1.42a.611.611 0 0 0-.03-.233.703.703 0 0 0-.13-.197.65.65 0 0 0-.2-.127.603.603 0 0 0-.24-.032l-20.4 1.67c-.39.07-.76.236-1.08.484a2.59 2.59 0 0 0-.73.935l-7.31 13.5c-.09.142-.14.304-.16.472-.01.167.02.336.09.489Zm17.27-1.55-7.77-13.28h.12l18.55-1.67c.4 0 .38.44 0 1l-10.67 13.74-.23.21Zm-16.88.81 7.37-13.4c.1-.195.23-.373.38-.53l8.42 14.62h-15.9c-.35.01-.47-.3-.27-.71v.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_953",
    fill: "#BCBCBC",
    d: "M1365.14 644.816a.635.635 0 0 1-.17.242.699.699 0 0 1-.54.186.751.751 0 0 1-.29-.088.863.863 0 0 1-.32-1.1.753.753 0 0 1 .66-.44l2-4.14a.41.41 0 0 1 .08-.107c.03-.03.07-.053.11-.067.05-.015.09-.02.14-.015.04.004.08.017.12.039.08.048.14.125.16.214.03.09.02.185-.03.266l-2 4.11c.09.13.15.282.16.44a.814.814 0 0 1-.08.46Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_954",
    fill: "#2B150A",
    d: "M1368.27 639.767a.288.288 0 0 0-.03-.181.425.425 0 0 0-.24-.265.468.468 0 0 0-.18-.044h-2a.47.47 0 0 0-.32.155.514.514 0 0 0-.13.335c0 .124.05.245.13.336.08.091.2.147.32.154h2a.45.45 0 0 0 .18-.043.425.425 0 0 0 .24-.265c.03-.058.04-.12.03-.182Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1070",
    className: "Group 1070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_955",
    fill: "#F0553F",
    d: "M1347.75 645.516c.43 0 .78-.38.78-.85 0-.469-.35-.85-.78-.85-.43 0-.78.381-.78.85 0 .47.35.85.78.85Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_956",
    fill: "#F0553F",
    d: "M1381.14 645.516c.43 0 .78-.38.78-.85 0-.469-.35-.85-.78-.85-.43 0-.78.381-.78.85 0 .47.35.85.78.85Z",
    className: "Vector"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "person",
    className: "person"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1091",
    className: "Group 1091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_957",
    fill: "#28130F",
    d: "M1368.87 614.987a1.49 1.49 0 0 1-.12 1.62c-.25.197-.57.292-.9.268a1.339 1.339 0 0 1-.85-.398s-3.49-4.55-4.91-6c-2.52-2.49-.85-4-.37-4.35.48-.35 2.93-1.24 4 2.33a21.818 21.818 0 0 1 3.15 6.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_958",
    fill: "#28130F",
    d: "M1367.87 617.517a3.391 3.391 0 0 1-1.27-1.85l1-.33c.36-.48.62-1.12 1.1-.77 2.49 1.85 3.41 4.39 5.07 6.18.59.503 1.2.97 1.84 1.4.42.41 0 1.8 0 1.8-.57.326-1.23.456-1.88.37-.6-.05-.77-.39-.37-.41 1-.08.71-1.5-.24-1.42-.26 0 0-1 0-1l-5.25-3.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_959",
    fill: "#3F1E19",
    d: "M1367.76 614.358a22.293 22.293 0 0 0-2.21-5.19c-.12-.676-.29-1.344-.49-2-.41-1.58-1.18-1-1.84-1.35a2.666 2.666 0 0 0-1.54.3c-.48.33-2.15 1.86.37 4.35 1.42 1.41 4.91 6 4.91 6 .27.372.58.709.93 1l4.11 3.16a19.99 19.99 0 0 0-4.24-6.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1088",
    className: "Group 1088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_960",
    fill: "#fff",
    d: "m1372.87 619.396-1.1.81a.095.095 0 0 0-.03.07c0 .027.01.052.03.07l.79 1.08a.12.12 0 0 0 .07.026.1.1 0 0 0 .07-.026l1.11-.8a.095.095 0 0 0 .03-.07c0-.025-.01-.05-.03-.07l-.79-1.08a.183.183 0 0 0-.03-.027.102.102 0 0 0-.04-.012.094.094 0 0 0-.04.007c-.01.005-.03.012-.04.022Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_961",
    fill: "#EAEAEA",
    d: "m1372.87 619.397.79 1.09a.097.097 0 0 1 0 .14l-1.11.8c.02.016.05.025.07.025.03 0 .05-.009.07-.025l1.11-.8a.097.097 0 0 0 0-.14l-.79-1.08c-.01-.02-.04-.032-.07-.034a.105.105 0 0 0-.07.024Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_962",
    fill: "#065B18",
    d: "m1373.23 619.91-1.18.877.28.377 1.18-.877-.28-.377Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1095",
    className: "Group 1095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1093",
    className: "Group 1093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "head",
    className: "head"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1092",
    className: "Group 1092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_963",
    fill: "#28130F",
    d: "M1363.95 601.326a9.734 9.734 0 0 1-2.48 4.19c.88.757 1.63 1.652 2.21 2.65a18.982 18.982 0 0 1 2.41-3.34c1.06-.97-2.14-3.5-2.14-3.5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1065",
    className: "Group 1065"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_964",
    fill: "#3F1E19",
    d: "M1369.26 603.076c-2 3.14-2.79 2.42-4 1.47a3.954 3.954 0 0 1-1.45-2.031 3.956 3.956 0 0 1 .03-2.499c.57-2.21 2.51-3.25 4.51-2.32 2 .93 2.85 2.64.91 5.38Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_965",
    fill: "#000",
    d: "M1370.26 601.076c.74.39 2.1-.46 2-1.9-.32 0-.77-.69-.93-1.08-.63-1.57-2.7-3.68-5-2-2-.93-5.21 4.5-3 6.75.54 0 1.63-.95 2.38-1.95s1.66-.54 1.32.24c1.19-.45.71-1.39 3.23-.06Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_966",
    fill: "#fff",
    d: "M1367.81 603.946c.09-.12-.07-.11-1.39-.38-.38-.08.61 1.5 1.39.38Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1094",
    className: "Group 1094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_967",
    fill: "#000",
    d: "M1366.31 597.336c.64 2.39 5.31 3.66 5.86 1.84-.32 0-.77-.69-.93-1.08-.63-1.57-2.69-3.68-4.94-2-1.86-.86-4.71 3.62-3.41 6.1a8.305 8.305 0 0 0 3.42-4.86Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_968",
    fill: "#000",
    d: "M1366.48 595.857c-.84-.15-1.71.008-2.44.445a3.585 3.585 0 0 0-1.56 1.935c-.08.44-.17 2.24-.31 2.51-.1.256-.27.481-.48.656-.22.175-.47.293-.75.344.27.295.62.51 1 .62-.33.27-1.13.06-1.13.06.13.279.33.519.59.694.25.176.55.281.85.306.37 0 .34-.48.42-.43a1.997 1.997 0 0 1 1.51-.6c-.04-.76 3.07-6.47 2.3-6.54Z",
    className: "Vector"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1086",
    className: "Group 1086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1083",
    className: "Group 1083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_969",
    fill: "#28130F",
    d: "M1361.64 644.807c.43.91 2.27 1.48 3.73 2 1.29.44.64.88.47 1h-5.23c-1.39 0-.7-1.95-.6-2.44.32-1.68 1.23-1.42 1.63-.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_970",
    fill: "#fff",
    d: "M1365.37 646.777c-1.2-.382-2.35-.909-3.42-1.57-.6.424-1.33.642-2.07.62-.12.53-.48 1.91.73 1.92h5.23c.17-.09.82-.54-.47-.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_971",
    fill: "#828282",
    d: "M1359.87 647.447c.09.103.19.184.32.236a.8.8 0 0 0 .38.064h5.23a.857.857 0 0 0 .3-.33l-6.23.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_972",
    fill: "#28130F",
    d: "M1361.47 644.727c-.85-4.61-.68-6.66-2-12.4a75.136 75.136 0 0 0-2.94-13.08c-2.65-1.18-6.67 2-5.15 3.36 2.76 6.85 5 7.51 5.45 9.63-.46 1.4-.28 3.24.79 5.71a36.994 36.994 0 0 1 2.65 7.35c.43-.118.84-.311 1.2-.57Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_973",
    fill: "#fff",
    d: "M1355.25 629.567c1.17-.48 2.35-.93 3.53-1.42a50.113 50.113 0 0 0-1.45-6.74c-1.27-4.37-5-.8-6.35 1.18a25.442 25.442 0 0 0 4.27 6.98Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1085",
    className: "Group 1085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1084",
    className: "Group 1084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_974",
    fill: "#28130F",
    d: "M1365.87 635.727c0 .49 2.28 1.49 3.73 2 1.29.43.64.87.47 1h-5.23c-1.38 0-.7-2-.6-2.44.27-1.68 1.46-1.01 1.63-.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_975",
    fill: "#28130F",
    d: "M1364.02 631.677c.45 2.22.07 4.16.19 5.7.5.028.99.091 1.48.19 0-4.05 2.72-12.54 1.25-13.64-4.83-3.66-8.77-4.12-12.21-6-4-2.2-5.21 4.74-2.3 5.5 6.72 2.94 9.54 1.45 11.34 2.66.26 1.25-.52 1.75.25 5.59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_976",
    fill: "#fff",
    d: "M1369.55 637.707c-1.1-.363-2.17-.839-3.18-1.42a3.39 3.39 0 0 1-2.33.54c-.38 1.44-.07 1.84.75 1.84h5.23c.17-.09.85-.53-.47-.96Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_977",
    fill: "#828282",
    d: "M1364.06 638.426c.1.09.22.158.34.199.13.042.26.056.39.042h5.23a.791.791 0 0 0 .28-.271l-6.24.03Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_978",
    fill: "#EAEAEA",
    d: "M1361.95 620.967c-2.67-1.22-4.83-2.39-7.07-3.47-4.33-2.07-5.76 5.09-2.85 5.86a24.46 24.46 0 0 0 8.28 2.05c.46-1.51 1.01-2.993 1.64-4.44Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1090",
    className: "Group 1090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_979",
    fill: "#022BAF",
    d: "M1363.61 613.866a7.207 7.207 0 0 0 1.38-2.644c.27-.967.34-1.981.2-2.976a12.496 12.496 0 0 0-2.61-3.93c-.94.5-1.4-.14-4.14 3.76-2 2.93-3 5.71-6.08 9.1 2 1.07 4.15 1.829 6.38 2.25 2.67-3.51 2.61-2.64 4.87-5.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1089",
    className: "Group 1089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_980",
    fill: "#28130F",
    d: "M1367.56 614.877c.13.251.19.532.17.814-.02.281-.11.552-.27.786a1.2 1.2 0 0 1-.84.169 1.22 1.22 0 0 1-.75-.439s-3.24-4.83-4.57-6.35c-2.35-2.69-.79-4.09-.35-4.38.44-.29 2.73-1 3.68 2.64a24.55 24.55 0 0 1 2.93 6.76Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_981",
    fill: "#28130F",
    d: "M1366.69 617.317a3.835 3.835 0 0 1-1.18-1.94l.89-.26c.34-.45.58-1.06 1-.67 2.32 2 3.18 4.65 4.73 6.57.55.549 1.12 1.066 1.72 1.55.38.45 0 1.8 0 1.8a2.54 2.54 0 0 1-1.76.22c-.55-.09-.71-.45-.34-.44.89 0 .66-1.44-.23-1.44-.23 0 0-1 0-1l-4.83-4.39Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1087",
    className: "Group 1087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_982",
    fill: "#fff",
    d: "m1371.06 619.397-1.1.81c-.01.008-.02.019-.02.031-.01.012-.01.026-.01.039 0 .013 0 .027.01.039 0 .012.01.023.02.031l.78 1.08c.02.016.05.025.07.025.03 0 .05-.009.07-.025l1.11-.8a.097.097 0 0 0 0-.14l-.79-1.08c-.01-.02-.04-.032-.06-.034a.114.114 0 0 0-.08.024Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_983",
    fill: "#EAEAEA",
    d: "m1371.06 619.397.79 1.09a.097.097 0 0 1 0 .14l-1.11.8c.02.016.05.025.07.025.03 0 .05-.009.07-.025l1.11-.8a.097.097 0 0 0 0-.14l-.79-1.08c-.01-.02-.04-.032-.06-.034a.114.114 0 0 0-.08.024Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_984",
    fill: "#FED843",
    d: "m1371.39 619.908-1.18.877.28.377 1.18-.877-.28-.377Z",
    className: "Vector"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "car",
    className: "car"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_985",
    fill: "#DAD8DB",
    d: "m1621.95 636.698-104.52-1.839-2.79-11.33v-2.131a1.78 1.78 0 0 1 .41-1.209c.27-.341.66-.572 1.1-.65l7.49-1.151c2.21-.337 4.36-.969 6.41-1.88l11.52-5.129a33.246 33.246 0 0 1 13.54-2.9h17c1.88.006 3.74.401 5.46 1.16 1.72.759 3.26 1.865 4.54 3.249l11.39 12.18 14.39.341c5.89 0 9.37 1.72 11.39 3.52l2.67 7.769Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_986",
    fill: "#ECEAEC",
    d: "M1613.87 636.598v-3a3.81 3.81 0 0 1 .63-2.149 3.797 3.797 0 0 1 1.74-1.411l3-1.11c.32.279.61.576.89.89a7.558 7.558 0 0 1 1.79 5v1.86l-8.07-.15.02.07Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_987",
    fill: "#FF8086",
    d: "M1514.63 632.929v-9.4h1.76c1.45.05 2.82.671 3.81 1.729a5.447 5.447 0 0 1 1.47 3.911v3.76h-7.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_988",
    fill: "#C8C5C9",
    d: "M1621.94 636.7v7.52c.04.964-.32 1.901-.97 2.606a3.649 3.649 0 0 1-2.54 1.154h-89.72l-13.43-4.78a3.79 3.79 0 0 1-2.41-3.57v-6.61c0-.246.04-.491.13-.72.09-.229.22-.438.39-.613.17-.176.38-.315.61-.409.22-.094.47-.141.71-.138l11.51.59c.94.065 1.88-.155 2.69-.63a13.15 13.15 0 0 1 6.83-1.93c2.89.009 5.7.961 8 2.71.76.55 1.67.864 2.6.9l43.35 2.24a3.28 3.28 0 0 0 2.66-1.1 13.517 13.517 0 0 1 4.91-3.644c1.9-.82 3.96-1.193 6.02-1.088 2.06.104 4.07.683 5.88 1.691a13.345 13.345 0 0 1 4.51 4.121c.3.411.68.75 1.13.992.44.243.94.382 1.44.408l5.7.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_989",
    fill: "#9B959D",
    d: "m1583.24 619.448-4.75 2.64-39.84-4c-.02-.375.07-.749.26-1.072.2-.323.48-.58.82-.738l3.19-1.42c.53-.24 1.07-.46 1.62-.67l3.52-1.09c2.29-.56 4.64-.845 7-.85h7l1.8.7 1.72-.7h6.48c1.41.009 2.8.307 4.08.877a10.17 10.17 0 0 1 3.39 2.433l3.71 3.89Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_990",
    fill: "#857E87",
    d: "M1586.53 622.96c.16.157.26.355.3.57.05.215.03.438-.05.641-.09.204-.23.379-.4.505-.18.126-.4.197-.62.204l-20.11-.47-1.78-.7-1.74.61-14.07-.33-3.52-.14a7.11 7.11 0 0 1-3.15-1.379 7.12 7.12 0 0 1-2.13-2.701l-.43-.92c-.1-.243-.17-.504-.18-.77l44.59 1.37 3.29 3.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_991",
    fill: "#676775",
    d: "M1562.13 612.236h3.52v12.17l-3.52-.09v-12.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_992",
    fill: "#676775",
    d: "M1544.54 614.178c1.15-.437 2.33-.801 3.52-1.09v10.9l-2.66-.06a8.31 8.31 0 0 1-.86-.08v-9.67Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 914",
    className: "Group 914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_993",
    fill: "#676775",
    d: "M1535.75 655.508c5.83 0 10.56-5.055 10.56-11.29 0-6.236-4.73-11.29-10.56-11.29-5.84 0-10.56 5.054-10.56 11.29 0 6.235 4.72 11.29 10.56 11.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_994",
    fill: "#fff",
    d: "M1535.74 651.737c3.89 0 7.04-3.367 7.04-7.52s-3.15-7.52-7.04-7.52c-3.88 0-7.04 3.367-7.04 7.52s3.16 7.52 7.04 7.52Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_995",
    fill: "#DAD8DB",
    d: "M1535.74 647.979c1.95 0 3.52-1.683 3.52-3.76s-1.57-3.76-3.52-3.76c-1.94 0-3.52 1.683-3.52 3.76s1.58 3.76 3.52 3.76Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 915",
    className: "Group 915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_996",
    fill: "#676775",
    d: "M1602.59 655.508c5.84 0 10.56-5.055 10.56-11.29 0-6.236-4.72-11.29-10.56-11.29-5.83 0-10.56 5.054-10.56 11.29 0 6.235 4.73 11.29 10.56 11.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_997",
    fill: "#fff",
    d: "M1602.59 651.737c3.89 0 7.04-3.367 7.04-7.52s-3.15-7.52-7.04-7.52-7.04 3.367-7.04 7.52 3.15 7.52 7.04 7.52Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_998",
    fill: "#DAD8DB",
    d: "M1602.6 647.979c1.94 0 3.52-1.683 3.52-3.76s-1.58-3.76-3.52-3.76c-1.95 0-3.52 1.683-3.52 3.76s1.57 3.76 3.52 3.76Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bus-stop 1",
    className: "bus-stop 1",
    clipPath: "url(#clip1_5370_44915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    className: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    className: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_999",
    fill: "#F5F8FD",
    d: "M1498.75 621.733H1411l-3.38-3.382v-33.743l3.38-3.375h42.24l1.63 1.018 1.63-1.018h42.25l3.37 3.368v33.758l-3.37 3.374Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1000",
    fill: "#E5EEFA",
    d: "M1498.75 581.233h-42.41v.103l-1.47.915-1.63-1.018H1411l-3.38 3.375v33.743l3.38 3.382h6.15v-32.695c0-.815.66-1.476 1.47-1.476h37.72v34.171h6.33v-32.695c0-.815.66-1.476 1.47-1.476h34.61l3.37 3.367v-6.328l-3.37-3.368Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1001",
    fill: "#B0B0BF",
    d: "M1453.08 614.975a1.63 1.63 0 1 0 3.26 0v-33.742h-3.26v33.742Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1002",
    fill: "#82AFAC",
    d: "m1505.5 567.729-6.75 3.371H1411l-6.75-3.371v-9.148c0-6.132 4.97-11.102 11.1-11.102h79.05c6.13 0 11.1 4.97 11.1 11.102v9.148Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1003",
    fill: "#B0B0BF",
    d: "m1488.87 656.09-2.49 4.389-4.51-4.389v-19.611h7v19.611Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1004",
    fill: "#B0B0BF",
    d: "m1427.87 656.401-2.49 4.078-4.51-4.078v-18.922h7v18.922Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1005",
    fill: "#F4F4F4",
    d: "M1478.5 560.979h-47.25a3.375 3.375 0 1 1 0-6.75h47.25c1.86 0 3.37 1.51 3.37 3.375a3.373 3.373 0 0 1-3.37 3.375Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1006",
    fill: "#E5E5E5",
    d: "M1434.39 557.604a3.375 3.375 0 0 1 3.38-3.375h-6.52a3.375 3.375 0 1 0 0 6.75h6.52a3.375 3.375 0 0 1-3.38-3.375Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 33",
    fill: "#B0B0BF",
    d: "M1417.87 630.479h74v7h-74z",
    className: "Rectangle 33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34",
    fill: "#B0B0BF",
    d: "M1498.87 566.479h7v91h-7z",
    className: "Rectangle 34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 35",
    fill: "#B0B0BF",
    d: "M1403.87 566.479h7v91h-7z",
    className: "Rectangle 35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36",
    fill: "#82AFAC",
    d: "M1403.87 563.479h102v8h-102z",
    className: "Rectangle 36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 971",
    className: "Group 971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1007",
    fill: "red",
    d: "M1271.27 652.691v-16.3a4 4 0 1 0-8 0v16.3h8Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1008",
    fill: "#C10202",
    d: "M1271.97 636.902h-9.64v1.97h9.64v-1.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1009",
    fill: "#C10202",
    d: "M1271.97 652h-9.45v2.27h9.45V652Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1010",
    fill: "#C10202",
    d: "M1269 631.32h-3.45v1.22h3.45v-1.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1011",
    fill: "#C10202",
    d: "M1267.61 629h-.64v2.79h.64V629Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1012",
    fill: "red",
    d: "M1273.03 642.973h-11.57v3.27h11.57v-3.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1013",
    fill: "red",
    d: "M1273.6 644.102h-12.73v1.04h12.73v-1.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1014",
    fill: "#C10202",
    d: "M1267.41 642.973a1.734 1.734 0 0 0-1.68.983c-.15.314-.2.665-.15 1.009.05.343.21.662.45.916.23.254.54.43.88.506a1.714 1.714 0 0 0 1.81-.719c.2-.288.3-.628.3-.975a1.668 1.668 0 0 0-1.61-1.72Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1015",
    fill: "#E8BC03",
    d: "M1200.45 632.92h.51c0-.33-.08-.65-.08-1 0-4.81 3.12-8.71 7-8.71.88.022 1.75.229 2.54.608s1.49.922 2.06 1.592a8.113 8.113 0 0 1 2.83-3.131 8.059 8.059 0 0 1 4.02-1.279c4.67 0 8.45 4.72 8.45 10.55 0 1.31-.2 2.612-.6 3.86 4.3.25 7.73 4.64 7.73 10.07 0 5.59-3.63 10.13-8.11 10.13-1.22 0-25.49-1.21-26.32-1.21-4.76 0-8.61-4.82-8.61-10.76 0-5.94 3.82-10.72 8.58-10.72Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "building_36",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1016",
    fill: "#CCC",
    d: "M4964.64 324.973h-254.77v330.08h254.77v-330.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1017",
    fill: "#CCC",
    d: "M4924.13 305H4748.6v20.45h175.53V305Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "windows_9",
    className: "windows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1018",
    fill: "#fff",
    d: "M4790.05 344.793h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1019",
    fill: "#fff",
    d: "M4853.35 344.793h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1020",
    fill: "#fff",
    d: "M4916.65 344.793h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1021",
    fill: "#fff",
    d: "M4790.05 410.352h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1022",
    fill: "#fff",
    d: "M4853.35 410.352h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1023",
    fill: "#fff",
    d: "M4916.65 410.352h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1024",
    fill: "#fff",
    d: "M4790.05 475.902h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1025",
    fill: "#fff",
    d: "M4853.35 475.902h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1026",
    fill: "#fff",
    d: "M4916.65 475.902h-37.28v41.53h37.28v-41.53Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1027",
    fill: "#EAEAEA",
    d: "M4830.8 594.871h-44.41v57.21h44.41v-57.21Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1028",
    fill: "#EAEAEA",
    d: "M4882.03 594.871h-44.41v57.21h44.41v-57.21Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "building_37",
    className: "building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1029",
    fill: "#A3A3A3",
    d: "M4740.2 444h-136.33v211.14h136.33V444Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1030",
    fill: "#686868",
    d: "M4740.38 440.801h-136.51v3.81h136.51v-3.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1031",
    fill: "#686868",
    d: "M4616.55 440.8h11.81v-5.71l-11.81-5.09v10.8Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1045",
    className: "Group 1045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1032",
    fill: "#fff",
    d: "M4642.96 457.879h-18.64v39.45h18.64v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1033",
    fill: "#fff",
    d: "M4642.91 516.07h-18.64v39.45h18.64v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1034",
    fill: "#fff",
    d: "M4681.43 458.031h-18.64v39.45h18.64v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1035",
    fill: "#fff",
    d: "M4681.38 516.23h-18.64v39.45h18.64v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1036",
    fill: "#fff",
    d: "M4719.64 457.879H4701v39.45h18.64v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1037",
    fill: "#fff",
    d: "M4719.59 516.07h-18.64v39.45h18.64v-39.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1038",
    fill: "#CCC",
    d: "M4689.55 598.398h-36.35v54.31h36.35v-54.31Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "company-outline",
    className: "company-outline",
    filter: "url(#filter4_f_5370_44915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1039",
    fill: "url(#paint8_linear_5370_44915)",
    stroke: "url(#paint9_linear_5370_44915)",
    strokeWidth: 6,
    d: "M5193.5 427.71h.5V414h-237.84v7.92h-.29v70.87h.18v7.51h.03v157.45h237.93v-3.002l-.11-161.1-.01-2.998v-4.06h-.39v-58.88Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "company",
    className: "company"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1040",
    fill: "#2C39B0",
    d: "M4959.08 493.65v161.1h231.93l-.11-161.1h-231.82Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1041",
    fill: "#2C39B0",
    d: "M5190.5 424.92h-231.63v64.87h231.63v-64.87Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1042",
    fill: "#5060F9",
    d: "M5191 417h-231.84v7.71H5191V417Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1043",
    fill: "#5060F9",
    d: "M5190.89 489.59h-231.84v7.71h231.84v-7.71Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1044",
    fill: "#1D2996",
    d: "M5097.07 602.113h-44.41v51.31h44.41v-51.31Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1045",
    fill: "#5060F9",
    d: "M5160.99 600.223h-29.48v26.45h29.48v-26.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1046",
    fill: "#5060F9",
    d: "M5018.58 600.203h-29.48v26.45h29.48v-26.45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1047",
    fill: "#5060F9",
    d: "M5018.44 519.59h-29.3v44.56h29.3v-44.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1048",
    fill: "#5060F9",
    d: "M5160.85 519.59h-29.3v44.56h29.3v-44.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1049",
    fill: "#5060F9",
    d: "M5089.4 519.59h-29.3v44.56h29.3v-44.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "company-sign",
    className: "company-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1050",
    fill: "#5060F9",
    d: "M5092.51 445.458h-8.66v-4.334a4.32 4.32 0 0 0-4.34-4.333h-8.66a4.32 4.32 0 0 0-4.34 4.333v4.334h-8.66c-2.41 0-4.31 1.928-4.31 4.333l-.03 23.833a4.321 4.321 0 0 0 4.34 4.334h34.66c2.41 0 4.34-1.929 4.34-4.334v-23.833a4.32 4.32 0 0 0-4.34-4.333Zm-13 0h-8.66v-4.334h8.66v4.334Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1051",
    className: "Group 1051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1051",
    fill: "#EAC632",
    d: "M5029.87 596h-19c-1.64 0-3 1.7-3 3.81v38.85c0 2.1 1.33 3.81 3 3.81h5.63v12.8h8.07v-12.75h5.31c1.64 0 3-1.71 3-3.81v-38.9c-.04-2.11-1.37-3.81-3.01-3.81Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1052",
    fill: "#EAEAEA",
    d: "M5030.63 598.719h-20.53v40.89h20.53v-40.89Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light_3",
    className: "light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1053",
    fill: "#4F7D99",
    d: "M4977.95 647.04h-4.85V525.12c0-7.78 5.13-14.12 11.43-14.12s11.44 6.34 11.44 14.12v11.48h-4.85v-11.48c0-4.49-3-8.14-6.59-8.14s-6.58 3.65-6.58 8.14v121.92Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1054",
    fill: "#A9C5D3",
    d: "M4979.08 618.152h-7.11l-4.1 36.6h14.81l-3.6-36.6Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1055",
    fill: "#FDC800",
    d: "M4985.71 541.57v.11c0 5.06 3.32 9.17 7.43 9.17 4.11 0 7.43-4.11 7.43-9.17v-.11h-14.86Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1056",
    fill: "#A9C5D3",
    d: "M4993.13 529.633c-6 0-10.88 6.06-10.88 13.54h21.76c0-7.48-4.87-13.54-10.88-13.54Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bush_7",
    className: "bush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1057",
    fill: "#B0BF1D",
    d: "M4764.83 635.35a4.959 4.959 0 0 0-3.49 1.57 5.402 5.402 0 0 0-5.08-3.563c-1.11 0-2.2.342-3.11.979-.91.638-1.6 1.54-1.98 2.584-1.42-2.94-3.95-4.92-6.86-4.92-4.25 0-7.71 4.23-8 9.58a4.454 4.454 0 0 0-1.51-2.198 4.456 4.456 0 0 0-2.49-.952c-2.45 0-4.44 2.55-4.44 5.68s2 5.69 4.44 5.69h32.49c3.12 0 5.65-3.24 5.65-7.23s-2.5-7.22-5.62-7.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1058",
    fill: "#EAE3D6",
    d: "M4769.67 646.52h-41.34v4.69h41.34v-4.69Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1059",
    fill: "#876C66",
    d: "M4732.69 655.99h32.83l1.49-4.74H4731l1.69 4.74Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "feuer_3",
    className: "feuer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1060",
    fill: "red",
    d: "M4934.32 652.7v-16.3c.06-.56.01-1.126-.16-1.663a4.068 4.068 0 0 0-.83-1.45 4.103 4.103 0 0 0-1.35-.985 3.98 3.98 0 0 0-1.63-.349c-.57 0-1.12.119-1.64.349-.51.23-.97.566-1.35.985-.37.42-.65.914-.83 1.45a4.068 4.068 0 0 0-.16 1.663v16.3h7.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1061",
    fill: "#C10202",
    d: "M4934.98 636.902h-9.64v1.97h9.64v-1.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1062",
    fill: "#C10202",
    d: "M4934.97 652h-9.45v2.27h9.45V652Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1063",
    fill: "#C10202",
    d: "M4932 631.32h-3.45v1.22h3.45v-1.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1064",
    fill: "#C10202",
    d: "M4930.61 629h-.64v2.79h.64V629Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1065",
    fill: "red",
    d: "M4936.03 642.973h-11.57v3.27h11.57v-3.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1066",
    fill: "red",
    d: "M4936.6 644.109h-12.73v1.04h12.73v-1.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1067",
    fill: "#C10202",
    d: "M4930.42 642.97a1.725 1.725 0 0 0-1.68.975c-.16.313-.21.665-.16 1.009.06.344.21.664.45.919.23.255.54.432.88.509.34.077.7.05 1.02-.078.32-.128.6-.35.8-.638.19-.288.3-.628.29-.976.02-.44-.14-.867-.44-1.189-.3-.322-.72-.513-1.16-.531Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1068",
    fill: "#B0BF1D",
    d: "M4908.33 634.93h-.51c.05-.331.08-.665.08-1 0-4.81-3.12-8.72-7-8.72-.88.022-1.74.231-2.53.612-.8.38-1.5.925-2.07 1.598a8.027 8.027 0 0 0-2.82-3.137 8.12 8.12 0 0 0-4.03-1.283c-4.67 0-8.45 4.73-8.45 10.56 0 1.307.21 2.605.6 3.85-4.3.26-7.73 4.65-7.73 10.08 0 5.59 3.63 10.13 8.11 10.13 1.23 0 25.49-1.21 26.32-1.21 4.76 0 8.62-4.82 8.62-10.76 0-5.94-3.83-10.72-8.59-10.72Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1069",
    fill: "#E8BC03",
    d: "M4595.47 635.92h.5c0-.33-.08-.65-.08-1 0-4.81 3.13-8.71 7-8.71.88.022 1.75.23 2.54.609a6.26 6.26 0 0 1 2.06 1.591 8.119 8.119 0 0 1 2.83-3.133 8.047 8.047 0 0 1 4.02-1.277c4.67 0 8.45 4.72 8.45 10.55 0 1.31-.2 2.612-.6 3.86 4.3.25 7.72 4.64 7.72 10.07 0 5.6-3.63 10.13-8.1 10.13-1.23 0-25.49-1.21-26.32-1.21-4.76 0-8.62-4.82-8.62-10.76 0-5.94 3.84-10.72 8.6-10.72Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "school",
    className: "school"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1112",
    className: "Group 1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "school-outline",
    className: "school-outline",
    filter: "url(#filter5_f_5370_44915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1070",
    fill: "url(#paint10_linear_5370_44915)",
    stroke: "url(#paint11_linear_5370_44915)",
    strokeWidth: 6,
    d: "M2386.36 346h-3v311.9h237.84V346h-234.84Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1071",
    fill: "#349CEA",
    d: "M2618.2 349h-231.84v305.9h231.84V349Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1072",
    fill: "#73C3FF",
    d: "M2500.78 576.512h-36.35v72.41h36.35v-72.41Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1073",
    fill: "#73C3FF",
    d: "M2540.13 576.512h-36.35v72.41h36.35v-72.41Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1074",
    fill: "#277FC1",
    d: "M2543.55 649.189h-81.68v5.98h81.68v-5.98Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1075",
    fill: "#73C3FF",
    d: "M2445.18 375.148h-29.3v44.02h29.3v-44.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1076",
    fill: "#73C3FF",
    d: "M2587.47 375.148h-29.3v44.02h29.3v-44.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1077",
    fill: "#73C3FF",
    d: "M2516.13 375.148h-29.3v44.02h29.3v-44.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1078",
    fill: "#73C3FF",
    d: "M2587.92 581.469h-29.48v26.13h29.48v-26.13Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1079",
    fill: "#73C3FF",
    d: "M2445.51 581.449h-29.48v26.13h29.48v-26.13Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1080",
    fill: "#73C3FF",
    d: "M2445.17 512.189h-29.3v44.02h29.3v-44.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1081",
    fill: "#73C3FF",
    d: "M2587.59 512.189h-29.3v44.02h29.3v-44.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1082",
    fill: "#73C3FF",
    d: "M2516.13 512.189h-29.3v44.02h29.3v-44.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1083",
    fill: "#73C3FF",
    d: "M2617.71 432.189h-231.84v5h231.84v-5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1084",
    fill: "#73C3FF",
    d: "M2618.2 494.211h-231.84v5h231.84v-5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "school-sign",
    className: "school-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1085",
    fill: "#73C3FF",
    d: "M2484.47 469.319v9.555l16.79 9.126 16.79-9.126v-9.555l-16.79 9.125-16.79-9.125ZM2501.26 445l-26.39 14.333 26.39 14.334 21.59-11.73v16.507h4.8v-19.111L2501.26 445Z",
    className: "Vector"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "kid_2",
    className: "kid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1086",
    fill: "#DDC092",
    d: "M2253.16 640.051c.21-.512.35-1.045.44-1.59a.55.55 0 0 0-.01-.255.59.59 0 0 0-.14-.215.437.437 0 0 0-.2-.098.444.444 0 0 0-.22.008c-.18.091-.33.235-.43.414a.998.998 0 0 0-.12.586c.06.319.15.631.28.93l-.27.22-.19-.09c-.03-.205-.1-.401-.21-.58-.08 0-.14.09-.16.16-.02.223-.02.448 0 .67 0 .12.26.28.37.35.33-.08.63-.258.86-.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1087",
    fill: "#DDC092",
    d: "M2252.38 638.789c.01-.161.06-.317.13-.459.08-.142.18-.265.31-.361.14.146.22.33.24.527a.93.93 0 0 1-.13.563l-.71 1.18-.18-.12c-.02-.12-.02-.241 0-.36.2-.287.32-.622.34-.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1088",
    fill: "#72CDD6",
    d: "M2259.92 639.01c1.07 1.22 1.87 4.3 2.44 6.29.41 1.44-1.62 2.49-2.21 1.23-.31-.68-.42-.85-2.3-3.36-2-1.13-2.57-1.62-2.26-3.34.31-1.72 2.89-2.46 4.33-.82Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1089",
    fill: "#663809",
    d: "M2261.85 652.501c.68.47.68 1.23 2.36 1.41 1 .1.76 1.22-.88 1.19-1.26 0-1.44.11-2.74.05-.89 0-.68-1.51-.36-2.4.39-1.06 1.15-.58 1.62-.25Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1090",
    fill: "#72CDD6",
    d: "M2262.46 645.719c.15 2.481.15 4.969 0 7.45-.14 0-2.34.19-2.34-.09 0-.71 0-4-.11-5.32-.17-2.85 0-2.58 0-2.58-.19-.83 2.2-1.4 2.45.54Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1091",
    fill: "#7ADCED",
    d: "M2260.53 639.891c-.31 1.6-2.76 5.86-3.48 7.1-.72 1.24-3.46.64-2.82-.6.51-1.394.81-2.857.88-4.34-.33-2.28.05-3 1.6-3.84 1.55-.84 4.24-.46 3.82 1.68Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1092",
    fill: "#663809",
    d: "M2252.32 651.472c.06 1.026.5 1.992 1.24 2.71.68.67-.36 1.47-1.63.43-1-.8-.83-.65-1.82-1.5-.67-.59.22-1.8 1-2.3.99-.58 1.03.07 1.21.66Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1093",
    fill: "#7ADCED",
    d: "M2257.27 646.622a47.75 47.75 0 0 1-4.68 6c-.1-.09-1.93-1.4-1.59-1.86 2.44-3.3 1-1.3 3.05-4.28 1.63-2.35 1.53-2 1.53-2 .31-.78 2.67.45 1.69 2.14Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1094",
    fill: "#DDC092",
    d: "M2256.7 626.922c.33 1.03.4 2.128.19 3.19.76.084 1.49.294 2.18.62-.08-.9-.05-1.806.08-2.7.23-.86-2.45-1.11-2.45-1.11Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1095",
    fill: "#3A3A3A",
    d: "M2260.77 633.941c-.15-1.91-.58-4.4-1.49-5.1a8.288 8.288 0 0 1-2.55-.95c-.38.71-1.59 1-1.52 5.16 0 2.71.12 4.6 0 6.69 1.72.599 3.59.652 5.34.15.36-1.963.43-3.967.22-5.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1096",
    fill: "#3E9696",
    d: "m2254.6 630.842.59.41c2.6-3.42 4.53-.68 3.34 1.74-.29.81-.63 1.604-1 2.38-1 1.73-2 2-2.38 1.53-.14-.18-1.73.65-1.93.6.33.23 1.53-.54 1.93-.2.59.5 2 .31 3-1.46.32-.59 1.14-2.42 1.14-2.42 1.33-3.48-2.19-6.41-4.69-2.58Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 992",
    className: "Group 992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1097",
    fill: "#4FADB2",
    d: "M2254.96 630.082a.225.225 0 0 1-.08.131.216.216 0 0 1-.15.039l-1-.16a.223.223 0 0 1-.13-.087.27.27 0 0 1-.04-.153.2.2 0 0 1 .09-.134c.04-.031.1-.044.15-.036l1 .16a.19.19 0 0 1 .08.027c.02.015.04.034.06.056.02.023.03.048.03.075.01.027.01.055 0 .082h-.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1098",
    fill: "#4FADB2",
    d: "m2253.96 629.87-.23 1.29.78.137.23-1.29-.78-.137Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 991",
    className: "Group 991"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1099",
    fill: "#4FADB2",
    d: "M2251.05 638.17c-.16.71.1 1.41.6 1.51l2.8.55c.5.09.88-.48.87-1.23l-.19-7.18a.586.586 0 0 0-.49-.54l-1.48-.3a.456.456 0 0 0-.35.048.5.5 0 0 0-.23.282l-1.53 6.86Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1100",
    fill: "#3E9696",
    d: "M2255.16 632.79c.14-.77.23-1.85-.41-2l-1.49-.29h-.24a.974.974 0 0 0-.63.208.959.959 0 0 0-.37.562l-1.42 6.37c-.07.28.41.61.46.41l1.49-6.67a.524.524 0 0 1 .09-.168c.04-.05.09-.091.15-.121a.474.474 0 0 1 .37-.031l1.48.29c.49.05.51 1.19.52 1.44Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1101",
    fill: "#3E9696",
    d: "m2254.52 639.221-2.97-.63.63-3.13 2.48.34-.14 3.42Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 990",
    className: "Group 990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1102",
    fill: "#F2D2A2",
    d: "M2260.53 625.651c0 2.41-.7 2.32-1.76 2.26-.57 0-1.13-.182-1.6-.52-.46-.337-.8-.814-.98-1.36a2.073 2.073 0 0 1 .81-2.598c.28-.174.6-.277.93-.302 1.53-.25 2.67.35 2.6 2.52Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1103",
    fill: "#E86E1C",
    d: "M2257.02 627.492c-1.28.25-2.47-2.82-1.12-3.9 1.38-3.25 4-.48 5-.7.25 1.57-1.63 1.91-2.3 2 0 1.86-1.08.29-1 1.25.03.256 0 .516-.11.753-.1.237-.26.443-.47.597Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1104",
    fill: "#DDC092",
    d: "M2259.22 635.502c-.81-1.34-1.17-1.84-1.59-2.58l.7-1.41a28.842 28.842 0 0 1 2 3.57c.17.49-.75 1.22-1.11.42Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1105",
    fill: "#DDC092",
    d: "M2265.83 640.491a6.992 6.992 0 0 0-1-1.28.48.48 0 0 0-.22-.136.495.495 0 0 0-.25-.014.493.493 0 0 0-.2.104c-.05.05-.1.114-.12.186-.02.199.01.401.11.58.09.178.23.324.41.42.29.134.6.238.91.31v.35l-.18.09a1.7 1.7 0 0 0-.6-.15c-.07 0 0 .16 0 .22.17.143.36.268.56.37.17.008.34-.026.49-.1.12-.302.15-.632.09-.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1106",
    fill: "#DDC092",
    d: "M2264.38 640.37a1.001 1.001 0 0 1-.31-.365c-.07-.145-.1-.304-.1-.465.2-.034.41.001.59.099s.33.253.41.441l.55 1.26-.2.08c-.1-.067-.19-.152-.26-.25a2.041 2.041 0 0 0-.68-.8Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1107",
    fill: "#DDC092",
    d: "M2260.12 636.632c-1-.86-1-1.36-.69-1.76.31-.4.51-.33 2.33 1.31 1 .91 2.14 2.33 2.57 2.7.24.28.43.32.3.5-.25.34-.45.32-.52.27-1.73-1.35-2.73-1.95-3.99-3.02Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 917",
    className: "Group 917"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1108",
    fill: "#94BDBC",
    d: "M2239.45 627.691c.27 1.225.4 2.476.4 3.73v11.18a3.795 3.795 0 0 1-1.18 2.665 3.822 3.822 0 0 1-2.72 1.055h-230.27a3.798 3.798 0 0 1-2.71-1.055 3.805 3.805 0 0 1-1.19-2.665v-55.88c.01-.5.12-.993.33-1.451.2-.458.49-.871.85-1.217a3.79 3.79 0 0 1 1.26-.797c.46-.18.96-.267 1.46-.255h206.86c2.28-.025 4.51.612 6.43 1.831 1.92 1.22 3.44 2.97 4.38 5.039l3.5 8-9.91 14.34 22.52 15.45-.01.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1109",
    fill: "#315C66",
    d: "M2207.26 642.601h32.59v3.74c-.01.501-.12.996-.32 1.455-.21.459-.5.873-.86 1.22a3.837 3.837 0 0 1-2.73 1.055h-97.57l-3.13-2.74h-32.29l-3.61 2.74h-62.44l-4.06-2.74h-23.31l-3.86 2.74h-3.9a3.821 3.821 0 0 1-3.9-3.73v-59.6c.01-.501.12-.994.33-1.452a3.759 3.759 0 0 1 2.11-2.013c.46-.181.96-.267 1.46-.255h3.9v18.62l20.08 41h12.51c.79.01 1.56-.221 2.21-.66a3.826 3.826 0 0 0 1.43-1.8 19.823 19.823 0 0 1 7.31-9.039 19.84 19.84 0 0 1 22.22 0 19.865 19.865 0 0 1 7.3 9.039c.29.732.79 1.36 1.44 1.8.65.439 1.42.67 2.2.66h80.78a3.86 3.86 0 0 0 2.21-.661 3.839 3.839 0 0 0 1.44-1.799 19.842 19.842 0 0 1 29.52-9.042 19.81 19.81 0 0 1 7.3 9.042c.29.732.79 1.36 1.44 1.8.65.439 1.42.67 2.2.66v-.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1110",
    fill: "#A4CCFF",
    d: "M2166.13 627.704a26.096 26.096 0 0 0-4.49 5.48 4.075 4.075 0 0 1-1.44 1.453c-.6.351-1.29.539-1.98.547h-70.91a3.99 3.99 0 0 1-3.43-2 27.064 27.064 0 0 0-4.48-5.48l12.14-29.79h7.8l3.33 2.72h33.32l2.38-2.72h7.81l19.95 29.79Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1111",
    fill: "#C3DDFF",
    d: "M2138.37 642.602v-44.7h-15.61l-3.67 2.72-4.13-2.72h-15.62v44.7l7.58 3.47h23.28l8.17-3.47Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1112",
    fill: "#676775",
    d: "M2060.31 657.492c6.47 0 11.71-5.001 11.71-11.17s-5.24-11.17-11.71-11.17c-6.46 0-11.71 5.001-11.71 11.17s5.25 11.17 11.71 11.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1113",
    fill: "#C3DDFF",
    d: "m2010.68 646.714-5-4.11v-41c.01-.501.12-.995.33-1.454.2-.458.49-.872.85-1.217.37-.346.8-.617 1.26-.796.47-.18.97-.266 1.47-.253h7.8l4.12 3.63 3.69-3.63h7.8a3.834 3.834 0 0 1 2.73 1.049c.36.345.65.759.86 1.217.2.459.31.953.32 1.454v41l-5 4.11h-21.23Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1114",
    fill: "#fff",
    d: "M2060.31 650.042c2.16 0 3.9-1.666 3.9-3.72 0-2.055-1.74-3.72-3.9-3.72-2.15 0-3.9 1.665-3.9 3.72 0 2.054 1.75 3.72 3.9 3.72Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 916",
    className: "Group 916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1115",
    fill: "#676775",
    d: "M2185.21 657.492c6.47 0 11.71-5.001 11.71-11.17s-5.24-11.17-11.71-11.17c-6.47 0-11.71 5.001-11.71 11.17s5.24 11.17 11.71 11.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1116",
    fill: "#fff",
    d: "M2185.21 650.042c2.15 0 3.9-1.666 3.9-3.72 0-2.055-1.75-3.72-3.9-3.72s-3.9 1.665-3.9 3.72c0 2.054 1.75 3.72 3.9 3.72Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1117",
    fill: "#315C66",
    d: "M2126.68 642.601h11.71v7.44h-39v-7.44h11.71a3.837 3.837 0 0 0 2.73-1.055c.36-.346.65-.761.86-1.22.2-.459.31-.953.32-1.455v-41h7.8v41a3.871 3.871 0 0 0 1.17 2.661c.73.698 1.7 1.083 2.7 1.069Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1118",
    fill: "#C3DDFF",
    d: "m2236.6 620.253-28 3.23-11.66-3.23v-18.63c.01-.5.12-.993.33-1.451a3.772 3.772 0 0 1 2.11-2.013c.47-.181.96-.268 1.46-.256h26l9.76 22.35Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1119",
    fill: "#C3DDFF",
    d: "M2091.54 597.903v22.35a7.632 7.632 0 0 1-7.81 7.45h-4.33a27.859 27.859 0 0 0-19.09-7.45c-1.11-.002-2.22.061-3.33.19a3.852 3.852 0 0 1-3.06-.82 3.854 3.854 0 0 1-1.41-2.84v-15.16c.02-.5.13-.993.33-1.451a3.772 3.772 0 0 1 2.11-2.013c.47-.181.96-.268 1.46-.256h35.13Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1120",
    fill: "#C3DDFF",
    d: "M2177.4 597.903c.5-.012 1 .075 1.47.256.46.18.89.451 1.25.796.36.346.65.759.86 1.217.2.458.31.951.32 1.451v15.89c0 .825-.28 1.625-.79 2.271-.51.646-1.23 1.1-2.03 1.289a27.801 27.801 0 0 0-12.35 6.63h-12.15a7.622 7.622 0 0 1-5.44-2.11 7.656 7.656 0 0 1-2.36-5.34v-22.35h31.22Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1121",
    fill: "#315C66",
    d: "M2029.09 642.601h7.81v7.44h-31.22v-7.44h7.81c.5.012 1-.075 1.47-.256s.89-.453 1.26-.799a3.821 3.821 0 0 0 1.17-2.675v-41h7.81v41c.03 1.01.45 1.969 1.18 2.668.73.699 1.7 1.081 2.71 1.062Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1122",
    fill: "#A4CCFF",
    d: "M2196.92 620.254h39.68l1.75 4a18.04 18.04 0 0 1 1.1 3.44h-33.7a3.841 3.841 0 0 1-2.49-.94 27.293 27.293 0 0 0-4.34-3 3.585 3.585 0 0 1-1.43-1.303 3.607 3.607 0 0 1-.57-1.857v-.34Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "car_2",
    className: "car"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1123",
    fill: "#DAD8DB",
    d: "m2200.95 645.22-104.53-1.84-2.79-11.33v-2.13c-.01-.439.14-.868.42-1.209.27-.342.66-.572 1.09-.651l7.49-1.15c2.22-.337 4.37-.969 6.41-1.88l11.52-5.13a33.282 33.282 0 0 1 13.54-2.9h17a13.598 13.598 0 0 1 10 4.41l11.39 12.18 14.39.34c5.89 0 9.37 1.72 11.39 3.52l2.68 7.77Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1124",
    fill: "#ECEAEC",
    d: "M2192.87 645.119v-3c-.01-.763.21-1.513.63-2.148a3.806 3.806 0 0 1 1.74-1.412l3-1.11c.32.279.61.576.89.89a7.56 7.56 0 0 1 1.79 5v1.86l-8.07-.15.02.07Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1125",
    fill: "#FF8086",
    d: "M2093.63 641.451v-9.4h1.76c1.45.049 2.82.671 3.81 1.728a5.45 5.45 0 0 1 1.47 3.912v3.76h-7.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1126",
    fill: "#C8C5C9",
    d: "M2200.94 645.221v7.52c.04.964-.32 1.902-.97 2.607a3.644 3.644 0 0 1-2.54 1.153h-89.72l-13.43-4.78a3.732 3.732 0 0 1-1.76-1.405 3.794 3.794 0 0 1-.65-2.165v-6.61c0-.245.04-.49.13-.719.09-.229.22-.438.39-.614.17-.175.38-.314.61-.408.22-.094.47-.141.71-.139l11.51.59c.94.065 1.88-.154 2.69-.63a13.16 13.16 0 0 1 6.83-1.93c2.89.01 5.7.961 8 2.71.76.551 1.67.864 2.6.9l43.35 2.24a3.274 3.274 0 0 0 2.66-1.1 13.526 13.526 0 0 1 4.91-3.643c1.9-.821 3.96-1.193 6.02-1.089 2.06.105 4.07.683 5.88 1.691a13.46 13.46 0 0 1 4.51 4.121c.3.411.68.751 1.13.993.44.242.94.382 1.44.407l5.7.3Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1127",
    fill: "#9B959D",
    d: "m2162.24 627.969-4.75 2.64-39.84-4c-.02-.375.07-.748.26-1.071.2-.323.48-.58.82-.739l3.19-1.419c.53-.24 1.07-.46 1.62-.67l3.52-1.09c2.29-.56 4.64-.846 7-.85h7l1.8.699 1.72-.699h6.48c1.41.008 2.8.307 4.08.876 1.29.57 2.44 1.398 3.39 2.434l3.71 3.889Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1128",
    fill: "#857E87",
    d: "M2165.53 631.482c.16.156.26.354.3.569.05.215.03.438-.05.642-.09.203-.23.379-.41.505-.17.125-.39.196-.61.204l-20.11-.47-1.78-.7-1.74.61-14.07-.33-3.52-.14a7.12 7.12 0 0 1-3.15-1.379 7.128 7.128 0 0 1-2.13-2.701l-.43-.92c-.1-.243-.17-.505-.18-.77l44.59 1.37 3.29 3.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1129",
    fill: "#676775",
    d: "M2141.13 620.758h3.52v12.17l-3.52-.09v-12.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1130",
    fill: "#676775",
    d: "M2123.54 622.699c1.15-.437 2.33-.801 3.52-1.09v10.9l-2.66-.06a8.31 8.31 0 0 1-.86-.08v-9.67Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 914_2",
    className: "Group 914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1131",
    fill: "#676775",
    d: "M2114.75 664.029c5.83 0 10.56-5.055 10.56-11.29 0-6.235-4.73-11.29-10.56-11.29-5.84 0-10.56 5.055-10.56 11.29 0 6.235 4.72 11.29 10.56 11.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1132",
    fill: "#fff",
    d: "M2114.74 660.259c3.89 0 7.04-3.367 7.04-7.52s-3.15-7.52-7.04-7.52c-3.88 0-7.04 3.367-7.04 7.52s3.16 7.52 7.04 7.52Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1133",
    fill: "#DAD8DB",
    d: "M2114.74 656.5c1.95 0 3.52-1.683 3.52-3.76 0-2.076-1.57-3.76-3.52-3.76-1.94 0-3.52 1.684-3.52 3.76 0 2.077 1.58 3.76 3.52 3.76Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 915_2",
    className: "Group 915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1134",
    fill: "#676775",
    d: "M2181.59 664.029c5.83 0 10.56-5.055 10.56-11.29 0-6.235-4.73-11.29-10.56-11.29s-10.56 5.055-10.56 11.29c0 6.235 4.73 11.29 10.56 11.29Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1135",
    fill: "#fff",
    d: "M2181.59 660.259c3.89 0 7.04-3.367 7.04-7.52s-3.15-7.52-7.04-7.52-7.04 3.367-7.04 7.52 3.15 7.52 7.04 7.52Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1136",
    fill: "#DAD8DB",
    d: "M2181.6 656.5c1.94 0 3.52-1.683 3.52-3.76 0-2.076-1.58-3.76-3.52-3.76-1.95 0-3.52 1.684-3.52 3.76 0 2.077 1.57 3.76 3.52 3.76Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 988",
    className: "Group 988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1137",
    fill: "#62CBF9",
    d: "M2379.52 601.08c-.4-.033-.78-.225-1.05-.534a1.61 1.61 0 0 1-.37-1.116v-60.28c0-5.05 3.54-9.15 7.89-9.15s7.88 4.1 7.88 9.15c.04.206.03.418-.03.62-.05.202-.15.389-.29.549-.13.16-.3.288-.49.376a1.442 1.442 0 0 1-2-.925 1.618 1.618 0 0 1-.03-.62c0-3.22-2.27-5.85-5-5.85s-5 2.63-5 5.85v60.29c.01.208-.01.416-.08.612-.07.195-.18.375-.32.528a1.78 1.78 0 0 1-.5.362c-.19.086-.4.133-.61.138Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1138",
    fill: "#62CBF9",
    d: "M2374.15 601.26c-.4-.03-.78-.221-1.05-.531-.26-.309-.4-.711-.37-1.119v-54c0-2.8-2-5.07-4.37-5.07s-4.37 2.27-4.37 5.07c.04.207.03.418-.03.62-.05.202-.15.39-.29.549-.13.16-.3.289-.49.377-.19.088-.4.134-.61.134-.21 0-.41-.046-.6-.134a1.509 1.509 0 0 1-.5-.377 1.411 1.411 0 0 1-.28-.549 1.444 1.444 0 0 1-.04-.62c0-4.62 3.23-8.38 7.21-8.38s7.21 3.76 7.21 8.38v54c.03.407-.1.808-.37 1.117-.26.308-.64.5-1.05.533Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1139",
    fill: "#62CBF9",
    d: "M2386.47 602.851c-.4-.033-.78-.225-1.05-.533-.26-.309-.4-.71-.37-1.117v-46.78c0-4.12 2.89-7.48 6.44-7.48 3.55 0 6.44 3.36 6.44 7.48v7.94c.03.205.02.413-.04.612-.06.198-.16.382-.29.538-.14.156-.31.281-.49.367a1.44 1.44 0 0 1-1.69-.367c-.14-.156-.24-.34-.3-.538a1.578 1.578 0 0 1-.04-.612v-7.94c.07-.514.03-1.037-.11-1.535-.15-.498-.4-.958-.74-1.35a3.663 3.663 0 0 0-2.74-1.247c-.52 0-1.04.111-1.51.326-.47.215-.89.529-1.23.921-.34.392-.6.852-.74 1.35a3.624 3.624 0 0 0-.12 1.535v46.78c.03.407-.1.81-.37 1.119-.26.31-.64.501-1.05.531Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1140",
    fill: "#62CBF9",
    d: "M2368.54 602.679a1.527 1.527 0 0 1-1.05-.537c-.27-.311-.4-.715-.37-1.123v-33.18c0-2.3-1.61-4.18-3.59-4.18-1.98 0-3.59 1.88-3.59 4.18v7.94a1.407 1.407 0 0 1-.34 1.15c-.13.156-.3.281-.49.367a1.407 1.407 0 0 1-1.19 0 1.375 1.375 0 0 1-.49-.367c-.14-.156-.24-.34-.3-.538a1.578 1.578 0 0 1-.04-.612v-7.94c0-4.13 2.89-7.48 6.44-7.48 3.55 0 6.44 3.35 6.44 7.48v33.18c.03.409-.11.813-.37 1.124-.27.31-.65.503-1.06.536Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 987",
    className: "Group 987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1141",
    fill: "#A9C5D3",
    d: "M2411.85 630.461h-68.68v24.56h68.68v-24.56Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1142",
    fill: "#91ACB7",
    d: "M2387.35 604.789h-19.68v26.59h19.68v-26.59Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1143",
    fill: "#4F7D99",
    d: "M2416.16 626.141h-77.29v7.5h77.29v-7.5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1144",
    fill: "#A9C5D3",
    d: "M2352.69 590.02c2.31 13.47 12.54 23.63 24.81 23.63s22.52-10.16 24.83-23.63h-49.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1145",
    fill: "#4F7D99",
    d: "M2403.15 586.832h-51.27v6.14h51.27v-6.14Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bench dog man",
    className: "bench dog man"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1104",
    className: "Group 1104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bench_2",
    className: "bench"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1146",
    fill: "#CCC",
    d: "M3571.9 638.891h-2.71v16.27h2.71v-16.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1147",
    fill: "#CCC",
    d: "M3608.25 638.891h-2.71v16.27h2.71v-16.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1148",
    fill: "#CCC",
    d: "M3575.08 621.129h-2.61v16.27h2.61v-16.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1149",
    fill: "#CCC",
    d: "M3604.96 621.129h-2.61v16.27h2.61v-16.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1150",
    fill: "#EDC472",
    d: "M3611.56 635.41h-45.69v6.52h45.69v-6.52Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1151",
    fill: "#EDC472",
    d: "M3608.39 619.211h-39.36v4.72h39.36v-4.72Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1152",
    fill: "#EDC472",
    d: "M3608.39 626.77h-39.36v4.72h39.36v-4.72Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dog2",
    className: "dog2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1010",
    className: "Group 1010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1153",
    fill: "#E5E5E5",
    d: "M3617.38 647.34s-.07 1.34 3 2.76l.76.56c1.45 1.07 1 3.75-.64 4.11-1.64.36.95-1.31-.14-2.41a48.117 48.117 0 0 0-4.25-3l1.27-2.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1154",
    fill: "#E5E5E5",
    d: "M3613.28 637.398s-.76 4.32 3 6.47c2.6 1.5 5.28 3.94 4.28 7.86-.56 2.2-1.84 2.21-1.84 2.21v.84a.848.848 0 0 1-.19.63.842.842 0 0 1-.58.31h-2a.944.944 0 0 1-.57-.312.955.955 0 0 1-.22-.608c0-.223.08-.438.22-.607a.95.95 0 0 1 .57-.313h1.53c-1.57.17-4.1-2-5.52-3.27a8.963 8.963 0 0 1-2.24-2.988 8.994 8.994 0 0 1-.84-3.642 7.571 7.571 0 0 1 1.32-4.42l3.08-2.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1155",
    fill: "#E5E5E5",
    d: "m3612.52 637.99.63-1.24.74.76c.43.459.74 1.013.91 1.616.18.603.21 1.238.09 1.854-.08.485-.26.949-.53 1.36a3.43 3.43 0 0 1-1.03 1.03.337.337 0 0 1-.27.026.296.296 0 0 1-.11-.072.29.29 0 0 1-.08-.114 2.086 2.086 0 0 1-.16-1.39l.11-.53a5.643 5.643 0 0 0-.27-3.3h-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1156",
    fill: "#E5E5E5",
    d: "M3609.39 643.878c.37.175.79.206 1.18.085.39-.12.72-.383.92-.736l.15-.25 1.49-2.14c.36-.549.58-1.18.64-1.835a3.941 3.941 0 0 0-.33-1.915v-.05a2.64 2.64 0 0 0-1.33-1.482 2.676 2.676 0 0 0-1.99-.148c-.66.301-1.22.807-1.58 1.443a3.48 3.48 0 0 0-.42 2.097l.16 2v.931c-.02.403.08.804.27 1.157.2.353.49.645.84.843Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1157",
    fill: "#F78131",
    d: "M3617.08 647.699s-.07 1.34 2.95 2.76l.76.56c1.45 1.07 1 3.75-.64 4.11-1.64.36 1-1.31-.14-2.41a48.327 48.327 0 0 0-4.25-3l1.32-2.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1158",
    fill: "#E0752D",
    d: "m3620.79 651.019-.76-.56c-3-1.42-2.95-2.76-2.95-2.76l-.61.95c.24.52.93 1.37 2.81 2.26l.76.56c.26.22.47.49.62.793.15.304.24.635.26.973.03.339-.02.679-.13.999-.12.32-.29.614-.52.865 1.58-.46 1.94-3 .52-4.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1007",
    className: "Group 1007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1159",
    fill: "#F78131",
    d: "M3609.02 646.48c-.41 1.701-.37 3.479.11 5.16.23.446.31.953.24 1.448-.08.495-.31.954-.66 1.312a.94.94 0 0 0-.28.49 1.12 1.12 0 0 0-.02.408c.02.136.07.266.14.382.08.117.17.217.29.294a.96.96 0 0 0 .37.156h.44a.859.859 0 0 0 .8-.83l.23-1.83.2-6.48-1.86-.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1160",
    fill: "#E0752D",
    d: "M3609.14 655.028c.05-.187.15-.357.28-.49.35-.355.58-.813.66-1.307.08-.493-.01-.999-.24-1.443a10.059 10.059 0 0 1-.12-5.11l-.7-.19c-.41 1.701-.37 3.479.11 5.16.23.446.31.953.24 1.448-.08.495-.31.954-.66 1.312a.94.94 0 0 0-.28.49 1.12 1.12 0 0 0-.02.408c.02.136.07.266.14.382.08.117.17.217.29.294.11.077.24.131.37.156h.3c-.16-.13-.28-.304-.34-.501a1.054 1.054 0 0 1-.03-.609Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1009",
    className: "Group 1009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1161",
    fill: "#F78131",
    d: "M3612.98 637.758s-.76 4.32 2.95 6.47c2.6 1.5 5.28 3.94 4.28 7.86-.56 2.2-1.84 2.21-1.84 2.21l.05.84a.89.89 0 0 1-.19.629.847.847 0 0 1-.58.311h-2a.95.95 0 0 1-.57-.313.954.954 0 0 1-.22-.607c0-.223.08-.439.22-.608.15-.169.35-.28.57-.312h1.53c-1.57.17-4.1-2-5.52-3.27a8.963 8.963 0 0 1-2.24-2.988 8.997 8.997 0 0 1-.84-3.642 7.567 7.567 0 0 1 1.32-4.42l3.08-2.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1162",
    fill: "#E0752D",
    d: "M3615.91 644.228c-3.71-2.15-2.95-6.47-2.95-6.47l-.76.53a6.44 6.44 0 0 0 .54 3.645 6.462 6.462 0 0 0 2.46 2.745c2.6 1.5 5.28 3.94 4.28 7.86a3.585 3.585 0 0 1-.89 1.73c.38-.11 1.21-.52 1.64-2.18 1-3.92-1.68-6.36-4.28-7.86h-.04Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1006",
    className: "Group 1006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1163",
    fill: "#EEE",
    d: "M3608.54 644.189v.16c.02 1.259.31 2.499.84 3.642a8.963 8.963 0 0 0 2.24 2.988c1.25 1.12 3.36 2.94 4.92 3.23.17-1.24-.63-1.84-1.4-2.45a14.719 14.719 0 0 1-5.08-8.47v-.07l-1.52.97Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1164",
    fill: "#E0E0E0",
    d: "M3612.36 650.529a9.117 9.117 0 0 1-2.23-2.992 8.979 8.979 0 0 1-.84-3.638v-.16l-.66-2.79s-.09 3.34-.09 3.4c.02 1.259.31 2.5.84 3.642a8.963 8.963 0 0 0 2.24 2.988c1.25 1.12 3.36 2.94 4.92 3.23.04-.228.04-.461 0-.69a17.81 17.81 0 0 1-4.17-3l-.01.01Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1008",
    className: "Group 1008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1165",
    fill: "#E0752D",
    d: "M3613.67 646.828c-.29.022-.57.149-.79.358-.21.209-.34.486-.37.782a9.102 9.102 0 0 0 .08 3.45 3.597 3.597 0 0 1-.7 3.26.888.888 0 0 0-.22.49.79.79 0 0 0-.01.342c.02.114.06.222.13.317a.805.805 0 0 0 .57.341h.79a.766.766 0 0 0 .49-.224c.12-.13.2-.303.21-.486l.59-4.23c.3-.971.44-1.984.41-3a1.27 1.27 0 0 0-.31-.913 1.291 1.291 0 0 0-.87-.437v-.05Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1166",
    fill: "#D16F2C",
    d: "M3612.41 655.168a.99.99 0 0 1 .23-.49 3.597 3.597 0 0 0 .7-3.26 9.102 9.102 0 0 1-.08-3.45 1.391 1.391 0 0 1 .79-1.07 1.005 1.005 0 0 0-.38-.07c-.29.023-.57.149-.79.358-.21.209-.34.486-.37.782a9.102 9.102 0 0 0 .08 3.45 3.597 3.597 0 0 1-.7 3.26.888.888 0 0 0-.22.49.79.79 0 0 0-.01.342c.02.114.06.222.13.317.06.095.15.175.25.234.1.058.21.095.32.107h.75a.805.805 0 0 1-.57-.341.75.75 0 0 1-.14-.316.794.794 0 0 1 .01-.343Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1005",
    className: "Group 1005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1167",
    fill: "#E0752D",
    d: "m3612.22 638.349.63-1.24.74.76c.43.46.74 1.013.91 1.616.18.603.21 1.238.09 1.854a3.556 3.556 0 0 1-1.56 2.39.299.299 0 0 1-.13.043.354.354 0 0 1-.14-.016.309.309 0 0 1-.11-.072.285.285 0 0 1-.08-.115 2.086 2.086 0 0 1-.16-1.39l.11-.53a5.643 5.643 0 0 0-.27-3.3h-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1168",
    fill: "#D16F2C",
    d: "m3613.59 637.869-.74-.76-.25.48.28.28c.43.46.74 1.013.92 1.616.17.603.2 1.238.08 1.854a3.527 3.527 0 0 1-1.31 2.22c.02.044.04.083.08.115.03.032.07.056.11.072.05.015.1.02.14.016a.299.299 0 0 0 .13-.043c.41-.267.77-.618 1.03-1.029.27-.412.45-.875.53-1.361a3.86 3.86 0 0 0-.09-1.849c-.17-.6-.48-1.152-.91-1.611Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1169",
    fill: "#E0752D",
    d: "m3609.56 637.381-.05-1.42-.89.19c-.56.151-1.07.456-1.47.88-.4.423-.67.95-.79 1.52-.24.974-.11 2.002.35 2.89.02.048.05.09.09.124.04.034.09.06.14.074a.347.347 0 0 0 .29-.048c.34-.236.57-.595.64-1l.13-.6c.22-1.02.77-1.939 1.56-2.61Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1170",
    fill: "#D16F2C",
    d: "M3607.11 638.548c.12-.569.39-1.094.79-1.518.39-.424.9-.729 1.46-.882h.16v-.16l-.89.19a3.16 3.16 0 0 0-1.47.88c-.4.424-.67.95-.79 1.52-.24.974-.11 2.002.35 2.89.02.048.05.09.09.124a.364.364 0 0 0 .29.083.32.32 0 0 0 .14-.057c.08-.051.15-.111.22-.18a4.03 4.03 0 0 1-.35-2.89Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1004",
    className: "Group 1004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1171",
    fill: "#F48F4A",
    d: "M3609.09 644.241c.37.175.79.206 1.18.085.39-.12.72-.383.92-.735l.16-.25 1.48-2.14c.36-.55.58-1.181.64-1.836a3.936 3.936 0 0 0-.33-1.914v-.05a2.671 2.671 0 0 0-3.32-1.63c-.66.301-1.22.806-1.58 1.443-.36.636-.5 1.371-.42 2.097l.16 2v.93c-.02.402.08.802.27 1.155s.48.646.83.845h.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1172",
    fill: "#E58848",
    d: "M3609.84 644.241a2.148 2.148 0 0 1-.83-.845c-.2-.353-.29-.753-.27-1.155v-.93l-.16-2c-.09-.726.06-1.461.42-2.097.36-.637.91-1.142 1.58-1.443.15-.054.3-.094.46-.12a2.398 2.398 0 0 0-1.21.12c-.67.301-1.22.806-1.58 1.443a3.408 3.408 0 0 0-.42 2.097l.16 2v.93c-.02.402.07.802.27 1.155.19.353.48.646.83.845.33.166.7.209 1.06.12a1.991 1.991 0 0 1-.31-.12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1003",
    className: "Group 1003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1173",
    fill: "#515151",
    d: "m3609.25 642.55-.05-.44c0-.39.29-.68.59-.51l.39.22a.53.53 0 0 1 .17.688.542.542 0 0 1-.17.192l-.35.22c-.23.16-.54-.03-.58-.37Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1174",
    fill: "#515151",
    d: "M3611.75 640.49c.17 0 .3-.17.3-.38 0-.209-.13-.38-.3-.38-.16 0-.3.171-.3.38 0 .21.14.38.3.38Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1175",
    fill: "#515151",
    d: "M3609.28 639.45c.17 0 .3-.161.3-.36 0-.198-.13-.36-.3-.36-.16 0-.3.162-.3.36 0 .199.14.36.3.36Z",
    className: "Vector"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1176",
    fill: "#D16F2C",
    d: "M3616.91 654.25c-.2-.368-.35-.761-.45-1.17a3.525 3.525 0 0 1 .02-1.615c.13-.529.39-1.021.74-1.435a.33.33 0 0 0 .07-.19.333.333 0 0 0-.07-.19.19.19 0 0 0-.07-.059.227.227 0 0 0-.09-.021c-.03 0-.06.008-.09.021-.02.014-.05.034-.07.059a4.1 4.1 0 0 0-.85 1.678 4.126 4.126 0 0 0-.02 1.882c.07.345.18.681.32 1 .12.032.25.056.37.07l.19-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1177",
    fill: "#fff",
    d: "M3615.32 649.15c0 .27.14.48.3.45.16-.03.27-.27.26-.54-.01-.27-.14-.49-.29-.46-.15.03-.28.27-.27.55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1178",
    fill: "#fff",
    d: "M3616.5 648.079c.23 0 .41-.345.41-.77 0-.425-.18-.77-.41-.77-.22 0-.41.345-.41.77 0 .425.19.77.41.77Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "man_2",
    className: "man"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1019",
    className: "Group 1019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1179",
    fill: "#4398D1",
    d: "M3599.08 651.281s.82.59 1.28 1a4.327 4.327 0 0 1 1.45 1.93c.1.207.15.436.13.666-.01.229-.08.451-.21.644-.13.192-.3.349-.5.454-.21.105-.44.156-.67.146-1 .06-2.59-.72-2.75-1.67-.16-.95-1.35-.83-1.51-1.5a3.79 3.79 0 0 1 .06-1.5l2.72-.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1180",
    fill: "#FFF2E3",
    d: "M3600.56 656.09c-1 .06-2.59-.72-2.75-1.67-.16-.95-1.35-.83-1.51-1.5-.1-.43-.12-.79.36-.15.32.57 1.15.48 1.39 1.45.32.617.86 1.089 1.52 1.32.44.154.93.137 1.36-.048.44-.185.78-.524.98-.952.14.74-.3 1.46-1.35 1.55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1181",
    fill: "#FFE5C4",
    d: "M3601.25 653.73c.3.219.54.508.69.84-.07.229-.2.436-.38.6-.17.165-.38.282-.62.34a1.832 1.832 0 0 1-1.62-.1l.12-1a3.072 3.072 0 0 1 1.81-.68Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1182",
    fill: "#3F5959",
    d: "M3599.45 655.792c.01.005.02.008.03.008.01 0 .02-.003.03-.008.01-.006.01-.013.02-.021v-.049c-.01-.008-.01-.015-.02-.02l-.17-.09a2.467 2.467 0 0 1-1.32-1.19 1.494 1.494 0 0 0-.3-.601c-.15-.174-.34-.31-.55-.399-.21-.106-.4-.264-.54-.46 0-.007-.01-.012-.02-.015-.01-.004-.01-.006-.02-.006a.08.08 0 0 0-.03.006c-.01.003-.01.008-.02.015 0 .006-.01.014-.01.023-.01.008-.01.017-.01.027 0 .009 0 .018.01.027 0 .008.01.016.01.023.15.218.35.394.59.51a1.305 1.305 0 0 1 .79.92c.28.591.78 1.05 1.39 1.28l.17.08-.03-.06Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1183",
    fill: "#3F5959",
    d: "M3596.34 653.029c-.07-.178-.1-.369-.09-.56l.34.43-.06.36a.596.596 0 0 1-.19-.23Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1017",
    className: "Group 1017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1184",
    fill: "#FFE5C4",
    d: "M3597.82 652.36c.4-.332.92-.494 1.44-.45 0 0 .07 0 .08-.06a.101.101 0 0 0-.02-.053c-.01-.015-.03-.024-.05-.027-.28-.025-.56.006-.82.09-.27.084-.52.22-.73.4-.01.015-.01.032-.01.05 0 .018 0 .035.01.05.01.008.01.015.02.02.01.005.02.007.03.007.01 0 .02-.002.03-.007.01-.005.02-.012.02-.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1185",
    fill: "#FFE5C4",
    d: "M3598.25 652.73a.25.25 0 0 0 .02.005c.01 0 .02-.002.03-.005.4-.333.92-.494 1.44-.45.01.001.02.001.03-.002 0-.002.01-.006.02-.012s.01-.013.01-.021c.01-.008.01-.017.01-.025 0 0 0-.07-.06-.08a2.128 2.128 0 0 0-1.55.5c-.01.005-.01.012-.01.02-.01.008-.01.016-.01.025 0 .008 0 .017.01.024 0 .008 0 .015.01.021h.05Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1186",
    fill: "#FFE5C4",
    d: "M3598.98 653.528h.05c.2-.168.43-.295.67-.372.25-.078.51-.104.77-.078.02-.002.03-.01.05-.023a.077.077 0 0 0 .02-.047v-.026c0-.008-.01-.016-.01-.023-.01-.007-.02-.012-.02-.016a2.073 2.073 0 0 0-.85.085c-.27.084-.52.22-.73.4-.01.007-.01.014-.02.023v.054c.01.009.01.017.02.023h.05Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1187",
    fill: "#FFE5C4",
    d: "m3598.6 653.138-.02.005a.105.105 0 0 1-.03-.005c-.01-.014-.01-.029-.01-.045 0-.016 0-.032.01-.045a2.088 2.088 0 0 1 1.56-.5c.02.006.03.016.04.031.01.014.02.031.02.049v.028c-.01.009-.02.017-.02.023a.073.073 0 0 1-.03.011 1.992 1.992 0 0 0-1.47.448h-.05Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1018",
    className: "Group 1018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1188",
    fill: "#4398D1",
    d: "M3591.41 651.281s-.82.59-1.28 1a4.478 4.478 0 0 0-1.45 1.93c-.1.207-.14.436-.13.666a1.356 1.356 0 0 0 .72 1.098c.2.105.43.156.66.146 1 .06 2.59-.72 2.75-1.67.16-.95 1.35-.83 1.51-1.5a3.79 3.79 0 0 0-.06-1.5l-2.72-.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1189",
    fill: "#FFF2E3",
    d: "M3589.94 656.09c1 .06 2.59-.72 2.75-1.67.16-.95 1.35-.83 1.51-1.5.1-.43.12-.79-.36-.15-.32.57-1.15.48-1.39 1.45a2.755 2.755 0 0 1-1.52 1.32c-.45.154-.94.137-1.37-.048a1.867 1.867 0 0 1-.97-.952c-.14.74.3 1.46 1.35 1.55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1190",
    fill: "#FFE5C4",
    d: "M3589.24 653.73a2.32 2.32 0 0 0-.69.84c.08.229.21.436.38.6.18.165.39.282.62.34a1.832 1.832 0 0 0 1.62-.1l-.12-1a3.048 3.048 0 0 0-1.81-.68Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1191",
    fill: "#3F5959",
    d: "M3591.04 655.792a.067.067 0 0 1-.03.008.067.067 0 0 1-.03-.008c0-.006-.01-.013-.01-.021-.01-.007-.01-.016-.01-.024 0-.009 0-.017.01-.025 0-.008.01-.015.01-.02l.17-.09a2.4 2.4 0 0 0 1.32-1.19c.06-.222.16-.427.31-.601s.33-.31.54-.399c.22-.106.4-.264.54-.46.01-.007.02-.012.02-.015a.08.08 0 0 1 .03-.006c.01 0 .01.002.02.006.01.003.02.008.02.015.01.006.01.014.02.023v.054c-.01.008-.01.016-.02.023-.15.218-.35.394-.59.51-.19.078-.37.203-.51.363-.13.16-.23.351-.28.557-.28.591-.78 1.05-1.39 1.28l-.17.08.03-.06Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1192",
    fill: "#3F5959",
    d: "M3594.15 653.029c.08-.178.11-.369.09-.56l-.34.43.06.36a.52.52 0 0 0 .19-.23Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1017_2",
    className: "Group 1017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1193",
    fill: "#FFE5C4",
    d: "M3592.67 652.36c-.4-.332-.92-.494-1.44-.45 0 0-.07 0-.08-.06 0-.019.01-.038.02-.053.02-.015.03-.024.05-.027.28-.025.56.006.83.09.26.084.51.22.72.4.01.015.02.032.02.05 0 .018-.01.035-.02.05 0 .008-.01.015-.02.02a.066.066 0 0 1-.03.007c-.01 0-.02-.002-.02-.007a.174.174 0 0 1-.03-.02Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1194",
    fill: "#FFE5C4",
    d: "M3592.25 652.73a.105.105 0 0 1-.03.005c-.01 0-.02-.002-.02-.005a2.006 2.006 0 0 0-1.44-.45.076.076 0 0 1-.03-.002c-.01-.002-.02-.006-.02-.012-.01-.006-.02-.013-.02-.021 0-.008-.01-.017 0-.025 0 0 0-.07.06-.08.56-.046 1.12.134 1.55.5 0 .005.01.012.01.02s.01.016.01.025c0 .008-.01.017-.01.024 0 .008-.01.015-.01.021h-.05Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1195",
    fill: "#FFE5C4",
    d: "M3591.52 653.528h-.05c-.2-.168-.43-.295-.68-.372-.25-.078-.51-.104-.76-.078-.02-.002-.04-.01-.05-.023a.077.077 0 0 1-.02-.047c-.01-.009-.01-.017 0-.026 0-.008 0-.016.01-.023 0-.007.01-.012.02-.016a2.114 2.114 0 0 1 1.58.485c0 .007.01.014.01.023s.01.018.01.027c0 .009-.01.019-.01.027 0 .009-.01.017-.01.023h-.05Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1196",
    fill: "#FFE5C4",
    d: "M3591.89 653.138c.01.003.02.005.03.005.01 0 .02-.002.02-.005.01-.014.02-.029.02-.045 0-.016-.01-.032-.02-.045a2.1 2.1 0 0 0-.72-.409 2.138 2.138 0 0 0-.84-.091c-.01.006-.03.016-.04.031-.01.014-.01.031-.02.049 0 .01.01.019.01.028 0 .009.01.017.02.023.01.006.02.01.03.011a1.992 1.992 0 0 1 1.46.448h.05Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1016",
    className: "Group 1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1197",
    fill: "#0379DB",
    d: "M3600.75 633.091a15.883 15.883 0 0 0-2.15-4.31h-6.27a16.54 16.54 0 0 0-2.16 4.31 2.075 2.075 0 0 0 1.08 2.35c.84.53 4.21.59 4.21.59s3.38-.06 4.22-.59c.43-.202.77-.549.97-.979.19-.43.23-.916.1-1.371Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1198",
    fill: "#0B44FC",
    d: "M3599.82 633.41s-.83 1.14-1.67 1.24c-2.19.23-5.89.57-7-1.4a1.25 1.25 0 0 0-.33.496c-.07.19-.09.394-.07.594l-.54-.3a2.1 2.1 0 0 0 1.09 1.4c.84.53 4.21.59 4.21.59s3.38-.06 4.22-.59c.24-.13.45-.307.63-.52.17-.213.3-.457.37-.72a.99.99 0 0 1-.58-.242 1.008 1.008 0 0 1-.33-.548Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1199",
    fill: "#A06E5F",
    d: "M3597 616.07c.11 1.19.91 1.19.91 1.19s.12 1.72-2.4 1.72-2.52-1.72-2.52-1.72c.27-.048.52-.196.69-.416.18-.219.26-.495.25-.774l1.26 1.06h.66s.86-.85 1.15-1.06Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1015",
    className: "Group 1015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1200",
    fill: "#A06E5F",
    d: "M3598.17 613.821c0 .179-.07.35-.2.475a.69.69 0 0 1-.48.196v-1.341a.6.6 0 0 1 .26 0c.09.03.16.078.22.14.07.063.11.138.14.22.05.096.07.204.06.31Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1201",
    fill: "#A06E5F",
    d: "M3593.33 613.148v1.34a.71.71 0 0 1-.26 0 .64.64 0 0 1-.22-.147.693.693 0 0 1-.22-.483c0-.093.03-.185.06-.27a.93.93 0 0 1 .15-.22.79.79 0 0 1 .23-.14.593.593 0 0 1 .26-.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1202",
    fill: "#B67D69",
    d: "m3593.13 612.279.08 2.88c0 .097.02.192.06.28.05.09.1.171.17.24l1.44 1.36a.81.81 0 0 0 .51.2h.06c.19 0 .36-.072.49-.2l1.47-1.34a.555.555 0 0 0 .18-.25.72.72 0 0 0 .06-.29v-2.88a.548.548 0 0 0-.05-.281.615.615 0 0 0-.16-.239.627.627 0 0 0-.23-.162.75.75 0 0 0-.29-.058h-3a.753.753 0 0 0-.53.22c-.06.073-.12.158-.16.25a.844.844 0 0 0-.1.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1014",
    className: "Group 1014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1203",
    fill: "#212121",
    d: "M3596.01 613.012c.12.11.49 0 .69 0 .2 0 .38.13.47.1.27-.1-.66-.51-1.14-.32v.05c-.02-.003-.04.004-.06.018a.067.067 0 0 0-.03.057c0 .022 0 .045.02.063.01.018.03.029.05.032Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1204",
    fill: "#212121",
    d: "M3594.92 612.819c-.49-.17-1.4.29-1.13.37.09 0 .36-.1.46-.11.1-.01.58 0 .7-.09l-.03-.17Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1205",
    fill: "#212121",
    d: "M3596.52 613.96c.14 0 .26-.55-.1-.55-.17-.01-.17.55.1.55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1206",
    fill: "#212121",
    d: "M3594.36 613.98c-.15 0-.27-.55.08-.55.19 0 .16.55-.08.55Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1207",
    fill: "#A06E5F",
    d: "M3595.75 614.891c0-.09-.08-.1-.15-.12-.23 0-.24.06-.13-.94 0-.2.05-.3-.07-.3-.12 0-.09.07-.11.29-.12 1.09-.13 1.08.33 1.15.07.02.12 0 .13-.08Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1208",
    fill: "#fff",
    d: "M3595.95 615.619c0-.11-.07-.07-1.06 0-.28.03.74.97 1.06 0Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1209",
    fill: "#212121",
    d: "M3592.24 612.67a.485.485 0 0 0 0 .17.568.568 0 0 0 .23.45c.07.059.15.101.23.12.09.015.18.015.26 0a.427.427 0 0 0 .23-.12.408.408 0 0 0 .16-.21.438.438 0 0 0 .05-.25.447.447 0 0 0-.07-.25c.23.098.48.123.71.07.24-.056.45-.19.6-.38.11.127.24.229.38.3a1.05 1.05 0 0 0 .94 0c.15-.071.28-.173.38-.3.16.19.37.324.6.38.24.052.48.028.7-.07a.542.542 0 0 0-.06.25c0 .087.01.174.05.25.04.08.09.152.15.21.08.052.16.093.24.12a.613.613 0 0 0 .49-.11.464.464 0 0 0 .16-.2.542.542 0 0 0 .06-.25.485.485 0 0 0 0-.17c.28-.021.53-.138.72-.33.19-.2.3-.465.3-.74 0-.275-.11-.539-.3-.74a1.052 1.052 0 0 0-.71-.36c.13-.208.18-.451.15-.692a1.05 1.05 0 0 0-.31-.638 1.056 1.056 0 0 0-.64-.31c-.23.119-.49.165-.75.133s-.5-.141-.7-.313a1.091 1.091 0 0 0-.4-.5.986.986 0 0 0-.61-.19 1.085 1.085 0 0 0-1.02.69c-.28.008-.55.122-.75.32-.21-.12-.45-.169-.7-.14-.24.022-.47.132-.64.31-.17.17-.28.398-.3.64-.03.241.03.484.15.69a1.11 1.11 0 0 0-1 1.1c0 .276.11.542.3.74.2.187.45.3.72.32Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1210",
    fill: "#A06E5F",
    d: "M3588.4 628.279c0-2.868.17-5.733.52-8.58l1.89 1.37c-.16 2.16 0 5.1-.46 7.21-.46 2.11-1.77 1.68-1.95 0Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1012",
    className: "Group 1012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1211",
    fill: "#A06E5F",
    d: "M3587.33 638.718c.06-.894.24-1.777.52-2.63a.76.76 0 0 1 .21-.363c.1-.102.22-.176.36-.217a.687.687 0 0 1 .36 0c.12.032.23.094.32.18.21.265.33.591.34.93.01.339-.09.672-.28.95-.33.418-.69.803-1.09 1.15l.23.51h.35c.19-.23.6-.68.74-.68s.13.23.12.34c-.14.353-.31.688-.52 1-.25.14-.52.219-.8.23-.43-.37-.72-.857-.86-1.4Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1212",
    fill: "#A06E5F",
    d: "M3589.32 637.341c.11-.243.17-.505.17-.77 0-.266-.06-.528-.17-.77-.29.126-.54.343-.71.62-.16.276-.24.599-.21.92l.17 2.29.35-.05a1.7 1.7 0 0 0 .17-.58c-.05-.564.03-1.132.23-1.66Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1213",
    fill: "#A06E5F",
    d: "M3588.29 628.281c.12-.81.34-1 1-1 .66 0 1.2.8.74 4.23-.23 1.73-.63 3.55-.74 4.24-.17.51-.34.4-.57.4-.55 0-.69-.23-.69-.35.15-2.86-.08-5.32.26-7.52Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1214",
    fill: "#A06E5F",
    d: "M3603.41 627.819a67.569 67.569 0 0 0-1.56-8.46l-1.71 1.6c.42 2.12.62 5.05 1.34 7.1.72 2.05 1.96 1.43 1.93-.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1013",
    className: "Group 1013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1215",
    fill: "#A06E5F",
    d: "M3611.57 635.031a4.85 4.85 0 0 0-1.37-1.18c-.86-.257-1.74-.418-2.64-.48a.805.805 0 0 0-.41.067.877.877 0 0 0-.33.263.81.81 0 0 0-.14.338c-.01.123 0 .248.05.362.17.293.43.522.75.656.31.133.65.162.98.084.37-.204.77-.327 1.18-.36.35-.03.71.058 1 .25.15.165.31.313.49.44.18.11.78.53.81.25.03-.28-.37-.69-.37-.69Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1216",
    fill: "#A06E5F",
    d: "M3608.25 635.22a1.877 1.877 0 0 1-1.42-.62c.22-.228.52-.379.83-.431.32-.053.65-.003.94.141l2.07 1s.22.11.15.25-.33.05-.33.05c-.2.022-.4.005-.59-.05a3.788 3.788 0 0 0-1.65-.34Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1217",
    fill: "#A06E5F",
    d: "M3603.4 628.012c-.56-.58-.88-.64-1.43-.24-.55.4-.52 1.35 1.85 3.88 1.19 1.27 2.57 2.52 3.06 3 .44.32.52.12.7 0 .45-.32.43-.58.36-.68-1.69-2.2-2.96-4.34-4.54-5.96Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1218",
    fill: "#D84B4B",
    d: "M3588.58 619.948c.33-.667.84-1.224 1.47-1.6a.157.157 0 0 1 .05-.008c.02.001.03.005.05.013.01.007.03.018.04.031 0 .013.01.028.01.044l.76 6.23c.01.018 0 .035 0 .052a.559.559 0 0 1-.03.044.134.134 0 0 1-.04.027.155.155 0 0 1-.06.007l-2.78-.47a.17.17 0 0 1-.07-.047.128.128 0 0 1-.03-.083c.09-1.428.3-2.847.63-4.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1219",
    fill: "#D84B4B",
    d: "M3602.37 619.949a3.747 3.747 0 0 0-1.47-1.6.088.088 0 0 0-.09-.001.08.08 0 0 0-.04.034c-.01.014-.02.03-.02.047l-.77 6.23c0 .018 0 .035.01.052.01.016.01.031.03.044.01.012.02.022.04.028.02.006.04.008.05.006l2.78-.47a.143.143 0 0 0 .08-.047.22.22 0 0 0 .02-.083 24.308 24.308 0 0 0-.62-4.24Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1220",
    fill: "#EB5757",
    fillRule: "evenodd",
    d: "m3597.87 617.18 3 1.17-.63 11.33-.05 1.81h-4.77v-13.1c1.31 0 2.36-.53 2.45-1.21Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1221",
    fill: "#EB5757",
    fillRule: "evenodd",
    d: "m3593.05 617.18-3 1.17.59 11.33.06 1.81h4.76v-13.1c-1.22 0-2.32-.53-2.41-1.21Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1222",
    fill: "#3386FF",
    d: "M3592.71 632.279a2.046 2.046 0 0 0-.83.075c-.27.081-.52.216-.74.396-.21.181-.38.404-.51.654-.13.251-.2.525-.21.805l.55 16.8c0 .94 3.4.93 3.4 0 0 0 .26-10.29.31-12 .05-1.71.24-5.09.24-5.09 0-.99-.67-1.64-2.21-1.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1223",
    fill: "#335AFF",
    d: "M3597.96 632.19c.28-.033.57-.009.84.071.27.079.52.213.73.392.22.18.4.402.53.652s.2.524.22.805l-.54 17.24c0 .94-3.46.93-3.46 0 0 0-.28-10.72-.33-12.45-.05-1.73-.24-5.08-.24-5.08 0-.97.73-1.63 2.25-1.63Z",
    className: "Vector"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "buildings_3",
    className: "buildings"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1224",
    fill: "#A3A3A3",
    d: "M3999.82 272.971h-60.72v87.4h60.72v-87.4Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1225",
    fill: "#A3A3A3",
    d: "M4064.44 282.009h-10.7v-44.98h-37.19v60.52h-28.2v26.16h28.2v19.86h37.19v-13.08h52.14v-70.13h-41.44v21.65Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1226",
    fill: "#A3A3A3",
    d: "M4152.59 301.129h-54.86v35.04h82.88v-104.03h-28.02v68.99Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bush_8",
    fill: "#96D632",
    d: "M496.473 631.47c.505-1.508.765-3.088.77-4.68 0-7.07-4.81-12.81-10.75-12.81a10.329 10.329 0 0 0-8.71 5.361 8.06 8.06 0 0 0-5.85-2.681c-4.9 0-8.87 4.74-8.87 10.58.013.402.046.802.1 1.2h-.64c-6 0-11 5.85-11 13.06 0 7.21 4.91 13.06 11 13.06 1.06 0 31.91 1.461 33.47 1.461 5.69 0 10.31-5.501 10.31-12.291 0-6.62-4.36-11.96-9.83-12.26Z",
    className: "bush"
  }), /*#__PURE__*/React.createElement("g", {
    id: "supermarket",
    className: "supermarket"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1043",
    className: "Group 1043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "supermarket-outline",
    className: "supermarket-outline",
    filter: "url(#filter6_f_5370_44915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1227",
    fill: "url(#paint12_linear_5370_44915)",
    stroke: "url(#paint13_linear_5370_44915)",
    strokeWidth: 6,
    d: "M3926.87 291.279h-3v366.43h260.77v-366.43h-257.77Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1228",
    fill: "#E54038",
    d: "M4181.64 294.279h-254.77v360.43h254.77v-360.43Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1229",
    fill: "#E5AEAE",
    d: "M4167.07 575.451h-226.95v79.27h226.95v-79.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1041",
    className: "Group 1041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1230",
    fill: "#FF7771",
    d: "M4008.9 327h-37.28v43.98h37.28V327Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1231",
    fill: "#FF7771",
    d: "M4072.18 327h-37.28v43.98h37.28V327Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1232",
    fill: "#FF7771",
    d: "M4135.46 327h-37.28v43.98h37.28V327Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1233",
    fill: "#FF7771",
    d: "M4008.9 395.98h-37.28v43.981h37.28V395.98Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1234",
    fill: "#FF7771",
    d: "M4072.18 395.98h-37.28v43.981h37.28V395.98Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1235",
    fill: "#FF7771",
    d: "M4135.46 395.98h-37.28v43.981h37.28V395.98Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1236",
    fill: "#FF7771",
    d: "M4008.9 464.96h-37.28v43.98h37.28v-43.98Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1237",
    fill: "#FF7771",
    d: "M4072.18 464.96h-37.28v43.98h37.28v-43.98Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1238",
    fill: "#FF7771",
    d: "M4135.46 464.96h-37.28v43.98h37.28v-43.98Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1239",
    fill: "#E2C3C3",
    d: "M4167.07 643.299h-226.95v11.42h226.95v-11.42Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1240",
    fill: "#E54038",
    d: "M4111.6 575.451h-4.71v79.27h4.71v-79.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1241",
    fill: "#E54038",
    d: "M4054.53 575.451h-1.87v79.27h1.87v-79.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1242",
    fill: "#E54038",
    d: "M4000.43 575.451h-4.71v79.27h4.71v-79.27Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "supermarket-sign",
    className: "supermarket-sign"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1243",
    fill: "#FF7771",
    d: "m4061.7 523 7.71 12.985h8.21v4.669h-2.8l-1.81 21.205a2.328 2.328 0 0 1-.77 1.524c-.44.396-1.02.617-1.63.617h-33.98c-.6 0-1.18-.221-1.62-.617-.45-.397-.72-.94-.77-1.524l-1.82-21.205h-2.8v-4.669h8.22l7.7-12.985 4.16 2.335-6.32 10.65h20.48l-6.32-10.65 4.16-2.335Zm-5.68 22.323h-4.8v9.339h4.8v-9.339Zm-9.6 0h-4.8v9.339h4.8v-9.339Zm19.2 0h-4.8v9.339h4.8v-9.339Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1064",
    className: "Group 1064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1060",
    className: "Group 1060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1244",
    fill: "#D36E46",
    d: "M4033.42 635.29c.11-3.192.32-8.726.09-10.485l-4.3 2.056c.6 2.554 1.12 5.847 1.5 8.368.38 2.521 2.51 2.022 2.71.061Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1245",
    fill: "#D36E46",
    d: "M4033.6 636.539c-.17-1.266-.48-1.999-1.49-2.01-1.17-.013-1.65 1.244-1.04 6.671.31 2.733.86 5.613 1.01 6.697.24.816.49.638.83.642.8.01 1.01-.349 1.01-.53-.12-4.428.21-7.864-.32-11.47Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1246",
    fill: "#D36E46",
    d: "M4024.2 635.29c-.11-3.192-.32-8.726-.09-10.485l4.3 2.056c-.6 2.554-1.12 5.847-1.5 8.368-.38 2.521-2.51 2.022-2.71.061Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1247",
    fill: "#D36E46",
    d: "M4024.03 636.539c.16-1.266.48-1.999 1.48-2.01 1.17-.013 1.65 1.244 1.04 6.671-.3 2.733-.85 5.613-1.01 6.697-.24.816-.48.638-.82.642-.81.01-1.01-.349-1.01-.53.11-4.428-.22-7.864.32-11.47Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1061",
    className: "Group 1061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1248",
    fill: "#3F1505",
    d: "m4025.96 647.9.08.548s.22.879.06 1.594c-.17.715-1.46.595-1.62 1.6-.16 1.004-1.83 1.851-2.92 1.782-1.1-.068-1.74-.889-1.33-2.033.41-1.143 1.06-1.613 1.54-2.056.49-.443 1.36-1.075 1.36-1.075l.44-.394",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1249",
    fill: "#3F1505",
    d: "M4025.95 647.827s0-.256-.37-.169l-.03.244h.41l-.01-.075Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1250",
    fill: "#3F1505",
    d: "M4023.57 647.867a.244.244 0 0 1 .05-.088.16.16 0 0 1 .1-.034v.122h-.15Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1251",
    fill: "#D36E46",
    d: "M4023.99 650.22c1.46-1.587 1.89-2.476 1.3-2.713-1.24-.498-1.55.506-3 1.763-1.92 1.655-1.89 2.477-1.2 3.102.65.591 1.75-.898 2.9-2.152Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1252",
    fill: "#3F1505",
    d: "M4020.8 650.929c-.27.218-.49.488-.64.795a.216.216 0 0 0 0 .158c.08.219.22.416.4.575.17.16.38.278.61.347.85.277 1.29.098 1.58-.037.05-.02.08-.054.1-.096a.17.17 0 0 0 .03-.137l-.09-.788a.478.478 0 0 0-.1-.23c-.53-.596-.98-.778-1.8-.62a.328.328 0 0 0-.09.033Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1253",
    fill: "#2B0B01",
    d: "M4021.56 653.423c1.1.069 2.76-.769 2.93-1.783.16-1.014 1.44-.885 1.61-1.597.1-.453.13-.833-.39-.157-.33.61-1.23.517-1.47 1.551-.37.886-1.22 1.191-1.63 1.402-1.06.366-2.19-.215-2.49-1.028-.15.736.31 1.527 1.44 1.612Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1062",
    className: "Group 1062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1254",
    fill: "#3F1505",
    d: "m4031.67 647.901-.08.548s-.23.879-.06 1.594c.17.715 1.45.595 1.61 1.6.16 1.004 1.84 1.851 2.93 1.782 1.09-.068 1.74-.889 1.33-2.037-.41-1.149-1.06-1.614-1.55-2.057-.48-.442-1.35-1.075-1.35-1.075l-.44-.394",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1255",
    fill: "#3F1505",
    d: "M4031.68 647.827s0-.256.36-.169c.03.165.04.244.04.244h-.41l.01-.075Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1256",
    fill: "#3F1505",
    d: "M4034.06 647.867a.244.244 0 0 0-.05-.088.16.16 0 0 0-.1-.034v.122h.15Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1257",
    fill: "#D36E46",
    d: "M4033.64 650.22c-1.46-1.587-1.89-2.476-1.31-2.713 1.24-.498 1.56.506 3.01 1.763 1.91 1.655 1.89 2.477 1.2 3.102-.65.591-1.75-.898-2.9-2.152Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1258",
    fill: "#3F1505",
    d: "M4036.83 650.929c.27.218.49.488.65.795.02.051.02.107 0 .158-.09.219-.23.416-.41.575-.17.16-.38.278-.61.347-.85.277-1.29.098-1.58-.037a.224.224 0 0 1-.1-.095.173.173 0 0 1-.03-.138l.09-.788a.478.478 0 0 1 .1-.23c.53-.596.98-.778 1.8-.62.04.005.07.017.09.033Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1259",
    fill: "#2B0B01",
    d: "M4036.07 653.423c-1.1.069-2.76-.769-2.93-1.783-.16-1.014-1.44-.885-1.61-1.597-.1-.453-.13-.833.38-.157.34.61 1.23.517 1.48 1.551.36.886 1.22 1.191 1.62 1.402 1.06.366 2.2-.215 2.5-1.028.14.736-.32 1.527-1.44 1.612Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1059",
    className: "Group 1059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1260",
    fill: "#545454",
    d: "M4029.02 597.011v11.439l-4.78.011c-.24-.378-1.14-1.97.12-3.225.22-.473.35-.535.1-1.576-.1-.662-.41-1.544.72-2.489 0-.768.37-4.16 3.84-4.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1261",
    fill: "#545454",
    d: "M4029.01 597.011v11.439l4.78.011c.24-.378 1.13-1.97-.12-3.225-.22-.473-.35-.535-.1-1.576.1-.662.41-1.544-.72-2.489 0-.768-.37-4.16-3.84-4.16Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1262",
    fill: "#D36E46",
    d: "M4030.63 604.351c.12 1.267.97 1.389.97 1.389s.13 1.709-2.56 1.709c-2.68 0-2.68-1.709-2.68-1.709.29-.088.55-.273.74-.524.18-.251.27-.556.26-.865 0-.038 1.34 1.132 1.34 1.132h.71s.91-.902 1.22-1.132Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1057",
    className: "Group 1057"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1263",
    fill: "#E57A47",
    d: "m4026.54 600.308.08 3.076c.01.103.03.206.07.3.04.094.1.179.18.25l1.54 1.449c.15.137.34.213.54.213h.06c.2 0 .39-.073.53-.205l1.57-1.435a.903.903 0 0 0 .19-.262c.04-.1.07-.208.07-.316v-3.072a.814.814 0 0 0-.23-.553.8.8 0 0 0-.55-.232l-3.26-.02a.731.731 0 0 0-.3.06c-.1.04-.19.1-.26.176a.607.607 0 0 0-.17.262.817.817 0 0 0-.06.309Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1056",
    className: "Group 1056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1264",
    fill: "#212121",
    d: "M4029.61 601.089c.13.122.53.032.74.06.11.013.4.137.5.102.28-.102-.71-.538-1.22-.345a.09.09 0 0 0-.04.037c-.01.014-.02.031-.02.048v.053c.01.018.02.033.04.045Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1265",
    fill: "#212121",
    d: "M4028.45 600.889c-.52-.177-1.49.305-1.2.396.09.03.38-.105.49-.122.21-.037.61.034.74-.091.01-.013.02-.029.02-.046a.05.05 0 0 0 0-.053c0-.017-.01-.034-.02-.048a.075.075 0 0 0-.04-.034l.01-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1266",
    fill: "#212121",
    d: "M4030.14 602.1c.16 0 .28-.585-.1-.585-.2-.003-.15.585.1.585Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1267",
    fill: "#212121",
    d: "M4027.84 602.123c-.15 0-.27-.587.1-.587.2-.002.16.587-.1.587Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1268",
    fill: "#D36E46",
    d: "M4029.33 603.094c.01-.092-.08-.109-.15-.122-.25-.057-.27.068-.15-1.003.03-.21.06-.32-.07-.323-.09 0-.09.074-.12.312-.13 1.164-.14 1.155.35 1.231.08.012.14-.008.14-.095Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1269",
    fill: "#fff",
    d: "M4029.54 603.869c.04-.122-.07-.067-1.13.014-.3.023.79 1.021 1.13-.014Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1270",
    fill: "#D36E46",
    d: "M4022.05 617.026c-.1-2.88.35-7.566.55-9.152l2.01 1.464c-.16 2.298 0 5.43-.48 7.688-.49 2.257-1.89 1.769-2.08 0Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1271",
    fill: "#D36E46",
    d: "M4029.03 621.228v-15.723l1.88-.01s3.37 1.385 4.23 1.83c.49.45.98.824.98 2.509-.04 1.199-.12 5.018-.12 5.018l-1.43-.153-1.77-2.162s-.75 3.891-.7 6.167c.03.897.36 1.978.36 2.489-.62.069-3.43.035-3.43.035Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1272",
    fill: "#D36E46",
    d: "M4020.9 628.134c-.05-.537.34-2.095.55-2.807a.933.933 0 0 1 .22-.384.902.902 0 0 1 .39-.226.768.768 0 0 1 .39-.005c.12.032.24.097.34.188.3.427.61 1.22.06 2.014-.35.441-.74.849-1.16 1.22l.24.549h.37c.2-.244.65-.732.79-.732.15 0 .15.244.13.366-.13.284-.41.891-.55 1.037-.15.146-.63.223-.86.244-.28-.265-.86-.927-.91-1.464Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1273",
    fill: "#D36E46",
    d: "M4023.03 626.669a1.975 1.975 0 0 0-.06-1.648 1.68 1.68 0 0 0-.75.667c-.18.295-.25.639-.22.981l.18 2.44.37-.061c.1-.19.16-.397.18-.61-.04-.605.07-1.211.3-1.769Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1274",
    fill: "#D36E46",
    d: "M4021.93 616.967c.13-.854.36-1.098 1.1-1.098.85 0 1.28.854.79 4.515-.24 1.843-.67 3.783-.79 4.515-.19.549-.37.427-.61.427-.59 0-.74-.244-.74-.366.13-2.99-.12-5.613.25-7.993Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1275",
    fill: "#424AEA",
    d: "M4021.59 608.708c.32-.77 1.1-1.457 1.56-1.708a.14.14 0 0 1 .05-.013c.02.001.04.005.06.014a.2.2 0 0 1 .03.037c.01.015.02.033.02.051l1.31 6.638c0 .019 0 .038-.01.056a.384.384 0 0 1-.03.047.094.094 0 0 1-.05.028.102.102 0 0 1-.05.004l-3.46-.503c-.03-.005-.05-.021-.07-.045a.131.131 0 0 1-.03-.084c.1-1.082.37-3.823.67-4.522Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1276",
    fill: "#424AEA",
    d: "M4036.29 608.707c-.33-.77-1.1-1.457-1.57-1.708-.01-.008-.03-.012-.05-.012-.02.001-.03.006-.05.014a.09.09 0 0 0-.04.037c-.01.015-.01.032-.02.05l-1.26 6.642c-.01.019 0 .038 0 .056.01.018.02.034.03.047.02.013.03.023.05.028.02.006.04.007.06.004l3.41-.503a.135.135 0 0 0 .08-.045.131.131 0 0 0 .03-.084c-.1-1.086-.37-3.827-.67-4.526Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1277",
    fill: "#6877FC",
    fillRule: "evenodd",
    d: "m4026.35 605.751-3.18 1.246 2.58 12.08.18 3.156h3.01v-15.187c-1.37 0-2.49-.569-2.59-1.295Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1278",
    fill: "#6877FC",
    fillRule: "evenodd",
    d: "m4031.53 605.751 3.18 1.246-2.59 12.08-.17 3.156h-3.01v-15.187c1.37 0 2.49-.569 2.59-1.295Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1279",
    fill: "#F79539",
    d: "M4033.8 634.667h-8.97s-3.29-16.262 0-19.345c0 0 3.08.668 4.12.668s4.12-.668 4.12-.668c3.29 3.081.73 19.345.73 19.345Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1280",
    fill: "#F7AF77",
    d: "M4031.31 634.667h-7.21s-2.55-16.262.73-19.345c0 0 3.08.668 4.12.668.56 0 1.69-.191 2.63-.366 2.83 3.709-.27 19.044-.27 19.044v-.001Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1281",
    fill: "#D48031",
    d: "M4033.77 616.365c-.76.196-3.77.955-4.81.955-1.04 0-4.07-.761-4.82-.956.16-.392.39-.747.69-1.046 0 0 3.08.668 4.12.668s4.12-.668 4.12-.668c.3.299.54.655.7 1.047Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1282",
    fill: "#878787",
    d: "M4029.02 597.014c-1.44.017-1.57 3.392-1.57 4.16-1.13.945-.82 1.83-.72 2.489.25 1.041.12 1.098-.1 1.577-1.25 1.254-.36 2.846-.12 3.225 0 0-1.63.307-2.22-1.465 0 0-.31-.842.56-1.708.23-.885.51-.589.34-2.331 0-.678.14-1.415 1.18-2.212-.03-1.032.3-3.986 2.64-3.734",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1283",
    fill: "#ADADAD",
    d: "M4028.96 597.014c1.44.017 1.57 3.392 1.57 4.16 1.14.945.82 1.83.73 2.489-.26 1.041-.13 1.098.09 1.577 1.26 1.254.37 2.846.12 3.225 0 0 1.64.307 2.23-1.465 0 0 .31-.842-.57-1.708-.23-.885-.51-.589-.33-2.331 0-.678-.15-1.415-1.18-2.212.03-1.032-.3-3.986-2.65-3.734",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1284",
    fill: "#D36E46",
    d: "M4037.16 628.134c.05-.537-.34-2.095-.55-2.806a.833.833 0 0 0-.22-.385.912.912 0 0 0-.39-.226.768.768 0 0 0-.39-.005.823.823 0 0 0-.34.189c-.3.427-.61 1.22-.06 2.013.35.441.74.85 1.16 1.22l-.24.549h-.37c-.2-.244-.65-.732-.79-.732-.15 0-.15.244-.13.366.13.284.41.891.55 1.037.15.147.63.224.86.244.28-.264.86-.927.91-1.464Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1285",
    fill: "#D36E46",
    d: "M4035.03 626.669a1.975 1.975 0 0 1 .06-1.648c.31.138.58.371.75.667.18.296.25.639.22.981l-.18 2.44-.36-.061a1.65 1.65 0 0 1-.19-.61 3.967 3.967 0 0 0-.3-1.769Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1286",
    fill: "#D36E46",
    d: "M4036.13 616.967c-.13-.854-.36-1.098-1.1-1.098-.85 0-1.28.854-.79 4.515.25 1.843.67 3.783.79 4.515.19.549.37.427.61.427.59 0 .74-.244.74-.366-.13-2.99.12-5.613-.25-7.993Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "time",
    className: "time"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1287",
    fill: "#FFC850",
    d: "m4036.14 624.301-.05-.294a.07.07 0 0 0-.02-.044c-.01-.01-.03-.016-.05-.016h-.15l.07.466.14-.037a.067.067 0 0 0 .04-.028c.01-.014.02-.03.02-.047Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1288",
    fill: "#E1A546",
    d: "m4036.08 624.017.04.277v.009c0 .003 0 .006.01.008v.004h.01l.24-.033c0-.001.01-.004.01-.01.01-.005.01-.011.01-.018l-.04-.278c-.01-.006-.01-.012-.01-.016-.01-.004-.02-.005-.02-.005l-.23.034c-.01.002-.02.005-.02.01v.018Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1289",
    fill: "#FFC850",
    d: "m4036.13 624.065.02.164c.01.004.01.009.01.013s0 .007.01.01c0 .003.01.005.01.006h.02c0-.001 0-.002.01-.005 0-.002.01-.005.01-.009v-.013c.01-.004.01-.009 0-.013l-.02-.163v-.013c-.01-.004-.01-.008-.01-.01-.01-.003-.01-.005-.02-.006 0-.002 0-.002-.01-.001 0 0-.01.002-.01.004-.01.003-.01.006-.01.01-.01.003-.01.008-.01.012v.014Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1290",
    fill: "#FFC850",
    d: "m4035.21 624.436-.04-.296c-.01-.017 0-.034.01-.049a.064.064 0 0 1 .04-.029l.14-.038.07.467h-.15c-.02 0-.03-.005-.05-.015-.01-.01-.02-.024-.02-.04Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1291",
    fill: "#FFDC64",
    d: "m4035.78 624.609-.01-.071-.14.021.01.069c0 .007.01.012.01.016.01.004.01.006.02.005l.09-.015c.01 0 .01-.004.02-.008v-.017Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1292",
    fill: "#FFF082",
    d: "M4035.65 624.572c.2 0 .35-.157.35-.352a.347.347 0 0 0-.35-.353.353.353 0 0 0 0 .705Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1293",
    fill: "#FFDC64",
    d: "M4035.98 624.181h.03a.548.548 0 0 0-.05-.13c-.02-.04-.06-.075-.09-.103a.35.35 0 0 0-.13-.059.301.301 0 0 0-.13-.007.403.403 0 0 0-.24.138c-.02.037-.04.079-.06.124a.321.321 0 0 0 0 .138h.02c.01-.001.01.001.02.004 0 .003.01.008.01.014.01.075.06.141.12.184a.32.32 0 0 0 .22.05.295.295 0 0 0 .19-.11.28.28 0 0 0 .07-.213v-.02c.01-.003.01-.006.01-.008l.01-.002Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1294",
    fill: "#464655",
    d: "M4035.65 624.479c.15 0 .26-.116.26-.258a.256.256 0 0 0-.26-.259c-.14 0-.26.116-.26.259 0 .142.12.258.26.258Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1295",
    fill: "#5B5D6E",
    d: "M4035.65 624.43c.12 0 .21-.095.21-.212a.209.209 0 0 0-.21-.212c-.12 0-.21.095-.21.212 0 .117.09.212.21.212Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1296",
    fill: "#464655",
    d: "M4035.65 624.293a.07.07 0 0 0 .07-.071.07.07 0 0 0-.07-.071.07.07 0 0 0-.07.071c0 .039.03.071.07.071Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1058",
    className: "Group 1058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1297",
    fill: "#E1A546",
    d: "m4035.6 624.037-.01-.07v-.009c0-.003 0-.006.01-.008v-.006l.01-.003c.01-.001.01.001.02.005 0 .003.01.009.01.015l.01.07c0 .006 0 .012-.01.016 0 .005-.01.007-.02.007 0 0-.01-.002-.01-.007-.01-.004-.01-.01-.01-.016v.006Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1298",
    fill: "#E1A546",
    d: "m4035.67 624.478-.01-.069v-.018c0-.002.01-.004.01-.006 0-.001 0-.003.01-.003 0-.001.01.001.01.005.01.003.01.008.01.015l.01.07v.017c0 .003 0 .005-.01.006 0 .002 0 .003-.01.003h-.01v-.004c-.01-.002-.01-.004-.01-.007v-.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1299",
    fill: "#E1A546",
    d: "M4035.81 624.196v-.009c.01-.003.01-.006.01-.008v-.007c.01-.001.01-.002.01-.003l.07-.009h.01c.01.001.01.002.01.004s.01.004.01.006v.027c-.01.002-.01.004-.01.006l-.01.003-.07.01-.01-.001s0-.002-.01-.003v-.007c0-.003-.01-.006-.01-.009Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1300",
    fill: "#E1A546",
    d: "M4035.37 624.262v-.01c0-.003.01-.006.01-.008v-.007l.01-.002.07-.01h.01c.01.001.01.002.01.004s.01.004.01.007v.008c0 .007 0 .013-.01.018 0 .005 0 .008-.01.009l-.07.01c-.01.001-.01-.001-.02-.004 0-.004-.01-.009-.01-.015Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1301",
    fill: "#FFDC64",
    d: "M4035.57 624.352v-.012l.06-.122c0-.006 0-.01.01-.013 0-.002.01-.003.02-.001l.15.05v.004c.01.002.01.005.01.008v.026c0 .002-.01.004-.01.005 0 .002-.01.003-.01.003l-.01-.002-.13-.043-.04.108c0 .004-.01.008-.01.011 0 .002-.01.004-.01.004-.01 0-.01-.002-.02-.004 0-.003-.01-.007-.01-.011v-.011Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1302",
    fill: "#E1A546",
    d: "m4035.19 624.143.04.278v.01c0 .003 0 .006-.01.009v.006l-.01.003-.23.033h-.01c-.01-.001-.01-.002-.01-.004s-.01-.005-.01-.007v-.01l-.04-.277v-.018c.01-.003.01-.005.01-.006 0-.002.01-.003.01-.004l.23-.034c.01 0 .01.001.02.005 0 .004.01.01.01.016Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1303",
    fill: "#FFC850",
    d: "m4035.15 624.211.02.163c.01.009 0 .018 0 .025l-.02.014h-.02c0-.001-.01-.003-.01-.006s-.01-.006-.01-.01v-.013l-.03-.164c0-.009 0-.018.01-.025 0-.008.01-.013.02-.014h.02c0 .002 0 .003.01.006 0 .003 0 .006.01.01v.014Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1304",
    fill: "#D36E46",
    d: "M4036.01 617.025c.03-.915-.05-2.011-.05-3.135 0-.132-2.33-.34-2.33.697 0 .199.03.397.04.592.05.62.14 1.237.26 1.846.49 2.257 1.9 1.769 2.08 0Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1305",
    fill: "#D36E46",
    d: "M4036.13 616.967c-.13-.854-.36-1.098-1.1-1.098-.85 0-1.28.854-.79 4.515.13.976.31 1.977.47 2.813.14.744 1.63.291 1.63-.413 0-2.11.07-4.031-.21-5.817Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1111",
    className: "Group 1111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1306",
    fill: "#A5A5A5",
    d: "M4110.02 626.84v-.33a3.589 3.589 0 0 0-.88-2.619 3.606 3.606 0 0 0-2.47-1.241h-2.2c-.95.072-1.84.518-2.47 1.241a3.676 3.676 0 0 0-.88 2.619v.41c-1.42.72-2.69 1.719-3.72 2.939a12.041 12.041 0 0 0-2.28 4.161c-.05.18.31.23 1 .23V655h19v-20.78c.64 0 1 0 .94-.21a11.725 11.725 0 0 0-2.28-4.208 11.659 11.659 0 0 0-3.76-2.962Zm-4.34-1c-.92.013-1.85.154-2.74.42.03-.409.2-.797.48-1.09.29-.293.67-.471 1.08-.5h2.2c.4.028.78.199 1.07.482.28.282.45.658.48 1.058a9.892 9.892 0 0 0-2.57-.38v.01Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1307",
    fill: "#878787",
    d: "M4116.33 632.891h-21.23v1.51h21.23v-1.51Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1308",
    fill: "#878787",
    d: "M4098.13 635.73a.61.61 0 0 0-.38.201c-.1.114-.14.26-.14.41v16.87a.56.56 0 0 0 .02.223.533.533 0 0 0 .51.379.533.533 0 0 0 .51-.379.557.557 0 0 0 .01-.223v-16.87a.568.568 0 0 0-.14-.413.587.587 0 0 0-.39-.198Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1309",
    fill: "#878787",
    d: "M4103.14 635.711a.564.564 0 0 0-.38.198.567.567 0 0 0-.14.412v16.87c-.01.15.04.298.14.412.1.114.23.185.38.198a.587.587 0 0 0 .39-.198c.1-.113.15-.261.14-.412v-16.87c.01-.075 0-.15-.02-.221a1.001 1.001 0 0 0-.11-.194.566.566 0 0 0-.4-.195Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1310",
    fill: "#878787",
    d: "M4108.1 635.76a.543.543 0 0 0-.38.197.624.624 0 0 0-.15.413v16.87a.625.625 0 0 0 .01.236.57.57 0 0 0 .29.356c.08.034.15.051.23.051a.53.53 0 0 0 .23-.051.487.487 0 0 0 .19-.145.57.57 0 0 0 .11-.211.472.472 0 0 0 0-.236v-16.87a.568.568 0 0 0-.14-.413.586.586 0 0 0-.39-.197Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1311",
    fill: "#878787",
    d: "M4113.11 635.74a.587.587 0 0 0-.39.198.67.67 0 0 0-.14.412v16.87c0 .151.05.299.14.413.1.114.24.184.39.197a.56.56 0 0 0 .52-.61v-16.87a.562.562 0 0 0-.52-.61Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1312",
    fill: "#fff",
    d: "M3912.87 486h-141v12h141v-12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1313",
    fill: "#fff",
    d: "M3912.87 507h-141v12h141v-12Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1314",
    fill: "#fff",
    d: "M3789.87 423h-13v45h13v-45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1315",
    fill: "#fff",
    d: "M3830.87 423h-13v45h13v-45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1316",
    fill: "#fff",
    d: "M3871.87 423h-13v45h13v-45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1317",
    fill: "#fff",
    d: "M3912.87 423h-13v45h13v-45Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1123",
    className: "Group 1123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1318",
    fill: "#F4D3C6",
    d: "M147.873 618.624a108.846 108.846 0 0 1 29.58-1.37s78.1-15.86 83.55-107.58c4.56-76.36 3.87-139.37 60.82-170.71 39.63-21.81 48.09-113.56 48.09-113.56l-20.36-69.4c-10.06-34.21-31-44.29-46.85-22.5a72.35 72.35 0 0 0-9.87 20.75l-75.54 242-69.42 222.37Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1319",
    fill: "#D3B4A7",
    d: "M177.451 617.254c7.853.7 15.614 2.204 23.16 4.49 33.42 10 79.59 8.83 118-46.61 13.62-19.79 25.41-44.95 34.74-74.17 13.67-42.28 40-74.71 68.37-99l-35.78-121.88-16-54.65s-8.46 91.75-48.09 113.56c-57 31.34-56.26 94.35-60.82 170.71-5.45 91.72-83.55 107.58-83.55 107.58l-.03-.03Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("g", {
    id: "balloon1_2",
    className: "balloon1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1320",
    fill: "#9BC1F9",
    fillRule: "evenodd",
    d: "M259.248 235c8.73 0 17.12 5.72 17.38 16.27.24 9.72-7.54 18.36-10.28 24.41h-7.1V235Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1321",
    fill: "#E8313F",
    fillRule: "evenodd",
    d: "M259.248 235c6.43 0 15.06 6.17 14.61 16.91-.37 8.65-5.13 15.52-9.38 23.77h-5.23V235Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1322",
    fill: "#9BC1F9",
    fillRule: "evenodd",
    d: "M259.248 235c4.57 0 10.71 6.17 10.39 16.91-.26 8.65-3.65 15.52-6.67 23.77h-3.72V235Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1323",
    fill: "#E8313F",
    fillRule: "evenodd",
    d: "M259.248 235c2.62 0 6.14 6.17 6 16.91-.15 8.65-2.09 15.52-3.83 23.77h-2.13l-.04-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1324",
    fill: "#9BC1F9",
    fillRule: "evenodd",
    d: "M259.248 235c-8.72 0-17.11 5.72-17.37 16.27-.24 9.72 7.541 18.36 10.281 24.41h7.089V235Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1325",
    fill: "#FF4248",
    fillRule: "evenodd",
    d: "M259.248 235c-6.42 0-15.05 6.17-14.6 16.91.36 8.65 5.13 15.52 9.38 23.77h5.22V235Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1326",
    fill: "#9BC1F9",
    fillRule: "evenodd",
    d: "M259.248 235c-4.56 0-10.7 6.17-10.37 16.91.25 8.65 3.64 15.52 6.66 23.77h3.71V235Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1327",
    fill: "#FF4248",
    fillRule: "evenodd",
    d: "M259.248 235c-2.61 0-6.13 6.17-6 16.91.15 8.65 2.09 15.52 3.83 23.77h2.12l.05-40.68Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 969_2",
    className: "Group 969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1328",
    fill: "#7D8696",
    d: "M256.487 282.738h-.45v3.28h.45v-3.28Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1329",
    fill: "#7D8696",
    d: "M262.46 282.738h-.45v3.28h.45v-3.28Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1330",
    fill: "#7D8696",
    fillRule: "evenodd",
    d: "M262.699 285.809h-6.89a.338.338 0 0 0-.31.36v4.07a.343.343 0 0 0 .081.243c.058.067.14.109.229.117h6.89a.343.343 0 0 0 .31-.36v-4.07a.338.338 0 0 0-.31-.36Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1331",
    fill: "#FFDF5A",
    fillRule: "evenodd",
    d: "M259.259 275.68h-7.14l3.26 7.38h3.88v-7.38Z",
    className: "Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1332",
    fill: "#FCD017",
    fillRule: "evenodd",
    d: "M259.26 275.68h7.13l-3.26 7.38h-3.87v-7.38Z",
    className: "Vector",
    clipRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "grass_26",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1333",
    fill: "#91DC5A",
    d: "M5477.41 428.843a12.449 12.449 0 0 0-1.72-4.089 11.771 11.771 0 0 0-3.97-3.692.578.578 0 0 0-.69.075.467.467 0 0 0-.15.31c-.02.118.01.237.08.334a15.561 15.561 0 0 1 2.71 7.813c.08 1.253.02 2.511-.21 3.746a.585.585 0 0 0 .01.228c.01.075.05.144.1.202a.615.615 0 0 0 .43.193h3.17a.54.54 0 0 0 .36-.122c.1-.083.16-.2.18-.329.16-1.562.06-3.14-.3-4.669Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1334",
    fill: "#4CBA68",
    d: "M5480.83 425.054a15.368 15.368 0 0 0-6.82-7.975.581.581 0 0 0-.69.076c-.08.08-.14.19-.15.309-.01.119.02.238.09.335a20.86 20.86 0 0 1 3.63 10.507c.14 1.68.07 3.371-.21 5.034a.44.44 0 0 0 0 .228c.02.076.06.145.11.201a.6.6 0 0 0 .2.141c.07.034.15.051.23.052h3.11c.14.003.28-.049.38-.146.1-.096.16-.229.17-.369v-8.211a.573.573 0 0 0-.05-.182Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1335",
    fill: "#91DC5A",
    d: "M5487.42 417.799a.5.5 0 0 0 .09-.334.524.524 0 0 0-.16-.31.566.566 0 0 0-.68-.076 15.336 15.336 0 0 0-5.24 4.873 16.706 16.706 0 0 0-2.29 5.367 19.12 19.12 0 0 0-.44 6.171.539.539 0 0 0 .55.451h4.22c.08.008.16-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.667.667 0 0 0-.01-.244 20.525 20.525 0 0 1-.23-5.012c.25-3.76 1.5-7.382 3.64-10.486Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1336",
    fill: "#4CBA68",
    d: "M5489.66 421.781a.5.5 0 0 0 .09-.334.523.523 0 0 0-.15-.31.578.578 0 0 0-.69-.075c-1.6.897-2.96 2.163-3.97 3.692a12.484 12.484 0 0 0-1.74 4.089 14.106 14.106 0 0 0-.33 4.669.539.539 0 0 0 .55.451h3.16c.08.008.17-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.504.504 0 0 0-.01-.244 15.22 15.22 0 0 1-.17-3.692 15.568 15.568 0 0 1 2.71-7.846Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_27",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1337",
    fill: "#91DC5A",
    d: "M5658.54 467.843a12.47 12.47 0 0 0-1.73-4.089 11.59 11.59 0 0 0-3.97-3.692.567.567 0 0 0-.35-.076.606.606 0 0 0-.34.151.517.517 0 0 0-.15.31c-.01.118.02.237.09.334a15.657 15.657 0 0 1 2.71 7.813 15.67 15.67 0 0 1-.21 3.746.44.44 0 0 0 0 .228c.02.075.06.144.11.202a.575.575 0 0 0 .43.193h3.16a.54.54 0 0 0 .55-.451c.16-1.562.06-3.14-.3-4.669Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1338",
    fill: "#4CBA68",
    d: "M5661.95 464.054a15.305 15.305 0 0 0-6.81-7.975.586.586 0 0 0-.69.076c-.09.08-.14.19-.15.309a.45.45 0 0 0 .09.335 20.754 20.754 0 0 1 3.62 10.507c.15 1.68.08 3.371-.2 5.034a.44.44 0 0 0 0 .228c.02.076.06.145.11.201a.562.562 0 0 0 .43.193h3.11c.14.003.28-.049.38-.146.1-.096.16-.229.17-.369v-8.211a.59.59 0 0 0-.06-.182Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1339",
    fill: "#91DC5A",
    d: "M5668.55 456.799a.554.554 0 0 0 .08-.334.463.463 0 0 0-.15-.31.586.586 0 0 0-.69-.076 15.305 15.305 0 0 0-5.23 4.873 16.706 16.706 0 0 0-2.29 5.367 19.12 19.12 0 0 0-.44 6.171.539.539 0 0 0 .55.451h4.22c.08.008.16-.003.24-.035.07-.031.14-.08.2-.144a.455.455 0 0 0 .1-.221.407.407 0 0 0-.01-.244 20.522 20.522 0 0 1-.22-5.012c.24-3.76 1.5-7.382 3.64-10.486Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1340",
    fill: "#4CBA68",
    d: "M5670.79 460.781c.07-.098.1-.216.08-.334a.472.472 0 0 0-.15-.31.55.55 0 0 0-.33-.151.553.553 0 0 0-.35.076c-1.6.897-2.96 2.163-3.97 3.692a12.484 12.484 0 0 0-1.74 4.089 14.106 14.106 0 0 0-.33 4.669c.02.129.08.246.18.329.1.083.23.126.36.122h3.17c.08.008.16-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.667.667 0 0 0-.01-.244c-.21-1.22-.27-2.459-.18-3.692a15.58 15.58 0 0 1 2.72-7.846Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_28",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1341",
    fill: "#91DC5A",
    d: "M5596.54 544.843a12.47 12.47 0 0 0-1.73-4.089 11.59 11.59 0 0 0-3.97-3.692.567.567 0 0 0-.35-.076.606.606 0 0 0-.34.151.517.517 0 0 0-.15.31c-.01.118.02.237.09.334a15.657 15.657 0 0 1 2.71 7.813 15.67 15.67 0 0 1-.21 3.746.44.44 0 0 0 0 .228c.02.075.06.144.11.202a.575.575 0 0 0 .43.193h3.16a.54.54 0 0 0 .55-.451c.16-1.562.06-3.14-.3-4.669Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1342",
    fill: "#4CBA68",
    d: "M5599.95 541.054a15.305 15.305 0 0 0-6.81-7.975.586.586 0 0 0-.69.076c-.09.08-.14.19-.15.309a.45.45 0 0 0 .09.335 20.754 20.754 0 0 1 3.62 10.507c.15 1.68.08 3.371-.2 5.034a.44.44 0 0 0 0 .228c.02.076.06.145.11.201a.562.562 0 0 0 .43.193h3.11c.14.003.28-.049.38-.146.1-.096.16-.229.17-.369v-8.211a.59.59 0 0 0-.06-.182Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1343",
    fill: "#91DC5A",
    d: "M5606.55 533.799a.554.554 0 0 0 .08-.334.463.463 0 0 0-.15-.31.586.586 0 0 0-.69-.076 15.305 15.305 0 0 0-5.23 4.873 16.706 16.706 0 0 0-2.29 5.367 19.12 19.12 0 0 0-.44 6.171.539.539 0 0 0 .55.451h4.22c.08.008.16-.003.24-.035.07-.031.14-.08.2-.144a.455.455 0 0 0 .1-.221.407.407 0 0 0-.01-.244 20.522 20.522 0 0 1-.22-5.012c.24-3.76 1.5-7.382 3.64-10.486Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1344",
    fill: "#4CBA68",
    d: "M5608.79 537.781c.07-.098.1-.216.08-.334a.472.472 0 0 0-.15-.31.55.55 0 0 0-.33-.151.553.553 0 0 0-.35.076c-1.6.897-2.96 2.163-3.97 3.692a12.484 12.484 0 0 0-1.74 4.089 14.106 14.106 0 0 0-.33 4.669c.02.129.08.246.18.329.1.083.23.126.36.122h3.17c.08.008.16-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.667.667 0 0 0-.01-.244c-.21-1.22-.27-2.459-.18-3.692a15.58 15.58 0 0 1 2.72-7.846Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_29",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1345",
    fill: "#91DC5A",
    d: "M5621.54 369.843a12.47 12.47 0 0 0-1.73-4.089 11.59 11.59 0 0 0-3.97-3.692.567.567 0 0 0-.35-.076.606.606 0 0 0-.34.151.517.517 0 0 0-.15.31c-.01.118.02.237.09.334a15.657 15.657 0 0 1 2.71 7.813 15.67 15.67 0 0 1-.21 3.746.44.44 0 0 0 0 .228c.02.075.06.144.11.202a.575.575 0 0 0 .43.193h3.16a.54.54 0 0 0 .55-.451c.16-1.562.06-3.14-.3-4.669Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1346",
    fill: "#4CBA68",
    d: "M5624.95 366.054a15.305 15.305 0 0 0-6.81-7.975.586.586 0 0 0-.69.076c-.09.08-.14.19-.15.309a.45.45 0 0 0 .09.335 20.754 20.754 0 0 1 3.62 10.507c.15 1.68.08 3.371-.2 5.034a.44.44 0 0 0 0 .228c.02.076.06.145.11.201a.562.562 0 0 0 .43.193h3.11c.14.003.28-.049.38-.146.1-.096.16-.229.17-.369v-8.211a.59.59 0 0 0-.06-.182Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1347",
    fill: "#91DC5A",
    d: "M5631.55 358.799a.554.554 0 0 0 .08-.334.463.463 0 0 0-.15-.31.586.586 0 0 0-.69-.076 15.305 15.305 0 0 0-5.23 4.873 16.706 16.706 0 0 0-2.29 5.367 19.12 19.12 0 0 0-.44 6.171.539.539 0 0 0 .55.451h4.22c.08.008.16-.003.24-.035.07-.031.14-.08.2-.144a.455.455 0 0 0 .1-.221.407.407 0 0 0-.01-.244 20.522 20.522 0 0 1-.22-5.012c.24-3.76 1.5-7.382 3.64-10.486Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1348",
    fill: "#4CBA68",
    d: "M5633.79 362.781c.07-.098.1-.216.08-.334a.472.472 0 0 0-.15-.31.55.55 0 0 0-.33-.151.553.553 0 0 0-.35.076c-1.6.897-2.96 2.163-3.97 3.692a12.484 12.484 0 0 0-1.74 4.089 14.106 14.106 0 0 0-.33 4.669c.02.129.08.246.18.329.1.083.23.126.36.122h3.17c.08.008.16-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.667.667 0 0 0-.01-.244c-.21-1.22-.27-2.459-.18-3.692a15.58 15.58 0 0 1 2.72-7.846Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_30",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1349",
    fill: "#91DC5A",
    d: "M5405.41 292.843a12.449 12.449 0 0 0-1.72-4.089 11.771 11.771 0 0 0-3.97-3.692.578.578 0 0 0-.69.075.467.467 0 0 0-.15.31c-.02.118.01.237.08.334a15.561 15.561 0 0 1 2.71 7.813c.08 1.253.02 2.511-.21 3.746a.585.585 0 0 0 .01.228c.01.075.05.144.1.202a.615.615 0 0 0 .43.193h3.17a.54.54 0 0 0 .36-.122c.1-.083.16-.2.18-.329.16-1.562.06-3.14-.3-4.669Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1350",
    fill: "#4CBA68",
    d: "M5408.83 289.054a15.368 15.368 0 0 0-6.82-7.975.581.581 0 0 0-.69.076c-.08.08-.14.19-.15.309-.01.119.02.238.09.335a20.86 20.86 0 0 1 3.63 10.507c.14 1.68.07 3.371-.21 5.034a.44.44 0 0 0 0 .228c.02.076.06.145.11.201a.6.6 0 0 0 .2.141c.07.034.15.051.23.052h3.11c.14.003.28-.049.38-.146.1-.096.16-.229.17-.369v-8.211a.573.573 0 0 0-.05-.182Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1351",
    fill: "#91DC5A",
    d: "M5415.42 281.799a.5.5 0 0 0 .09-.334.524.524 0 0 0-.16-.31.566.566 0 0 0-.68-.076 15.336 15.336 0 0 0-5.24 4.873 16.706 16.706 0 0 0-2.29 5.367 19.12 19.12 0 0 0-.44 6.171.539.539 0 0 0 .55.451h4.22c.08.008.16-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.667.667 0 0 0-.01-.244 20.525 20.525 0 0 1-.23-5.012c.25-3.76 1.5-7.382 3.64-10.486Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1352",
    fill: "#4CBA68",
    d: "M5417.66 285.781a.5.5 0 0 0 .09-.334.523.523 0 0 0-.15-.31.578.578 0 0 0-.69-.075c-1.6.897-2.96 2.163-3.97 3.692a12.484 12.484 0 0 0-1.74 4.089 14.106 14.106 0 0 0-.33 4.669.539.539 0 0 0 .55.451h3.16c.08.008.17-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.504.504 0 0 0-.01-.244 15.22 15.22 0 0 1-.17-3.692 15.568 15.568 0 0 1 2.71-7.846Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_31",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1353",
    fill: "#91DC5A",
    d: "M5511.41 332.843a12.449 12.449 0 0 0-1.72-4.089 11.771 11.771 0 0 0-3.97-3.692.578.578 0 0 0-.69.075.467.467 0 0 0-.15.31c-.02.118.01.237.08.334a15.561 15.561 0 0 1 2.71 7.813c.08 1.253.02 2.511-.21 3.746a.585.585 0 0 0 .01.228c.01.075.05.144.1.202a.615.615 0 0 0 .43.193h3.17a.54.54 0 0 0 .36-.122c.1-.083.16-.2.18-.329.16-1.562.06-3.14-.3-4.669Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1354",
    fill: "#4CBA68",
    d: "M5514.83 329.054a15.368 15.368 0 0 0-6.82-7.975.581.581 0 0 0-.69.076c-.08.08-.14.19-.15.309-.01.119.02.238.09.335a20.86 20.86 0 0 1 3.63 10.507c.14 1.68.07 3.371-.21 5.034a.44.44 0 0 0 0 .228c.02.076.06.145.11.201a.6.6 0 0 0 .2.141c.07.034.15.051.23.052h3.11c.14.003.28-.049.38-.146.1-.096.16-.229.17-.369v-8.211a.573.573 0 0 0-.05-.182Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1355",
    fill: "#91DC5A",
    d: "M5521.42 321.799a.5.5 0 0 0 .09-.334.524.524 0 0 0-.16-.31.566.566 0 0 0-.68-.076 15.336 15.336 0 0 0-5.24 4.873 16.706 16.706 0 0 0-2.29 5.367 19.12 19.12 0 0 0-.44 6.171.539.539 0 0 0 .55.451h4.22c.08.008.16-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.667.667 0 0 0-.01-.244 20.525 20.525 0 0 1-.23-5.012c.25-3.76 1.5-7.382 3.64-10.486Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1356",
    fill: "#4CBA68",
    d: "M5523.66 325.781a.5.5 0 0 0 .09-.334.523.523 0 0 0-.15-.31.578.578 0 0 0-.69-.075c-1.6.897-2.96 2.163-3.97 3.692a12.484 12.484 0 0 0-1.74 4.089 14.106 14.106 0 0 0-.33 4.669.539.539 0 0 0 .55.451h3.16c.08.008.17-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.504.504 0 0 0-.01-.244 15.22 15.22 0 0 1-.17-3.692 15.568 15.568 0 0 1 2.71-7.846Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_32",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1357",
    fill: "#91DC5A",
    d: "M5356.42 345.843a12.687 12.687 0 0 0-1.73-4.089 11.771 11.771 0 0 0-3.97-3.692.583.583 0 0 0-.69.075.46.46 0 0 0-.15.31c-.02.119.02.238.09.334a15.658 15.658 0 0 1 2.7 7.813c.1 1.251.04 2.509-.17 3.746a.445.445 0 0 0 0 .229c.02.075.05.144.11.201a.575.575 0 0 0 .43.193h3.16a.54.54 0 0 0 .55-.451c.15-1.564.04-3.142-.33-4.669Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1358",
    fill: "#4CBA68",
    d: "M5359.85 342.054a15.35 15.35 0 0 0-6.81-7.975.586.586 0 0 0-.69.076c-.09.08-.14.19-.16.309-.01.119.02.238.1.335a20.754 20.754 0 0 1 3.62 10.507c.14 1.681.06 3.372-.22 5.034a.584.584 0 0 0-.01.228c.02.076.06.145.11.201.06.06.13.108.2.141a.56.56 0 0 0 .23.052h3.12a.55.55 0 0 0 .38-.146c.1-.096.16-.229.16-.369v-8.211a.56.56 0 0 0-.03-.182Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1359",
    fill: "#91DC5A",
    d: "M5366.37 334.799a.554.554 0 0 0 .08-.334.467.467 0 0 0-.15-.31.566.566 0 0 0-.68-.076 15.326 15.326 0 0 0-5.24 4.873 16.697 16.697 0 0 0-2.29 5.367 18.56 18.56 0 0 0-.38 6.171c.02.129.08.246.18.329.11.083.23.126.36.122h4.22c.08.008.17-.003.24-.035.08-.031.15-.08.2-.144a.589.589 0 0 0 .11-.221.667.667 0 0 0-.01-.244 20.525 20.525 0 0 1-.23-5.012 20.879 20.879 0 0 1 3.59-10.486Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1360",
    fill: "#4CBA68",
    d: "M5368.66 338.781a.5.5 0 0 0 .09-.334.523.523 0 0 0-.15-.31.578.578 0 0 0-.69-.075c-1.6.897-2.96 2.163-3.97 3.692a12.484 12.484 0 0 0-1.74 4.089 14.106 14.106 0 0 0-.33 4.669.539.539 0 0 0 .55.451h3.22c.08.008.16-.003.24-.035.07-.031.14-.08.2-.144a.455.455 0 0 0 .1-.221.407.407 0 0 0-.01-.244c-.66-4.03.25-8.16 2.55-11.538h-.06Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_33",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1361",
    fill: "#91DC5A",
    d: "M4881.19 240.84a18.034 18.034 0 0 0-2.47-5.799 16.568 16.568 0 0 0-5.65-5.266.815.815 0 0 0-.98.122.676.676 0 0 0-.21.441.67.67 0 0 0 .12.475 21.906 21.906 0 0 1 3.85 11.096c.14 1.783.06 3.579-.25 5.342a.888.888 0 0 0 .01.325c.03.106.09.204.16.285a.812.812 0 0 0 .61.275h4.5a.787.787 0 0 0 .51-.187c.15-.12.24-.286.27-.47.21-2.224.05-4.467-.47-6.639Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1362",
    fill: "#4CBA68",
    d: "M4886.04 235.466a21.761 21.761 0 0 0-9.7-11.355.815.815 0 0 0-.98.122.74.74 0 0 0-.22.441.73.73 0 0 0 .13.475 29.7 29.7 0 0 1 5.17 14.942c.19 2.39.08 4.795-.33 7.158a.714.714 0 0 0 .16.61.8.8 0 0 0 .28.205c.11.048.22.072.34.07h4.39a.786.786 0 0 0 .56-.207.745.745 0 0 0 .23-.541V235.71a.51.51 0 0 0-.03-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1363",
    fill: "#91DC5A",
    d: "M4895.32 225.149c.1-.138.15-.307.13-.475a.74.74 0 0 0-.22-.441.815.815 0 0 0-.98-.122 22.127 22.127 0 0 0-7.43 6.929 23.89 23.89 0 0 0-3.26 7.631 26.9 26.9 0 0 0-.63 8.761.807.807 0 0 0 .79.656h6a.812.812 0 0 0 .55-.212c.07-.07.13-.153.17-.245.04-.091.06-.19.06-.291a.562.562 0 0 0 0-.183 28.247 28.247 0 0 1-.34-7.112 29.737 29.737 0 0 1 5.16-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1364",
    fill: "#4CBA68",
    d: "M4898.59 230.765a.67.67 0 0 0 .12-.475.676.676 0 0 0-.21-.441.82.82 0 0 0-.47-.227.802.802 0 0 0-.51.105 16.787 16.787 0 0 0-5.65 5.266 18.008 18.008 0 0 0-2.45 5.799c-.54 2.171-.7 4.416-.48 6.64.03.184.13.352.27.473.14.12.32.185.51.183h4.58a.746.746 0 0 0 .54-.213.65.65 0 0 0 .17-.244.74.74 0 0 0 .07-.291.562.562 0 0 0 0-.183 20.87 20.87 0 0 1-.25-5.235c.22-3.99 1.52-7.846 3.76-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "grass_34",
    className: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1365",
    fill: "#91DC5A",
    d: "M4989.18 291.842a18.143 18.143 0 0 0-2.46-5.815 16.811 16.811 0 0 0-5.64-5.25.846.846 0 0 0-.51-.108.812.812 0 0 0-.47.215.636.636 0 0 0-.22.44c-.02.169.03.339.13.476a22.273 22.273 0 0 1 3.84 11.111c.14 1.779.06 3.568-.24 5.326a.719.719 0 0 0-.01.326.75.75 0 0 0 .16.285.825.825 0 0 0 .61.275h4.5a.75.75 0 0 0 .51-.174.737.737 0 0 0 .27-.467 20.32 20.32 0 0 0-.47-6.64Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1366",
    fill: "#4CBA68",
    d: "M4994.04 286.468a21.82 21.82 0 0 0-9.7-11.355.815.815 0 0 0-.97.107.71.71 0 0 0-.23.448c-.01.172.03.343.14.483a29.523 29.523 0 0 1 5.15 14.926 27.7 27.7 0 0 1-.33 7.159.714.714 0 0 0 .01.325c.03.106.08.204.16.285a.764.764 0 0 0 .61.275h4.42c.1.004.2-.012.3-.047a.875.875 0 0 0 .25-.156.716.716 0 0 0 .23-.53v-11.676a.676.676 0 0 0-.04-.244Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1367",
    fill: "#91DC5A",
    d: "M5003.33 276.151a.815.815 0 0 0 .12-.482.76.76 0 0 0-.21-.449.83.83 0 0 0-.98-.107 21.83 21.83 0 0 0-7.45 6.929 23.868 23.868 0 0 0-3.25 7.631c-.7 2.87-.91 5.837-.62 8.776.03.184.12.35.26.468.15.118.33.179.51.173h6a.755.755 0 0 0 .55-.201c.07-.068.13-.15.18-.241.04-.092.06-.19.07-.29v-.183c-.4-2.354-.51-4.748-.32-7.128a29.627 29.627 0 0 1 5.14-14.896Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1368",
    fill: "#4CBA68",
    d: "M5006.59 281.798a.689.689 0 0 0-.11-.916.76.76 0 0 0-.46-.213.82.82 0 0 0-.5.106 16.66 16.66 0 0 0-5.64 5.25c-1.16 1.78-2 3.748-2.48 5.815a20.32 20.32 0 0 0-.47 6.64c.03.183.13.349.27.467.14.118.32.18.51.174h4.58a.782.782 0 0 0 .55-.202c.07-.068.13-.15.17-.241.04-.091.07-.19.07-.29a.562.562 0 0 0 0-.183 21.977 21.977 0 0 1-.24-5.25 21.966 21.966 0 0 1 3.75-11.157Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tree_12",
    className: "tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1369",
    fill: "#C0EA6E",
    d: "M5550.2 587.173a15.46 15.46 0 0 0 2.48-8.457c0-7.331-4.96-13.373-11.34-14.189-1.16-6.568-6.34-11.527-12.56-11.527-6.23 0-11.41 4.959-12.57 11.527-6.38.816-11.34 6.858-11.34 14.189a15.5 15.5 0 0 0 2.48 8.468 7.837 7.837 0 0 0-1.86 2.659 7.585 7.585 0 0 0-.61 3.187c.02 1.094.27 2.171.73 3.161.47.99 1.14 1.871 1.97 2.585a15.494 15.494 0 0 0-.57 4.228c0 7.889 5.73 14.286 12.8 14.286a11.807 11.807 0 0 1 8.86-3.997c1.67 0 3.33.356 4.86 1.045 1.52.689 2.88 1.696 3.99 2.952 7.08 0 12.82-6.44 12.82-14.286 0-1.38-.18-2.755-.54-4.089a7.56 7.56 0 0 0 2.15-2.678c.5-1.047.75-2.195.73-3.354a7.612 7.612 0 0 0-2.48-5.71Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1370",
    fill: "#72493E",
    d: "M5531.09 612.119h-4.65v43.618h4.65v-43.618Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1371",
    fill: "#A3E440",
    d: "M5550.2 587.174a15.465 15.465 0 0 0 2.48-8.458c.03-2.307-.47-4.591-1.48-6.667a14.827 14.827 0 0 0-4.32-5.289 34.68 34.68 0 0 1 1.34 9.659c0 17.398-12.64 31.501-28.24 31.501a25.873 25.873 0 0 1-12.88-3.477c.64 7.223 6.1 12.879 12.75 12.879a11.805 11.805 0 0 1 4-2.951c1.53-.69 3.18-1.046 4.86-1.046a11.767 11.767 0 0 1 8.85 3.997c7.08 0 12.82-6.44 12.82-14.285 0-1.381-.18-2.755-.54-4.089a7.572 7.572 0 0 0 2.15-2.679c.5-1.046.75-2.194.73-3.353a7.718 7.718 0 0 0-.64-3.144 7.703 7.703 0 0 0-1.88-2.598Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bush_9",
    className: "bush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1372",
    fill: "#44AA85",
    d: "M5430.76 353c1.15.068 2.26.464 3.18 1.141a5.952 5.952 0 0 1 2.06 2.679 5.607 5.607 0 0 1 1.92-2.423 5.551 5.551 0 0 1 2.92-1.017c3.12 0 5.64 3.16 5.64 7.05a8.185 8.185 0 0 1-.75 3.51h.06c3.31 0 6 3.35 6 7.48 0 4.13-2.68 7.48-6 7.48s-16.2-.71-18.48-.71c-3.33 0-2.58-13.49-2.58-17.65 0-4.16 2.7-7.54 6.03-7.54Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1373",
    fill: "#4FC99A",
    d: "M5411.79 365.51h.3a5.825 5.825 0 0 1 0-.591c0-2.82 1.83-5.099 4.09-5.099.52.01 1.03.131 1.49.353.47.223.88.542 1.21.936.38-.747.95-1.38 1.65-1.835a4.773 4.773 0 0 1 2.35-.754c2.74 0 5 2.77 5 6.19 0 .767-.12 1.529-.36 2.259 2.52.15 4.53 2.721 4.53 5.901 0 3.18-2.13 5.94-4.75 5.94-.72 0-14.94-.711-15.43-.711-2.78 0-5-2.82-5-6.31 0-3.49 2.14-6.279 4.92-6.279Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bush_10",
    className: "bush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1374",
    fill: "#44AA85",
    d: "M5587.89 460c1.15.068 2.25.464 3.18 1.141a5.952 5.952 0 0 1 2.06 2.679 5.535 5.535 0 0 1 4.84-3.44c3.12 0 5.64 3.16 5.64 7.05a8.335 8.335 0 0 1-.75 3.51h.06c3.31 0 6 3.35 6 7.48 0 4.13-2.68 7.48-6 7.48s-16.2-.71-18.48-.71c-3.33 0-2.58-13.49-2.58-17.65 0-4.16 2.7-7.54 6.03-7.54Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1375",
    fill: "#4FC99A",
    d: "M5568.92 472.51h.3a5.825 5.825 0 0 1 0-.591c0-2.82 1.83-5.099 4.09-5.099a3.629 3.629 0 0 1 2.7 1.289c.38-.747.95-1.38 1.65-1.835.7-.455 1.51-.715 2.35-.754 2.74 0 5 2.77 5 6.19 0 .767-.13 1.529-.36 2.259 2.52.15 4.53 2.721 4.53 5.901 0 3.18-2.13 5.94-4.75 5.94-.72 0-14.94-.711-15.43-.711-2.78 0-5-2.82-5-6.31 0-3.49 2.14-6.279 4.92-6.279Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1149",
    className: "Group 1149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1376",
    fill: "#82AFAC",
    d: "M1610.87 459h-253v5h253v-5Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1377",
    fill: "#82AFAC",
    d: "M1610.87 521h-253v5h253v-5Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1155",
    className: "Group 1155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1154",
    className: "Group 1154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1142",
    className: "Group 1142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1139",
    className: "Group 1139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1137",
    className: "Group 1137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fill: "#99D53B",
    fillRule: "evenodd",
    d: "M3098 475.214V496a4 4 0 0 1-4 4h-40a4 4 0 0 1-4-4v-20.408c4.73-9.224 12.2-16.925 23.97-16.925 11.62 0 19.16 7.491 24.03 16.547Z",
    className: "Intersect",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fill: "#D2F0A2",
    fillRule: "evenodd",
    d: "M3054 452a4 4 0 0 0-4 4v21.786c4.33-9.25 11.69-17.786 24.1-17.786 12.31 0 19.6 8.383 23.9 17.537V456a4 4 0 0 0-4-4h-40Z",
    className: "Subtract",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hill-sign",
    className: "hill-sign"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hill-sign_2",
    className: "hill-sign"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    className: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1131",
    className: "Group 1131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1133",
    className: "Group 1133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1378",
    fill: "#D2F0A2",
    d: "M3089.05 481.234v2.923h-5.88l-1.46-1.461 1.46-1.462h5.88Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1379",
    fill: "#D2F0A2",
    d: "M3077.29 481.234h5.88v2.923h-5.88v-2.923Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1134",
    className: "Group 1134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1380",
    fill: "#D2F0A2",
    d: "M3089.05 477.334v2.923h-5.87l-1.47-1.462 1.47-1.461h5.87Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1381",
    fill: "#D2F0A2",
    d: "M3077.3 477.334h5.87v2.923h-5.87v-2.923Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1134_2",
    className: "Group 1134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1132",
    className: "Group 1132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1382",
    fill: "#D2F0A2",
    d: "M3089.52 486.105v1.949h-6.36l-.97-.926.97-1.023h6.36Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1383",
    fill: "#D2F0A2",
    d: "M3076.79 486.105h6.37v1.949h-6.37v-1.949Z",
    className: "Vector"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1384",
    fill: "#D2F0A2",
    d: "M3075.33 482.87v8.464h1.95v-8.464h-1.95Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1385",
    fill: "#D2F0A2",
    d: "M3088.99 482.74v8.594h1.94v-8.594h-1.94Z",
    className: "Vector"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1135",
    className: "Group 1135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1136",
    className: "Group 1136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_1386",
    fill: "#D2F0A2",
    d: "M3068.1 481.218h-2.48v10.115h2.48v-10.115Z",
    className: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1387",
    fill: "#D2F0A2",
    d: "M3072.42 475.749c.42-.571.64-1.237.64-1.918 0-1.662-1.29-3.032-2.94-3.217-.3-1.49-1.64-2.614-3.26-2.614-1.61 0-2.95 1.124-3.26 2.614-1.65.185-2.93 1.555-2.93 3.217-.01.681.22 1.349.64 1.92-.21.169-.37.375-.48.603a1.53 1.53 0 0 0-.16.723c0 .248.07.492.19.717.12.224.29.424.51.586-.1.312-.15.635-.15.959 0 1.789 1.49 3.239 3.32 3.239.29-.285.64-.513 1.04-.669.39-.157.82-.237 1.25-.237.44 0 .87.08 1.26.237.4.156.75.384 1.04.669 1.83 0 3.32-1.46 3.32-3.239 0-.313-.05-.625-.14-.928.24-.162.43-.37.56-.607.13-.237.19-.497.19-.76 0-.244-.05-.485-.16-.708a1.95 1.95 0 0 0-.48-.587Z",
    className: "Vector"
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 47",
    fill: "#7D8696",
    d: "M3070.31 500h5.538v66.462h-5.538z",
    className: "Rectangle 47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5370_44915",
    x1: 3312.72,
    x2: 3312.72,
    y1: 349,
    y2: 655.22,
    className: "paint0_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5370_44915",
    x1: 3312.72,
    x2: 3312.72,
    y1: 349,
    y2: 655.22,
    className: "paint1_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5370_44915",
    x1: 1842.32,
    x2: 1842.32,
    y1: 430.889,
    y2: 654.692,
    className: "paint2_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5370_44915",
    x1: 1842.32,
    x2: 1842.32,
    y1: 430.889,
    y2: 654.692,
    className: "paint3_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5370_44915",
    x1: 1484.37,
    x2: 1484.37,
    y1: 256,
    y2: 654,
    className: "paint4_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5370_44915",
    x1: 1484.37,
    x2: 1484.37,
    y1: 256,
    y2: 654,
    className: "paint5_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5370_44915",
    x1: 686.843,
    x2: 686.843,
    y1: 474.76,
    y2: 654.691,
    className: "paint6_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5370_44915",
    x1: 686.843,
    x2: 686.843,
    y1: 474.76,
    y2: 654.691,
    className: "paint7_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5370_44915",
    x1: 5074.94,
    x2: 5074.94,
    y1: 417,
    y2: 654.75,
    className: "paint8_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5370_44915",
    x1: 5074.94,
    x2: 5074.94,
    y1: 417,
    y2: 654.75,
    className: "paint9_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5370_44915",
    x1: 2502.28,
    x2: 2502.28,
    y1: 349,
    y2: 654.9,
    className: "paint10_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5370_44915",
    x1: 2502.28,
    x2: 2502.28,
    y1: 349,
    y2: 654.9,
    className: "paint11_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5370_44915",
    x1: 4054.26,
    x2: 4054.26,
    y1: 294.279,
    y2: 654.709,
    className: "paint12_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5370_44915",
    x1: 4054.26,
    x2: 4054.26,
    y1: 294.279,
    y2: 654.709,
    className: "paint13_linear_5370",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5370_44915",
    width: 692.63,
    height: 326.22,
    x: 2966.38,
    y: 339,
    className: "filter0_f_5370",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5370_44915",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5370_44915",
    width: 236.161,
    height: 243.804,
    x: 1724.24,
    y: 420.889,
    className: "filter1_f_5370",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5370_44915",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5370_44915",
    width: 273,
    height: 418,
    x: 1347.87,
    y: 246,
    className: "filter2_f_5370",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5370_44915",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_5370_44915",
    width: 175.403,
    height: 199.931,
    x: 599.142,
    y: 464.76,
    className: "filter3_f_5370",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5370_44915",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_5370_44915",
    width: 252.137,
    height: 257.75,
    x: 4948.87,
    y: 407,
    className: "filter4_f_5370",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5370_44915",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_5370_44915",
    width: 251.84,
    height: 325.9,
    x: 2376.36,
    y: 339,
    className: "filter5_f_5370",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5370_44915",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_5370_44915",
    width: 274.77,
    height: 380.43,
    x: 3916.87,
    y: 284.279,
    className: "filter6_f_5370",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5370_44915",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5370_44915",
    className: "clip0_5370"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h6472v668H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5370_44915",
    className: "clip1_5370"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h108v108H0z",
    transform: "translate(1400.87 547.479)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.691029e9f9133521bbad5776d36f7f90.svg";
export { ForwardRef as ReactComponent };